import React from 'react';
import TextField from '@material-ui/core/TextField';
import {
  propertyColumnsPTF,
  propertyAllocationList,
  propertyallocationConfig,
  transitionTrackerSteps,
  managementFeeColumns,
  readOnlyManagementFeeColumns,
  ExpenseColumns,
  EngineerHourBillingColumns,
  clientContactDetailsColumn
} from '../../constants/MockData';
import PageHeader from '../common/PageHeader';
import {
  AppBar,
  Button,
  Dialog,
  FormControl,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
  Checkbox
} from '@material-ui/core';
import '../Transition/style.less';
import GridTable from '../common/Table/Table';
import { Link, Visibility, CloudUploadOutlined } from '@material-ui/icons';
import {
  apiBatchRequest,
  apiDelete,
  apiPost,
  apiPut,
  apiRequest,
  getSpsAPiRequest,
  spsApiPost,
  uploadSpsAPiRequest,
  uploadSpsMetadataAPiRequest,
  deleteSpsApiRequest
} from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  getCurrentPayCycleStartDate,
  getDistinctByProperty,
  getSectionAttributeValueByKey,
  getSectionFieldByKey,
  isGridFormValid,
  isInputValid,
  RemoveSectionAttributeByKeyValue,
  getSectionAttributesByKeyValue,
  removeDuplicates,
  setSectionAttributeValueByKey,
  setSectionFieldAttributeByKey,
  UpdateColumnWithConfiguration,
  UpdateFieldsWithConfiguration,
  getSectionAttributeFieldValueByKeyValue,
  cloneDeep,
  removeNullValuesFromArray,
  IsSectionVisible,
  GetReadOnlyServiceType,
  with2DecimalsPoints
} from '../../utils/helper';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';
import FormGenerator from '../common/FormGenerator';
import { ApprovedStatus, controlType } from '../../constants/common';
import _ from 'lodash';
import CustomizedTimeline from '../common/Timeline/timeline';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import store from '../../store/appStore';
import {
  DateFormat,
  getSPSTokenData,
  Operators,
  SECTIONS,
  setSPSToken,
  TRANSITION_TYPE_ID, ServiceTypes, DEPARTMENT, Markets, TERMINATION_TYPE, RECORD_SOURCE, SOURCE_ACCOUNTING_TYPE
} from '../../constants/appConstants';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  getCurrentEnvironment,
  getSharePointUrl
} from '../../constants/sharepointApi';
import commonLabels from '../../constants/messageConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import Fuse from 'fuse.js';
import { transition } from 'd3-transition';
import { getFormattedValues } from '../../utils/formatData';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';

// Field array of New Client Contact Details
const newclientContactDetailConfig = [
  { key: 'name', type: controlType.Autofill, multiple: false },
  // { key: 'city', type: controlType.DropDown, multiple: false },
  { key: 'state', type: controlType.DropDown, multiple: false },
  {
    key: 'role',
    type: controlType.DropDown,
    dataFormat: 'DropDown',
    multiple: false
  }
  // {
  //   key: 'isNonUsState',
  //   type: controlType.CheckBox,
  //   isVisible: true,
  //   dependentField: {
  //     key: 'state',
  //     type: [{
  //       whenValue: 0,
  //       type: controlType.DropDown
  //     },
  //     {
  //       whenValue: 1,
  //       type: controlType.TextBox
  //     }
  //     ]
  //   }
  // }
];

// Array of Change in Ownership fields
const changeOfOwnerShipFields = [
  'NewClient',
  'ChangeOfOwnershipDocumentName',
  'NewLegalEntity',
  'EffectiveFrom',
  'NewServiceType',
  'TerminationDocumentName',
  'ContinueAllocation',
  'UpdatedProperties'
];

// AddEdit component to View/Edit PTF Details
class AddEdit extends React.PureComponent {
  // Constructor to define initial state of component
  constructor(props) {
    super(props);
    this.state = {
      pmaTitleMasterData: [],
      sourceAccountingSystemId: 0,
      previewSourceAccountingData: [],
      sourceAccountingDialog: false,
      spsData: [],
      spsAllData: [],
      transitionData: [],
      propertyDetails: [],
      ExistingPropertyDetails: [],
      propertyLandLordDetails: [],
      employeesForAllocationMasterData: [],
      allowToEdit: this.props.readOnly !== true,
      isApproved: false,
      showPropertyDialog: false,
      showClientContactDialog: false,
      previewData: {},
      assignmentMasterData: [],
      allocationData: [],
      isInAddMode: false,
      deleteAllocation: [],
      allocationConfiguration: [],
      updateData: {},
      actionType: this.props.actionType,
      marketMasterData: [],
      trackerTimeLineData: transitionTrackerSteps,
      hasTransitionChanged: false,
      selectedPropertyId: this.props.selectedPropertyId || 0,
      newClientDetail: [],
      propertyMasterData: this.props.propertyMasterData,
      originalPropertyMasterData: this.props.propertyMasterData,
      newMultiProperty: [],
      reloadPtf: false,
      validationMessages: [],
      isClientSelected: false,
      isMarketSelected: false,
      isPropertyTypeSelected: false,
      originalserviceTypeMasterData: this.props.serviceTypeMasterData,
      serviceTypeMasterData: this.props.serviceTypeMasterData,
      selectedOriginalTransitionTypeId: '',
      reloadProperty: false,
      isMultiBuilding: false,
      cityMasterData: [],
      stateMasterData: [],
      propertyAllocation: propertyAllocationList,
      allocationMarkets: [],
      selectedClientId: this.props.selectedClientId || 0,
      readOnly: this.props.readOnly,
      originalAllocationData: [],
      isEditableMode: false,
      allocationMessage: '',
      expenseTypes: [],
      sourceAccountingSystemData: [],
      propertySubTypeData: [],
      originalPropertySubTypeData: [],
      showGraceButton: false,
      gracePeriodDialog: false,
      propAccounting: false,
      isButtonsDisabled: false,
      isErrorOccurredWhileFileUpload: false,
      RetryFileUploadTitle: 'Error While Uploading File(s)',
      retryFileUploadMessage: 'Error occurred while uploading file(s). Please try again or you can upload the file(s) later.',
      isTrueUpPopupOpen: false,
      trueUpConfirmationMessage: '',
      isPopupOpen: false,
      confirmationMessage: '',
      isConfirmPopupOpen: false,
      deleteFileConfirmationMessage: '',
      mngFeeData: [],
      enableSubmitButtons: false,
      isChangesInClientContact: false,
      isChangesInTransitionDetails: false,
      isChangesInManagementFee: false,
      isChangesInEngineerHourBilling: false,
      originalClientContactDetails: [],
      editContactDetails: false,
      editCIOContactDetails: false,
      isRowChecked: false,
      headerData: {
        selectAll: false
      },
      ccDetailsFormFields: [],
      selectedClientContact: [],
      reloadClientContactSection: false,
      reloadClientContactTable: false,
      clientContactMainData: [],
      selectedClientContactDataRow: [],
      CIOClientContacts: [],
      CIOClientContactMasterData: [],
      ClientContactMasterData: [],
      ContactRoleMasterData: [],
      isClientContactDetailsEditable: false,
      isClientCIOContactDetailsEditable: false,
      IsNewClientContact: false,
      showSubmitBtnOnEnggBillingSection: false,
      hasPmaAccess: false

    };
  }

  // Method calls before components are render. This method is used to make API calls to get master data
  componentDidMount() {
    //  const query = useQuery();
    let groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).configurationName || '';
    let hasPMAAccess = groupName.replaceAll(' ', '').toLowerCase() == 'propertymanagementadmin'
    if (hasPMAAccess) {
      this.setState({ hasPmaAccess: hasPMAAccess });
    }
    this.LoadTransitionData();
    this.loadContactRoles();
  }

  // Method to View Property details
  setPropertyPreviewDialog = (propertyId, isEditableProperty, cellInfo) => {
    const { newMultiProperty, transitionData } = this.state;

    let formData;
    newMultiProperty.forEach((prop) => {
      if (
        getSectionAttributeValueByKey(prop, 'propertyId').toString() ===
        propertyId.toString()
      ) {
        formData = cloneDeep(prop);
      }
    });
    if (formData === undefined) {
      apiBatchRequest([
        {
          url:
            API_URL.Property.GetPropertyDetails +
            '?isPtfCall=true&propertyId=' +
            propertyId +
            '&propertyTransitionId=' +
            this.props.selectedTransitionId,
          key: 'newPropertyData'
        }
      ])
        .then(({ newPropertyData }) => {
          setSectionFieldAttributeByKey(
            newPropertyData.data,
            'clientName',
            'isEditable',
            false
          );
          if (!this.state.isMultiBuilding) {
            setSectionFieldAttributeByKey(
              newPropertyData.data,
              'legalEntity',
              'isEditable',
              false
            );
          }
          if (this.state.selectedTransitionTypeId?.toString() === '2') {
            setSectionFieldAttributeByKey(
              newPropertyData.data,
              'propertyName',
              'isEditable',
              false
            );
          }


          const serviceTypeIds = getSectionAttributeValueByKey(transitionData, 'ServiceTypeId')?.split('|') || [];
          if (serviceTypeIds.find(x => x?.toString() === ServiceTypes.Property_Accounting?.toString())) {
            setSectionFieldAttributeByKey(newPropertyData.data, 'ARAdminName', 'isVisible', true);
          } else {
            setSectionFieldAttributeByKey(newPropertyData.data, 'ARAdminName', 'isVisible', false);
          }

          // newPropertyData.data.push({
          //   attributeSortOrder: 33,
          //   attributeValue: '',
          //   dataFormat: 'Boolean',
          //   dbColumn: 'IsNonUsState',
          //   displayName: 'Non US State',
          //   isEditable: true,
          //   isRequired: false,
          //   isVisible: true,
          //   recordId: null,
          //   sectionDetailId: 542,
          //   sectionId: 18,
          //   type: 'Checkbox'
          // });

          this.setState({
            showPropertyDialog: true,
            previewData: newPropertyData.data,
            isEditableProperty: isEditableProperty
          });
        })
        .catch(() => {
          this._asyncRequest = null;
          ShowToast(
            this.state.commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        });
    } else {
      setSectionFieldAttributeByKey(
        formData,
        'clientName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        formData,
        'yardiCode',
        'attributeValue',
        cellInfo.yardiCode
      );
      if (!this.state.isMultiBuilding) {
        setSectionFieldAttributeByKey(
          formData,
          'legalEntity',
          'isEditable',
          false
        );
      }
      if (this.state.selectedTransitionTypeId?.toString() === '2') {
        setSectionFieldAttributeByKey(
          formData,
          'propertyName',
          'isEditable',
          false
        );
      }
      this.setState({
        showPropertyDialog: true,
        previewData: cloneDeep(formData),
        isEditableProperty: isEditableProperty
      });
    }
  };

  // Render Delete action button for record of Management Fee
  renderDeleteAction = (cellInfo) => {
    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    const isEditable =
      IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT)
      && ((this.state?.selectedTransitionTypeId?.toString() === '2' && isApproved === true) ||
        ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && this.state.propAccounting)) &&
          (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
          (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'))
      );

    return isEditable
      ? (
        <Tooltip title="Delete Record">
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.DeleteManagementFeeRecord(cellInfo);
            }}
          >
            <DeleteIcon fontSize="small" size="small" />
          </IconButton>
        </Tooltip>
      )
      : (
        <></>
      );
  };

  // Render Delete button on record/row of Expense Details
  renderDeleteExpenseAction = (cellInfo) => {
    return IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) && this.state.allowToEdit &&
      this.state?.selectedTransitionTypeId?.toString() !== '3'
      ? (
        <Tooltip title="Delete Record">
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.DeleteExpenseRecord(cellInfo);
            }}
          >
            <DeleteIcon fontSize="small" size="small" />
          </IconButton>
        </Tooltip>
      )
      : (
        <></>
      );
  };

  // Render Delete button for records/rows of Engineer Hour Billings
  renderDeleteEngineerHourBillingAction = (cellInfo) => {
    const isApproved = getSectionAttributeValueByKey(this.state.transitionData, 'ApprovalStatusId').toString() === '4';
    const isEditable =
      IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT)
      && ((this.state?.selectedTransitionTypeId?.toString() === '2' && isApproved === true) ||
        ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && this.state.propAccounting)) &&
          (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
          (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'))
      );

    return isEditable
      ? (
        <Tooltip title="Delete Record">
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.DeleteEngineerHourBillingRecord(cellInfo);
            }}
          >
            <DeleteIcon fontSize="small" size="small" />
          </IconButton>
        </Tooltip>
      )
      : (
        <></>
      );
  };

  // Open Client Contact dialog
  openClientContactDialog = (isFromCIO = false) => {
    this.setState({
      showClientContactDialog: true,
      IsNewClientContact: isFromCIO
    });
  }

  // Render Action buttons for records/rows into Property table
  renderActionColumnOriginalProperty = (cellInfo) => {
    let isEditableProperty =
      IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
      this.state.readOnly !== true &&
      this.state.allowToEdit &&
      (cellInfo.isFreezed === '0' || !cellInfo.isFreezed || cellInfo.isFreezed === '') &&
      (this.state.selectedOriginalTransitionTypeId?.toString() === '1' || this.state.selectedOriginalTransitionTypeId?.toString() === '');
    isEditableProperty = (isEditableProperty === false) ? false : ((this.state.selectedTransitionTypeId?.toString() === '3') ? false : true);
    return (
      <>
        <Tooltip title={isEditableProperty ? 'Edit Details' : 'View Details'}>
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.setPropertyPreviewDialog(
                cellInfo.propertyId,
                isEditableProperty,
                cellInfo
              );
            }}
          >
            {isEditableProperty
              ? (
                <EditIcon fontSize="small" size="small" />
              )
              : (
                <Visibility fontSize="small" size="small" />
              )}
          </IconButton>
        </Tooltip>

        {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
          (cellInfo.isFreezed === '0' || !cellInfo.isFreezed) &&
          this.state.selectedOriginalTransitionTypeId?.toString() === '1' &&
          cellInfo.propertyId !== null &&
          cellInfo.propertyId !== undefined &&
          cellInfo.propertyId !== '' &&
          parseInt(cellInfo.propertyId) > 0 && (
            <Tooltip title="Link to Source Accounting System">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.linkPropertyAccountingCode(cellInfo.propertyId);
                }}
              >
                <Link fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          )}
      </>
    );
  };

  // Render Action buttons to View/Edit client contacts
  renderActionForEditClientContact = (cellInfo) => {
    let isEditableContact = true;
    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    const { selectedOriginalTransitionTypeId, selectedTransitionTypeId } = this.state;
    if (((selectedOriginalTransitionTypeId === TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) || (selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP)) ||
      (selectedOriginalTransitionTypeId === TRANSITION_TYPE_ID.TERMINATION && isApproved)) {
      isEditableContact = false;
    }
    if (cellInfo.comments === undefined) {
      cellInfo.comments = '';
    }
    const data = cloneDeep(this.state.clientContactMainData);
    const selectedData = data.filter(x => x.recordId == cellInfo.recordId);
    return (
      <>
        <Tooltip title={isEditableContact ? 'Edit Details' : 'View Details'}>
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.setState({
                editContactDetails: true,
                selectedClientContact: selectedData,
                isClientContactDetailsEditable: isEditableContact
              });
            }}
          >
            {isEditableContact
              ? (
                <EditIcon fontSize="small" size="small" />
              )
              : (
                <Visibility fontSize="small" size="small" />
              )}
          </IconButton>
        </Tooltip>

        {isEditableContact && <><Tooltip title={isEditableContact ? 'Delete Details' : 'View Details'}>
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.DeleteClientContactRecord(cellInfo);
            }}
          >
            {isEditableContact
              ? (
                <DeleteIcon fontSize="small" size="small" />
              )
              : (
                <EditIcon fontSize="small" size="small" />
              )}
          </IconButton>
        </Tooltip></>}
      </>
    );
  };

  // Render Action buttons to View/Edit client contact details of CIO client
  renderActionForEditCIOClientContact = (cellInfo) => {
    let isEditableContact = true;
    const { selectedTransitionTypeId } = this.state;
    if (selectedTransitionTypeId == '3' || (!this.state.allowToEdit)) {
      isEditableContact = false;
    }
    const data = cloneDeep(this.state.CIOClientContacts);
    const selectedData = data.filter(x => x.recordId == cellInfo.recordId);
    return (
      <>
        <Tooltip title={isEditableContact ? 'Edit Details' : 'View Details'}>
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.setState({
                editCIOContactDetails: true,
                selectedClientContact: selectedData,
                isClientCIOContactDetailsEditable: isEditableContact
              });
            }}
          >
            {isEditableContact
              ? (
                <EditIcon fontSize="small" size="small" />
              )
              : (
                <Visibility fontSize="small" size="small" />
              )}
          </IconButton>
        </Tooltip>

        {isEditableContact && <><Tooltip title={isEditableContact ? 'Delete Details' : 'View Details'}>
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.DeleteClientContactRecord(cellInfo);
            }}
          >
            {isEditableContact
              ? (
                <DeleteIcon fontSize="small" size="small" />
              )
              : (
                <EditIcon fontSize="small" size="small" />
              )}
          </IconButton>
        </Tooltip></>}
      </>
    );
  };

  // Add selected client contacts into main list for selected PTF
  handleAddToPTF = () => {
    const { headerData, clientContactDetails, clientContactMainData, CIOClientContacts, selectedClientContactDataRow, selected, ccDetailsFormFields } = this.state;
    ccDetailsFormFields.forEach(x => {
      x.attributeValue = '';
      x.errorMessage = '';
      x.isInErrorState = false;
    });
    headerData.selectAll = false;
    if (selectedClientContactDataRow.length === 0) {
      ShowToast('No Existing Client Selected.', toastType.ERROR, 5000, 500);
      return;
    }
    let data1 = clientContactMainData;
    let data2 = CIOClientContacts;
    if (this.state.selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) {
      // data2 = [...CIOClientContacts, ...selectedClientContactDataRow];
      data2 = this.getUniqueClients(selectedClientContactDataRow, CIOClientContacts, data2);
    } else {
      data1 = this.getUniqueClients(selectedClientContactDataRow, clientContactMainData, data1);
    }
    this.setState({
      clientContactMainData: data1 == [] ? clientContactMainData : data1,
      CIOClientContacts: data2 == [] ? CIOClientContacts : data2,
      showClientContactDialog: false,
      reloadClientContactTable: !this.state.reloadClientContactTable,
      headerData,
      IsNewClientContact: false,
      selectedClientContactDataRow: [],
      ccDetailsFormFields
    });
  }

  // Handle Edit action of client contact 
  handleTableHeaderEditChange = (value, fieldName) => {
    const { headerData, ClientContactMasterData, CIOClientContactMasterData, selectedTransitionTypeId } = this.state;
    headerData[fieldName] = value;
    let data = [];
    if (selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) {
      data = value ? CIOClientContactMasterData : [];
    } else {
      data = value ? ClientContactMasterData : [];
    }
    this.setState({
      headerData,
      reload: !this.state.reload,
      isRowChecked: value,
      selectedClientContactDataRow: data
    }, () => { this.forceUpdate(); });
  }

  // Render Checkbox for client contacts to select/deselect contacts
  renderActionForCheckBoxClientContact = (cellInfo) => {
    // const isChecked = this.state.isRowChecked; // false; // (this.state?.selectedAllocation?.find(x => x.allocationId === row.allocationId) !== undefined || false);
    const { selectedClientContactDataRow, headerData, isRowChecked } = this.state;
    let isChecked = false;
    if (headerData.selectAll) {
      isChecked = true;
    } else {
      isChecked = (selectedClientContactDataRow?.find(x => x.recordId == cellInfo.recordId) !== undefined || false);
    }
    return (
      <>
        <Tooltip title={isChecked ? 'Deselect Contact Details' : 'Select Contact Details'}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={(e) => this.selectContactDetail(e, cellInfo)}
                name="Select Contact Details"
                color="default"
                size="small"
                className={'white-checkbox'}
              />
            }
          />
        </Tooltip>
      </>
    );
  };

  // Select contact(s) details from existing contact list
  selectContactDetail = (e, cellInfo) => {
    const {
      isRowChecked,
      ccDetailsFormFields,
      ClientContactMasterData,
      CIOClientContactMasterData,
      selectedTransitionTypeId,
      headerData,
      selectedClientContactDataRow
    } = this.state;
    let masterData = [];
    let arr = cloneDeep(selectedClientContactDataRow?.filter(x => x.dbColumn !== 'ClientContactId' && x.dbColumn !== 'MarketDisplayName'));
    const newArr = cloneDeep(ccDetailsFormFields);
    newArr.forEach(x => {
      x.recordId = cellInfo.recordId;
    });
    this.setState({
      isRowChecked: !isRowChecked
    });

    if (e.target.checked) {
      setSectionAttributeValueByKey(newArr, 'address', cellInfo.address);
      setSectionAttributeValueByKey(newArr, 'city', cellInfo.city);
      setSectionAttributeValueByKey(newArr, 'clientId', cellInfo.clientId);
      setSectionAttributeValueByKey(newArr, 'contactName', cellInfo.contactName);
      setSectionAttributeValueByKey(newArr, 'email', cellInfo.email);
      setSectionAttributeValueByKey(newArr, 'phoneNumber', cellInfo.phoneNumber);
      setSectionAttributeValueByKey(newArr, 'state', cellInfo.state);
      setSectionAttributeValueByKey(newArr, 'zipCode', cellInfo.zipCode);
      setSectionAttributeValueByKey(newArr, 'comments', cellInfo.comments);
      setSectionAttributeValueByKey(newArr, 'role', cellInfo.role);
      // setSectionAttributeValueByKey(newArr, 'isSelected', true);
      arr = [...arr, ...newArr];
      arr = arr?.filter(x => x.dbColumn !== 'ClientContactId');
      if (selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) {
        masterData = CIOClientContactMasterData?.filter(x => x.dbColumn !== 'ClientContactId' && x.dbColumn !== 'MarketDisplayName');
        if (masterData.length === arr.length) {
          headerData.selectAll = true;
        }
      } else {
        masterData = ClientContactMasterData?.filter(x => x.dbColumn !== 'ClientContactId' && x.dbColumn !== 'MarketDisplayName');
        if (masterData.length === arr.length) {
          headerData.selectAll = true;
        }
      }

      this.setState({
        selectedClientContactDataRow: arr,
        headerData
      });
    } else {
      const data = selectedClientContactDataRow.filter(x => x.recordId != cellInfo.recordId);
      headerData.selectAll = false;
      this.setState({
        selectedClientContactDataRow: data,
        headerData
      });
    }
  }

  // Render Action buttons on each row/record of Property table
  renderActionColumn = (cellInfo) => {
    const isEditableProperty =
      this.state.readOnly !== true &&
      this.state.allowToEdit &&
      (cellInfo.isFreezed === '0' || !cellInfo.isFreezed);
    return (
      <>
        <Tooltip title={isEditableProperty ? 'Edit Details' : 'View Details'}>
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.setPropertyPreviewDialog(
                cellInfo.propertyId,
                isEditableProperty,
                cellInfo
              );
            }}
          >
            {isEditableProperty
              ? (
                <EditIcon fontSize="small" size="small" />
              )
              : (
                <Visibility fontSize="small" size="small" />
              )}
          </IconButton>
        </Tooltip>

        {(cellInfo.isFreezed === '0' || !cellInfo.isFreezed) &&
          cellInfo.propertyId !== null &&
          cellInfo.propertyId !== undefined &&
          cellInfo.propertyId !== '' &&
          parseInt(cellInfo.propertyId) > 0 && (
            <Tooltip title="Link to Source Accounting System">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.linkPropertyAccountingCode(cellInfo.propertyId);
                }}
              >
                <Link fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          )}
      </>
    );
  };

  // Link Source Accounting System and Property Code to the property
  linkPropertyAccountingCode = (propertyId) => {
    apiBatchRequest([
      {
        url:
          API_URL.Property.GetPropertyDetails +
          '?isPtfCall=true&propertyId=' +
          propertyId +
          '&propertyTransitionId=' +
          this.props.selectedTransitionId,
        key: 'newPropertyData'
      }
    ])
      .then(({ newPropertyData }) => {
        const sourceAccountingData = newPropertyData.data.filter(
          (x) =>
            x.dbColumn === 'PropertyName' ||
            // x.dbColumn === 'SourceAccountingSystem' ||
            x.dbColumn === 'SourceAccountingSystemId' ||
            x.dbColumn === 'PropertyId'
        );

        const sourceAccountingSystem = newPropertyData.data.find((x) => x.dbColumn === 'SourceAccountingSystem');
        sourceAccountingSystem.key = 'sourceAccountingSystem';
        sourceAccountingSystem.changePropertyCodeValidations = true;
        sourceAccountingData.push(sourceAccountingSystem);

        const accountCode = newPropertyData.data.find(
          (x) => x.dbColumn === 'YardiCode'
        );
        accountCode.isRequired = true;
        accountCode.isEditable = true;
        sourceAccountingData.push(accountCode);

        const sourceAccountingTypeId = getSectionAttributeValueByKey(sourceAccountingData, 'SourceAccountingSystemId');
        if (sourceAccountingTypeId?.toString() === SOURCE_ACCOUNTING_TYPE.STREAM_ACCOUNTING_SYSTEM?.toString()) {
          setSectionFieldAttributeByKey(sourceAccountingData, 'YardiCode', 'dataFormat', 'Text');
        } else {
          setSectionFieldAttributeByKey(sourceAccountingData, 'YardiCode', 'dataFormat', 'NumericText');
        }
        this.setState({
          sourceAccountingDialog: true,
          previewSourceAccountingData: sourceAccountingData
        });
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          this.state.commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      });
  };

  // Handle Edit event of table row of Property/Allocation tables
  handleTableEditChange = (value, fieldName) => {
    const { propertyAllocation, propertyDetails, allocationData } = this.state;
    const marketData = this.state.marketMasterData;
    const departmentData = this.state.departmentMasterData;
    const employeeData = this.props.employeeTypeMasterData;
    const pmaTitleData = this.state.pmaTitleMasterData;
    const param = this.state.updateData;
    let message = '';

    if (fieldName === 'allocationEndDate') {
      param[fieldName] = value;
      param.billingEndDate = value;
    }
    if (
      fieldName === 'isAllocatedToLegalEntity' ||
      fieldName === 'propertyAllocationPercent' ||
      fieldName === 'propertyBillingPercent' ||
      fieldName === 'additionalFixedAmount'
    ) {
      if (fieldName === 'isAllocatedToLegalEntity') {
        if (value) {
          const existingPendingRecord = allocationData.find(
            (y) =>
              y.employeeId === (param || {}).employeeId &&
              y.allocationId !== param.allocationId &&
              y.marketId === (param || {}).marketId &&
              y.pmaTitleId === (param || {}).pmaTitleId
          );
          if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
            message =
              existingPendingRecord !== undefined
                ? 'Employee: ' +
                (existingPendingRecord || {}).preferredName +
                ' already allocated to the Property: ' +
                (existingPendingRecord || {}).propertyName +
                ' and PMA Title: ' +
                ((existingPendingRecord || {}).pmaTitle) +
                '. If you want to update any information please edit that particular record.'
                : '';
          } else {
            message =
              existingPendingRecord !== undefined
                ? 'Employee: ' +
                (existingPendingRecord || {}).preferredName +
                ' already allocated to the Property: ' +
                (existingPendingRecord || {}).propertyName +
                // ' and PMA Title: ' +
                // ((existingPendingRecord || {}).pmaTitle) +
                '. If you want to update any information please edit that particular record.'
                : '';
          }
        }
        if (message === '') {
          param[fieldName] = value;
          if (fieldName === 'additionalFixedAmount') {
            param[fieldName] = with2DecimalsPoints(value, 'Percent');
          }
          param.legalEntityAndPropertyData = [
            ...this.setPropertyData(
              param.legalEntity,
              { ...param },
              false,
              fieldName
            )
          ];
        }
      } else {
        param[fieldName] = with2DecimalsPoints(value);
        if (fieldName === 'additionalFixedAmount') {
          param[fieldName] = with2DecimalsPoints(value, 'Percent');
        }
        param.legalEntityAndPropertyData = [
          ...this.setPropertyData(
            param.legalEntity,
            { ...param },
            false,
            fieldName
          )
        ];
      }
    } else if (fieldName === 'pmaTitle') {
      const valueOfPmaTitle = pmaTitleData.find((x) => x.pmaTitle === value);
      param.pmaTitleId = (valueOfPmaTitle || {}).pmaTitleId;
      param[fieldName] = (valueOfPmaTitle || {}).pmaTitle;
      const existingPendingRecord = allocationData.find(
        (y) =>
          y.employeeId === param.employeeId &&
          y.isAllocatedToLegalEntity === true &&
          y.allocationId !== param.allocationId &&
          y.marketId === (param || {}).marketId &&
          y.pmaTitleId === (param || {}).pmaTitleId
      );
      if (existingPendingRecord) {
        if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      } else {
        const existingPendingRecord = allocationData.find(
          (y) =>
            y.employeeId === param.employeeId &&
            y.propertyId === param.propertyId &&
            y.allocationId !== param.allocationId &&
            y.marketId === (param || {}).marketId &&
            y.pmaTitleId === (param || {}).pmaTitleId
        );
        if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      }
    } else if (fieldName === 'legalEntity' || fieldName === 'LegalEntity') {
      const valueOfLegalEntity =
        propertyDetails.find((x) => x.legalEntity === value) || {};
      param.propertyName = '';
      param.legalEntityId = 0;
      param.legalEntity = '';
      param.LegalEntity = '';
      if (message === '') {
        param[fieldName] = value;
        param.legalEntityId = valueOfLegalEntity.legalEntityId;
        param.legalEntity = valueOfLegalEntity.legalEntity;
        param.LegalEntity = valueOfLegalEntity.legalEntity;
        param.propertyId = valueOfLegalEntity.propertyId;
        param.propertyName = valueOfLegalEntity.propertyName;
        param.legalEntityAndPropertyData = [
          ...this.setPropertyData(
            param.legalEntity,
            { ...param },
            false,
            fieldName
          )
        ];
      }
    } else if (fieldName === 'propertyName') {
      const valueOfMarket = {
        ...propertyDetails.find((x) => x.propertyName === value)
      };
      const existingPendingRecord = allocationData.find(
        (y) =>
          y.employeeId === param?.employeeId &&
          y.isAllocatedToLegalEntity === true &&
          y.allocationId !== param.allocationId &&
          y.marketId === (param || {}).marketId &&
          y.pmaTitleId === (param || {}).pmaTitleId
      );
      if (existingPendingRecord) {
        if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              ' and PMA Title: ' + (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              // ' and PMA Title: ' + (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      } else {
        const existingPendingRecord = allocationData.find(
          (y) =>
            y.employeeId === (param || {}).employeeId &&
            y.propertyId === valueOfMarket?.propertyId &&
            y.allocationId !== param.allocationId &&
            y.marketId === (param || {}).marketId &&
            y.pmaTitleId === (param || {}).pmaTitleId
        );
        if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      }
      param.propertyName = '';
      param.legalEntityId = 0;
      param.legalEntity = '';
      param.LegalEntity = '';
      if (message === '') {
        param.propertyId = valueOfMarket?.propertyId;
        param[fieldName] = valueOfMarket?.propertyName;
        param.legalEntityId = valueOfMarket?.legalEntityId;
        param.LegalEntity = valueOfMarket?.legalEntity;
        param.legalEntity = valueOfMarket?.legalEntity;
      }
    } else if (fieldName === 'marketName') {
      const valueOfMarket = marketData.find((x) => x.marketName === value);
      param.marketId = valueOfMarket?.marketId;
      param[fieldName] = valueOfMarket?.marketName;
      if (param.marketId !== 6 || param.marketId !== 7) {
        param.pmaTitleId = 0;
        param.pmaTitle = '';
      }
    } else if (fieldName === 'departmentName') {
      const valueOfDepartment = departmentData.find(
        (x) => x.departmentName === value
      );
      param.departmentId = (valueOfDepartment || {}).departmentId;
      param[fieldName] = (valueOfDepartment || {}).departmentName;
    } else if (fieldName === 'preferredName') {
      const valueOfEmployee = employeeData.find(
        (x) => x.employeeName === value
      );
      param.employeeId = 0;
      param[fieldName] = '';
      param.departmentId = 0;
      param.departmentName = '';
      param.overallMarketAllocationPercent = 0;
      param.overallPropertyAllocationPercent = 0;
      param.overallPropertyBillingPercent = 0;
      const existingPendingRecord = allocationData.find(
        (y) =>
          y.employeeId === (valueOfEmployee || {}).employeeId &&
          y.isAllocatedToLegalEntity === true &&
          y.allocationId !== param.allocationId &&
          y.marketId === (param || {}).marketId &&
          y.pmaTitleId === (param || {}).pmaTitleId
      );
      if (existingPendingRecord) {
        if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      } else {
        const existingPendingRecord = allocationData.find(
          (y) =>
            y.employeeId === (valueOfEmployee || {}).employeeId &&
            y.propertyId === param.propertyId &&
            y.allocationId !== param.allocationId &&
            y.marketId === (param || {}).marketId &&
            y.pmaTitleId === (param || {}).pmaTitleId
        );
        if (parseInt(param.marketId) === 6 || parseInt(param.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      }
      if (message === '') {
        param.employeeId = (valueOfEmployee || {}).employeeId;
        param[fieldName] = (valueOfEmployee || {}).employeeName;
        param.departmentId = (valueOfEmployee || {}).departmentId;
        param.departmentName = (valueOfEmployee || {}).departmentName;
        param.overallMarketAllocationPercent = (
          valueOfEmployee || {}
        ).overallMarketAllocationPercent;
        param.overallPropertyAllocationPercent = (
          valueOfEmployee || {}
        ).overallPropertyAllocationPercent;
        param.overallPropertyBillingPercent = (
          valueOfEmployee || {}
        ).overallPropertyBillingPercent;
        if (param.legalEntityAndPropertyData !== undefined) {
          param.legalEntityAndPropertyData?.forEach((x) => {
            x.employeeId = (valueOfEmployee || {}).employeeId;
            x.preferredName = (valueOfEmployee || {}).employeeName;
            x.departmentId = (valueOfEmployee || {}).departmentId;
            x.departmentName = (valueOfEmployee || {}).departmentName;
          });
        }
        if ((param.marketId?.toString() === '6' || param.marketId?.toString() === '7') && param.departmentId?.toString() === '16') {
          const valueOfPmaTitle = pmaTitleData.find((x) => x.pmaTitleId === 1);
          param.pmaTitleId = (valueOfPmaTitle || {}).pmaTitleId;
          param.pmaTitle = (valueOfPmaTitle || {}).pmaTitle;
          propertyAllocation.map(x => {
            if (x.key === 'pmaTitle') {
              x.disabled = true;
            }
            return x;
          });
        } else {
          propertyAllocation.map(x => {
            if (x.key === 'pmaTitle') {
              x.disabled = false;
            }
            return x;
          });
        }
      }
    } else if (fieldName === 'allocationStartDate') {
      param[fieldName] = value;
      param.billingStartDate = value;
    } else {
      if (fieldName === 'isReimbursed' && value === false) {
        param.propertyBillingPercent = 0.0;
        if (param.isAllocatedToLegalEntity) {
          (param.legalEntityAndPropertyData || []).map((x) => {
            x.propertyBillingPercent = 0.0;
            return x;
          });
        }
        const propertyAllocationObj = propertyAllocation.find(
          (x) => x.key === 'propertyAllocationPercent'
        );
        propertyAllocationObj.isInErrorState = false;
        propertyAllocationObj.errorMessage = '';
      } else if (fieldName === 'isReimbursed' && value === true) {
        param.additionalFixedAmount = 0;
        param.propertyBillingPercent = param.propertyAllocationPercent;
        param.legalEntityAndPropertyData = [
          ...this.setPropertyData(param.legalEntity, { ...param })
        ];
        const propertybillingObj = propertyAllocation.find(
          (x) => x.key === 'propertyBillingPercent'
        );
        propertybillingObj.isInErrorState = false;
        propertybillingObj.errorMessage = '';
        const propertyAllocationObj = propertyAllocation.find(
          (x) => x.key === 'propertyAllocationPercent'
        );
        propertyAllocationObj.isInErrorState = false;
        propertyAllocationObj.errorMessage = '';
      }
      param[fieldName] = value;
      if (param.isAllocatedToLegalEntity) {
        param.legalEntityAndPropertyData = [
          ...this.setPropertyData(
            param.legalEntity,
            { ...param },
            false,
            fieldName
          )
        ];
      }
    }
    if (message === '') {
      // New
      const selectedEditRowId = {
        key: 'allocationId',
        value: param.allocationId
      };
      param.allocationEmployeePropertyId =
        '' + param.allocationId + param.employeeId + param.propertyId;
      param.statusId = param.statusId === 0 ? 1 : param.statusId;
      param.cloudOrgId = param.cloudOrgId === undefined ? 1 : param.cloudOrgId;
      param.userEmail =
        param.userEmail === undefined
          ? (((store.getState() || {}).auth || {}).account || {}).username
          : param.userEmail;
      param.approvalStatusId = 3;
      const selectedField = propertyAllocation.find((x) => x.key === fieldName);
      if (value === 'Invalid date') {
        const allocationEndObj = propertyAllocation.find(
          (x) => x.key === fieldName
        );
        allocationEndObj.isVisible = true;
        isGridFormValid(value, allocationEndObj, param);
      } else {
        if (fieldName === 'allocationEndDate') {
          if (param.allocationType === 'Property') {
            const allocationEndObj = propertyAllocation.find(
              (x) => x.key === 'billingEndDate'
            );
            allocationEndObj.isVisible = true;
            if (value !== null && value !== undefined && value !== '') {
              if (param.billingEndDate === null) {
                allocationEndObj.isRequired = true;
                allocationEndObj.isInErrorState = true;
              } else {
                allocationEndObj.isRequired = false;
                allocationEndObj.isInErrorState = false;
              }
            } else {
              allocationEndObj.isRequired = false;
              allocationEndObj.isInErrorState = false;
            }
            isGridFormValid(param.billingEndDate, allocationEndObj, param);
          }
        } else if (fieldName === 'billingEndDate') {
          if (param.allocationType === 'Property') {
            const allocationEndObj = propertyAllocation.find(
              (x) => x.key === 'billingEndDate'
            );
            allocationEndObj.isVisible = true;
            if (
              param.allocationEndDate !== null &&
              param.allocationEndDate !== undefined &&
              param.allocationEndDate !== ''
            ) {
              if (value === null) {
                allocationEndObj.isRequired = true;
                allocationEndObj.isInErrorState = true;
              } else {
                allocationEndObj.isRequired = false;
                allocationEndObj.isInErrorState = false;
              }
            } else {
              allocationEndObj.isRequired = false;
              allocationEndObj.isInErrorState = false;
            }
            isGridFormValid(param.billingEndDate, allocationEndObj, param);
          }
        }
        isGridFormValid(
          value,
          propertyAllocation.find((x) => x.key === fieldName),
          param
        );
      }
      if (
        selectedField.dependentFieldValidation !== undefined &&
        selectedField.dependentFieldValidation.length > 0
      ) {
        selectedField.dependentFieldValidation.forEach((x) => {
          if (param[x] !== undefined && param[x] !== '' && param[x] !== null) {
            isGridFormValid(
              param[x],
              propertyAllocation.find((y) => y.key === x),
              param
            );
          }
        });
      }
      this.setState(
        {
          updateData: param,
          selectedEditRowId: selectedEditRowId,
          propertyAllocation,
          reloadAllocationTable: !this.state.reloadAllocationTable,
          allocationMessage: message
        },
        () => {
          this.forceUpdate();
        }
      );
    } else {
      this.setState(
        {
          updateData: param,
          allocationMessage: message
        },
        () => {
          this.forceUpdate();
        }
      );
      ShowToast(message, toastType.WARNING, 5000, 500);
      return null;
    }
  };

  // Handle text change event of textbox
  handleChangeOnText = (e, index, fieldName) => {
    const updateData = cloneDeep(this.state.updateData);
    const propertyAllocation = this.state.propertyAllocation;
    let value = e.target.value;
    if (fieldName === 'Flat Fee') {
      value = with2DecimalsPoints(value, 'Percent');
    } else {
      value = with2DecimalsPoints(value);
    }
    updateData.legalEntityAndPropertyData[index][e.target.name] = value; // e.target.value;

    if (
      parseFloat(
        updateData.legalEntityAndPropertyData[index][e.target.name]
      ) <= 0 ||
      updateData.legalEntityAndPropertyData[index][e.target.name] === 0.0
    ) {
      updateData.legalEntityAndPropertyData[index][
        e.target.name + 'IsInErrorState'
      ] = true;
      updateData.legalEntityAndPropertyData[index][
        e.target.name + 'ErrorMessage'
      ] =
        fieldName + ' should be greater than 0.';
    } else {
      updateData.legalEntityAndPropertyData[index][
        e.target.name + 'IsInErrorState'
      ] = false;
      updateData.legalEntityAndPropertyData[index][
        e.target.name + 'ErrorMessage'
      ] = '';
    }
    updateData[e.target.name] = updateData.legalEntityAndPropertyData.reduce(
      (total, obj) => (fieldName === 'Flat Fee'
        ? (Math.floor((parseFloat(obj[e.target.name]) + parseFloat(total)) * 100000) / 100000).toFixed(2)
        : (Math.floor((parseFloat(obj[e.target.name]) + parseFloat(total)) * 100000) / 100000).toFixed(4)),
      0
    );

    const selectedField = propertyAllocation.find(
      (x) => x.key === e.target.name
    );
    if (
      selectedField.dependentFieldValidation !== undefined &&
      selectedField.dependentFieldValidation.length > 0
    ) {
      selectedField.dependentFieldValidation.forEach((x) => {
        if (
          updateData[x] !== undefined &&
          updateData[x] !== '' &&
          updateData[x] !== null
        ) {
          isGridFormValid(
            updateData[x],
            propertyAllocation.find((y) => y.key === x),
            updateData
          );
        }
      });
    }
    isGridFormValid(
      updateData[e.target.name],
      propertyAllocation.find((x) => x.key === e.target.name),
      updateData
    );
    this.setState({
      updateData,
      propertyAllocation,
      reloadAllocationTable: !this.state.reloadAllocationTable
    });
  };

  // Render Dynamic form to show Legal Entity - Property wise splitted values of Allocation Percent, Billing Percent, Flat Fee etc
  renderDynamicForm = (controlList) => {
    if (controlList !== undefined) {
      return (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Property Name</TableCell>
              <TableCell>Property Allocation Percent</TableCell>
              {controlList.isReimbursed && (
                <TableCell>Property Billing Percent</TableCell>
              )}
              {controlList.isReimbursed && (
                <TableCell>Flat Fee</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {(controlList.legalEntityAndPropertyData || []).map((col, i) => (
              <TableRow key={'renderDynamicForm' + i}>
                <TableCell>{col.propertyName}</TableCell>
                <TableCell>
                  <TextField
                    margin="normal"
                    size="small"
                    type='number'
                    title=""
                    color="primary"
                    className="editable"
                    name="propertyAllocationPercent"
                    value={col.propertyAllocationPercent}
                    onChange={(e) => this.handleChangeOnText(e, i, 'Property Allocation Percent')}
                    error={col.propertyAllocationPercentIsInErrorState}
                    helperText={col.propertyAllocationPercentErrorMessage}
                  />
                </TableCell>
                {controlList.isReimbursed && (
                  <TableCell>
                    <TextField
                      margin="normal"
                      size="small"
                      type='number'
                      title=""
                      color="primary"
                      className="editable"
                      name="propertyBillingPercent"
                      value={
                        controlList.isReimbursed === true
                          ? col.propertyBillingPercent
                          : 0.0
                      }
                      onChange={(e) => this.handleChangeOnText(e, i, 'Property Billing Percent')}
                      disabled={controlList.isReimbursed !== true}
                      error={col.propertyBillingPercentIsInErrorState}
                      helperText={col.propertyBillingPercentErrorMessage}
                    />
                  </TableCell>
                )}
                {controlList.isReimbursed && (
                  <TableCell>
                    <TextField
                      margin="normal"
                      size="small"
                      type='number'
                      title=""
                      color="primary"
                      className="editable"
                      name="additionalFixedAmount"
                      value={
                        controlList.isReimbursed === true
                          ? col.additionalFixedAmount
                          : 0.0
                      }
                      onChange={(e) => this.handleChangeOnText(e, i, 'Flat Fee')}
                      disabled={controlList.isReimbursed !== true}
                      error={col.additionalFixedAmountIsInErrorState}
                      helperText={col.additionalFixedAmountErrorMessage}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    }
  };

  // Set details of Properties in legal entity like Allocation Percent, Billing Percent, Flat Fee etc
  setPropertyData = (
    value,
    updateDataValue,
    isSetValue = false,
    fieldName = ''
  ) => {
    const { propertyDetails, originalAllocationData } = this.state;
    const updateData = cloneDeep(updateDataValue);
    let propertyData = [];
    let isNewProperty = false;
    const dataValue = [];
    if (
      updateData.isAllocatedToLegalEntity &&
      value !== null &&
      value !== '' &&
      value !== undefined
    ) {
      propertyData = propertyDetails.filter(
        (x) => x.legalEntity?.toLowerCase() === value?.toLowerCase()
      );
      const propertyAllocationPercent =
        updateData.propertyAllocationPercent / propertyData.length;
      const propertyBillingPercent =
        updateData.propertyBillingPercent / propertyData.length;
      const additionalFixedAmount =
        updateData.additionalFixedAmount / propertyData.length;

      propertyData.forEach((data) => {
        updateData.propertyId = data.propertyId;
        updateData.propertyName = data.propertyName;
        const allocationRecord = originalAllocationData.find(
          (x) =>
            x.isAllocatedToLegalEntity &&
            x.employeeId === updateData.employeeId &&
            x.marketId === updateData.marketId &&
            x.propertyId === data.propertyId &&
            x.legalEntityId === updateData.legalEntityId &&
            x.pmaTitleId === updateData.pmaTitleId
        );
        if (
          fieldName === '' ||
          fieldName === 'legalEntity' ||
          fieldName === 'LegalEntity' ||
          fieldName === 'isAllocatedToLegalEntity'
        ) {
          updateData.propertyAllocationPercent = with2DecimalsPoints(parseFloat(propertyAllocationPercent));
          updateData.propertyBillingPercent = with2DecimalsPoints(parseFloat(propertyBillingPercent));
          updateData.additionalFixedAmount = with2DecimalsPoints(parseFloat(additionalFixedAmount), 'Percent');
        }
        if (
          fieldName === 'isReimbursed' ||
          fieldName === 'allocationEndDate' ||
          fieldName === 'billingEndDate' ||
          fieldName === 'billingStartDate'
        ) {
          if (updateData.legalEntityAndPropertyData !== undefined) {
            const d1 =
              updateData.legalEntityAndPropertyData.find(
                (x) =>
                  x.isAllocatedToLegalEntity &&
                  x.employeeId === updateData.employeeId &&
                  x.marketId === updateData.marketId &&
                  x.propertyId === data.propertyId &&
                  x.legalEntityId === updateData.legalEntityId &&
                  x.pmaTitleId === updateData.pmaTitleId
              ) || {};
            updateData.propertyBillingPercent =
              d1.propertyBillingPercent !== undefined
                ? with2DecimalsPoints(parseFloat(d1.propertyBillingPercent))
                : 0;
            updateData.additionalFixedAmount =
              d1.additionalFixedAmount !== undefined
                ? with2DecimalsPoints(parseFloat(d1.additionalFixedAmount), 'Percent')
                : 0;
            updateData.propertyAllocationPercent =
              d1.propertyAllocationPercent !== undefined
                ? with2DecimalsPoints((d1.propertyAllocationPercent))
                : 0;
          }
        } else if (fieldName === 'propertyAllocationPercent') {
          updateData.propertyAllocationPercent = with2DecimalsPoints(parseFloat(
            propertyAllocationPercent));
          if (updateData.legalEntityAndPropertyData !== undefined) {
            const d1 =
              updateData.legalEntityAndPropertyData.find(
                (x) =>
                  x.isAllocatedToLegalEntity &&
                  x.employeeId === updateData.employeeId &&
                  x.marketId === updateData.marketId &&
                  x.propertyId === data.propertyId &&
                  x.legalEntityId === updateData.legalEntityId &&
                  x.pmaTitleId === updateData.pmaTitleId
              ) || {};
            updateData.propertyBillingPercent =
              d1.propertyBillingPercent !== undefined
                ? with2DecimalsPoints(parseFloat(d1.propertyBillingPercent))
                : 0;
            updateData.additionalFixedAmount =
              d1.additionalFixedAmount !== undefined
                ? with2DecimalsPoints(parseFloat(d1.additionalFixedAmount), 'Percent')
                : 0;
          }
        } else if (fieldName === 'propertyBillingPercent') {
          updateData.propertyBillingPercent = with2DecimalsPoints(parseFloat(propertyBillingPercent));
          if (updateData.legalEntityAndPropertyData !== undefined) {
            const d1 =
              updateData.legalEntityAndPropertyData.find(
                (x) =>
                  x.isAllocatedToLegalEntity &&
                  x.employeeId === updateData.employeeId &&
                  x.marketId === updateData.marketId &&
                  x.propertyId === data.propertyId &&
                  x.legalEntityId === updateData.legalEntityId &&
                  x.pmaTitleId === updateData.pmaTitleId
              ) || {};
            updateData.propertyAllocationPercent =
              d1.propertyAllocationPercent !== undefined
                ? with2DecimalsPoints(parseFloat(d1.propertyAllocationPercent))
                : 0;
            updateData.additionalFixedAmount =
              d1.additionalFixedAmount !== undefined
                ? with2DecimalsPoints(parseFloat(d1.additionalFixedAmount), 'Percent')
                : 0;
          }
        } else if (fieldName === 'additionalFixedAmount') {
          updateData.additionalFixedAmount = with2DecimalsPoints(parseFloat(additionalFixedAmount), 'Percent');
          if (updateData.legalEntityAndPropertyData !== undefined) {
            const d1 =
              updateData.legalEntityAndPropertyData.find(
                (x) =>
                  x.isAllocatedToLegalEntity &&
                  x.employeeId === updateData.employeeId &&
                  x.marketId === updateData.marketId &&
                  x.propertyId === data.propertyId &&
                  x.legalEntityId === updateData.legalEntityId &&
                  x.pmaTitleId === updateData.pmaTitleId
              ) || {};
            updateData.propertyBillingPercent =
              d1.propertyBillingPercent !== undefined
                ? with2DecimalsPoints(parseFloat(d1.propertyBillingPercent))
                : 0;
            updateData.propertyAllocationPercent =
              d1.propertyAllocationPercent !== undefined
                ? with2DecimalsPoints(parseFloat(d1.propertyAllocationPercent))
                : 0;
          }
        }
        updateData.allocationId =
          allocationRecord !== undefined
            ? allocationRecord.allocationId
            : propertyData.length === 1
              ? updateData.allocationId
              : 0;
        updateData.approvalId =
          allocationRecord !== undefined
            ? allocationRecord.approvalId
            : ApprovedStatus.PendingApproval;
        if (isSetValue) {
          let propertyAllocationPercent1 = with2DecimalsPoints(propertyAllocationPercent);
          let propertyBillingPercent1 = with2DecimalsPoints(propertyBillingPercent);
          let additionalFixedAmount1 = with2DecimalsPoints(additionalFixedAmount, 'Percent');

          if (allocationRecord === undefined) {
            const allocationRecord1 = originalAllocationData.find(
              (x) =>
                x.isAllocatedToLegalEntity &&
                x.employeeId === updateData.employeeId &&
                x.marketId === updateData.marketId &&
                x.legalEntityId === data.legalEntityId &&
                x.pmaTitleId === updateData.pmaTitleId
            );
            if (
              allocationRecord1 !== undefined &&
              allocationRecord1.legalEntityAndPropertyData !== undefined
            ) {
              const data1 =
                allocationRecord1.legalEntityAndPropertyData.find(
                  (x) =>
                    x.isAllocatedToLegalEntity &&
                    x.employeeId === allocationRecord1.employeeId &&
                    x.marketId === allocationRecord1.marketId &&
                    x.propertyId === data.propertyId &&
                    x.legalEntityId === data.legalEntityId &&
                    x.pmaTitleId === allocationRecord1.pmaTitleId
                ) || {};
              propertyAllocationPercent1 =
                data1.propertyAllocationPercent !== undefined
                  ? with2DecimalsPoints(parseFloat(data1.propertyAllocationPercent))
                  : 0;
              propertyBillingPercent1 =
                data1.propertyBillingPercent !== undefined
                  ? with2DecimalsPoints(parseFloat(data1.propertyBillingPercent))
                  : 0;
              additionalFixedAmount1 =
                data1.additionalFixedAmount !== undefined
                  ? with2DecimalsPoints(parseFloat(data1.additionalFixedAmount), 'Percent')
                  : 0;
            }
          }
          if (allocationRecord !== undefined) {
            if (allocationRecord.legalEntityAndPropertyData === undefined) {
              updateData.propertyAllocationPercent = with2DecimalsPoints(parseFloat(allocationRecord.propertyAllocationPercent));
              updateData.propertyBillingPercent = with2DecimalsPoints(parseFloat(allocationRecord.propertyBillingPercent));
              updateData.additionalFixedAmount = with2DecimalsPoints(parseFloat(allocationRecord.additionalFixedAmount), 'Percent');
              isNewProperty = true;
            } else {
              const data2 = allocationRecord.legalEntityAndPropertyData.find(
                (x) =>
                  x.isAllocatedToLegalEntity &&
                  x.employeeId === allocationRecord.employeeId &&
                  x.marketId === allocationRecord.marketId &&
                  x.propertyId === data.propertyId &&
                  x.legalEntityId === data.legalEntityId &&
                  x.pmaTitleId === allocationRecord.pmaTitleId
              );
              updateData.propertyAllocationPercent =
                isNewProperty === false
                  ? data2?.propertyAllocationPercent !== undefined
                    ? with2DecimalsPoints(parseFloat(data2.propertyAllocationPercent))
                    : 0
                  : 0;
              updateData.propertyBillingPercent =
                isNewProperty === false
                  ? data2?.propertyBillingPercent !== undefined
                    ? with2DecimalsPoints(parseFloat(data2.propertyBillingPercent))
                    : 0
                  : 0;
              updateData.additionalFixedAmount =
                isNewProperty === false
                  ? data2?.additionalFixedAmount !== undefined
                    ? with2DecimalsPoints(parseFloat(data2.additionalFixedAmount), 'Percent')
                    : 0
                  : 0;
            }
          } else {
            updateData.propertyAllocationPercent = isNewProperty
              ? 0
              : data.allocationId > 0
                ? 0
                : propertyAllocationPercent1;
            updateData.propertyBillingPercent = isNewProperty
              ? 0
              : data.allocationId > 0
                ? 0
                : propertyBillingPercent1;
            updateData.additionalFixedAmount = isNewProperty
              ? 0
              : data.allocationId > 0
                ? 0
                : additionalFixedAmount1;
          }
        }
        dataValue.push({ ...updateData });
      });
    }
    dataValue.forEach((x) => {
      x.legalEntityAndPropertyData = undefined;
    });
    return dataValue;
  };

  EditRecord = (cellInfo, mode = 'Edit') => {
    const propertyAllocation = cloneDeep(propertyAllocationList);
    const assignmentStartDate = getSectionAttributeValueByKey(
      this.state.transitionData,
      'AssignmentStartDate'
    );

    propertyAllocation.forEach((x) => {
      if (
        cellInfo.allocationType === 'Property' &&
        (x.key === 'marketName')
      ) {
        x.disabled = true;
      }
      if (cellInfo.allocationType === 'Property' && cellInfo.isAllocatedToLegalEntity === true && (x.key === 'isAllocatedToLegalEntity' || x.key === 'propertyName' || x.key === 'legalEntity')) {
        x.disabled = true;
      }
      if (x.key === 'allocationStartDate') {
        // x.minDate = getCurrentPayCycleStartDate(); // moment().format('YYYY/MM/DD');//
        x.minDate = assignmentStartDate; // moment().format('YYYY/MM/DD');//
      }
      if (
        x.key === 'allocationEndDate' ||
        x.key === 'billingStartDate' ||
        x.key === 'billingEndDate'
      ) {
        // x.minDate = getCurrentPayCycleStartDate(); // moment().format('YYYY/MM/DD');// getCurrentPayCycleStartDate();
        x.minDate = assignmentStartDate;
      }
      if (x.key === 'allocationEndDate' || x.key === 'billingEndDate') {
        const endate = getSectionAttributeValueByKey(
          this.state.transitionData,
          'AssignmentEndDate',
          true
        );
        if (endate && endate !== '') {
          x.maxDate = getSectionAttributeValueByKey(
            this.state.transitionData,
            'AssignmentEndDate'
          );
        } else {
          x.maxDate = undefined;
        }
      }
      if (x.key === 'approvedBy') {
        if (cellInfo.approvalId === ApprovedStatus.RequestedChanges) {
          x.name = 'Changes Suggested By';
        } else {
          x.name = 'Approved By';
        }
      }
      if (x.key === 'approvedOn') {
        if (cellInfo.approvalId === ApprovedStatus.RequestedChanges) {
          x.name = 'Changes Suggested On';
        } else {
          x.name = 'Approved On';
        }
      }
    });
    if (
      cellInfo.allocationEndDate === undefined ||
      cellInfo.allocationEndDate === '' ||
      cellInfo.allocationEndDate === '0001-01-01T00:00:00' ||
      cellInfo.allocationEndDate === '0001-01-01' ||
      moment(cellInfo.allocationEndDate).isValid() === false
    ) {
      cellInfo.allocationEndDate = null;
    }
    if (
      cellInfo.billingEndDate === undefined ||
      cellInfo.billingEndDate === '' ||
      cellInfo.billingEndDate === '0001-01-01T00:00:00' ||
      cellInfo.billingEndDate === '0001-01-01' ||
      moment(cellInfo.billingEndDate).isValid() === false
    ) {
      cellInfo.billingEndDate = null;
    }
    cellInfo.legalEntityAndPropertyData = [
      ...this.setPropertyData(cellInfo.legalEntity, { ...cellInfo }, true)
    ];

    cellInfo.propertyAllocationPercent = cellInfo.isAllocatedToLegalEntity
      ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce(
        (total, obj) =>
          parseFloat(obj.propertyAllocationPercent) + parseFloat(total),
        0
      )) * 100000) / 100000).toFixed(4)
      : cellInfo.propertyAllocationPercent;
    cellInfo.propertyBillingPercent = cellInfo.isAllocatedToLegalEntity
      ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce(
        (total1, obj) =>
          parseFloat(obj.propertyBillingPercent) + parseFloat(total1),
        0
      )) * 100000) / 100000).toFixed(4)
      : cellInfo.propertyBillingPercent;
    cellInfo.additionalFixedAmount = cellInfo.isAllocatedToLegalEntity
      ? (Math.floor((cellInfo.legalEntityAndPropertyData.reduce(
        (total1, obj) =>
          parseFloat(obj.additionalFixedAmount) + parseFloat(total1),
        0
      )) * 100000) / 100000).toFixed(2)
      : cellInfo.additionalFixedAmount;
    let filteredAllocationData = [];
    if (
      cellInfo.isAllocatedToLegalEntity &&
      cellInfo.legalEntityAndPropertyData !== undefined &&
      cellInfo.legalEntityAndPropertyData.length > 0
    ) {
      if (cellInfo.allocationId > 0) {
        filteredAllocationData = this.state.allocationData;
        const allocationIds = (
          cellInfo.legalEntityAndPropertyData.filter(
            (x) => x.allocationId !== cellInfo.allocationId
          ) || []
        ).map((x) => x.allocationId);
        allocationIds.forEach((x) => {
          filteredAllocationData = filteredAllocationData.filter(
            (y) => y.allocationId !== x
          );
        });
      } else {
        filteredAllocationData = this.state.allocationData;
      }
    } else {
      filteredAllocationData = this.state.allocationData;
    }
    cellInfo.allocationEmployeePropertyId =
      '' + cellInfo.allocationId + cellInfo.employeeId + cellInfo.propertyId;
    const selectedEditRowId = {
      key: 'allocationId',
      value: cellInfo.allocationId,
      mode: mode
    };
    this.setState({
      isEditableMode: true,
      allocationData: filteredAllocationData,
      // selectedEditRowId: {
      //   key: 'allocationEmployeePropertyId',
      //   value: '' + cellInfo.allocationId + cellInfo.employeeId + cellInfo.propertyId,
      //   mode: mode
      // },
      reloadAllocationTable: !this.state.reloadAllocationTable,
      selectedEditRowId,
      isInAddMode: false,
      updateData: cloneDeep(cellInfo),
      propertyAllocation,
      retloadPtf: !this.state.reloadPtf
    });
  };

  renderAllocationActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.allocationId === this.state.selectedEditRowId.value
          ? (
            <>
              {
                <Tooltip title="Save Record">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => { }}
                  >
                    <SaveIcon
                      fontSize="small"
                      size="small"
                      onClick={this.SaveNewRecord}
                    />
                  </IconButton>
                </Tooltip>
              }
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.cancelChanges}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : (
            <>
              {this.isEditIconVisible(cellInfo) && (cellInfo.approvalStatusId || '').toString() !== '4' && (
                <Tooltip title="Edit Record">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => {
                      if (
                        this.state.isInAddMode === true ||
                        this.state.selectedEditRowId !== undefined
                      ) {
                        ShowToast(
                          'You can add/Edit one row at a time!',
                          toastType.WARNING,
                          5000,
                          500
                        );
                        return false;
                      } else {
                        this.EditRecord(cellInfo);
                      }
                    }}
                  >
                    <EditIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>
              )}
              {this.isDeleteIconVisible(cellInfo)
                ? (
                  <Tooltip title="Delete Record">
                    <IconButton
                      aria-label={'refreshData'}
                      size="small"
                      onClick={() => {
                        this.DeleteRecord(cellInfo);
                      }}
                    >
                      <DeleteIcon fontSize="small" size="small" />
                    </IconButton>
                  </Tooltip>
                )
                : (
                  ''
                )}
            </>
          )}
      </>
    );
  };

  DeleteRecord = (cellInfo) => {
    const { allocationData, deleteAllocation } = this.state;
    let filterAllocation = allocationData;

    if (cellInfo.allocationId > 0) {
      const params = {
        allocationId: cellInfo.allocationId,
        allocationType: cellInfo.allocationType,
        marketName: cellInfo.marketName,
        propertyName: cellInfo.propertyName,
        departmentId: cellInfo.departmentId,
        serviceTypeId: cellInfo.serviceTypeId,
        marketId: cellInfo.marketId,
        pmaTitleId: cellInfo.pmaTitleId
      };
      deleteAllocation.push(params);
      filterAllocation =
        allocationData.filter(
          (x) => !(x.allocationId === cellInfo.allocationId)
        ) || [];
    } else {
      filterAllocation =
        allocationData.filter(
          (x) =>
            !(
              x.employeeId === cellInfo.employeeId &&
              x.legalEntityId === cellInfo.legalEntityId &&
              x.propertyId === cellInfo.propertyId &&
              x.marketId === cellInfo.marketId &&
              x.pmaTitleId === cellInfo.pmaTitleId
            )
        ) || [];
    }
    // const allocationIds = (allocationData.filter(x => x.employeeId === cellInfo.employeeId && x.legalEntityId === cellInfo.legalEntityId &&
    //   x.propertyId === cellInfo.propertyId && x.marketId === cellInfo.marketId) || []).map(x => x.allocationId);
    this.setState({
      allocationData: filterAllocation,
      deleteAllocation: deleteAllocation,
      reloadAllocationTable: !this.state.reloadAllocationTable
    });
  };

  DeleteManagementFeeRecord = (cellInfo) => {
    const { managementFeeData } = this.state;
    const updatedManagementFeeData = managementFeeData.filter(
      (x) => x.recordId !== cellInfo.recordId
    );
    this.setState({
      managementFeeData: updatedManagementFeeData,
      isChangesInManagementFee: true
    });
  };

  DeleteExpenseRecord = (cellInfo) => {
    const { expenseData } = this.state;
    const updatedExpenseData = expenseData.filter(
      (x) => x.recordId !== cellInfo.recordId
    );
    this.setState({
      expenseData: updatedExpenseData
    });
  };

  // Delete Engineer Hour Billing Record
  DeleteEngineerHourBillingRecord = (cellInfo) => {
    const { engineerHourBillingData } = this.state;
    const updatedEnineerHourBillingData = engineerHourBillingData.filter(
      (x) => x.recordId !== cellInfo.recordId
    );
    this.setState({
      engineerHourBillingData: updatedEnineerHourBillingData
    });
  }

  DeleteClientContactRecord = (cellInfo) => {
    const { clientContactMainData, CIOClientContacts, selectedOriginalTransitionTypeId, selectedTransitionTypeId } = this.state;
    if ((selectedOriginalTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) || (selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP)) {
      const unChangedData = CIOClientContacts.filter(x => x.recordId == 0 || x.recordId != cellInfo.recordId);
      this.setState({
        CIOClientContacts: unChangedData
      });
      ShowToast(
        'Record Deleted Successfully',
        toastType.SUCCESS,
        5000,
        500
      );
    } else {
      const data = clientContactMainData;
      const unChangedData = data.filter(x => x.recordId != cellInfo.recordId || x.recordId == '0');
      ShowToast(
        'Record Deleted Successfully',
        toastType.SUCCESS,
        5000,
        500
      );
      this.setState({
        clientContactMainData: unChangedData
      });
    }
  };

  AddNewRecord = (SelectedRecord) => {
    if (
      this.state.isInAddMode === true ||
      this.state.selectedEditRowId !== undefined
    ) {
      ShowToast(
        'You can add/Edit one row at a time!',
        toastType.WARNING,
        5000,
        500
      );
      return false;
    } else {
      const { transitionData, allocationData } = this.state;
      const propertyAllocation = cloneDeep(propertyAllocationList);
      let propertyData = cloneDeep(this.state.propertyDetails);
      propertyData = propertyData.filter(x => x.marketId?.toString() === getSectionAttributeValueByKey(this.state.transitionData, 'MarketId')?.toString());
      const assignmentStartDate = getSectionAttributeValueByKey(
        transitionData,
        'AssignmentStartDate'
      );
      const rowNew = {
        allocationEmployeePropertyId:
          '' +
          0 +
          ((SelectedRecord || [])[0] || {}).employeeId +
          ((propertyData || [])[0] || {}).propertyId,
        allocationId: ((allocationData || []).length + 1) * -1,
        employeeId: ((SelectedRecord || [])[0] || {}).employeeId,
        preferredName: ((SelectedRecord || [])[0] || {}).employeeName,
        departmentId: 0,
        departmentName: '',
        pmaTitleId: 0,
        pmaTitle: '',
        marketId: ((propertyData || [])[0] || {}).marketId,
        marketName: ((propertyData || [])[0] || {}).marketName,
        allocationType: 'Property',
        propertyId: ((propertyData || [])[0] || {}).propertyId,
        propertyName: ((propertyData || [])[0] || {})
          .propertyName,
        propertyTypeId: ((propertyData || [])[0] || {})
          .propertyTypeId,
        propertyTypeName: ((propertyData || [])[0] || {})
          .propertyTypeName,
        // allocationStartDate: getSectionAttributeValueByKey(
        //   transitionData,
        //   'AssignmentStartDate'
        // ),
        // allocationStartDate: (moment(assignmentStartDate).format('YYYY/MM/DD') < moment(currentPaycycleStartDate).format('YYYY/MM/DD')) ? currentPaycycleStartDate : assignmentStartDate,
        // allocationStartDate: (moment(assignmentStartDate).format('YYYY/MM/DD') < moment().format('YYYY/MM/DD')) ? moment().format('YYYY/MM/DD') : assignmentStartDate,
        allocationStartDate: assignmentStartDate,
        allocationEndDate: getSectionAttributeValueByKey(
          transitionData,
          'AssignmentEndDate'
        ),
        // billingStartDate: (moment(assignmentStartDate).format('YYYY/MM/DD') < moment(currentPaycycleStartDate).format('YYYY/MM/DD')) ? currentPaycycleStartDate : assignmentStartDate,
        // billingStartDate: (moment(assignmentStartDate).format('YYYY/MM/DD') < moment().format('YYYY/MM/DD')) ? moment().format('YYYY/MM/DD') : assignmentStartDate,
        billingStartDate: assignmentStartDate,
        billingEndDate: null,
        marketAllocationPercent: 0,
        marketBillingPercent: 0,
        propertyAllocationPercent: 0,
        propertyBillingPercent: 0,
        overallMarketAllocationPercent: 0,
        overallMarketBillingPercent: 0,
        overallPropertyAllocationPercent: 0,
        overallPropertyBillingPercent: 0,
        additionalFixedAmount: 0,
        rateValue: 0,
        isReimbursed: false,
        isApproved: false,
        statusId: 0,
        statusName: null,
        legalEntityId: ((propertyData || [])[0] || {})
          .legalEntityId,
        legalEntity: ((propertyData || [])[0] || {}).legalEntity,
        LegalEntity: ((propertyData || [])[0] || {}).legalEntity,
        isAllocatedToLegalEntity: false,
        approvalStatusId: 3,
        isEditableMode: true
      };
      propertyAllocation.forEach((x) => {
        if (x.key === 'allocationStartDate') {
          // x.minDate = getSectionAttributeValueByKey(
          //   transitionData,
          //   'AssignmentStartDate'
          // );
          // x.minDate = getCurrentPayCycleStartDate(); // moment().format('YYYY/MM/DD');//
          x.minDate = assignmentStartDate;
        }
        if (
          x.key === 'allocationEndDate' ||
          x.key === 'billingStartDate' ||
          x.key === 'billingEndDate'
        ) {
          // x.minDate = getCurrentPayCycleStartDate(); // moment().format('YYYY/MM/DD');//
          x.minDate = assignmentStartDate;
        }
        if (x.key === 'allocationEndDate' || x.key === 'billingEndDate') {
          const endate = getSectionAttributeValueByKey(
            this.state.transitionData,
            'AssignmentEndDate',
            true
          );
          if (endate && endate !== '') {
            x.isRequired = true;
            x.isVisible = true;
            x.maxDate = getSectionAttributeValueByKey(
              this.state.transitionData,
              'AssignmentEndDate'
            );
          } else {
            x.isRequired = false;
            x.isVisible = false;
            x.maxDate = undefined;
          }
        }
      });

      //  selectedEditRowId: {
      //     key: 'allocationEmployeePropertyId',
      //     value: '' + 0 + ((SelectedRecord || [])[0] || {}).employeeId + ((propertyData || [])[0] || {}).propertyId
      // }

      this.setState({
        isInAddMode: true,
        selectedEditRowId: {
          key: 'allocationId',
          value: rowNew.allocationId
        },
        updateData: rowNew,
        propertyAllocation,
        isEditableMode: true,
        reloadAllocationTable: !this.state.reloadAllocationTable
      });
      this.forceUpdate();
    }
  };

  isValidForm = () => {
    let IsValid = true;
    const { updateData, propertyAllocation } = this.state;
    propertyAllocation.forEach((ele) => {
      if (ele.key === 'billingEndDate') {
        if (
          updateData.allocationEndDate !== null &&
          updateData.allocationEndDate !== undefined &&
          updateData.allocationEndDate !== '' &&
          (updateData[ele.key] === null ||
            updateData[ele.key] === '' ||
            updateData[ele.key] === undefined)
        ) {
          ele.isRequired = true;
          ele.isVisible = true;
        } else {
          ele.isRequired = false;
          ele.errorMessage = '';
          ele.isVisible = false;
        }
      }
      if (ele.key === 'propertyBillingPercent') {
        if (
          updateData.isReimbursed === true && updateData.additionalFixedAmount !== null && updateData.additionalFixedAmount !== undefined && parseFloat(updateData.additionalFixedAmount) <= 0
        ) {
          ele.isRequired = true;
          ele.isVisible = true;
        } else {
          ele.isRequired = false;
          ele.errorMessage = '';
          ele.isVisible = false;
        }
      }
      if (ele.key === 'pmaTitle') {
        if (
          updateData.marketId === 6 ||
          updateData.marketId === 7
        ) {
          ele.isRequired = true;
          ele.isVisible = true;
        } else {
          ele.isRequired = false;
          ele.errorMessage = '';
          ele.isVisible = false;
        }
      }
      if (ele.key === 'allocationEndDate' || ele.key === 'billingEndDate') {
        const endate = getSectionAttributeValueByKey(
          this.state.transitionData,
          'AssignmentEndDate',
          true
        );
        if (endate && endate !== '') {
          ele.isRequired = true;
          ele.isVisible = true;
          ele.maxDate = getSectionAttributeValueByKey(
            this.state.transitionData,
            'AssignmentEndDate'
          );
        } else {
          ele.isRequired = false;
          ele.isVisible = false;
          ele.maxDate = undefined;
        }
      }
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    if (
      updateData.isAllocatedToLegalEntity &&
      updateData.legalEntityAndPropertyData.length > 0
    ) {
      updateData.legalEntityAndPropertyData.forEach((form) => {
        if (
          parseFloat(form.propertyAllocationPercent) <= 0 ||
          form.propertyAllocationPercent === 0.0
        ) {
          form.propertyAllocationPercentIsInErrorState = true;
          form.propertyAllocationPercentErrorMessage =
            'Property Allocation Percent should be greater than 0.';
          IsValid = false;
        } else {
          form.propertyAllocationPercentIsInErrorState = false;
          form.propertyAllocationPercentErrorMessage = '';
        }
        if (updateData.isReimbursed && updateData.propertyBillingPercent > 0 && (parseFloat(updateData.additionalFixedAmount) === 0 || updateData.additionalFixedAmount === 0 || updateData.additionalFixedAmount === null ||
          updateData.additionalFixedAmount === undefined || updateData.additionalFixedAmount === '') &&
          (parseFloat(form.propertyBillingPercent) <= 0 || form.propertyBillingPercent === 0.00)) {
          form.propertyBillingPercentIsInErrorState = true;
          form.propertyBillingPercentErrorMessage = 'Property Billing Percent should be greater than 0.';
          IsValid = false;
        } else if (updateData.isReimbursed && updateData.additionalFixedAmount > 0 && (parseFloat(updateData.propertyBillingPercent) === 0 ||
          updateData.propertyBillingPercent === 0 || updateData.propertyBillingPercent === null || updateData.propertyBillingPercent === undefined ||
          updateData.propertyBillingPercent === '') &&
          (parseFloat(form.additionalFixedAmount) <= 0 || form.additionalFixedAmount === 0.00)) {
          form.additionalFixedAmountIsInErrorState = true;
          form.additionalFixedAmountErrorMessage = 'Flat fee should be greater than 0.';
          IsValid = false;
        } else {
          form.propertyBillingPercentIsInErrorState = false;
          form.propertyBillingPercentErrorMessage = '';
          form.additionalFixedAmountIsInErrorState = false;
          form.additionalFixedAmountErrorMessage = '';
        }
      });
    }
    this.setState({ propertyAllocation, updateData }, this.forceUpdate());
    return IsValid;
  };

  validateForm = () => {
    const { updateData, propertyDetails } = this.state;
    let employeeMaster = this.props.employeeTypeMasterData || [];

    const serviceType = (
      getSectionAttributeValueByKey(this.state.transitionData, 'ServiceType') ||
      ''
    ).split('|');
    employeeMaster = (this.state.employeesForAllocationMasterData || []).filter(
      (x) =>
        serviceType.find((y) => y === x.serviceType) ||
        (x.serviceType || '')
          .split('|')
          .find((z) => serviceType.find((yy) => yy === z))
    );
    let empDataForAllocation = cloneDeep(employeeMaster);
    const serviceTypeList = GetReadOnlyServiceType();

    empDataForAllocation = empDataForAllocation.filter(y => serviceTypeList.find(x => x.serviceTypeId.toString() === y.serviceTypeId.toString()) === undefined);

    empDataForAllocation = (empDataForAllocation || []).filter((x) => x.employeeStatus === true);
    empDataForAllocation = empDataForAllocation.filter((x) =>
    ((x.marketId)?.toString() === (updateData.marketId || '').toString() ||
      (x.otherMarketId !== null && (x.otherMarketId || '').split('|').indexOf((updateData.marketId || '').toString()) !== -1) ||
      (x.serviceTypeId?.toString() === '3')
    ));
    if (propertyDetails.filter(x => x.marketId?.toString() === updateData.marketId?.toString())?.length > 0 && parseInt(updateData.marketId) !== parseInt(((propertyDetails.filter(x => x.marketId?.toString() === updateData.marketId?.toString()) || [])[0] || {}).marketId)) {
      ShowToast('Selected Market is not valid in employee allocation.', toastType.ERROR, 5000, 500);
      return false;
    } else if (propertyDetails.filter(x => x.marketId?.toString() === updateData.marketId?.toString())?.length > 0 && empDataForAllocation.find(x => parseInt(x.employeeId) === parseInt(updateData.employeeId)) === undefined) {
      ShowToast('Selected Employee is not valid in employee allocation.', toastType.ERROR, 5000, 500);
      return false;
    } else if (propertyDetails.filter(x => x.marketId?.toString() === updateData.marketId?.toString())?.length <= 0 && propertyDetails.filter(x => x.marketId?.toString() === updateData.marketId?.toString()).find(x => parseInt(x.propertyId) === parseInt(updateData.propertyId)) === undefined) {
      ShowToast('Selected Property is not valid in employee allocation.', toastType.ERROR, 5000, 500);
      return false;
    } else if (
      updateData.isReimbursed &&
      ((updateData.propertyBillingPercent !== null &&
        parseFloat(updateData.propertyBillingPercent) === 0 &&
        updateData.additionalFixedAmount !== null &&
        parseFloat(updateData.additionalFixedAmount) === 0) ||
        (updateData.propertyBillingPercent !== null &&
          parseFloat(updateData.propertyBillingPercent) > 0 &&
          updateData.additionalFixedAmount !== null &&
          parseFloat(updateData.additionalFixedAmount) > 0))
    ) {
      const msg =
        'You can enter either Flat fee Amount or Property Billing Percent';
      ShowToast(msg, toastType.ERROR, 5000, 500);
      return false;
    }
    return true;
  };

  SaveNewRecord = () => {
    if (!this.isValidForm() || !this.validateForm()) {
      return false;
    }
    if (this.state.allocationMessage !== '') {
      ShowToast(this.state.allocationMessage, toastType.WARNING, 5000, 500);
      return false;
    }
    const params = this.state.updateData;
    params.allocationEmployeePropertyId =
      '' + params.allocationId + params.employeeId + params.propertyId;
    params.allocationStartDate = moment(params.allocationStartDate).format(
      'YYYY/MM/DD'
    );

    params.allocationEndDate =
      params.allocationEndDate &&
        params.allocationEndDate.length > 1 &&
        moment(params.allocationEndDate).isValid() === true &&
        params.allocationEndDate !== '0001-01-01T00:00:00' &&
        params.allocationEndDate !== '0001-01-01'
        ? moment(params.allocationEndDate).format('YYYY/MM/DD')
        : null;

    params.billingStartDate = moment(params.billingStartDate).format(
      'YYYY/MM/DD'
    );

    params.billingEndDate =
      params.billingEndDate &&
        params.billingEndDate.length > 1 &&
        moment(params.billingEndDate).isValid() === true &&
        params.billingEndDate !== '0001-01-01T00:00:00' &&
        params.billingEndDate !== '0001-01-01'
        ? moment(params.billingEndDate).format('YYYY/MM/DD')
        : null;

    params.approvalStatusId =
      this.props.selectedTransitionId > 0
        ? getSectionAttributeValueByKey(this.state.transitionData, 'approvalId')
        : params.allocationId > 0
          ? params.approvalStatusId
          : ApprovedStatus.Draft;

    params.approvalStatus =
      this.props.selectedTransitionId > 0
        ? getSectionAttributeValueByKey(
          this.state.transitionData,
          'approvalStatus'
        )
        : params.allocationId > 0
          ? params.approvalStatus
          : 'Draft';
    let allocationDataToStore = [...this.state.allocationData];
    let message = '';
    if (this.state.isInAddMode === true) {
      let existingPendingRecord;

      if (params.isAllocatedToLegalEntity) {
        existingPendingRecord = allocationDataToStore.find(
          (y) =>
            y.employeeId === params.employeeId &&
            y.legalEntityId === params.legalEntityId &&
            y.allocationId !== params.allocationId &&
            y.marketId === (params || {}).marketId &&
            y.pmaTitleId === (params || {}).pmaTitleId
        );
        if (parseInt(params.marketId) === 6 || parseInt(params.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Legal Entity: ' +
              (existingPendingRecord || {}).legalEntity +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      } else {
        existingPendingRecord = allocationDataToStore.find(
          (y) =>
            y.employeeId === params.employeeId &&
            y.propertyId === params.propertyId &&
            y.allocationId !== params.allocationId &&
            y.marketId === (params || {}).marketId &&
            y.pmaTitleId === (params || {}).pmaTitleId
        );
        if (parseInt(params.marketId) === 6 || parseInt(params.marketId) === 7) {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              ' and PMA Title: ' +
              (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        } else {
          message =
            existingPendingRecord !== undefined
              ? 'Employee: ' +
              (existingPendingRecord || {}).preferredName +
              ' already allocated to the same Property: ' +
              (existingPendingRecord || {}).propertyName +
              // ' and PMA Title: ' +
              // (existingPendingRecord || {}).pmaTitle +
              '. If you want to update any information please edit that particular record.'
              : '';
        }
      }
      if (message !== '') {
        ShowToast(message, toastType.WARNING, 5000, 500);
        return null;
      } else {
        if (
          params !== undefined &&
          params.isAllocatedToLegalEntity &&
          params.legalEntityAndPropertyData !== undefined &&
          params.legalEntityAndPropertyData.length > 0
        ) {
          const propertyWiseAllocationPercent =
            with2DecimalsPoints(params.legalEntityAndPropertyData.reduce(
              (total, obj) =>
                parseFloat(obj.propertyAllocationPercent) + parseFloat(total),
              0
            ));
          const propertyWiseBillingPercent =
            with2DecimalsPoints(params.legalEntityAndPropertyData.reduce(
              (total, obj) =>
                parseFloat(obj.propertyBillingPercent) + parseFloat(total),
              0
            ));
          const additionalFixedAmount =
            with2DecimalsPoints(params.legalEntityAndPropertyData.reduce(
              (total, obj) =>
                parseFloat(obj.additionalFixedAmount) + parseFloat(total),
              0
            ));

          params.legalEntityAndPropertyData.forEach((y, index) => {
            y.legalEntityAndPropertyData = undefined;
            if (
              params.legalEntityAndPropertyData !== undefined &&
              params.legalEntityAndPropertyData.length > 0
            ) {
              if (
                index === 0 &&
                parseFloat(params.propertyAllocationPercent) !==
                parseFloat(propertyWiseAllocationPercent && (parseFloat(params.propertyAllocationPercent) -
                  parseFloat(propertyWiseAllocationPercent)) >= 0)
              ) {
                let calculatedValue = (parseFloat(params.propertyAllocationPercent) - parseFloat(propertyWiseAllocationPercent));
                calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
                y.propertyAllocationPercent = parseFloat(y.propertyAllocationPercent) + parseFloat(calculatedValue);
              }
              if (
                params.isReimbursed &&
                index === 0 &&
                parseFloat(params.propertyBillingPercent) !==
                parseFloat(propertyWiseBillingPercent) &&
                (parseFloat(params.propertyBillingPercent) -
                  parseFloat(propertyWiseBillingPercent)) >= 0
              ) {
                let calculatedValue = (parseFloat(params.propertyBillingPercent) - parseFloat(propertyWiseBillingPercent));
                calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
                y.propertyBillingPercent = parseFloat(y.propertyBillingPercent) + parseFloat(calculatedValue);
              }
              if (
                params.isReimbursed &&
                index === 0 &&
                parseFloat(params.additionalFixedAmount) !==
                parseFloat(additionalFixedAmount) &&
                (parseFloat(params.additionalFixedAmount) -
                  parseFloat(additionalFixedAmount)) >= 0
              ) {
                let calculatedValue = (parseFloat(params.additionalFixedAmount) - parseFloat(additionalFixedAmount));
                calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
                y.additionalFixedAmount = parseFloat(y.additionalFixedAmount) + parseFloat(calculatedValue);
              }
              const dataToPush = params.legalEntityAndPropertyData.find(
                (z) => z.propertyId === y.propertyId
              );
              dataToPush.approvalStatusId = params.approvalStatusId;
              dataToPush.approvalStatus = params.approvalStatus;
              dataToPush.allocationStartDate = params.allocationStartDate;
              dataToPush.allocationEndDate = params.allocationEndDate;
              dataToPush.billingStartDate = params.billingStartDate;
              dataToPush.billingEndDate = params.billingEndDate;
              dataToPush.allocationId =
                dataToPush.allocationId !== 0
                  ? dataToPush.allocationId
                  : ((allocationDataToStore || []).length + 1) * -1;
              if (dataToPush.allocationId > 0) {
                allocationDataToStore = allocationDataToStore.filter(
                  (x) =>
                    x.allocationId !== dataToPush.allocationId &&
                    x.allocationId > 0
                );
              } else {
                const allocation = allocationDataToStore.find(
                  (x) =>
                    x.marketId === dataToPush.marketId &&
                    x.employeeId === dataToPush.employeeId &&
                    x.legalEntityId === dataToPush.legalEntityId &&
                    x.propertyId === dataToPush.propertyId
                );
                if (allocation !== undefined) {
                  allocationDataToStore = allocationDataToStore.filter(
                    (x) => x.allocationId !== allocation.allocationId
                  );
                }
              }
              allocationDataToStore.push(dataToPush);
            }
          });
        } else {
          allocationDataToStore.push(params);
        }
      }
    } else {
      if (params.isAllocatedToLegalEntity) {
        // const allocationData = (allocationDataToStore.find(x => x.allocationId === params.allocationId) || {});
        allocationDataToStore = allocationDataToStore.filter(
          (x) => x.allocationId !== params.allocationId
        );
        if (
          params !== undefined &&
          params.legalEntityAndPropertyData !== undefined &&
          params.legalEntityAndPropertyData.length > 0
        ) {
          const propertyWiseAllocationPercent =
            with2DecimalsPoints(params.legalEntityAndPropertyData.reduce(
              (total, obj) =>
                parseFloat(obj.propertyAllocationPercent) + parseFloat(total),
              0
            ));
          const propertyWiseBillingPercent =
            with2DecimalsPoints(params.legalEntityAndPropertyData.reduce(
              (total, obj) =>
                parseFloat(obj.propertyBillingPercent) + parseFloat(total),
              0
            ));
          const additionalFixedAmount =
            with2DecimalsPoints(params.legalEntityAndPropertyData.reduce(
              (total, obj) =>
                parseFloat(obj.additionalFixedAmount) + parseFloat(total),
              0
            ));

          params.legalEntityAndPropertyData.forEach((y, index) => {
            y.legalEntityAndPropertyData = undefined;
            if (
              params.legalEntityAndPropertyData !== undefined &&
              params.legalEntityAndPropertyData.length > 0
            ) {
              if (
                index === 0 &&
                parseFloat(params.propertyAllocationPercent) !==
                parseFloat(propertyWiseAllocationPercent) &&
                (parseFloat(params.propertyAllocationPercent) -
                  parseFloat(propertyWiseAllocationPercent)) >= 0
              ) {
                let calculatedValue = (parseFloat(params.propertyAllocationPercent) - parseFloat(propertyWiseAllocationPercent));
                calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
                y.propertyAllocationPercent = parseFloat(y.propertyAllocationPercent) + parseFloat(calculatedValue);
              }
              if (
                params.isReimbursed &&
                index === 0 &&
                parseFloat(params.propertyBillingPercent) !==
                parseFloat(propertyWiseBillingPercent) &&
                (parseFloat(params.propertyBillingPercent) -
                  parseFloat(propertyWiseBillingPercent)) >= 0
              ) {
                let calculatedValue = (parseFloat(params.propertyBillingPercent) - parseFloat(propertyWiseBillingPercent));
                calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
                y.propertyBillingPercent = parseFloat(y.propertyBillingPercent) + parseFloat(calculatedValue);
              }
              if (
                params.isReimbursed &&
                index === 0 &&
                parseFloat(params.additionalFixedAmount) !==
                parseFloat(additionalFixedAmount) &&
                (parseFloat(params.additionalFixedAmount) -
                  parseFloat(additionalFixedAmount)) >= 0
              ) {
                let calculatedValue = (parseFloat(params.additionalFixedAmount) - parseFloat(additionalFixedAmount));
                calculatedValue = (Math.floor(calculatedValue * 100000) / 100000).toFixed(4);
                y.additionalFixedAmount = parseFloat(y.additionalFixedAmount) + parseFloat(calculatedValue);
              }
              const dataToPush = params.legalEntityAndPropertyData.find(
                (z) => z.propertyId === y.propertyId
              );
              dataToPush.approvalStatusId = params.approvalStatusId;
              dataToPush.approvalStatus = params.approvalStatus;
              dataToPush.allocationStartDate = params.allocationStartDate;
              dataToPush.allocationEndDate = params.allocationEndDate;
              dataToPush.billingStartDate = params.billingStartDate;
              dataToPush.billingEndDate = params.billingEndDate;
              dataToPush.allocationId =
                dataToPush.allocationId !== 0
                  ? dataToPush.allocationId
                  : ((allocationDataToStore || []).length + 1) * -1;
              if (dataToPush.allocationId > 0) {
                allocationDataToStore = allocationDataToStore.filter(
                  (x) =>
                    x.allocationId !== dataToPush.allocationId &&
                    x.allocationId > 0
                );
              } else {
                const allocation = allocationDataToStore.find(
                  (x) =>
                    x.marketId === dataToPush.marketId &&
                    x.employeeId === dataToPush.employeeId &&
                    x.legalEntityId === dataToPush.legalEntityId &&
                    x.propertyId === dataToPush.propertyId
                );
                if (allocation !== undefined) {
                  allocationDataToStore = allocationDataToStore.filter(
                    (x) => x.allocationId !== allocation.allocationId
                  );
                }
              }
              allocationDataToStore.push(dataToPush);
            }
          });
        } else {
          allocationDataToStore.push(params);
        }
      } else {
        allocationDataToStore = allocationDataToStore.filter(
          (x) => x.allocationId !== params.allocationId
        );
        allocationDataToStore.push(params);
      }
    }
    if (message === '') {
      const lastClosedPayPeriodEndDate = this.state.lastClosedPayPeriodEndDate;
      if (moment(params.billingStartDate) <= moment(lastClosedPayPeriodEndDate) && params.isReimbursed === true) {
        const trueUpMsg = 'This is a backdated Allocation having Billing Start Date Prior to a Closed Pay Period. \n\n Once this Allocation is approved, the applicable "True-up/ Credit" amounts will be reflected in the Property Reimbursement reports for that Pay Period. \n\n Are you sure to save this record?';
        this.setState({ isTrueUpPopupOpen: true, trueUpConfirmationMessage: trueUpMsg, allocationDataToStore: allocationDataToStore });
      } else {
        this.setState({
          allocationData: allocationDataToStore,
          originalAllocationData: allocationDataToStore,
          isInAddMode: false,
          selectedEditRowId: undefined,
          updateData: undefined,
          isEditableMode: false,
          reloadAllocationTable: !this.state.reloadAllocationTable
        });
      }

    }
  };

  cancelChanges = () => {
    this.setState({
      isInAddMode: false,
      selectedEditRowId: undefined,
      updateData: undefined,
      selectedAllocationIdEditRowId: undefined,
      isEditableMode: false,
      reloadAllocationTable: !this.state.reloadAllocationTable,
      allocationMessage: ''
      //  allocationData: this.state.originalAllocationData
    });
  };

  getPropertyCodeSystem = (value, sourceIdField) => {
    const newPropertyData = this.state.previewSourceAccountingData;
    this.setState({
      sourceAccountingSystemId: sourceIdField.value,
      previewSourceAccountingData: newPropertyData,
      reloadProperty: !this.state.reloadProperty,
      reloadPtf: !this.state.reloadPtf
    });
  };

  getSourceAccountingDetails = (value, sourceIdField) => {
    const newPropertyData = this.state.newPropertyData;
    this.setState({
      sourceAccountingSystemId: sourceIdField.value,
      newPropertyData,
      reloadProperty: !this.state.reloadProperty,
      reloadPtf: !this.state.reloadPtf
    });
  };

  getSelectedTransitionDetails = (value, sourceIdField) => {
    const { assignmentMasterData, newPropertyData } = this.state;
    const currentTransitionData = this.state.transitionData;
    let selectedPropertyID = 0;

    const legal = getSectionFieldByKey(newPropertyData, 'LegalEntity');
    if (!this.state.isMultiBuilding) {
      legal.attributeValue = value;
    }
    legal.isEditable = !!this.state.isMultiBuilding;

    setSectionAttributeValueByKey(
      currentTransitionData,
      'assignmentName',
      value
    );
    if (
      _.camelCase((sourceIdField || {}).key) === _.camelCase('AssignmentId') &&
      value !== ''
    ) {
      const assignment =
        assignmentMasterData.find((x) => x.assignmentName === value) || {};
      const transitionTypeSelected =
        currentTransitionData.find((x) => x.dbColumn === 'TransitionType') ||
        {};
      const transitionTypeIDSelected =
        currentTransitionData.find((x) => x.dbColumn === 'TransitionTypeId') ||
        {};

      // assignment.assignmentId = assignment.assignmentId === undefined ? -1 : assignment.assignmentId;
      if (assignment.assignmentId) {
        this._asyncRequest = apiBatchRequest([
          {
            url:
              API_URL.Transition.GetTransitionDetails +
              '?assignmentId=' +
              assignment.assignmentId +
              '&transitiontypeid=1',
            key: 'assignmentData'
          }
        ])
          .then(({ assignmentData }) => {
            this._asyncRequest = null;
            if (assignmentData.success === true) {
              assignmentData.data.forEach((dataObject) => {
                // if (dataObject.dbColumn === "PropertyTransitionId") {
                //   dataObject.attributeValue = "0";
                // }
                if (dataObject.dbColumn === 'TransitionTypeId') {
                  dataObject.attributeValue =
                    transitionTypeIDSelected.attributeValue;
                }
                if (dataObject.dbColumn === 'TransitionType') {
                  dataObject.attributeValue =
                    transitionTypeSelected.attributeValue;
                }
                if (dataObject.dbColumn === 'PropertyId') {
                  selectedPropertyID = dataObject.attributeValue;
                }
              });
              const managementFeeData =
                getSectionAttributesByKeyValue(
                  assignmentData.data,
                  'sectionId',
                  37
                ) || [];
              assignmentData.data =
                RemoveSectionAttributeByKeyValue(
                  assignmentData.data,
                  'sectionId',
                  37
                ) || [];

              let engineerHourBillingData = getSectionAttributesByKeyValue(assignmentData.data, 'sectionId', 93) || [];
              if (transitionTypeIDSelected.attributeValue?.toString() === '2') {
                // clear Engineer Hour Billing data of original PTF when CIO is selected from longer way
                engineerHourBillingData = [];
              }
              const isEngineerHourBilling = this.getEngineerHourBillingStatus(engineerHourBillingData);
              assignmentData.data = RemoveSectionAttributeByKeyValue(assignmentData.data, 'sectionId', 93) || [];

              const ccDetailsFormFields = cloneDeep(getSectionAttributesByKeyValue(assignmentData.data, 'sectionId', 36)).filter(x => (x.recordId === '0')) || [];
              // if (ccDetailsFormFields.length === 0) {
              //   ccDetailsFormFields = cloneDeep(clientContactDetails.data); // getSectionAttributesByKeyValue(reorderData, 'sectionId', 36) || [];
              // }
              // ccDetailsFormFields.forEach(x => {
              //   x.attributeValue = '';
              // });
              const ccDetails = getSectionAttributesByKeyValue(assignmentData.data, 'sectionId', 36).filter(x => (x.attributeValue !== '' || x.attributeValue !== null)) || [];
              // if (ccDetails.length === 0) {
              //   ccDetails = clientContactDetails.data;
              // }
              const clientContactMainData = cloneDeep(ccDetails);

              assignmentData.data =
                RemoveSectionAttributeByKeyValue(assignmentData.data, 'sectionId', 36) ||
                [];

              // const expenseData =
              //   getSectionAttributesByKeyValue(assignmentData.data, 'sectionId', 49) ||
              //   [];
              // assignmentData.data =
              //   RemoveSectionAttributeByKeyValue(assignmentData.data, 'sectionId', 49) ||
              //   [];

              const { reorderData } = this.setUpFieldsBasedonTransitionType(
                assignmentData.data,
                this.state.originaltransitionData,
                this.state.allowToEdit
              );
              if (transitionTypeIDSelected.attributeValue === '3') {
                this.disableFields(
                  [],
                  assignmentData.data,
                  _.cloneDeep(assignmentData.data)
                );
              }
              if (transitionTypeIDSelected.attributeValue?.toString() !== '1') {
                setSectionFieldAttributeByKey(
                  reorderData,
                  'DocumentName',
                  'isEditable',
                  false
                );
                setSectionFieldAttributeByKey(
                  reorderData,
                  'W9DocumentName',
                  'isEditable',
                  false
                );
              }

              const propIds = getSectionAttributeValueByKey(
                reorderData,
                'PropertyId'
              )?.split('|');
              const CIOProperties = [];

              const propertyDetails = this.state.propertyDetails || [];

              this.state?.propertyMasterData
                ?.filter((x) =>
                  propIds?.find(
                    (y) => y?.toString() === x.propertyId?.toString()
                  )
                )
                ?.forEach((pm) => {
                  CIOProperties.push(pm);
                  propertyDetails.push(pm);
                });
              this.getPropertyDetailsById(selectedPropertyID, {
                CIOProperties: CIOProperties,
                propertyDetails: propertyDetails,
                ExistingPropertyDetails: propertyDetails,
                transitionData: reorderData,
                newPropertyData: cloneDeep(newPropertyData),
                managementFeeData: managementFeeData,
                feeDataStructure: this.setManagementFeeData(managementFeeData),
                engineerHourBillingData: cloneDeep(engineerHourBillingData),
                showSubmitBtnOnEnggBillingSection: isEngineerHourBilling
              });
              this.setState({
                clientContactDetails: ccDetails || [],
                clientContactDataStructure: this.setClientContactdata(ccDetails || []),
                clientContactMainData: clientContactMainData,
                transitionData: reorderData
                // originalClientContactDetails: cloneDeep(clientContactDetails.data || []),
                // clientContactDetailConfig: clientContactDetails.config || [],
              }, () => { this.getAssignmentSpsData(); });
            } else {
              ShowToast(
                'There is some issue in fetching assignment details',
                toastType.ERROR,
                5000,
                500,
                'Server error'
              );
            }
          })
          .catch(() => {
            this._asyncRequest = null;
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          })
          .catch(() => {
            this._asyncRequest = null;
          });
      } else {
        // const { reorderData } = this.setUpFieldsBasedonTransitionType(currentTransitionData, this.state.originaltransitionData, this.state.allowToEdit);
        // const managementFeeData = getSectionAttributesByKeyValue(this.state.originaltransitionData, 'sectionId', 37) || [];
        let newTransitionData = cloneDeep(this.state.transitionData);
        // const managementFeeData = getSectionAttributesByKeyValue(newTransitionData, 'sectionId', 37) || [];
        newTransitionData =
          RemoveSectionAttributeByKeyValue(
            newTransitionData,
            'sectionId',
            37
          ) || [];
        const { reorderData } = this.setUpFieldsBasedonTransitionType(
          newTransitionData,
          this.state.originaltransitionData,
          this.state.allowToEdit
        );
        this.getPropertyDetailsById(-1, {
          transitionData: newTransitionData,
          newPropertyData: cloneDeep(this.state.newPropertyData),
          managementFeeData: this.state.managementFeeData,
          feeDataStructure: this.setManagementFeeData(
            this.state.feeDataStructure
          )
        });
        // this.setState({
        //   transitionData: reorderData,
        //   managementFeeData: managementFeeData,
        //   allocationData: [],
        //   newPropertyData: []
        // });
      }
    } else {
      if (this.state.selectedTransitionTypeId?.toString() === '1') {
        const assignmentName = value;
        let propertyDetails = this.state.propertyDetails;
        (propertyDetails || []).forEach((property) => {
          if (property.propertyId < 0) {
            if (
              assignmentName !== null &&
              assignmentName !== '' &&
              assignmentName !== undefined
            ) {
              // && (property.legalEntity === null || property.legalEntity === undefined || property.legalEntity === '')) {
              property.legalEntity = assignmentName;
            }
            // if (legalEntityId !== null && legalEntityId !== 0 && legalEntityId !== '' && legalEntityId !== undefined) { // && (property.legalEntityId === null || property.legalEntityId === undefined || property.legalEntityId === '' || property.legalEntityId === 0)) {
            //   property.legalEntityId = legalEntityId;
            // }
          }
        });
        propertyDetails = propertyDetails.filter(
          (x) => x.legalEntity === assignmentName
        );
        // const managementFeeData = [];
        // const expenseData = [];
        // (propertyDetails || []).forEach((property) => {
        //   managementFeeData.push(this.state.managementFeeData.filter(x => x.recordId?.toString() === property.propertyId?.toString()));
        //   expenseData.push(this.state.expenseData.filter(y => y.recordId?.toString() === property.propertyId?.toString()));
        // });

        let { allocationData } = this.state;
        allocationData = allocationData.filter(
          (x) => x.legalEntity === assignmentName
        );
        allocationData.forEach((x) => {
          x.legalEntity = assignmentName;
          x.LegalEntity = assignmentName;
        });
        // setSectionAttributeValueByKey(currentTransitionData, 'PropertyName', '');
        // setSectionAttributeValueByKey(currentTransitionData, 'PropertyId', '');
        const { feeDataStructure } = this.state;
        setSectionAttributeValueByKey(
          feeDataStructure,
          'ManagementPropertyId',
          null
        );
        setSectionAttributeValueByKey(
          feeDataStructure,
          'ManagementPropertyName',
          ''
        );
        const { expenseDataStructure } = this.state;
        setSectionAttributeValueByKey(
          expenseDataStructure,
          'expensesBillablePropertyName',
          ''
        );
        setSectionAttributeValueByKey(
          expenseDataStructure,
          'ExpensesBillablePropertyId',
          null
        );

        this.setState({
          newPropertyData: cloneDeep(newPropertyData),
          transitionData: currentTransitionData,
          propertyDetails: propertyDetails,
          allocationData: allocationData,
          managementFeeData: [],
          expenseData: [],
          reloadManagementFeeSetion: true,
          reloadExpenseSection: true,
          reloadEngineerHourBillingSection: true,
          feeDataStructure: feeDataStructure,
          expenseDataStructure: expenseDataStructure
        });
      } else {
        this.setState({
          newPropertyData: cloneDeep(newPropertyData),
          transitionData: currentTransitionData
        });
      }
    }
  };

  TransitionTypeChange = (value, sourceIdField, multiple) => {
    const {
      originaltransitionData,
      selectedTransitionTypeId,
      originalserviceTypeMasterData,
      allowToEdit,
      isApproved,
      originalPropertyMasterData,
      clientContactDetails
    } = this.state;
    const originalTransitionId = getSectionAttributeValueByKey(
      originaltransitionData,
      'TransitionTypeId'
    );

    let transitionData = [...this.state.transitionData];
    // if (originalTransitionId !== sourceIdField.value.toString()) {
    //   setSectionFieldAttributeByKey(transitionData, 'EmailCC', 'isVisible', true);
    //   setSectionFieldAttributeByKey(transitionData, 'EmailCC', 'isRequired', false);
    //   setSectionFieldAttributeByKey(transitionData, 'EmailCC', 'isEditable', true);
    // }
    const managementFeeData = _.cloneDeep(this.state.managementFeeData);
    let serviceTypeMasterData = [...this.state.serviceTypeMasterData];
    let propertyMasterData = [...this.state.propertyMasterData];
    let allowChanges = allowToEdit;
    const isInError = false;
    if (isApproved === true) {
      if (
        (sourceIdField.value || '').toString() !==
        (this.state.selectedOriginalTransitionTypeId || '').toString()
      ) {
        allowChanges = true;
      } else {
        allowChanges = false;
      }
    } else {
      if (
        (sourceIdField.value || '').toString() === '1' ||
        this.state.actionType !== 'Edit'
      ) {
        allowChanges = true;
      } else {
        allowChanges = false;
        ShowToast(
          value +
          ' cannot be submitted for this assignment as this is New transition and it is not yet approved.',
          toastType.ERROR,
          5000,
          5000
        );
        sourceIdField.value = selectedTransitionTypeId;
        setSectionAttributeValueByKey(
          transitionData,
          'selectedTransitionTypeId',
          selectedTransitionTypeId
        );
        this.setState({
          transitionData: cloneDeep(transitionData),
          selectedTransitionTypeId: sourceIdField.value,
          reloadPtf: !this.state.reloadPtf
        });
        return;
      }
    }

    if (this.props.actionType === 'Edit' && allowChanges) {
      ({ serviceTypeMasterData, propertyMasterData, transitionData } =
        this.setUpMasterDataBasedOnTransitionType(
          sourceIdField.value,
          originaltransitionData,
          serviceTypeMasterData,
          originalserviceTypeMasterData,
          propertyMasterData,
          originalPropertyMasterData,
          transitionData
        ));
    } else {
      transitionData = _.cloneDeep(originaltransitionData);
      if ((sourceIdField.value || '').toString() === '3') {
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'isVisible',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'isEditable',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'attributeSortOrder',
          3
        );
      } else {
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'isVisible',
          false
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'isRequired',
          false
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'TerminationDocumentName',
          'isEditable',
          false
        );
      }
      serviceTypeMasterData = _.cloneDeep(originalserviceTypeMasterData);
      // managementFeeData = _.cloneDeep(this.state.originalManagementFeeData);
    }
    if (allowChanges) {
      setSectionAttributeValueByKey(transitionData, 'transitionType', value);
      if (
        value === 'Termination' &&
        serviceTypeMasterData.includes('Property Accounting')
      ) {
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isEditable',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isVisible',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isRequired',
          true
        );
        this.setState({
          propAccounting: true
        });
      } else {
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isEditable',
          false
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isVisible',
          false
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isRequired',
          false
        );

        this.setState({
          propAccounting: true
        });
      }
      setSectionAttributeValueByKey(
        transitionData,
        'transitionTypeId',
        sourceIdField.value
      );
    }

    const { reorderData, propAccounting } =
      this.setUpFieldsBasedonTransitionType(
        [...transitionData],
        _.cloneDeep(this.state.originaltransitionData),
        allowChanges
      );
    if (this.props.selectedTransitionId === 0) {
      setSectionFieldAttributeByKey(
        reorderData,
        'propertyTransitionId',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'propertyTransitionId',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'PtfNumber',
        'isVisible',
        false
      );

      setSectionFieldAttributeByKey(
        reorderData,
        'ApprovalStatus',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'ApprovalStatus',
        'isVisible',
        false
      );
      if (
        (sourceIdField.value || '').toString() === '2' ||
        (sourceIdField.value || '').toString() === '3'
      ) {
        setSectionFieldAttributeByKey(
          reorderData,
          'clientName',
          'isHighlight',
          true
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'marketName',
          'isHighlight',
          true
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'assignmentName',
          'isHighlight',
          true
        );
      }
    } else {
      setSectionFieldAttributeByKey(
        reorderData,
        'propertyTransitionId',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'propertyTransitionId',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'PtfNumber',
        'isVisible',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'PtfNumber',
        'isEditable',
        false
      );

      setSectionFieldAttributeByKey(
        reorderData,
        'ApprovalStatus',
        'isEditable',
        false
      );
      // setSectionFieldAttributeByKey(reorderData, 'ApprovalStatus', 'isVisible', true);
      setSectionFieldAttributeByKey(
        reorderData,
        'clientName',
        'isHighlight',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'marketName',
        'isHighlight',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'assignmentName',
        'isHighlight',
        false
      );
    }
    transitionData = _.cloneDeep(reorderData);
    const cioStateChanges = {};
    if (sourceIdField?.value?.toString() === '2') {
      setSectionFieldAttributeByKey(
        transitionData,
        'UpdatedProperties',
        'isVisible',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'UpdatedProperties',
        'isEditable',
        allowChanges
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'UpdatedProperties',
        'isRequired',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'PropertyName',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'W9DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'Description',
        'isEditable',
        true
      );
      cioStateChanges.expenseData = this.state.expenseDataStructure;
      cioStateChanges.engineerHourBillingData = this.state.engineerHourBillingDataStructure;
      cioStateChanges.showSubmitBtnOnEnggBillingSection = this.getEngineerHourBillingStatus(this.state.engineerHourBillingDataStructure);
      cioStateChanges.managementFeeData = this.state.feeDataStructure;
      const managementProperties = this.getManagementProperties(transitionData);
      cioStateChanges.managementProperties = managementProperties;
    } else {
      cioStateChanges.expenseData = this.state.originalExpenseData;
      cioStateChanges.engineerHourBillingData = this.state.originalEngineerHourBillingData;
      cioStateChanges.managementFeeData = this.state.originalManagementFeeData;
      cioStateChanges.managementProperties = this.state.propertyDetails;
    }
    let renderData = clientContactDetails;
    if ((sourceIdField.value || '').toString() === '3') {
      renderData = this.disableFields(
        [],
        clientContactDetails,
        cloneDeep(clientContactDetails)
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'W9DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'UpdatedProperties',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'PropertyName',
        'isVisible',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isRequired',
        false
      );
    }
    if ((sourceIdField.value || '').toString() === '3') {
      let msgTerminatedProperties = '';
      const terminatedProperties = getSectionAttributeValueByKey(
        transitionData,
        'TerminatedProperties'
      );
      if (terminatedProperties !== undefined) {
        const distinctTerminatdProperties = removeNullValuesFromArray(
          removeDuplicates(terminatedProperties?.split('|')?.map((r) => r.trim()) || [])
        );
        if (distinctTerminatdProperties !== undefined && distinctTerminatdProperties !== '' && distinctTerminatdProperties.length > 0) {
          msgTerminatedProperties = distinctTerminatdProperties.join(', ');
        }
      }
      const terminatedServices = getSectionAttributeValueByKey(
        transitionData,
        'TerminatedServices'
      );
      if (terminatedServices !== undefined) {
        const distinctTerminatdServices = removeNullValuesFromArray(
          removeDuplicates(
            terminatedServices
              ?.split('|')
              ?.map((r) => r.split('-')[0].trim()) || []
          )
        );
        if (
          distinctTerminatdServices !== undefined &&
          distinctTerminatdServices !== '' &&
          distinctTerminatdServices.length > 0
        ) {
          // let msg = (<span> {'Termination for below service types is already in progress : ' + <br /> +
          //   distinctTerminatdServices.map(x => (<>
          //     {x} <br />
          //   </>))} </span>);
          let allPropertiesCount = 0;
          let ownershipChangedPropertiesCount = 0;
          const allProperties = getSectionAttributeValueByKey(
            transitionData,
            'PropertyName'
          );
          const ownershipChangedProperties = getSectionAttributeValueByKey(
            transitionData,
            'OwnershipChangedProperty'
          );
          allPropertiesCount =
            allProperties === undefined || allProperties === ''
              ? 0
              : allProperties?.split('|').length;
          ownershipChangedPropertiesCount =
            ownershipChangedProperties === undefined ||
              ownershipChangedProperties === ''
              ? 0
              : ownershipChangedProperties?.split('|').length;

          if (
            ownershipChangedPropertiesCount === 0 &&
            allPropertiesCount !== ownershipChangedPropertiesCount
          ) {
            let msg1 = 'Below service type(s) are already Terminated : ' + distinctTerminatdServices.join(', ');
            msg1 = ((msgTerminatedProperties || '').length > 0) ? msg1 + ' for Property(s) - ' + msgTerminatedProperties : msg1;
            ShowToast(msg1, toastType.INFO, 5000, 5000);
          }
          if (
            ownershipChangedPropertiesCount > 0 &&
            allPropertiesCount !== ownershipChangedPropertiesCount
          ) {
            const distinctOwnershipChangedProperties =
              removeNullValuesFromArray(
                removeDuplicates(
                  ownershipChangedProperties
                    ?.split('|')
                    ?.map((r) => r.substring(0, r.lastIndexOf('-')).trim()) || []
                )
              );
            const msg1 =
              'Services are already terminated due to Change In Ownership for below Property(s) : ' +
              distinctOwnershipChangedProperties.join(', ');
            ShowToast(msg1, toastType.ERROR, 5000, 5000);
          }
        }
      }
    }

    // if ((this.props.actionType !== 'Edit' &&
    //   ((sourceIdField.value || '1').toString() === '2' || (sourceIdField.value || '1').toString() === '3'))) {
    //   ShowToast('Please select existing Client and Market having ongoing Property Transition for ' + value,
    //     toastType.INFO, false, 400);
    // }

    if (sourceIdField?.value?.toString() === '1') {
      this.getAllocationData(
        getSectionAttributeValueByKey(transitionData, 'propertyId')
      );
    }
    const feeDataStructure = this.state.feeDataStructure;
    setSectionFieldAttributeByKey(
      feeDataStructure,
      'ManagementPropertyName',
      ''
    );

    const engineerHourBillingDataStructure = this.setEngineerHourBillingData(this.state.engineerHourBillingDataStructure);
    setSectionAttributeValueByKey(
      engineerHourBillingDataStructure,
      'IsEngineerHourBilling',
      '0'
    );

    const expenseDataStructure = this.state.expenseDataStructure;
    setSectionFieldAttributeByKey(
      expenseDataStructure,
      'ExpensesBillablePropertyName',
      ''
    );

    this.setState({
      ...cioStateChanges,
      clientContactDetails: cloneDeep(renderData),
      transitionData: cloneDeep(transitionData),
      dataAfterTransitionTypeChange: cloneDeep(transitionData),
      selectedTransitionTypeId: sourceIdField.value,
      expenseDataStructure: cloneDeep(expenseDataStructure),
      feeDataStructure: cloneDeep(feeDataStructure),
      engineerHourBillingDataStructure: cloneDeep(engineerHourBillingDataStructure),
      reloadPtf: !this.state.reloadPtf,
      serviceTypeMasterData: serviceTypeMasterData,
      propertyMasterData: propertyMasterData,
      // managementFeeData: managementFeeData,
      reloadManagementFeetable: !this.state.reloadManagementFeetable,
      reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
      reloadExpenseSection: !this.state.reloadExpenseSection,
      reloadBillableExpenseTable: !this.state.reloadBillableExpenseTable,
      reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
      reloadEngineerHourBillingTable: !this.reloadEngineerHourBillingTable,
      reloadNewClientDetails: !this.state.reloadNewClientDetails,
      allowToEdit: allowChanges,
      selectedTransitionName: value,
      propAccounting,
      filesToBeUploaded: [],
      filesToBeDeleted: [],
      w9FilesToBeUploaded: [],
      w9FilesToBeDeleted: []
    });
    this.forceUpdate();
  };

  getSelectedPropertyDetails = (value, sourceIdField, multiple) => {
    const PropertyList = this.state.propertyMasterData;
    const { transitionData, newPropertyData } = this.state;

    // Detect re-selection of an already selected property
    const currentPropertyName = getSectionAttributeValueByKey(transitionData, 'propertyName');
    const currentPropertyId = getSectionAttributeValueByKey(transitionData, 'propertyId');
    if (multiple === false && value && currentPropertyName === value) {
      ShowToast('This property is already selected.', toastType.WARNING, 3000, 500);
      return;
    }
    if (multiple !== false && Array.isArray(sourceIdField && sourceIdField.value)) {
      const newIds = sourceIdField.value.map(x => x?.toString());
      const uniqueNewIds = [...new Set(newIds)];
      if (uniqueNewIds.length < newIds.length) {
        ShowToast('This property is already selected.', toastType.WARNING, 3000, 500);
        return;
      }
    }

    let SelectedRecord = [];
    let SelectedProperty = [];
    let SelectedID = null;
    let LegalEntity = '';
    const legal = getSectionFieldByKey(newPropertyData, 'LegalEntity');
    if (value === null || value === undefined || value.length <= 0) {
      // setSectionAttributeValueByKey(
      //   transitionData,
      //   'assignmentName',
      //   undefined
      // );
      legal.isEditable = true;
      SelectedID = -1000;
    } else if (multiple === false) {
      SelectedRecord = PropertyList.find((x) => x.propertyName === value);
      if (SelectedRecord) {
        const assignmentName = getSectionAttributeValueByKey(
          this.state.transitionData,
          'assignmentName'
        );
        if (
          assignmentName !== null &&
          (SelectedRecord.legalEntity === null ||
            SelectedRecord.legalEntity === undefined ||
            SelectedRecord.legalEntity === '')
        ) {
          SelectedRecord.legalEntity = assignmentName;
        }

        SelectedID = SelectedRecord.propertyId;
        LegalEntity = SelectedRecord.legalEntity;
        if (this.state.selectedTransitionTypeId?.toString() !== '1') {
          setSectionAttributeValueByKey(
            transitionData,
            'assignmentName',
            SelectedRecord.legalEntity
          );
        }
      } else {
        SelectedID = -1000;
      }
      SelectedProperty.push(value);
    } else {
      if (value.length === 1) {
        SelectedRecord = PropertyList.find((x) => x.propertyName === value[0]);
        if (SelectedRecord) {
          const assignmentName = getSectionAttributeValueByKey(
            this.state.transitionData,
            'assignmentName'
          );
          if (
            assignmentName !== null &&
            (SelectedRecord.legalEntity === null ||
              SelectedRecord.legalEntity === undefined ||
              SelectedRecord.legalEntity === '')
          ) {
            SelectedRecord.legalEntity = assignmentName;
          }
          if (this.state.selectedTransitionTypeId?.toString() !== '1') {
            setSectionAttributeValueByKey(
              transitionData,
              'assignmentName',
              SelectedRecord.legalEntity
            );
          }

          if ((SelectedRecord.legalEntity || '').length > 0) {
            // var legal = newPropertyData.find((x) => _.camelCase(x.dbColumn) === _.camelCase('LegalEntity'));
            legal.isEditable = !!this.state.isMultiBuilding;
            legal.attributeValue = SelectedRecord.legalEntity;
          }
        }
      }
      if (sourceIdField.value.find((y) => y > 0) === undefined) {
        legal.isEditable = true;
      }
      SelectedProperty = value;
      sourceIdField.value = removeNullValuesFromArray(sourceIdField.value);
      SelectedID = sourceIdField.value.join('|');
    }

    SelectedProperty = removeNullValuesFromArray(SelectedProperty);
    setSectionAttributeValueByKey(
      transitionData,
      'propertyName',
      SelectedProperty?.join('|')
    );
    setSectionAttributeValueByKey(transitionData, 'propertyId', SelectedID);
    const newProperties = [];
    this.state.newMultiProperty.forEach(x => {
      if (x.find(y => SelectedID?.toString().split('|')?.find(z => z?.toString() === y.recordId?.toString())) !== undefined) {
        newProperties.push(x);
      }
    });

    const propertyMaster = this.state.propertyMasterData.filter(x => x.propertyId > 0 || SelectedID?.toString().split('|')?.find(y => y?.toString() === x.propertyId?.toString()) !== undefined);

    this.getPropertyDetailsById(
      SelectedID.toString(),
      {
        transitionData: transitionData,
        newPropertyData: cloneDeep(newPropertyData),
        newMultiProperty: newProperties,
        propertyMasterData: propertyMaster
      },
      SelectedProperty
    );
  };

  serviceTypeChanged = (value, sourceIdField, multiple) => {
    if (this.state.finalServiceList && this.state.finalServiceList.length > 0 && this.state.selectedTransitionTypeId === '1') {
      let isValid = true;
      const notFoundServiceType = [];
      this.state.finalServiceList.forEach(xp => {
        if ((value || []).find(pr => pr?.toLowerCase().trim() === xp?.toLowerCase().trim()) === undefined) {
          isValid = false;
          notFoundServiceType.push(xp);
        }
      });
      if (!isValid) {
        ShowToast(
          'You are not allowed to remove Service Type ' + notFoundServiceType.join(', ') + ' as there are allocations associated with this Service type',
          toastType.WARNING,
          3090,
          3090
        );
        this.setState({ reloadPtf: !this.state.reloadPtf });
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  CheckLeagalEntity = (value, key, sourceIdField, multiple) => {
    const PropertyList = this.state.propertyMasterData;
    const LegalEntity = getSectionAttributeValueByKey(
      this.state.transitionData,
      'assignmentName'
    );

    if (
      multiple &&
      sourceIdField &&
      sourceIdField.value &&
      !this.state.isMultiBuilding
    ) {
      if (LegalEntity) {
        const currentProperty = PropertyList.find(
          (x) =>
            x.propertyId === sourceIdField.value[sourceIdField.value.length - 1]
        );
        if (
          currentProperty &&
          currentProperty.LegalEntity &&
          currentProperty.LegalEntity !== LegalEntity
        ) {
          ShowToast(
            'Legal entity for select property does not match with other properties in the list.',
            toastType.WARNING,
            3090,
            3090
          );
          return false;
        }
      }
    }
    if (this.state.finalProperties && this.state.finalProperties.length > 0 && this.state.selectedTransitionTypeId === '1') {
      let isValid = true;
      const notFoundProperties = [];
      this.state.finalProperties.forEach(xp => {
        if ((value || []).find(pr => pr?.toLowerCase().trim() == xp.propertyName.toLowerCase().trim()) == undefined) {
          isValid = false;
          notFoundProperties.push(xp.propertyName);
        }
      });
      if (!isValid) {
        ShowToast(
          'You are not allowed to remove Property ' + notFoundProperties.join(', ') + ' as there are allocations associated with this property',
          toastType.WARNING,
          3090,
          3090
        );
        this.setState({ reloadPtf: !this.state.reloadPtf });
        return false;
      }
    }
    return true;
  };

  getAllocationData = (propertyId) => {
    this._asyncRequest = apiBatchRequest([
      // {
      //   url:
      //     API_URL.Allocation.GetAllocationData +
      //     '?propertyId=' +
      //     (propertyId || '-1') +
      //     (this.props.selectedTransitionId
      //       ? '&propertyTransitionId=' + this.props.selectedTransitionId
      //       : ''),
      //   key: 'allocationData'
      // }
      {
        url: API_URL.Allocation.GetPTFAllocationData +
          '?propertyTransitionId=' + (this.props.selectedTransitionId || 0) +
          (propertyId ? '&propertyId=' + propertyId : ''),
        key: 'allocationData'
      }
    ])
      .then(({ allocationData }) => {
        this._asyncRequest = null;
        if (allocationData.success === true) {
          allocationData.data = (allocationData.data || [])
            .filter((ad) => ad.allocationId > 0)
            ?.map((x) => {
              x.allocationEmployeePropertyId =
                '' + x.allocationId + x.employeeId + x.propertyId;
              return x;
            });
          this.setState({
            originalAllocationData: allocationData.data,
            allocationConfiguration: allocationData.config,
            allocationData:
              this.props.selectedPropertyId !== 0
                ? allocationData.data
                  ? allocationData.data
                  : []
                : []
          });
        } else {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Disable the fields on the Form based on Transition type selected.
  disableFields = (
    ignoreFields,
    formFields,
    originalstate,
    transitionTypeId = undefined,
    allowToEdit
  ) => {
    allowToEdit = this.props.readOnly !== true;
    formFields.forEach((x) => {
      if (
        ignoreFields.find((y) => _.camelCase(y) === _.camelCase(x.dbColumn)) ===
        undefined
      ) {
        x.isEditable = false;
        if (
          ((transitionTypeId || '1').toString() === '1' &&
            _.camelCase(x.dbColumn) === _.camelCase('transitionType')) ||
          (this.props.selectedTransitionId === 0 &&
            (transitionTypeId || '1').toString() === '1')
        ) {
          x.isEditable = true;
        }
      } else {
        if (
          (transitionTypeId || '1').toString() !== '1' &&
          this.props.selectedTransitionId > 0
        ) {
          x.isEditable = x.isVisible && allowToEdit;
          if (
            getSectionAttributeValueByKey(
              this.state.originaltransitionData,
              'transitionTypeId'
            ) !== '1' &&
            _.camelCase(x.dbColumn) === _.camelCase('transitionType')
          ) {
            x.isEditable = false;
          }
        } else {
          // x.isEditable = x.isVisible;
          x.isEditable = this.props.readOnly === true ? false : x.isVisible;
          if ((transitionTypeId || '1').toString() !== '1' && x.dbColumn === 'DocumentName') {
            x.isEditable = false;
          }
        }
      }
    });
    if (this.props.selectedTransitionId === 0) {
      setSectionFieldAttributeByKey(
        formFields,
        'propertyTransitionId',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        formFields,
        'propertyTransitionId',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        formFields,
        'ApprovalStatus',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        formFields,
        'ApprovalStatus',
        'isVisible',
        false
      );
      if (
        (transitionTypeId || '').toString() === '2' ||
        (transitionTypeId || '').toString() === '3'
      ) {
        setSectionFieldAttributeByKey(
          formFields,
          'clientName',
          'isHighlight',
          true
        );
        setSectionFieldAttributeByKey(
          formFields,
          'marketName',
          'isHighlight',
          true
        );
        setSectionFieldAttributeByKey(
          formFields,
          'assignmentName',
          'isHighlight',
          true
        );
      }
    }
    changeOfOwnerShipFields.forEach((x) => {
      if (
        (transitionTypeId || '').toString() === '3' &&
        ignoreFields.find((y) => _.camelCase(y) === _.camelCase(x)) !==
        undefined
      ) {
        setSectionFieldAttributeByKey(formFields, x, 'isVisible', true);
        setSectionFieldAttributeByKey(formFields, x, 'isEditable', allowToEdit);
        setSectionFieldAttributeByKey(formFields, x, 'isRequired', true);
      } else {
        setSectionFieldAttributeByKey(
          formFields,
          x,
          'isVisible',
          (transitionTypeId || '').toString() === '2'
        );
        setSectionFieldAttributeByKey(
          formFields,
          x,
          'isEditable',
          (transitionTypeId || '').toString() === '2' && allowToEdit
        );
        setSectionFieldAttributeByKey(
          formFields,
          x,
          'isRequired',
          (transitionTypeId || '').toString() === '2' &&
          getSectionFieldByKey(formFields, x).dataFormat !== 'Boolean'
        );
      }
    });
    return formFields;
  };

  reEnableFields = (
    formFields,
    originalstate,
    transitionTypeId = undefined
  ) => {
    formFields.forEach((x) => {
      x.isEditable = (
        originalstate.find(
          (z) => _.camelCase(z.dbColumn) === _.camelCase(x.dbColumn)
        ) || {}
      ).isEditable;
    });

    formFields.forEach((f) => {
      if (
        changeOfOwnerShipFields.find(
          (x) => _.camelCase(x) === _.camelCase(f.dbColumn)
        )
      ) {
        f.isVisible = (transitionTypeId || '').toString() === '2';
        f.isRequired = (transitionTypeId || '').toString() === '2';
      }
    });
    return formFields;
  };

  getChanges = (formFields) => {
    // this.validateRequiredFields(formFields);
    const { reorderData } = this.setUpFieldsBasedonTransitionType(
      [...formFields],
      cloneDeep(this.state.originaltransitionData),
      true
    );

    let isChangesInTransitionDetails = false;
    (this.state.originaltransitionData || []).forEach((attribute) => {
      const originalAttributeVal = attribute.attributeValue === null ? '' : attribute.attributeValue;
      const newValue = getSectionAttributeValueByKey(
        reorderData,
        attribute.dbColumn
      );
      if (originalAttributeVal !== newValue) {
        isChangesInTransitionDetails = true;
      }
    });

    const getIsPortfolio = (
      reorderData.find((x) => x.dbColumn === 'IsPortfolio') || {}
    ).attributeValue;

    if (this.state.selectedTransitionTypeId?.toString() === '2') {
      const ownershipChangedOriginalPropertyIds = getSectionAttributeValueByKey(
        reorderData,
        'ParentPtfProperties'
      );
      const distinctOwnershipChangedProperties = removeNullValuesFromArray(
        removeDuplicates(ownershipChangedOriginalPropertyIds?.split('|') || [])
      );
      const updatedProperties = getSectionAttributeValueByKey(
        reorderData,
        'UpdatedProperties'
      )?.split('|');

      if (
        updatedProperties !== undefined &&
        updatedProperties.length > 0 &&
        distinctOwnershipChangedProperties !== undefined &&
        distinctOwnershipChangedProperties.length > 0
      ) {
        updatedProperties.forEach((x) => {
          const propertyId = x.split('::')[0];
          const propertyName = x.split('::')[1];
          if (distinctOwnershipChangedProperties.includes(propertyId)) {
            ShowToast(
              'Change in ownership for property ' +
              propertyName +
              ' is already done',
              toastType.ERROR,
              5000,
              500
            );
          }
        });
      }
    }

    const stateToUpdate = {};
    stateToUpdate.reloadManagementFeeSetion =
      !this.state.reloadManagementFeeSetion;
    stateToUpdate.reloadBillableExpenseTable =
      !this.state.reloadBillableExpenseTable;
    stateToUpdate.reloadManagementFeetable =
      !this.state.reloadManagementFeetable;
    stateToUpdate.reloadExpenseSection = !this.state.reloadExpenseSection;
    stateToUpdate.reloadEngineerHourBillingSection = !this.state.reloadEngineerHourBillingSection;
    stateToUpdate.reloadEngineerHourBillingTable = !this.state.reloadEngineerHourBillingTable;
    // }
    this.setState({
      ...stateToUpdate,
      transitionData: reorderData,
      isMultiBuilding: getIsPortfolio === '1',
      isChangesInTransitionDetails: isChangesInTransitionDetails
    });
  };

  updatePortfolio = (getIsPortfolio) => {
    DetailsFormConfig.forEach((value) => {
      if (value.key === 'propertyName') {
        value.multiple = getIsPortfolio === true;
      }
    });
  };

  getClientContactChanges = (formFields) => {
    let isChangesInClientContact = false;
    (formFields || []).forEach((attribute) => {
      const newAttributeVal = attribute.attributeValue === null ? '' : attribute.attributeValue;
      let oldValue = getSectionAttributeValueByKey(
        this.state.originalClientContactDetails,
        attribute.dbColumn
      );
      oldValue = oldValue === null ? '' : oldValue;
      if (newAttributeVal !== oldValue) {
        isChangesInClientContact = true;
      }
    });
    this.setState({ clientContactDetails: formFields, isChangesInClientContact: isChangesInClientContact });
  };

  validateRequiredFields = (
    formElementFields,
    IsDraft = false,
    stateToBeUpdate = {}
  ) => {
    let IsValid = true;
    if ((this.state.selectedTransitionTypeId || '').toString() === '3') {
      setSectionFieldAttributeByKey(
        formElementFields,
        'AssignmentEndDate',
        'isRequired',
        true
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'AssignmentEndDate',
        'isEditable',
        true
      );
    }
    if ((this.state.selectedTransitionTypeId || '').toString() === '2') {
      setSectionFieldAttributeByKey(
        formElementFields,
        'UpdatedProperties',
        'isRequired',
        true
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'UpdatedProperties',
        'isEditable',
        true
      );
    }

    if (IsDraft || this.state.enableSubmitButtons === true) {
      setSectionFieldAttributeByKey(
        formElementFields,
        'DocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'DocumentName',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'DocumentName',
        'errorMessage',
        ''
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'W9DocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'W9DocumentName',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'W9DocumentName',
        'errorMessage',
        ''
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'ChangeOfOwnershipDocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'ChangeOfOwnershipDocumentName',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'ChangeOfOwnershipDocumentName',
        'errorMessage',
        ''
      );

      setSectionFieldAttributeByKey(
        formElementFields,
        'TerminationDocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'TerminationDocumentName',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        formElementFields,
        'TerminationDocumentName',
        'errorMessage',
        ''
      );

    } else {
      if ((this.state.selectedTransitionTypeId || '').toString() === '1') {
        setSectionFieldAttributeByKey(
          formElementFields,
          'DocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'DocumentName',
          'isInErrorState',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'DocumentName',
          'errorMessage',
          ''
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'W9DocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'W9DocumentName',
          'isInErrorState',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'W9DocumentName',
          'errorMessage',
          ''
        );
      } else if (
        (this.state.selectedTransitionTypeId || '').toString() === '2'
      ) {
        setSectionFieldAttributeByKey(
          formElementFields,
          'ChangeOfOwnershipDocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'ChangeOfOwnershipDocumentName',
          'isInErrorState',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'ChangeOfOwnershipDocumentName',
          'errorMessage',
          ''
        );

        setSectionFieldAttributeByKey(
          formElementFields,
          'TerminationDocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'TerminationDocumentName',
          'isInErrorState',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'TerminationDocumentName',
          'errorMessage',
          ''
        );
      } else {
        const terminationDocInfo = getSectionAttributeValueByKey(
          formElementFields,
          'TerminationDocumentName'
        );
        if (terminationDocInfo === '0') {
          setSectionFieldAttributeByKey(
            formElementFields,
            'TerminationDocumentName',
            'attributeValue',
            null
          );
        }
        setSectionFieldAttributeByKey(
          formElementFields,
          'TerminationDocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'TerminationDocumentName',
          'isInErrorState',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'TerminationDocumentName',
          'errorMessage',
          ''
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'ExtendedDate',
          'isVisible',
          true
        );
        setSectionFieldAttributeByKey(
          formElementFields,
          'ExtendedDate',
          'isEditable',
          true
        );
      }
    }

    formElementFields.forEach((ele) => {
      if (ele.isVisible === true && ele.isEditable === true) {
        isInputValid(ele.attributeValue, ele, formElementFields);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      }
    });
    stateToBeUpdate = {
      ...stateToBeUpdate,
      transitionData: formElementFields,
      reloadPtf: !this.state.reloadPtf
    };
    this.setState(stateToBeUpdate);

    return IsValid;
  };

  validateClientContactDetails = (
    IsDraft,
    clientContactDetailsArray,
    transitionTypeId,
    stateToBeUpdate = {}
  ) => {
    let IsValid = true;
    if (clientContactDetailsArray.length <= 0) {
      IsValid = false;
    }
    const contactName = getSectionAttributeValueByKey(
      clientContactDetailsArray,
      'ContactName'
    );

    const address = getSectionAttributeValueByKey(
      clientContactDetailsArray,
      'Address'
    );

    const city = getSectionAttributeValueByKey(
      clientContactDetailsArray,
      'City'
    );

    const state = getSectionAttributeValueByKey(
      clientContactDetailsArray,
      'State'
    );

    const zipCode = getSectionAttributeValueByKey(
      clientContactDetailsArray,
      'zipCode'
    );

    const contactNameFlag = contactName === '';
    const addressFlag = address === '';
    const cityFlag = city === '';
    const stateFlag = state === '';
    const zipCodeNameFlag = zipCode === '';

    if (contactNameFlag) {
      IsValid = false;
    }
    if (IsDraft || transitionTypeId?.toString() === '3') {
      IsValid = true;
    }
    if (transitionTypeId?.toString() === '2') {
      IsValid = true; // New PTF Client contact not required in case of CIO
    }
    stateToBeUpdate = {
      ...stateToBeUpdate,
      reloadClientContactDetails: !this.state.reloadClientContactDetails
    };
    this.setState(stateToBeUpdate);
    if (!this.isAllocationValid()) {
      IsValid = false;
    }

    return IsValid;
  };

  isAllocationValid = () => {
    const {
      allocationData,
      transitionData,
      propertyDetails,
      allocationMarkets
    } = this.state;
    let isValid = true;
    if (
      this.state.selectedTransitionTypeId !== '2' &&
      this.state.selectedTransitionTypeId !== '3'
    ) {
      allocationData.forEach((x) => {
        const allocationStartDate = getSectionAttributeValueByKey(
          transitionData,
          'AssignmentStartDate'
        );
        const allocationEndDate = getSectionAttributeValueByKey(
          transitionData,
          'AssignmentEndDate'
        );

        if (
          this.state.selectedTransitionTypeId === '1' &&
          moment(x.allocationStartDate).format(DateFormat) <
          moment(allocationStartDate).format(DateFormat)
        ) {
          ShowToast(
            'Selected Allocation Start date is not valid in employee allocation. Please edit allocation(s).',
            toastType.ERROR,
            5000,
            500
          );
          isValid = false;
        } else if (
          this.state.selectedTransitionTypeId === '1' &&
          allocationEndDate !== '' &&
          allocationEndDate !== undefined &&
          allocationEndDate !== null &&
          (x.allocationEndDate === '' ||
            x.allocationEndDate === undefined ||
            x.allocationEndDate === null ||
            x.allocationEndDate === '0001-01-01T00:00:00')
        ) {
          ShowToast(
            'Please update employee allocation end date with respect to selected Service(s) End Date.',
            toastType.ERROR,
            5000,
            500
          );
          isValid = false;
        } else if (
          this.state.selectedTransitionTypeId === '1' &&
          x.allocationEndDate !== '' &&
          x.allocationEndDate !== undefined &&
          x.allocationEndDate !== null &&
          allocationEndDate !== '' &&
          allocationEndDate !== undefined &&
          allocationEndDate !== null &&
          moment(x.allocationEndDate).format(DateFormat) >
          moment(allocationEndDate).format(DateFormat)
        ) {
          ShowToast(
            'Please update employee allocation end date with respect to selected Service(s) End Date.',
            toastType.ERROR,
            5000,
            500
          );
          isValid = false;
        } else if (
          this.state.selectedTransitionTypeId === '1' &&
          !propertyDetails.some(
            (property) =>
              property.propertyId.toString() === x.propertyId.toString()
          )
        ) {
          ShowToast(
            'Selected Property is not valid in employee allocation. Please edit allocation(s).',
            toastType.ERROR,
            5000,
            500
          );
          isValid = false;
        } else if (
          this.state.selectedTransitionTypeId === '1' &&
          x.isAllocatedToLegalEntity === true &&
          !propertyDetails.some(
            (property) =>
              property.legalEntity === x.legalEntity ||
              x.legalEntity ===
              getSectionAttributeValueByKey(
                this.state.transitionData,
                'newLegalEntity'
              ) ||
              x.legalEntity ===
              getSectionAttributeValueByKey(
                this.state.transitionData,
                'assignmentName'
              )
          )
        ) {
          ShowToast(
            'Selected Legal Entity is not valid in allocation. Please edit allocation(s).',
            toastType.ERROR,
            5000,
            500
          );
          isValid = false;
        } else if (this.state.selectedTransitionTypeId === '1') {
          const checkSdctMarket =
            propertyDetails.some(
              (property) => property.marketId.toString() === '6'
            ) ||
            propertyDetails.some(
              (property) => property.marketId.toString() === '7'
            );
          if (
            checkSdctMarket &&
            !allocationMarkets.some(
              (property) =>
                property.marketId.toString() === x.marketId.toString()
            )
          ) {
            ShowToast(
              'Selected Market is not valid in employee allocation. Please edit allocation(s).',
              toastType.ERROR,
              5000,
              500
            );
            isValid = false;
          } else if (
            !checkSdctMarket &&
            !propertyDetails.some(
              (property) =>
                property.marketId.toString() === x.marketId.toString()
            )
          ) {
            ShowToast(
              'Selected Market is not valid in employee allocation. Please edit allocation(s).',
              toastType.ERROR,
              5000,
              500
            );
            isValid = false;
          }
        }
      });
    }
    return isValid;
  };

  getUniqueClients(selectedClientContactDataRow, clientContactMainData, data1) {
    const ids = [];
    const mainIds = [];
    const groupedData = this.getGroupedData(selectedClientContactDataRow);
    groupedData?.forEach(x => {
      ids.push(x.recordId);
    });

    const groupedMainData = this.getGroupedData(clientContactMainData?.filter(x => x.recordId !== '0' && x.recordId !== 'null' && x.recordId !== null));
    groupedMainData?.forEach(x => {
      mainIds.push(x.recordId);
    });
    let isDuplicate = false;
    mainIds?.forEach(y => {
      ids?.forEach(x => {
        if (x === y) {
          isDuplicate = true;
        }
      });
    });
    const d1 = cloneDeep(clientContactMainData?.filter(x => x?.recordId !== '0' && x?.recordId !== 'null' && x?.recordId !== null));
    const d2 = cloneDeep(selectedClientContactDataRow);
    const d3 = this.getGroupedData(d1, 'dbColumn');
    const d4 = this.getGroupedData(d2, 'dbColumn');
    if (isDuplicate === false) {
      if (d3.length > 0 && d4.length > 0) {
        let arrMain = [];
        let arrSelected = [];
        d3.forEach(x => {
          if (x.dbColumn === 'ContactName') {
            arrMain = [...x.data.flat(), ...arrMain];
          }
        });

        d4.forEach(x => {
          if (x.dbColumn === 'ContactName') {
            arrSelected = [...x.data.flat(), ...arrSelected];
          }
        });
        const mainContacts = arrMain.map(x => x.attributeValue);
        const selectedContacts = arrSelected.map(x => x.attributeValue);
        mainContacts.forEach(x => {
          selectedContacts.forEach(y => {
            if (x === y) {
              isDuplicate = true;
            }
          });
        });
      }
    }

    if (isDuplicate) {
      ShowToast(
        'The record you are trying to add already exists in main client table',
        toastType.WARNING,
        5000,
        500
      );
    } else {
      data1 = [...clientContactMainData, ...selectedClientContactDataRow];
    }
    return data1;
  }

  getManagementProperties(transitionData) {
    const updatedProperties = getSectionAttributeValueByKey(
      transitionData,
      'UpdatedProperties'
    )?.split('|');
    const managementProperties = [];

    updatedProperties.forEach((x) => {
      const prop = x.split('::');
      const property = cloneDeep(
        this.state.propertyMasterData.find(
          (x) => x.propertyId?.toString() === prop[0]
        )
      );
      if (property) {
        property.propertyName = prop[1];
        managementProperties.push(property);
      }
    });
    return managementProperties;
  }

  handleGraceClick() {
    // alert('Grace Button clicked');
    this.setState({
      ...this.state,
      gracePeriodDialog: true
    });
  }

  // Validate the Engineer Hour Billing Records if Service Start Date or Service End Date or Grace Period date is changed
  validateEngineerHourBillingDetails = () => {
    let isValidEngineerHourBilling = true;
    const engineerHourBillingData = this.state.engineerHourBillingData;

    if (engineerHourBillingData) {
      const serviceStartDate = this.state?.selectedTransitionTypeId?.toString() === '2'
        ? getSectionAttributeValueByKey(this.state.transitionData, 'effectiveFrom')
        : getSectionAttributeValueByKey(this.state.transitionData, 'assignmentStartDate')

      const serviceEndDate = this.state?.selectedTransitionTypeId?.toString() === '2'
        ? null
        : getSectionAttributeValueByKey(this.state.transitionData, 'assignmentEndDate');
      const extendedDate = this.state?.selectedTransitionTypeId?.toString() === '2'
        ? null
        : getSectionAttributeValueByKey(this.state.transitionData, 'extendedDate');

      const startRecords = engineerHourBillingData.filter(x => x.recordId?.toString() !== '0' && x.dbColumn === 'EngineerHourlyBillingStartDate') || [];
      const endRecords = engineerHourBillingData.filter(x => x.recordId?.toString() !== '0' && x.dbColumn === 'EngineerHourlyBillingEndDate') || [];

      if ((serviceStartDate || '') !== '' && startRecords.length > 0 && startRecords.find(x => new Date(x.attributeValue) < new Date(serviceStartDate)) !== undefined) {
        isValidEngineerHourBilling = false;
        ShowToast('Engineer Hour Billing Start Date should be greater than or equal to Service Start Date ' + serviceStartDate, toastType.ERROR, 5000, 500);
      } else if ((extendedDate || '') !== '' && endRecords.length > 0 && endRecords.find(x => new Date(x.attributeValue) > new Date(extendedDate)) !== undefined) {
        isValidEngineerHourBilling = false;
        ShowToast('Engineer Hour Billing End Date should be less than or equal to Grace Period Date ' + extendedDate, toastType.ERROR, 5000, 500);
      } else if ((serviceEndDate || '') !== '' && endRecords.length > 0 && endRecords.find(x => new Date(x.attributeValue) > new Date(serviceEndDate)) !== undefined) {
        isValidEngineerHourBilling = false;
        ShowToast('Engineer Hour Billing End Date should be less than or equal to Service End Date ' + serviceEndDate, toastType.ERROR, 5000, 500);
      } else if ((extendedDate || '') !== '' && startRecords.length > 0 && startRecords.find(x => new Date(x.attributeValue) > new Date(extendedDate)) !== undefined) {
        isValidEngineerHourBilling = false;
        ShowToast('Engineer Hour Billing Start Date should be less than or equal to Grace Period Date ' + extendedDate, toastType.ERROR, 5000, 500);
      } else if ((serviceEndDate || '') !== '' && startRecords.length > 0 && startRecords.find(x => new Date(x.attributeValue) > new Date(serviceEndDate)) !== undefined) {
        isValidEngineerHourBilling = false;
        ShowToast('Engineer Hour Billing Start Date should be less than or equal to Service End Date ' + serviceEndDate, toastType.ERROR, 5000, 500);
      }
    }
    return isValidEngineerHourBilling;
  }

  SubmitTransition = (IsDraft, isNotify = false) => {
    let transitionData = this.state.transitionData;
    // const allocationData = this.state.allocationData;     

    if (this.validateEngineerHourBillingDetails() === false) {
      this.setState({ isButtonsDisabled: false });
      return;
    }

    const type = getSectionAttributeValueByKey(
      this.state.transitionData,
      'TransitionType'
    );
    const transitionTypeId = getSectionAttributeValueByKey(
      this.state.transitionData,
      'transitionTypeId'
    );
    const oldUpdatedProperties = getSectionAttributeValueByKey(
      this.state.transitionData,
      'UpdatedProperties'
    );
    if (oldUpdatedProperties && oldUpdatedProperties.length > 0) {
      const updatedProperties = oldUpdatedProperties?.split('|');
      const newValue = [];
      updatedProperties.forEach((up) => {
        const value = up.split('::');
        newValue.push(value[0] + '::' + value[1]);
      });
      setSectionAttributeValueByKey(
        transitionData,
        'UpdatedProperties',
        newValue.join('|')
      );
    }
    if (transitionData.find((x) => x.dbColumn === 'Notify') === undefined) {
      transitionData.push({
        attributeSortOrder: 2,
        attributeValue: false,
        dataFormat: 'Boolean',
        dbColumn: 'notify',
        displayName: 'Notify',
        isEditable: false,
        isRequired: false,
        isVisible: false,
        recordId: null,
        sectionDetailId: 274,
        sectionId: 26
      });
    }

    if (transitionData.find((x) => x.dbColumn === 'files') === undefined) {
      transitionData.push({
        attributeSortOrder: 2,
        attributeValue: this.state.files,
        dataFormat: 'Text',
        dbColumn: 'files',
        displayName: 'files',
        isEditable: false,
        isRequired: false,
        isVisible: false,
        recordId: null,
        sectionDetailId: 274,
        sectionId: 26
      });
    }
    setSectionFieldAttributeByKey(
      transitionData,
      'files',
      'attributeValue',
      this.state.files
    );
    const draftandSend = IsDraft && isNotify;
    let notify = '';
    if (draftandSend === true) {
      notify = 'notify';
    } else {
      notify = '';
    }
    notifyEmail = notify;
    setSectionFieldAttributeByKey(
      transitionData,
      'Notify',
      'attributeValue',
      // notify
      (this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) || (this.state.w9FilesToBeUploaded && this.state.w9FilesToBeUploaded.length > 0) ? '' : notify // do not send email from here, if new file is uploaded
    );
    if (
      this.validateClientContactDetails(
        IsDraft,
        this.state.clientContactMainData.filter(x => x.recordId !== '0' && x.recordId !== 'null' && x.recordId !== null),
        transitionTypeId
      ) & this.validateRequiredFields(transitionData, IsDraft)
    ) {
      if (this.state.newClientDetail && this.state.IsNewClientAdded === true) {
        transitionData = [...transitionData, ...this.state.newClientDetail];
      }

      let newMultiProperty = this.state.newMultiProperty || [];
      if (this.state.selectedTransitionTypeId?.toString() !== '2') {
        newMultiProperty = newMultiProperty.filter((x) =>
          this.state.propertyDetails.find(
            (y) =>
              y.propertyId.toString() ===
              (((x || [])[0] || {}).recordId || '').toString()
          )
        );
      } else {
        newMultiProperty = newMultiProperty.filter((x) =>
          this.state.CIOPropertydetails.find(
            (y) =>
              y.propertyId.toString() ===
              (((x || [])[0] || {}).recordId || '').toString()
          )
        );
      }

      if ((newMultiProperty || []).length > 0) {
        newMultiProperty.forEach((property) => {
          transitionData = [...transitionData, ...property];
        });
      }

      const existingPropertyIds = new Set(
        (this.state.ExistingPropertyDetails || [])
          .map((property) => (property?.propertyId || '').toString())
          .filter((propertyId) => propertyId !== '')
      );
      const selectedProperties = this.state.selectedTransitionTypeId?.toString() === '2'
        ? (this.state.CIOPropertydetails || [])
        : (this.state.propertyDetails || []);
      const isPropertyAddedInPTF = selectedProperties.some((property) => {
        const propertyId = (property?.propertyId || '').toString();
        return propertyId !== '' && existingPropertyIds.has(propertyId) === false;
      });

      let isChangeInOwnerShip = false;
      isChangeInOwnerShip = this.InTransitCIO(this.state.selectedTransitionTypeId, isChangeInOwnerShip);
      if (isChangeInOwnerShip) {
        if (IsDraft === false && this.state.CIOClientContacts.length === 0) {
          ShowToast('Please add/select atleast one client Contact in New Client Contact Section', toastType.ERROR, false, 500);
          this.setState({
            isButtonsDisabled: false
          });
          return;
        }
        transitionData = [...transitionData, ...this.state.CIOClientContacts];
      } else {
        if (this.state.clientContactMainData) {
          const data = this.state.clientContactMainData.filter(x => x.recordId !== '0' && x.recordId !== null && x.recordId !== 'null');
          if (IsDraft === false && (transitionTypeId?.toString() === '1' || transitionTypeId?.toString() === '2') && this.state.clientContactMainData.length === 0) {
            ShowToast('Please add/select atleast one client Contact in Client Contact Section', toastType.ERROR, 5000, 500);
            this.setState({
              isButtonsDisabled: false
            });
            return;
          }
          transitionData = [
            ...transitionData,
            ...data
          ];
        }
      }

      if (this.state.managementFeeData) {
        transitionData = [...transitionData, ...this.state.managementFeeData];
      }
      if (this.state.expenseData) {
        transitionData = [...transitionData, ...this.state.expenseData];
      }
      if (this.state.engineerHourBillingData) {
        transitionData = [...transitionData, ...this.state.engineerHourBillingData];
      }

      // Calculate folderName before looping through transitionData
      const assignmentName = getSectionAttributeValueByKey(
        this.state.transitionData,
        'assignmentName',
        false
      );
      const calculatedFolderName = getSectionAttributeValueByKey(this.state.transitionData, 'folderName', false) ?? this.cleanName(assignmentName);

      (transitionData || []).forEach((value) => {
        if (this.state.enableSubmitButtons !== true) {
          if (_.camelCase(value.dbColumn) === _.camelCase('ApprovalStatusId')) {
            value.attributeValue = IsDraft === true ? '5' : '3';
          }
        }
        // multiple documents name here
        if (value.dbColumn === 'DocumentName') {
          value.category = 'NewAssignment';
        } else if (value.dbColumn === 'ChangeOfOwnershipDocumentName') {
          value.category = 'ChangeInOwnerShip';
        } else if (value.dbColumn === 'TerminationDocumentName') {
          value.category = 'Termination';
        } else if (value.dbColumn === 'W9DocumentName') {
          value.category = 'NewAssignment'
        }
        if (
          _.camelCase(value.dbColumn) === _.camelCase('DocumentName') ||
          _.camelCase(value.dbColumn) ===
          _.camelCase('ChangeOfOwnershipDocumentName') ||
          _.camelCase(value.dbColumn) === _.camelCase('TerminationDocumentName') ||
          _.camelCase(value.dbColumn) === _.camelCase('W9DocumentName')
        ) {
          let localFiles = [];
          if (value.dbColumn === 'W9DocumentName') {
            localFiles = (this.state.w9FilesToBeUploaded || []).filter(
              (x) => x.category === value.category
            );
          } else {
            localFiles = (this.state.filesToBeUploaded || []).filter(
              (x) => x.category === value.category
            );
          }

          if (localFiles.length > 0) {
            const filesArray = value.attributeValue?.split('|') || [];
            const fileArray = [];

            // For already uploaded files
            (filesArray || []).forEach((x) => {
              if ((x || '').toString().includes('_Document_') || (x || '').toString().startsWith('W-9_')) {
                fileArray.push(x);
              }
            });

            // For new files, use W9_ prefix only for W9DocumentName, else use category_Document_
            localFiles.forEach((x) => {
              if (value.dbColumn === 'W9DocumentName') {
                fileArray.push('W-9_' + ((x?.file?.name) ? (x?.file?.name) : '.pdf'));
              } else {
                fileArray.push(value.category + '_Document_' + ((x?.file?.name) ? (x?.file?.name) : '.pdf'));
              }
            });
            value.attributeValue = removeDuplicates(fileArray).join('|');
          }
        }
        if (_.camelCase(value.dbColumn) === _.camelCase('FolderName')) {
          value.attributeValue = calculatedFolderName;
        }
        if (value.attributeValue) {
          value.attributeValue = value.attributeValue.toString();
        }
        if (value.recordId) {
          value.recordId = (value.recordId || '').toString();
        }
        if (
          _.camelCase(value.dbColumn) === _.camelCase('propertyTransitionId')
        ) {
          if (
            (this.state.selectedTransitionTypeId || '').toString() !== '1' &&
            this.state.selectedOriginalTransitionTypeId === '1'
          ) {
            value.attributeValue = '0';
          }
        }
      });
      if (this.props.actionType === 'Edit') {
        const propertyTransitionId = transitionData.filter(
          (x) => _.camelCase(x.dbColumn) === _.camelCase('propertyTransitionId')
        );
        const serviceTypesId = getSectionAttributeValueByKey(
          transitionData,
          'ServiceTypeId'
        ).split('|');
        const serviceTypes = getSectionAttributeValueByKey(
          transitionData,
          'ServiceType'
        ).split('|');
        setSectionAttributeValueByKey(
          transitionData,
          'ServiceTypeId',
          // removeDuplicates(propertyId).join('|')
          removeNullValuesFromArray(removeDuplicates(serviceTypesId)).join('|')
        );
        setSectionAttributeValueByKey(
          transitionData,
          'ServiceType',
          // removeDuplicates(propertyId).join('|')
          removeNullValuesFromArray(removeDuplicates(serviceTypes)).join('|')
        );

        const marketId = getSectionAttributeValueByKey(transitionData, 'marketId');
        if (removeNullValuesFromArray(removeDuplicates(serviceTypesId)).length === 1 &&
          serviceTypesId.find(x => x?.toString() === ServiceTypes.Property_Accounting?.toString()) &&
          marketId?.toString() !== Markets.SRP?.toString() && 1 === 2
        ) {
          const confirmDialogMessage = 'You have selected Property Accounting service type only and selected market is other than SRP. Once you save the record then SRP market will be set by default. Do you want to continue?';
          this.setState({ showSRPConfirmDialog: true, ConfirmDialogMessage: confirmDialogMessage });
        } else {
          const approvalStatusId = getSectionAttributeValueByKey(transitionData, 'ApprovalStatusId');
          const isApprovedPTF = (approvalStatusId || '').toString() === '4';
          const isDraftReNotification =
            this.props.selectedTransitionId > 0 && notifyEmail === 'notify';
          const isEditAfterApproval =
            this.props.selectedTransitionId > 0 &&
            isApprovedPTF &&
            IsDraft === false &&
            isDraftReNotification === false;
          apiPut(API_URL.Transition.UpdateTransition, transitionData, {
            PropertyTransitionId: propertyTransitionId[0].attributeValue,
            isEditAfterApproval: isEditAfterApproval,
            isDraftReNotification: isDraftReNotification,
            isPropertyAddedInPTF: isPropertyAddedInPTF
          })
            .then(({ data: response }) => {
              if (response.success === true) {
                // (trackerTimeLineData.data || []).forEach((step) => {
                //   step.propertyId = parseInt(this.state.selectedPropertyID);
                //   step.propertyTransitionId = propertyTransitionId[0].attributeValue || 0;
                // });
                const postBodyData = this.prepareAllocationModel(
                  response.data[0].errorCode,
                  IsDraft
                );
                const ptfNumber = transitionData.filter(
                  (x) => _.camelCase(x.dbColumn) === _.camelCase('PtfNumber')
                );

                const ptfNumberToShow =
                  propertyTransitionId[0].attributeValue === '0' ||
                    propertyTransitionId[0].attributeValue === null
                    ? response.data[0].errorCode
                    : ptfNumber[0].attributeValue;
                this.UpdateAllocationData(
                  API_URL.Allocation.UpdateMultipleAllocation,
                  postBodyData,
                  response.data[0].errorCode,
                  'Record updated successfully. ' +
                  // (type || '') + ' PTF number is ' + response.data[0].errorCode);
                  (type || '') +
                  ' PTF number is ' +
                  ptfNumberToShow
                );
              } else {
                this.setState({ isButtonsDisabled: false });
                ShowToast(response.message, toastType.ERROR, 5000, 500);
              }
            })
            .catch(() => {
              this.setState({ isButtonsDisabled: false });
              ShowToast(commonLabels.somethingWrong, toastType.ERROR, false, 500);
            });
        }
      } else {
        const assignmentName = getSectionAttributeValueByKey(
          this.state.transitionData,
          'AssignmentName'
        );
        setSectionAttributeValueByKey(
          transitionData,
          'propertyTransitionId',
          0
        );
        setSectionAttributeValueByKey(
          transitionData,
          'LegalEntity',
          assignmentName
        );
        const serviceTypesId = getSectionAttributeValueByKey(
          transitionData,
          'ServiceTypeId'
        ).split('|');
        const serviceTypes = getSectionAttributeValueByKey(
          transitionData,
          'ServiceType'
        ).split('|');
        setSectionAttributeValueByKey(
          transitionData,
          'ServiceTypeId',
          // removeDuplicates(propertyId).join('|')
          removeNullValuesFromArray(removeDuplicates(serviceTypesId)).join('|')
        );
        setSectionAttributeValueByKey(
          transitionData,
          'ServiceType',
          // removeDuplicates(propertyId).join('|')
          removeNullValuesFromArray(removeDuplicates(serviceTypes)).join('|')
        );
        const marketId = getSectionAttributeValueByKey(transitionData, 'marketId');
        if (removeNullValuesFromArray(removeDuplicates(serviceTypesId)).length === 1 &&
          serviceTypesId.find(x => x?.toString() === ServiceTypes.Property_Accounting?.toString()) &&
          marketId?.toString() !== Markets.SRP?.toString() && 1 === 2
        ) {
          const confirmDialogMessage = 'You have selected Property Accounting service type only and selected market is other than SRP. Once you save the record then SRP market will be set by default. Do you want to continue?';
          this.setState({ showSRPConfirmDialog: true, ConfirmDialogMessage: confirmDialogMessage });
        } else {
          apiPost({
            url: API_URL.Transition.InsertTransition,
            params: {},
            postBody: transitionData
          })
            .then(({ data: response }) => {
              if (response.success === true) {
                const postBodyData = this.prepareAllocationModel(
                  response.data[0].errorCode,
                  IsDraft
                );
                this.UpdateAllocationData(
                  API_URL.Allocation.UpdateMultipleAllocation,
                  postBodyData,
                  response.data[0].errorCode,
                  'Record Created Successfully. ' +
                  (type || '') +
                  ' PTF number is ' +
                  response.data[0].errorCode
                );
              } else {
                this.setState({ isButtonsDisabled: false });
                ShowToast(response.msg, toastType.ERROR, 5000, 500);
              }
            })
            .catch(() => {
              this.setState({ isButtonsDisabled: false });
              ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500);
            });
        }
      }
    } else {
      if (this.validateClientContactDetails(
        IsDraft,
        this.state.clientContactMainData.filter(x => x.recordId !== '0' && x.recordId !== 'null' && x.recordId != null),
        transitionTypeId
      ) === false) {
        ShowToast('Please add/select atleast one client contact', toastType.ERROR, 5000, 500);
      }
      this.setState({ isButtonsDisabled: false });
    }
  };

  // Add this new method to the class
  loadContactRoles = () => {
    apiBatchRequest([
      {
        url: API_URL.Users.GetContactRolesMapping,
        key: 'contactRoleMasterData'
      }
    ])
      .then(({ contactRoleMasterData }) => {
        if (contactRoleMasterData.success === true) {
          this.setState({
            contactRoleMasterData: contactRoleMasterData.data || []
          });
        }
      })
      .catch(() => {
        // Fails silently — doesn't crash the page
        console.warn('Contact roles could not be loaded');
        this.setState({ contactRoleMasterData: [] });
      });
  };


  LoadTransitionData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url:
          API_URL.Transition.GetTransitionDetails +
          '?transitionId=' +
          this.props.selectedTransitionId,
        key: 'transitionData'
      },
      {
        url: API_URL.Allocation.GetPTFAllocationData +
          '?propertyTransitionId=' + (this.props.selectedTransitionId || 0) +
          (this.props.selectedPropertyId
            ? '&propertyId=' + this.props.selectedPropertyId
            : ''),
        key: 'allocationData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData'
      },
      {
        url:
          API_URL.Property.GetPropertyData +
          '?propertyId=' +
          (this.props.selectedPropertyId || -1) +
          (this.props.selectedTransitionId
            ? '&transitionId=' + this.props.selectedTransitionId
            : ''),
        key: 'PropertyData'
      },
      {
        url:
          API_URL.Property.GetPropertyDetails +
          '?isPtfCall=true&propertyId=' +
          (this.props.selectedPropertyId || '0').split('|')[0] +
          '&propertyTransitionId=' +
          this.props.selectedTransitionId,
        key: 'newPropertyData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientMasterData'
      },
      {
        url: API_URL.Transition.GetCustomerListingData,
        key: 'customerMasterData'
      },

      {
        url: `${API_URL.Market.GetMarketCityStateMasterData}?stateId=${-1}`,
        key: 'allMarketStateData'
      },

      {
        url: API_URL.Transition.GetClientDetail + '?clientId=0',
        key: 'NewClientDetail'
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData'
      },
      {
        url:
          API_URL.Transition.GetClientContactDetails +
          '?clientId=' +
          this.state.selectedClientId,
        key: 'clientContactDetails'
      },
      {
        url:
          API_URL.Employee.GetEmployeeMasterData +
          '?showInActive=true&outputType=ListAll',
        key: 'employeesAllMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url:
          API_URL.Employee.GetEmployeeMasterData +
          '?showInActive=true&outputType=List',
        key: 'employeesForAllocationMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Property.GetExpenseType,
        key: 'expenseTypes'
      },
      {
        url: API_URL.Transition.GetSourceAccounting,
        key: 'sourceAccountingSystemData'
      },
      {
        url: API_URL.Users.GetPmaTitles,
        key: 'pmaTitleMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertySubType,
        key: 'propertySubTypeData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Allocation.GetPayPeriod,
        key: 'payPeriodData'
      },
      {
        url:
          API_URL.Employee.GetControllerDetail +
          '?outputType=List',
        key: 'controllerEmployeesMasterData',
        fromCache: true,
        duration: 15
      }
      // ,
      // {
      //   url: API_URL.Users.GetContactRolesMapping,
      //   key: 'contactRolesData',
      //   duration: 60
      // }
    ])
      .then(
        async ({
          transitionData,
          employeesAllMasterData,
          allocationData,
          departmentMasterData,
          PropertyData,
          newPropertyData,
          marketMasterData,
          clientMasterData,
          customerMasterData,
          trackerstepsMasterData,
          NewClientDetail,
          propertyTypeMasterData,
          clientContactDetails,
          allMarketStateData,
          employeesForAllocationMasterData,
          expenseTypes,
          sourceAccountingSystemData,
          pmaTitleMasterData,
          propertySubTypeData,
          payPeriodData,
          controllerEmployeesMasterData
        }) => {
          this._asyncRequest = null;
          if (transitionData.success === true) {
            const ImpakSetupValue = getSectionAttributeValueByKey(
              transitionData.data,
              'IMPAKSetup'
            );
            const transitionType = getSectionAttributeValueByKey(
              transitionData.data,
              'TransitionType'
            );
            if (
              ImpakSetupValue === null ||
              ImpakSetupValue === '' ||
              ImpakSetupValue === '0'
            ) {
              setSectionFieldAttributeByKey(
                transitionData.data,
                'IMPAKSetupDate',
                'isVisible',
                false
              );
            }

            if (transitionType === 'Termination') {
              setSectionFieldAttributeByKey(
                transitionData.data,
                'ExtendedDate',
                'isEditable',
                true
              );
              setSectionFieldAttributeByKey(
                transitionData.data,
                'ExtendedDate',
                'isVisible',
                true
              );
              setSectionFieldAttributeByKey(
                transitionData.data,
                'ExtendedDate',
                'isRequired',
                true
              );
            } else {
              // setSectionFieldAttributeByKey(transitionData.data, 'ExtendedDate', 'isEditable', true);
              setSectionFieldAttributeByKey(
                transitionData.data,
                'ExtendedDate',
                'isVisible',
                false
              );
              setSectionFieldAttributeByKey(
                transitionData.data,
                'ExtendedDate',
                'isRequired',
                false
              );
            }
            setSectionFieldAttributeByKey(
              transitionData.data,
              'propertyId',
              'attributeSortOrder',
              0
            );
            const abc = getSectionAttributeValueByKey(
              transitionData.data,
              'TerminationDocumentName'
            );

            if (
              getSectionAttributeValueByKey(
                transitionData.data,
                'TerminationDocumentName'
              ) == '0'
            ) {
              setSectionFieldAttributeByKey(
                transitionData.data,
                'TerminationDocumentName',
                'attributeValue',
                null
              );
            }
            if (
              getSectionAttributeValueByKey(
                transitionData.data,
                'TerminationDocumentContent'
              ) == '0'
            ) {
              setSectionFieldAttributeByKey(
                transitionData.data,
                'TerminationDocumentContent',
                'attributeValue',
                null
              );
            }
            let reorderData = _.orderBy(
              transitionData.data,
              ['attributeSortOrder', 'PropertyId'],
              ['asc', 'desc']
            );
            let IsInEditMode = false;

            if (
              (getSectionAttributeValueByKey(
                reorderData,
                'transitionTypeId',
                false
              ) || '1') !== '1'
            ) {
              setSectionFieldAttributeByKey(
                reorderData,
                'transitionType',
                'isEditable',
                false
              );
            }

            let selectedOriginalTransitionTypeId;
            let selectedTransitionTypeId;
            const allowToEdit =
              getSectionAttributeValueByKey(
                reorderData,
                'ApprovalStatusId'
              ).toString() !== '4';
            if (getSectionAttributeValueByKey(reorderData, 'TransitionTypeId').toString() == 0 || getSectionAttributeValueByKey(reorderData, 'TransitionTypeId').toString() == null) {
              reorderData.push({
                attributeSortOrder: 3,
                attributeValue: null,
                dataFormat: 'Number',
                dbColumn: 'ClientId',
                displayName: 'Client Id',
                isEditable: false,
                isRequired: false,
                isVisible: false,
                recordId: null,
                sectionDetailId: 300,
                sectionId: 26
              });
            }

            const managementFeeData =
              getSectionAttributesByKeyValue(reorderData, 'sectionId', 37) ||
              [];
            reorderData =
              RemoveSectionAttributeByKeyValue(reorderData, 'sectionId', 37) ||
              [];
            const engineerHourBillingData = getSectionAttributesByKeyValue(reorderData, 'sectionId', 93) || [];
            const isEngineerHourBilling = this.getEngineerHourBillingStatus(engineerHourBillingData);
            reorderData = RemoveSectionAttributeByKeyValue(reorderData, 'sectionId', 93) || [];
            let ccDetailsFormFields = cloneDeep(
              getSectionAttributesByKeyValue(reorderData, 'sectionId', 36)
            ).filter(x => (x.recordId === '0')) || [];

            if (ccDetailsFormFields.length === 0) {
              ccDetailsFormFields = cloneDeep(clientContactDetails.data || []);
            } else {
              const existingColumns = new Set(
                ccDetailsFormFields.map(x => x.dbColumn?.toLowerCase())
              );
              (clientContactDetails.data || []).forEach(field => {
                if (!existingColumns.has(field.dbColumn?.toLowerCase())) {
                  const mergedField = cloneDeep(field);
                  mergedField.recordId = '0';
                  mergedField.attributeValue = '';
                  mergedField.key = _.camelCase(field.dbColumn);

                  if (field.dbColumn?.toLowerCase() === 'role') {
                    mergedField.dataFormat = 'DropDown';
                    mergedField.type = 'DropDown';
                  }
                  ccDetailsFormFields.push(mergedField);
                }
              });
            }
            ccDetailsFormFields.forEach(x => {
              x.attributeValue = '';
            });
            let ccDetails = getSectionAttributesByKeyValue(reorderData, 'sectionId', 36).filter(x => (x.attributeValue !== '' || x.attributeValue !== null)) || [];
            if (ccDetails.length === 0) {
              ccDetails = clientContactDetails.data;
            }
            let clientContactMainData = cloneDeep(ccDetails);
            // Added for contact role data binding 
            clientContactMainData.forEach(field => {
              if (!field.key) {
                field.key = _.camelCase(field.dbColumn);
              }
              if (field.dbColumn === 'Role') {
                field.dataFormat = 'DropDown';
                field.type = 'DropDown';
              }
            });

            reorderData =
              RemoveSectionAttributeByKeyValue(reorderData, 'sectionId', 36) ||
              [];
            const expenseData =
              getSectionAttributesByKeyValue(reorderData, 'sectionId', 49) ||
              [];
            reorderData =
              RemoveSectionAttributeByKeyValue(reorderData, 'sectionId', 49) ||
              [];
            const originaltransitionData = cloneDeep(reorderData);
            if (this.props.actionType === 'Edit') {
              IsInEditMode = true;
              if (!allowToEdit) {
                originaltransitionData.forEach((x) => {
                  if (
                    _.camelCase(x.dbColumn) !== _.camelCase('transitionType')
                  ) {
                    x.isEditable = false;
                  }
                });
              }
            }
            ({
              selectedOriginalTransitionTypeId,
              selectedTransitionTypeId,
              reorderData
            } = this.setUpFieldsBasedonTransitionType(
              cloneDeep(reorderData),
              cloneDeep(originaltransitionData),
              allowToEdit
            ));

            const getIsPortfolio = getSectionAttributeValueByKey(
              reorderData,
              'IsPortfolio'
            );

            const master = this.setUpMasterDataBasedOnTransitionType(
              selectedTransitionTypeId,
              cloneDeep(originaltransitionData),
              cloneDeep(this.state.serviceTypeMasterData),
              cloneDeep(this.state.originalserviceTypeMasterData),
              cloneDeep(this.state.propertyMasterData),
              cloneDeep(this.state.originalPropertyMasterData),
              reorderData
            );

            const allocationMarkets = (
              (marketMasterData || {}).data || []
            ).filter((x) =>
              getSectionAttributeValueByKey(reorderData, 'marketId')
                .split('|')
                .find((y) => y.toString() === x.marketId.toString())
            );

            if (
              allocationMarkets.find((x) => parseInt(x.marketId) === 6) !==
              undefined
            ) {
              const sdctMarket = ((marketMasterData || {}).data || []).find(
                (y) => parseInt(y.marketId) === 7
              );
              if (
                sdctMarket !== undefined &&
                allocationMarkets.find((x) => parseInt(x.marketId) === 7) ===
                undefined
              ) {
                allocationMarkets.push(sdctMarket);
              }
            }

            if (
              allocationMarkets.find((x) => parseInt(x.marketId) === 7) !==
              undefined
            ) {
              const sdctMarket = ((marketMasterData || {}).data || []).find(
                (y) => parseInt(y.marketId) === 6
              );
              if (
                sdctMarket !== undefined &&
                allocationMarkets.find((x) => parseInt(x.marketId) === 6) ===
                undefined
              ) {
                allocationMarkets.push(sdctMarket);
              }
            }
            let CIOClientContactMasterData = [];

            if (selectedTransitionTypeId === '3') {
              this.disableFields(
                [],
                clientContactDetails.data,
                _.cloneDeep(clientContactDetails.data)
              );
            }
            let CIOClientContacts = [];
            if (selectedTransitionTypeId === '2') {
              const newClientId = getSectionAttributeValueByKey(reorderData, 'newClientId');
              const clientId = getSectionAttributeValueByKey(reorderData, 'clientId');
              const oldClients = ccDetails.filter(x => x.dbColumn === 'ClientId' && x.attributeValue === clientId)?.map(x => x.recordId);
              const newClients = ccDetails.filter(x => x.dbColumn === 'ClientId' && x.attributeValue === newClientId)?.map(x => x.recordId);

              CIOClientContacts = ccDetails;

              const CIOClients = this.getGroupedData(ccDetails.filter(x => x.recordId != '0'));
              CIOClientContacts = CIOClients.filter(y => newClients?.find(z => z === y.recordId))?.map(x => x.data)?.flat();
              ccDetails = CIOClients.filter(y => oldClients?.find(z => z === y.recordId))?.map(x => x.data)?.flat();
              clientContactMainData = cloneDeep(ccDetails);
              // added for contact roles data binding in edit mode of change in ownership
              CIOClientContacts.forEach(field => {
                if (!field.key) {
                  field.key = _.camelCase(field.dbColumn);
                }
                if (field.dbColumn === 'Role') {
                  field.dataFormat = 'DropDown';
                  field.type = 'DropDown';
                }
              });


              // CIOClientContacts = CIOClientData;
              // ccDetails = OldClientData

              CIOClientContactMasterData = await this.getNewClientContactDetailsData(
                getSectionAttributeValueByKey(reorderData, 'newClientId')
              );
            }

            const serviceType = (
              getSectionAttributeValueByKey(reorderData, 'ServiceType') || ''
            ).split('|');
            const assignmentName = (
              getSectionAttributeValueByKey(reorderData, 'AssignmentName') || ''
            )?.replace('&amp;', '&');
            const newLegalEntity = (
              getSectionAttributeValueByKey(reorderData, 'newLegalEntity') || ''
            )?.replace('&amp;', '&');
            const clientName = (
              getSectionAttributeValueByKey(reorderData, 'clientName') || ''
            )?.replace('&amp;', '&');
            const newClientName = (
              getSectionAttributeValueByKey(reorderData, 'newClient') || ''
            )?.replace('&amp;', '&');

            const propertyData = (PropertyData.data || []).filter(
              (x) =>
                (x.clientName === clientName &&
                  x.customerName?.replace('&amp;', '&').toLowerCase() ===
                  assignmentName?.toLowerCase()) ||
                (x.clientName?.replace('&amp;', '&') === newClientName &&
                  x.customerName?.replace('&amp;', '&') === newLegalEntity) ||
                getIsPortfolio === '1' ||
                (getSectionAttributeValueByKey(
                  reorderData,
                  'transitionTypeId'
                ) || '') === '3'
            );
            allocationData.data = (allocationData.data || []).filter(
              (x) =>
                (x.legalEntity?.toLowerCase()?.replace('&amp;', '&') ===
                  newLegalEntity.toLowerCase()?.replace('&amp;', '&') ||
                  x.legalEntity?.toLowerCase()?.replace('&amp;', '&') ===
                  assignmentName.toLowerCase()?.replace('&amp;', '&') ||
                  getIsPortfolio === '1') &&
                (serviceType.find((y) => y === x.serviceType) ||
                  (x.serviceType || '')
                    .split('|')
                    .find((z) => serviceType.find((yy) => yy === z)))
            );

            const finalServiceList = serviceType.filter(ser => allocationData?.data?.find(al => al.serviceType === ser) != undefined);
            const finalProperties = propertyData.filter(pro => allocationData?.data?.find(al => al.propertyId === pro.propertyId) != undefined);

            if (this.props.selectedTransitionId === 0) {
              setSectionFieldAttributeByKey(
                reorderData,
                'PropertyTransitionId',
                'isVisible',
                false
              );
              setSectionFieldAttributeByKey(
                reorderData,
                'PtfNumber',
                'isVisible',
                false
              );
              setSectionFieldAttributeByKey(
                reorderData,
                'ApprovalStatus',
                'isEditable',
                false
              );
              setSectionFieldAttributeByKey(
                reorderData,
                'ApprovalStatus',
                'isVisible',
                false
              );
            } else {
              setSectionFieldAttributeByKey(
                reorderData,
                'PropertyTransitionId',
                'isVisible',
                false
              );
              setSectionFieldAttributeByKey(
                reorderData,
                'ApprovalStatus',
                'isEditable',
                false
              );

            }

            const updatedProperties = getSectionAttributeValueByKey(
              reorderData,
              'UpdatedProperties'
            )?.split('|');
            const propIds = getSectionAttributeValueByKey(
              reorderData,
              'OriginalProperties'
            )?.split('|');
            const CIOProperties = [];
            propertyData.forEach((p) => {
              CIOProperties.push(p);
            });

            this.state?.propertyMasterData
              ?.filter((x) =>
                propIds?.find((y) => y?.toString() === x.propertyId?.toString())
              )
              ?.forEach((pm) => {
                CIOProperties.push(pm);
              });
            let managementProperties = [];

            if (selectedTransitionTypeId?.toString() === '2') {
              updatedProperties.forEach((x) => {
                const prop = x.split('::');
                const property = cloneDeep(
                  this.state.propertyMasterData.find(
                    (x) => x.propertyId?.toString() === prop[0]
                  )
                );
                if (property) {
                  property.propertyName = prop[1];
                  managementProperties.push(property);
                }
              });
            } else {
              managementProperties = cloneDeep(propertyData);
            }
            const CIOPropertydetails = [];
            const { propertyMasterData } = this.state;
            const cioPropertyId = getSectionAttributeValueByKey(
              reorderData,
              'CiOProperties'
            )?.split('|');

            if (cioPropertyId && cioPropertyId.length > 0) {
              // this.state.propertyTypeMasterData?.filter(pm => cioPropertyId
              propertyMasterData
                ?.filter((pm) =>
                  cioPropertyId.find(
                    (ci) => ci?.toString() === pm.propertyId?.toString()
                  )
                )
                ?.forEach((prop) => {
                  console.log(prop);
                  CIOPropertydetails.push(prop);
                });
            }

            function compare(a, b) {
              if (a.propertyName < b.propertyName) {
                return -1;
              }
              if (a.propertyName > b.propertyName) {
                return 1;
              }
              return 0;
            }

            // clientContactDetails.data.push({
            //   attributeSortOrder: 12,
            //   attributeValue: '',
            //   dataFormat: 'Boolean',
            //   dbColumn: 'IsNonUsState',
            //   displayName: 'Non US State',
            //   isEditable: true,
            //   isRequired: false,
            //   isVisible: true,
            //   recordId: null,
            //   sectionDetailId: 542,
            //   sectionId: 36,
            //   type: 'Checkbox'
            // });

            const errorMessage = getSectionAttributeValueByKey(
              reorderData,
              'errorMessage'
            );
            let isReadOnly = false;
            if (errorMessage !== undefined && errorMessage !== '') {
              this.setState({
                hasPmaAccess: false
              })
              isReadOnly = true;
              ShowToast(errorMessage, toastType.ERROR, false, 500);
            }

            // newPropertyData.data.push({
            //   attributeSortOrder: 33,
            //   attributeValue: '',
            //   dataFormat: 'Boolean',
            //   dbColumn: 'IsNonUsState',
            //   displayName: 'Non US State',
            //   isEditable: true,
            //   isRequired: false,
            //   isVisible: true,
            //   recordId: null,
            //   sectionDetailId: 542,
            //   sectionId: 18,
            //   type: 'Checkbox'
            // });

            // NewClientDetail.data.push({
            //   attributeSortOrder: 12,
            //   attributeValue: '',
            //   dataFormat: 'Boolean',
            //   dbColumn: 'IsNonUsState',
            //   displayName: 'Non US State',
            //   isEditable: true,
            //   isRequired: false,
            //   isVisible: true,
            //   recordId: null,
            //   sectionDetailId: 542,
            //   sectionId: 20,
            //   type: 'Checkbox'
            // });

            let lastClosedPayPeriodEndDate = new Date('01/01/2000');
            if (((payPeriodData.data || []).filter(x => x.isClosed === true) || []).length > 0) {
              const lastClosedPayPeriod = ((payPeriodData.data || []).filter(x => x.isClosed === true) || []).reduce(function (r, a) {
                return new Date(r.periodEndDate) > new Date(a.periodEndDate) ? r : a;
              });
              lastClosedPayPeriodEndDate = lastClosedPayPeriod.periodEndDate;
            }

            this.setState(
              {
                pmaTitleMasterData: pmaTitleMasterData.data || [],
                managementProperties,
                CIOPropertydetails,
                CIOProperties,
                reloadManagementFeeSetion:
                  !this.state.reloadManagementFeeSetion,
                reloadBillableExpenseTable:
                  !this.state.reloadBillableExpenseTable,
                reloadManagementFeetable: !this.state.reloadManagementFeetable,
                reloadExpenseSection: !this.state.reloadExpenseSection,
                reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
                reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable,
                propertyMarketMasterData: cloneDeep(allocationMarkets),
                selectedPropertyId: this.props.selectedPropertyId,
                allMarketStateData: allMarketStateData.data || [],
                originalManagementFeeData: cloneDeep(managementFeeData),
                managementFeeData: cloneDeep(managementFeeData),
                originalExpenseData: cloneDeep(expenseData),
                expenseData: cloneDeep(expenseData),
                originalEngineerHourBillingData: cloneDeep(engineerHourBillingData),
                engineerHourBillingData: cloneDeep(engineerHourBillingData),
                feeDataStructure: this.setManagementFeeData(managementFeeData),
                expenseDataStructure: this.setPropertyExpenseData(expenseData),
                engineerHourBillingDataStructure: this.setEngineerHourBillingData(engineerHourBillingData),
                clientContactDetails: ccDetails || [],
                clientContactDataStructure: this.setClientContactdata(ccDetails || []),
                originalClientContactDetails: cloneDeep(clientContactDetails.data || []),
                clientContactDetailConfig: clientContactDetails.config || [],
                originaltransitionData: originaltransitionData || [],
                transitionData: cloneDeep(reorderData),
                allowToEdit: allowToEdit,
                allocationMarkets: allocationMarkets || [],
                isApproved: !allowToEdit,
                allocationConfiguration: allocationData.config || [],
                serviceTypeMasterData: master.serviceTypeMasterData || [],
                propertyMasterData: master.propertyMasterData || [],
                originalAllocationData: allocationData.data,
                employeesAllMasterData: employeesAllMasterData.data || [],
                employeesForAllocationMasterData:
                  employeesForAllocationMasterData.data || [],
                allocationData:
                  this.props.selectedPropertyId !== 0
                    ? allocationData.data.filter((x) => x.allocationId > 0)
                      ? allocationData.data.filter((x) => x.allocationId > 0)
                      : []
                    : [],
                isMultiBuilding: getIsPortfolio === '1',
                departmentMasterData: departmentMasterData.data || [],
                newPropertyData: newPropertyData.data || [],
                defaultNewPropertyData: cloneDeep(newPropertyData.data || []),
                marketMasterData: marketMasterData.data || [],
                clientMasterData: clientMasterData.data || [],
                customerMasterData: customerMasterData.data || [],
                // trackerTimeLineData: trackerstepsMasterData.data,
                newClientDetail: NewClientDetail.data || [],
                propertyTypeMasterData: propertyTypeMasterData.data || [],
                propertyDetails: propertyData.sort(compare) || [],
                ExistingPropertyDetails: propertyData || [],
                selectedOriginalTransitionTypeId:
                  selectedOriginalTransitionTypeId,
                selectedTransitionTypeId: (
                  selectedTransitionTypeId || '1'
                ).toString(),
                isMarketSelected: IsInEditMode,
                isClientSelected: IsInEditMode,
                isPropertyTypeSelected: IsInEditMode,
                expenseTypes: expenseTypes.data || [],
                sourceAccountingSystemData:
                  sourceAccountingSystemData.data || [],
                readOnly: isReadOnly,
                finalServiceList,
                finalProperties,
                ccDetailsFormFields,
                clientContactMainData,
                CIOClientContacts,
                CIOClientContactMasterData,
                ClientContactMasterData: clientContactDetails.data || [],
                propertySubTypeData: propertySubTypeData.data || [],
                originalPropertySubTypeData: propertySubTypeData.data || [],
                lastClosedPayPeriodEndDate: lastClosedPayPeriodEndDate,
                controllerEmployeesMasterData: controllerEmployeesMasterData.data || [],
                // ContactRoleMasterData: contactRoleMasterData.data || [],
                showSubmitBtnOnEnggBillingSection: isEngineerHourBilling
              },
              () => {
                if (selectedTransitionTypeId?.toString() === '2') {
                  this.CIOPropertyChanges(
                    getSectionAttributeValueByKey(
                      reorderData,
                      'updatedProperties'
                    )
                  );
                }
                this.getCityStateData(
                  getSectionAttributeValueByKey(reorderData, 'marketId')
                );
                this.getSpsData();
                if (selectedTransitionTypeId?.toString() === '2') {
                  this.getAllocationData(
                    getSectionAttributeValueByKey(reorderData, 'CiOProperties')
                  );
                  // this.props.selectedPropertyId &&
                  //   this.props.selectedPropertyId > 0 &&
                  //   this.getPropertyDetailsById(getSectionAttributeValueByKey(reorderData, 'CiOProperties'), {
                  //     managementFeeData: cloneDeep(managementFeeData),
                  //     expenseData: cloneDeep(expenseData)
                  //   });
                } else {
                  this.props.selectedPropertyId &&
                    this.props.selectedPropertyId > 0 &&
                    this.getPropertyDetailsById(this.props.selectedPropertyId, {
                      managementFeeData: cloneDeep(managementFeeData),
                      expenseData: cloneDeep(expenseData),
                      engineerHourBillingData: cloneDeep(engineerHourBillingData),
                      showSubmitBtnOnEnggBillingSection: isEngineerHourBilling
                    });
                }
              }
            );
          } else {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  setClientContactdata(clientContactData) {
    const groupedData = _.cloneDeep(
      this.getGroupedData(clientContactData || []) || []
    );
    const contactDataStructure = _.cloneDeep((groupedData[0] || {}).data || []);

    // const contactDataStructure = _.cloneDeep((groupedData
    //   .find(x => x.recordId === null || x.recordId === 'null') || {}).data || []);

    // contactDataStructure.forEach((x) => {
    //   x.recordId = 0;
    // });
    return contactDataStructure;
  }

  setManagementFeeData(managementFeeData) {
    const groupedData = _.cloneDeep(
      this.getGroupedData(managementFeeData || []) || []
    );
    const feeDataStructure = _.cloneDeep((groupedData[0] || {}).data || []);

    // const feeDataStructure = _.cloneDeep((groupedData
    //   .find(x => x.recordId === null || x.recordId === 'null') || {}).data || []);

    if (
      feeDataStructure.find((x) => x.dbColumn === 'ApplyToAll') === undefined
    ) {
      const applyToAll = _.cloneDeep(
        managementFeeData.find((x) => x.dbColumn === 'ApplyToAll')
      );
      if (applyToAll !== undefined) {
        applyToAll.dbColumn = 'ApplyToAll';
        applyToAll.attributeValue = '0';
        applyToAll.displayName = 'Apply To All';
        applyToAll.dataFormat = 'Boolean';
        applyToAll.recordId = (groupedData[0] || {}).recordId;
        feeDataStructure.push(_.cloneDeep(applyToAll));
      }
    }
    const applyToAll = _.cloneDeep(
      managementFeeData.find((x) => x.dbColumn === 'Startdate')
    );
    if (applyToAll !== undefined) {
      applyToAll.dbColumn = 'exclatedFee';
      applyToAll.attributeValue = '0';
      applyToAll.displayName = 'Add as new escalated Fee Group';
      applyToAll.dataFormat = 'Boolean';
      applyToAll.isRequired = false;
      applyToAll.recordId = (groupedData[0] || {}).recordId;
      applyToAll.attributeSortOrder = (applyToAll.attributeSortOrder || 49) + 1;
      feeDataStructure.push(_.cloneDeep(applyToAll));
    }
    const applyAll = getSectionAttributeValueByKey(feeDataStructure, 'ApplyToAll');
    feeDataStructure.forEach((x) => {
      if (x.dbColumn === 'ManagementPropertyName' && applyAll === '1') {
        x.isRequired = false;
        x.errorMessage = '';
      }
      x.recordId = 0;
    });
    return feeDataStructure;
  }

  setPropertyExpenseData(expenseData) {
    const groupedData = _.cloneDeep(
      this.getGroupedData(expenseData || []) || []
    );
    const expenseDataStructure = _.cloneDeep((groupedData[0] || {}).data || []);
    // const expenseDataStructure = _.cloneDeep((groupedData
    //   .find(x => x.recordId === null || x.recordId === 'null') || {}).data || []);

    if (
      expenseDataStructure.find((x) => x.dbColumn === 'ApplyToAll') ===
      undefined
    ) {
      const applyToAll = _.cloneDeep(
        expenseData.find((x) => x.dbColumn === 'ApplyToAll')
      );
      if (applyToAll !== undefined) {
        applyToAll.dbColumn = 'ApplyToAll';
        applyToAll.attributeValue = '0';
        applyToAll.displayName = 'Apply To All';
        applyToAll.dataFormat = 'Boolean';
        applyToAll.isVisible = true;
        applyToAll.recordId = (groupedData[0] || {}).recordId;
        expenseDataStructure.push(_.cloneDeep(applyToAll));
      }
    }

    expenseDataStructure.forEach((x) => {
      x.recordId = 0;
      if (x.dbColumn === 'ApplyToAll') {
        x.attributeValue = '0';
        x.isVisible = true;
      }
      if (
        x.dbColumn === 'ExpensesBillablePropertyName' ||
        x.dbColumn === 'ExpenseName'
      ) {
        x.isVisible = true;
        x.attributeValue = '';
      }
    });
    return expenseDataStructure;
  }

  // Show/Hide Engineer Hour Billing fields based on conditions
  showHideEngineerHourBillingFields(isEngineerHourBilling, engineerHourBillingDataStructure, recordCount = 0) {
    engineerHourBillingDataStructure.forEach((x) => {
      x.recordId = 0;
      if (isEngineerHourBilling === '1' || isEngineerHourBilling === 1 || isEngineerHourBilling === true) {
        if (x.dbColumn === 'EngineerHourlyBillingRate' || x.dbColumn === 'EngineerOvertimeHourlyBillingRate' || x.dbColumn === 'EngineerHourlyBillingStartDate') {
          x.isVisible = true;
          x.isRequired = true;
        } else if (x.dbColumn === 'IsEngineerHourBilling') {
          x.isVisible = true;
          x.attributeValue = '1';
        } else if (x.dbColumn === 'EngineerHourlyBillingEndDate') {
          x.attributeValue = null;
          x.isVisible = false;
          x.isRequired = false;
          x.errorMessage = '';
          x.isInErrorState = false;
        }
      } else {
        if (x.dbColumn === 'EngineerHourlyBillingRate' || x.dbColumn === 'EngineerOvertimeHourlyBillingRate') {
          x.attributeValue = 0;
          x.isVisible = false;
          x.isRequired = false;
          x.errorMessage = '';
          x.isInErrorState = false;
        } else if (x.dbColumn === 'EngineerHourlyBillingStartDate') {
          x.attributeValue = null;
          x.isVisible = false;
          x.isRequired = false;
          x.errorMessage = '';
          x.isInErrorState = false;
        } else if (x.dbColumn === 'EngineerHourlyBillingEndDate') {
          x.attributeValue = null;
          x.isVisible = recordCount > 0;
          x.isRequired = recordCount > 0;
          x.errorMessage = '';
          x.isInErrorState = false;
        }
      }
    });
    return engineerHourBillingDataStructure;
  }

  // Get Status of Engineering Hour Billing flag
  getEngineerHourBillingStatus(engineerHourBillingData) {
    const groupedData = _.cloneDeep(
      this.getGroupedData(engineerHourBillingData || []) || []
    );
    // const engineerHourBillingDataStructure = _.cloneDeep((groupedData[0] || {}).data || []);
    const engineerHourBillingDataStructure = _.cloneDeep((groupedData?.find(x => x.recordId?.toString() !== '0' && x.recordId !== 'null'))?.data || []);
    const isEngineerHourBilling = getSectionAttributeValueByKey(engineerHourBillingDataStructure, 'IsEngineerHourBilling') || 0;
    return (isEngineerHourBilling === '1' || isEngineerHourBilling === 1 || isEngineerHourBilling === true);
  }

  // Set Engineer Hour Billing Data
  setEngineerHourBillingData(engineerHourBillingData) {
    const groupedData = _.cloneDeep(
      this.getGroupedData(engineerHourBillingData || []) || []
    );
    let engineerHourBillingDataStructure = _.cloneDeep((groupedData[0] || {}).data || []);
    const engineerHourBillingDataStructure1 = _.cloneDeep((groupedData?.find(x => x.recordId?.toString() !== '0' && x.recordId !== 'null'))?.data || []);
    let isEngineerHourBilling = getSectionAttributeValueByKey(engineerHourBillingDataStructure1, 'IsEngineerHourBilling') || 0;
    isEngineerHourBilling = (isEngineerHourBilling === '1' || isEngineerHourBilling === 1 || isEngineerHourBilling === true);
    engineerHourBillingDataStructure = this.showHideEngineerHourBillingFields(isEngineerHourBilling, engineerHourBillingDataStructure);
    return engineerHourBillingDataStructure;
  }

  normalizePath(folderName, fileName) {
    const folder = (folderName || "").replace(/\/+$/, "").trim();
    return (folder ? folder + "/" + fileName : fileName).toLowerCase();
  }

  computeTargetFileName(x) {
    return x.isW9
      ? 'W-9_' + ((x && x.file && x.file.name) ? x.file.name : 'document.pdf')
      : (x.category + '_Document_' + ((x && x.file && x.file.name) ? x.file.name : 'document.pdf'));
  }

  async UpdateAllocationData(url, postBodyData, transitionId, msg) {
    //     return;
    const state = this.state || {};

    // 1) Collect all uploads this submit
    const uploads = []
      .concat(state.filesToBeUploaded || [])
      .concat(state.w9FilesToBeUploaded || []);

    const uploadNamesSet = new Set(
      uploads.map(x => this.normalizePath(state.folderName, this.computeTargetFileName(x)))
    );

    // 2) Collect deletes but skip ones we’re replacing
    const candidatesToDelete = []
      .concat(state.filesToBeDeleted || [])
      .concat(state.w9FilesToBeDeleted || []);

    const toDelete = candidatesToDelete.filter(name =>
      !uploadNamesSet.has(this.normalizePath(state.folderName, name))
    );

    if (toDelete.length) {
      await this.deleteSpsData(toDelete);
    }

    if (uploads.length) {
      await this.getSpsData(transitionId);
    }
    if (
      this.props.actionType === 'Edit' &&
      (this.state.filesToBeUploaded === undefined || (this.state.filesToBeUploaded || []).length === 0)
    ) {
      this.props.onViewChange();
    }

    if (this.state.deleteAllocation && this.state.deleteAllocation.length > 0) {
      this.state.deleteAllocation.forEach((params) => {
        apiDelete({
          url: API_URL.Allocation.DeleteAllocation,
          params
        })
          .then(({ data }) => { })
          .catch(() => { });
      });
    }

    if (
      postBodyData &&
      postBodyData.length > 0 &&
      (this.state.selectedTransitionTypeId?.toString() || '1') !== '2'
    ) {
      apiBatchRequest([
        {
          url: `${API_URL.Property.GetPropertyData}?transitionId=${this.props.selectedTransitionId > 0 &&
            (this.state.selectedTransitionTypeId || '1') !== '2'
            ? this.props.selectedTransitionId
            : transitionId
            }`,
          key: 'properties'
        }
      ]).then(({ properties }) => {
        if ((this.state.selectedTransitionTypeId || '1').toString() === '3') {
          ShowToast(msg, toastType.SUCCESS, 5000, 500);
          if (!this.props.actionType || this.props.actionType === 'Edit') {
            this.props.onViewChange();
          } else if (this.state.filesToBeUploaded === undefined) {
            this.props.onViewChange();
          }
        } else {
          postBodyData.forEach((allocation) => {
            allocation.propertyId = (
              (properties.data || []).find(
                (x) =>
                  x.propertyName?.toLowerCase() ===
                  allocation.propertyName?.toLowerCase()
              ) || {}
            ).propertyId;
            allocation.legalEntityId = (
              (properties.data || []).find(
                (x) =>
                  x.legalEntity?.toLowerCase() ===
                  allocation.legalEntity?.toLowerCase()
              ) || {}
            ).legalEntityId;
          });
          apiPost({
            url: url,
            params: {},
            postBody: postBodyData
          }).then(({ data: response }) => {
            ShowToast(msg, toastType.SUCCESS, 5000, 500);
            this.props.onViewChange();
          });
        }
      });
    } else {
      ShowToast(msg, toastType.SUCCESS, 5000, 500);
      if (!this.props.actionType || this.state.filesToBeUploaded === undefined || (this.state.filesToBeUploaded || []).length === 0) {
        this.props.onViewChange();
      }
      // this.props.onViewChange();
    }
  }

  getList = (fileName, emailId, x) => {
     getSpsAPiRequest(
      getSharePointUrl(
        'streamrealty',
        'getSps',
        this.state.spListkey,
        this.state.folderName
      )
    ).then((spsDataRes) => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.updateMetaData(value[i].listItem.id, emailId, x.category);
            break;
          }
        }
      }
    });
  };

  getListCIO = (fileName, emailId, x, newFolderName, spCIOListkey) => {
    getSpsAPiRequest(
      getSharePointUrl(
        'streamrealty',
        'getSps',
        spCIOListkey, // this.state.spCIOListkey,
        newFolderName // this.state.newFolderName
      )
    ).then((spsDataRes) => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.updateMetaDataCIO(value[i].listItem.id, emailId, 'NewAssignment', newFolderName, spCIOListkey);
            break;
          }
        }
      }
    });
  };

  updateMetaDataCIO = (itemid, emailId = '', category, newFolderName, spCIOListkey) => {
    const metadata = {
      FileType: category,
      UserEmail: emailId
    };
    uploadSpsMetadataAPiRequest(
      getSharePointUrl(
        'streamrealty',
        'uploadMetadata',
        spCIOListkey, // this.state.spCIOListkey,
        itemid
      ),
      metadata
    ).then(() => {
      // this.setState({ filesToUpload: [], selectedFile: [] });
      // this.getSpsData();
    });
  };

  updateMetaData = (itemid, emailId = '', category) => {
    const metadata = {
      FileType: category,
      UserEmail: emailId
    };
    uploadSpsMetadataAPiRequest(
      getSharePointUrl(
        'streamrealty',
        'uploadMetadata',
        this.state.spListkey,
        itemid
      ),
      metadata
    ).then(() => {
      // this.setState({ filesToUpload: [], selectedFile: [] });
      // this.getSpsData();
    });
  };

  prepareAllocationModel = (propertyTransitionId, IsDraft) => {
    const { allocationData } = this.state;
    const postBodyData = [];

    const excludedStatuses = [
      ApprovedStatus.Approved.toString(),
      ApprovedStatus.Historical.toString(),
      ApprovedStatus.RequestedChanges.toString(),
    ];

    allocationData
      .filter((x) => !excludedStatuses.includes(x.approvalId?.toString()) && x.statusId !== 11)
      .forEach((x) => {
        x.approvalId = IsDraft
          ? ApprovedStatus.Draft
          : ApprovedStatus.PendingApproval;

        // x.LegalEntity = ;
        // x.legalEntity = ;
        if (
          x.isAllocatedToLegalEntity === false ||
          x.legalEntityAndPropertyData === undefined
        ) {
          const data = this.prepareDataModel(
            x,
            x.propertyId,
            x.allocationId,
            x.propertyAllocationPercent,
            x.propertyBillingPercent,
            x.additionalFixedAmount,
            x.approvalId,
            x.propertyName,
            propertyTransitionId
          );
          postBodyData.push(data);
        } else {
          if (x.legalEntityAndPropertyData !== undefined) {
            x.legalEntityAndPropertyData.forEach((element) => {
              const data = this.prepareDataModel(
                x,
                element.propertyId,
                element.allocationId,
                element.propertyAllocationPercent,
                element.propertyBillingPercent,
                element.additionalFixedAmount,
                x.approvalId,
                element.propertyName,
                propertyTransitionId
              );
              postBodyData.push(data);
            });
          }
        }
      });

    return postBodyData;
  };

  prepareDataModel = (
    newParam,
    propertyId,
    allocationId,
    propertyAllocationPercent,
    propertyBillingPercent,
    additionalFixedAmount,
    approvalId,
    propertyName,
    propertyTransitionId
  ) => {
    return {
      pmaTitleId: newParam.pmaTitleId,
      departmentId: newParam.departmentId,
      propertyId: propertyId,
      propertyName: propertyName,
      employeeId: newParam.employeeId,
      allocationStartDate: moment(newParam.allocationStartDate).format(
        'YYYY/MM/DD'
      ),
      allocationEndDate:
        newParam.allocationEndDate &&
          moment(newParam.allocationEndDate).isValid() === true &&
          newParam.allocationEndDate !== '0001-01-01T00:00:00' &&
          newParam.allocationEndDate !== '0001-01-01' &&
          newParam.allocationEndDate.length > 0
          ? moment(newParam.allocationEndDate).format('YYYY/MM/DD')
          : null,
      billingStartDate: moment(newParam.billingStartDate).format('YYYY/MM/DD'),
      billingEndDate:
        newParam.billingEndDate &&
          newParam.billingEndDate.length > 1 &&
          moment(newParam.billingEndDate).isValid() === true &&
          newParam.billingEndDate !== '0001-01-01T00:00:00' &&
          newParam.billingEndDate !== '0001-01-01'
          ? moment(newParam.billingEndDate).format('YYYY/MM/DD')
          : null,
      marketAllocationPercent:
        newParam.marketAllocationPercent != null &&
          newParam.marketAllocationPercent !== '' &&
          newParam.marketAllocationPercent !== undefined
          ? newParam.marketAllocationPercent
          : 0,
      marketBillingPercent: newParam.marketBillingPercent,
      propertyAllocationPercent:
        propertyAllocationPercent !== null &&
          propertyAllocationPercent !== '' &&
          propertyAllocationPercent !== undefined
          ? parseFloat(propertyAllocationPercent)
          : 0,
      propertyBillingPercent:
        propertyBillingPercent !== null &&
          propertyBillingPercent !== '' &&
          propertyBillingPercent !== undefined
          ? parseFloat(propertyBillingPercent)
          : 0,
      additionalFixedAmount:
        additionalFixedAmount !== null &&
          additionalFixedAmount !== '' &&
          additionalFixedAmount !== undefined
          ? parseFloat(additionalFixedAmount)
          : 0,
      rateValue: newParam.rateValue,
      isReimbursed: newParam.isReimbursed,
      isApproved: newParam.isApproved,
      allocationType: newParam.allocationType,
      statusId: 1,
      marketId: parseInt(newParam.marketId),
      isAllocatedToLegalEntity: newParam.isAllocatedToLegalEntity,
      legalEntityId: parseInt(newParam.legalEntityId),
      // LegalEntity: newParam.legalEntity,
      legalEntity: newParam.legalEntity,
      allocationId: allocationId,
      approvalStatusId:
        (approvalId || '').toString() ===
          ApprovedStatus.RequestedChanges.toString()
          ? ApprovedStatus.PendingApproval
          : approvalId,
      propertyTransitionId:
        newParam.propertyTransitionId ?? propertyTransitionId
    };
  };

  getTrackerSteps = () => {
    return (
      <Paper className="custom-section">
        <CustomizedTimeline
          callbackOnchange={this.updateTrackerListItem}
          trackerTimeLineData={this.state.trackerTimeLineData}
        ></CustomizedTimeline>
      </Paper>
    );
  };

  updateTrackerListItem = (item) => {
    this.setState({
      selectedTrackerItem: { ...item },
      openUpdateTrackerItemPopup: true
    });
  };

  onTrackerItemChange = (value, key) => {
    const { selectedTrackerItem } = this.state;
    selectedTrackerItem[key] = value;
    this.setState({ selectedTrackerItem: selectedTrackerItem });
    this.forceUpdate();
  };

  saveTrackerChanges = () => {
    const { trackerTimeLineData, selectedTrackerItem } = this.state;
    const updatedData = [];
    trackerTimeLineData.forEach((step) => {
      if (
        step.propertyTransitionTrackerStepId ===
        selectedTrackerItem.propertyTransitionTrackerStepId
      ) {
        selectedTrackerItem.completedOn = moment().format(
          'YYYY/MM/DDThh:mm:00'
        );
        selectedTrackerItem.completedBy =
          (((store.getState() || {}).auth || {}).account || {}).username || '';
        updatedData.push({ ...selectedTrackerItem });
      } else {
        updatedData.push(step);
      }
    });
    this.setState({
      selectedTrackerItem: undefined,
      trackerTimeLineData: updatedData,
      openUpdateTrackerItemPopup: false
    });
    this.forceUpdate();
  };

  cancelTrackerChanges = () => {
    this.setState({
      selectedTrackerItem: undefined,
      openUpdateTrackerItemPopup: false
    });
    this.forceUpdate();
  };

  addNewProperty = (source, option, updateoption = true) => {
    const {
      newPropertyData,
      transitionData,
      isClientSelected,
      isMarketSelected,
      isPropertyTypeSelected,
      originalPropertySubTypeData
    } = this.state;
    newPropertyData.forEach((ele) => {
      if (
        _.camelCase(ele.dbColumn) !== _.camelCase('ClientName') &&
        _.camelCase(ele.dbColumn) !== _.camelCase('PropertyType') &&
        _.camelCase(ele.dbColumn) !== _.camelCase('MarketName') &&
        _.camelCase(ele.dbColumn) !== _.camelCase('LegalEntity')
      ) {
        ele.attributeValue = '';
      }
    });
    // const newPropertyData = cloneDeep(defaultNewPropertyData);
    newPropertyData.forEach((ele) => {
      if (
        _.camelCase(ele.dbColumn) !== _.camelCase('ClientName') &&
        _.camelCase(ele.dbColumn) !== _.camelCase('PropertyType') &&
        _.camelCase(ele.dbColumn) !== _.camelCase('MarketName') &&
        _.camelCase(ele.dbColumn) !== _.camelCase('LegalEntity')
      ) {
        ele.attributeValue = '';
      }
    });
    const serviceTypeIds = getSectionAttributeValueByKey(transitionData, 'ServiceTypeId')?.split('|') || [];
    if (serviceTypeIds.find(x => x?.toString() === ServiceTypes.Property_Accounting?.toString())) {
      setSectionFieldAttributeByKey(newPropertyData, 'ARAdminName', 'isVisible', true);
    } else {
      setSectionFieldAttributeByKey(newPropertyData, 'ARAdminName', 'isVisible', false);
    }
    setSectionAttributeValueByKey(
      newPropertyData,
      'LegalEntity',
      getSectionAttributeValueByKey(transitionData, 'assignmentName')
    );
    if (isClientSelected && isMarketSelected && isPropertyTypeSelected) {
      if (this.state.isMultiBuilding) {
        (
          newPropertyData.find(
            (x) => _.camelCase(x.dbColumn) === _.camelCase('LegalEntity')
          ) || {}
        ).isEditable = true;
      } else {
        const leagal = newPropertyData.find(
          (x) => _.camelCase(x.dbColumn) === _.camelCase('LegalEntity')
        );
        if (
          leagal &&
          leagal.attributeValue &&
          leagal.attributeValue?.length > 0
        ) {
          leagal.isEditable = false;
        }
      }

      if (updateoption) {
        setSectionAttributeValueByKey(newPropertyData, 'PropertyName', option);
      }

      setSectionAttributeValueByKey(newPropertyData, 'propertyId', '-1');
      setSectionAttributeValueByKey(
        newPropertyData,
        'ClientName',
        getSectionAttributeValueByKey(transitionData, 'ClientName')
      );

      setSectionAttributeValueByKey(
        newPropertyData,
        'ClientName',
        getSectionAttributeValueByKey(transitionData, 'ClientName')
      );
      setSectionFieldAttributeByKey(
        newPropertyData,
        'ClientName',
        'isEditable',
        false
      );

      setSectionAttributeValueByKey(
        newPropertyData,
        'ClientId',
        getSectionAttributeValueByKey(transitionData, 'ClientId')
      );

      setSectionAttributeValueByKey(
        newPropertyData,
        'MarketName',
        getSectionAttributeValueByKey(transitionData, 'MarketName').split(
          '|'
        )[0]
      );

      setSectionAttributeValueByKey(
        newPropertyData,
        'MarketId',
        (getSectionAttributeValueByKey(transitionData, 'MarketId') || '')
          .toString()
          .split('|')[0]
      );

      setSectionFieldAttributeByKey(
        newPropertyData,
        'MarketName',
        'isEditable',
        !!this.state.isMultiBuilding
      );

      // Propert Type newly added
      setSectionAttributeValueByKey(
        newPropertyData,
        'PropertyTypeName',
        getSectionAttributeValueByKey(transitionData, 'PropertyType')
      );
      setSectionAttributeValueByKey(
        newPropertyData,
        'PropertyTypeId',
        getSectionAttributeValueByKey(transitionData, 'PropertyTypeId')
      );
      setSectionFieldAttributeByKey(
        newPropertyData,
        'PropertyTypeName',
        'isEditable',
        false
      );
      // function compare (a, b) {
      //   if (a.dbColumn === 'PropertyName' && b.dbColumn === 'PropertyName') {
      //     if (a.attributeValue < b.attributeValue) {
      //       return -1;
      //     }
      //     if (a.attributeValue > b.attributeValue) {
      //       return 1;
      //     }
      //     return 0;
      //   }
      // }

      // newPropertyData.sort(compare);
      const propertySubTypeData = cloneDeep(originalPropertySubTypeData);
      const value = getSectionAttributeValueByKey(transitionData, 'PropertyType');
      if (propertySubTypeData.find(x => x.propertySubTypeName === value) !== undefined) {
        setSectionAttributeValueByKey(
          newPropertyData,
          'PropertySubTypeName',
          value
        );
        setSectionAttributeValueByKey(
          newPropertyData,
          'PropertySubTypeId',
          getSectionAttributeValueByKey(transitionData, 'PropertyTypeId')
        );
        setSectionFieldAttributeByKey(
          newPropertyData,
          'PropertySubTypeName',
          'isEditable',
          false
        );
      } else {
        setSectionFieldAttributeByKey(
          newPropertyData,
          'PropertySubTypeName',
          'isEditable',
          true
        );
      }
      this.setState(
        {
          openaddform: true,
          addformtitle: source.AddNewOptiontitle,
          addNewformComponent: source.AddOptionComponent,
          transitionData: transitionData,
          newPropertyData: [...cloneDeep(newPropertyData)],
          reloadProperty: !this.state.reloadProperty
        },
        () => {
          this.forceUpdate();
        }
      );
    } else {
      const entity = [];
      if (isClientSelected !== true) {
        entity.push(<b> Client</b>);
      }
      if (isMarketSelected !== true) {
        if (entity.length > 0) {
          if (isPropertyTypeSelected !== true) {
            entity.push(', ');
          } else {
            entity.push(' and');
          }
        }
        entity.push(<b> Market</b>);
      }
      if (isPropertyTypeSelected !== true) {
        if (entity.length > 0) {
          entity.push(' and');
        }
        entity.push(<b> Property Type.</b>);
      }
      ShowToast(
        <p>
          Please select {entity.map((obj) => obj)} before adding a new Property.
        </p>,
        toastType.INFO,
        3000,
        6565
      );
    }
  };

  SaveClientDetails = (formdetails) => {
    const { transitionData, clientMasterData } = this.state;
    if ((this.state.selectedTransitionTypeId || '').toString() === '2') {
      transitionData.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('NewClient')
      ).attributeValue = formdetails.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
      ).attributeValue;
      transitionData.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('NewClientId')
      ).attributeValue = formdetails.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientId')
      ).attributeValue;
    } else {
      transitionData.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientName')
      ).attributeValue = formdetails.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
      ).attributeValue;
      transitionData.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientId')
      ).attributeValue = formdetails.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientId')
      ).attributeValue;
    }

    const value = formdetails.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
    ).attributeValue;
    if (value === undefined || value === null || value === '') {
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'isInErrorState',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'errorMessage',
        'New Client field is required.'
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'errorMessage',
        ''
      );
    }
    const selectedClientName = (
      getSectionAttributeValueByKey(formdetails, 'Name') || ''
    ).toString();
    const selectedClientId = (
      getSectionAttributeValueByKey(formdetails, 'ClientId') || ''
    ).toString();
    const filtered = clientMasterData.filter((x) => x.clientId !== -1);
    if (selectedClientId === '-1') {
      const findobject = {
        ...(clientMasterData.find((x) => x[_.camelCase('ClientId')] === -1) || {
          ...clientMasterData[0]
        })
      };
      findobject.clientId = -1;
      findobject.clientName = formdetails.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
      ).attributeValue;
      filtered.push(findobject);
      formdetails.forEach((ele) => {
        ele.recordId = -1;
      });
    } else {
      formdetails.forEach((ele) => {
        ele.recordId = selectedClientId;
      });
    }

    const fuseOptions = {
      includeScore: true,
      // Search in `author` and in `tags` array
      ignoreLocation: true,
      threshold: 0.4,
      minMatchCharLength: (selectedClientName || '').length / 2,
      keys: ['clientName']
    };
    const fuse = new Fuse(clientMasterData, fuseOptions);
    const options = fuse.search(selectedClientName);

    let showConfirmDialog = false;

    if (selectedClientId === '-1') {
      if (options.length > 0) {
        showConfirmDialog = true;
      }
    }
    transitionData.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientName')
    ).isInErrorState = false;
    transitionData.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientName')
    ).errorMessage = '';
    this.setState(
      {
        newClientDetail: formdetails,
        transitionData: transitionData,
        clientMasterData: filtered,
        IsNewClientAdded: true,
        isClientSelected: true,
        openaddform: false,
        showConfirmDialog,
        ConfirmDialogMessage: this.getClientOptionMessage(
          options,
          selectedClientName
        )
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  getClientOptionMessage = (options, selectedClientName) => {
    return (
      <div>
        Are you sure you want to create a new client record as{' '}
        <b>
          <i>{selectedClientName}</i>
        </b>
        ?<br />
        Because we have found some similar name records as listed below either
        select from below list or create new.
        <ul>
          {(_.orderBy(options, ['score'], ['desc']) || [])
            .slice(0, 10)
            .map((x, i) => (
              <li key={x.item.clientId + i}>{x.item.clientName}</li>
            ))}
        </ul>
      </div>
    );
  };

  // onClickHandel= (e) => {
  //   if (e === true) {
  //     this.setState({
  //       IsNewClientAdded: true,
  //       showConfirmDialog: false,
  //       openaddform: false,
  //       ConfirmDialogMessage: []
  //     });
  //   } else {
  //     this.setState({
  //       IsNewClientAdded: false,
  //       showConfirmDialog: false,
  //       openaddform: true,
  //       addformtitle: this.state.addnewClientSource.AddNewOptiontitle,
  //       addNewformComponent: (this.getNewClientdetailForm(this.state.newClientDetail)),
  //       addnewClientSource: this.state.addnewClientSource
  //     });
  //   }
  // }

  // onConfirmHandle = (e) => {
  //   if (e === true) {

  //   } else {
  //     this.setState({
  //       showSRPConfirmDialog: false,
  //       ConfirmDialogMessage: '',
  //       isButtonsDisabled: false
  //     });
  //   }
  // }

  onClickHandel = async (e) => {
    if (e === true) {
      const newClient = this.state.newClientDetail;
      const name = newClient.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
      ).attributeValue;
      const address = newClient.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('Address')
      ).attributeValue;
      const city = newClient.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('City')
      ).attributeValue;
      const state = newClient.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('State')
      ).attributeValue;
      const zipcode = newClient.find(
        (x) => _.camelCase(x.dbColumn) === _.camelCase('ZipCode')
      ).attributeValue;

      const duplicates = await this.CheckDuplicate(
        'client',
        name,
        address,
        city,
        state,
        zipcode,
        false
      );
      if (duplicates && duplicates.length > 0) {
        // duplicate found
        // const msg = 'Duplicate clients exists with same name/address: ' + duplicates.join(',');
        const msg =
          'Duplicate client(s) exists with same name : ' + duplicates.join(',');
        ShowToast(msg, toastType.ERROR, 5000, 500, 'Duplicate Found');
        this.setState({
          IsNewClientAdded: false,
          showConfirmDialog: false,
          openaddform: true,
          addformtitle: this.state.addnewClientSource.AddNewOptiontitle,
          addNewformComponent: this.getNewClientdetailForm(
            this.state.newClientDetail
          ),
          addnewClientSource: this.state.addnewClientSource
        });
      } else {
        // no duplicate
        this.setState({
          IsNewClientAdded: true,
          showConfirmDialog: false,
          openaddform: false,
          ConfirmDialogMessage: []
        });
      }
    } else {
      this.setState({
        IsNewClientAdded: false,
        showConfirmDialog: false,
        openaddform: true,
        addformtitle: this.state.addnewClientSource.AddNewOptiontitle,
        addNewformComponent: this.getNewClientdetailForm(
          this.state.newClientDetail
        ),
        addnewClientSource: this.state.addnewClientSource
      });
    }
  };

  SaveOwnerChangeClientDetails = (formdetails) => {
    const { transitionData, clientMasterData } = this.state;
    transitionData.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('NewClient')
    ).attributeValue = formdetails.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
    ).attributeValue;
    transitionData.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('NewClientId')
    ).attributeValue = formdetails.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('ClientId')
    ).attributeValue;
    const findobject = {
      ...(clientMasterData.find((x) => x[_.camelCase('ClientId')] === -1) || {
        ...clientMasterData[0]
      })
    };

    findobject.clientId = -1;
    findobject.clientName = formdetails.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
    ).attributeValue;
    const filtered = clientMasterData.filter((x) => x.clientId !== -1);
    filtered.push(findobject);
    formdetails.forEach((ele) => {
      ele.recordId = -1;
    });

    const value = formdetails.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase('Name')
    ).attributeValue;
    if (value === undefined || value === null || value === '') {
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'isInErrorState',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'errorMessage',
        'New Client field is required.'
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'errorMessage',
        ''
      );
    }
    this.setState({
      newClientDetail: formdetails,
      transitionData: transitionData,
      clientMasterData: filtered,
      IsNewClientAdded: true,
      isClientSelected: true,
      openaddform: false
    });
  };

  IsDuplicateproperty = async (formdetails) => {
    const propertyId = getSectionAttributeValueByKey(formdetails, 'PropertyId');
    const name = getSectionAttributeValueByKey(formdetails, 'propertyName');
    const address = getSectionAttributeValueByKey(formdetails, 'Address');
    const city = getSectionAttributeValueByKey(formdetails, 'city');
    const state = getSectionAttributeValueByKey(formdetails, 'state');
    const zipcode = getSectionAttributeValueByKey(formdetails, 'zipCode');
    const clientId = getSectionAttributeValueByKey(formdetails, 'ClientId');
    const yardiCode = getSectionAttributeValueByKey(formdetails, 'YardiCode');

    const duplicates = await this.CheckDuplicate(
      'property',
      name,
      address,
      city,
      state,
      zipcode,
      false,
      propertyId,
      clientId,
      yardiCode
    );
    if (duplicates && duplicates.length > 0) {
      // duplicate found
      // const msg = 'Duplicate property exists with the same name and address: ' + duplicates.join(',');
      const msg = name + ' already exists without a Property Code. Please link the Property Code to the existing Property from the Properties screen and try again.'; // 'Duplicate property exists with the same name.';
      ShowToast(msg, toastType.ERROR, 5000, 500, 'Duplicate Found');
      return true;
    }
    return false;
  };

  CheckDuplicate = (
    type,
    name,
    address,
    city,
    state,
    zipcode,
    checkOnlyAddress,
    id = null,
    clientId = null,
    yardiCode = null
  ) => {
    return new Promise(function (resolve, reject) {
      apiBatchRequest([
        {
          url: `${API_URL.Transition.CheckDuplicate}?name=${name}&address=${address}&city=${city}&state=${state}&zipcode=${zipcode}&type=${type}&checkOnlyAddress=${checkOnlyAddress}&id=${id}&clientId=${clientId}&yardiCode=${yardiCode}`,
          key: 'duplicateRecords'
        }
      ])
        .then(({ duplicateRecords }) => {
          return resolve(duplicateRecords.data || []);
        })
        .catch(() => {
          return resolve([]);
        });
    });
  };

  SaveNewProperty = async (formdetails) => {
    const propertyDetails = [...this.state.propertyDetails];
    let IsValid = true;
    formdetails.forEach((ele) => {
      isInputValid(ele.attributeValue, ele, formdetails);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    if (!IsValid) {
      this.setState({
        newPropertyData: formdetails,
        reloadProperty: !this.state.reloadProperty
      });
      return;
    }
    const x = await this.IsDuplicateproperty(formdetails);
    if (!x) {
      let minPropertyId = 0;
      let currentPropertyId = 0;
      propertyDetails?.forEach((p) => {
        currentPropertyId = parseInt(p.propertyId);
        minPropertyId = currentPropertyId < minPropertyId ? currentPropertyId : minPropertyId;
      });
      minPropertyId = minPropertyId - 1;
      minPropertyId = minPropertyId >= 0 ? (minPropertyId * (-1)) : minPropertyId;
      // const newPropertyId = (propertyDetails.length + 1) * -1;
      // setSectionAttributeValueByKey(formdetails, 'propertyId', newPropertyId);
      setSectionAttributeValueByKey(formdetails, 'propertyId', minPropertyId);
      this.updateProperty(formdetails, x);
    }

    // this.updateProperty(formdetails);
    // }
    // }
  };

  checkDuplicateAndUpdateProperty = async (formdetails) => {
    const x = await this.IsDuplicateproperty(formdetails);
    if (!x) {
      this.updateProperty(formdetails, x);
    }
  }

  updateAllocation = (formdetails) => {
    let newPropertyId = 0;
    let propertyName = '';
    newPropertyId = getSectionAttributeValueByKey(formdetails, 'propertyId');
    propertyName = getSectionAttributeValueByKey(formdetails, 'propertyName');

    const { allocationData } = this.state;
    const isLegalEntityAllocation =
      allocationData.filter((x) => x.isAllocatedToLegalEntity) || [];
    let empIds = isLegalEntityAllocation.map((x) => {
      return x.employeeId;
    });
    empIds = removeDuplicates(empIds);
    empIds.forEach((x) => {
      const allocationByEmployee = allocationData.filter(
        (y) => y.employeeId === x
      );
      const propertyBillingPercent =
        allocationByEmployee.reduce(
          (total1, obj) =>
            parseFloat(obj.propertyBillingPercent) + parseFloat(total1),
          0
        ) /
        (allocationByEmployee.length + 1);
      const additionalFixedAmount =
        allocationByEmployee.reduce(
          (total1, obj) =>
            parseFloat(obj.additionalFixedAmount) + parseFloat(total1),
          0
        ) /
        (allocationByEmployee.length + 1);
      const propertyAllocationPercent =
        allocationByEmployee.reduce(
          (total1, obj) =>
            parseFloat(obj.propertyAllocationPercent) + parseFloat(total1),
          0
        ) /
        (allocationByEmployee.length + 1);
      allocationData
        .filter((y) => y.employeeId === x)
        .map((x) => {
          x.propertyBillingPercent = propertyBillingPercent;
          x.additionalFixedAmount = additionalFixedAmount;
          x.propertyAllocationPercent = propertyAllocationPercent;
          return x;
        });
      if (this.state.enableSubmitButtons !== true) {
        const newRecord = cloneDeep(
          allocationData.find((y) => y.employeeId === x)
        );
        newRecord.propertyId = newPropertyId;
        newRecord.propertyName = propertyName;
        newRecord.allocationId = -(allocationData.length + 1);
        allocationData.push(newRecord);
      }
    });
    return allocationData;
  };

  updateProperty = (formdetails, isDuplicate = false) => {
    const { transitionData, propertyMasterData, newMultiProperty, employeesAllMasterData } = this.state;
    let propertyDetails = [...this.state.propertyDetails];
    let CIOPropertydetails = [...this.state.CIOPropertydetails];
    let updatednewMultiProperty = [];
    const propertyName = [];
    const propertyId = [];
    const newDetails = {};
    let isAddressValid = true;

    const aRAdminName = getSectionAttributeValueByKey(formdetails, 'ARAdminName');
    const aRAdminId = (employeesAllMasterData || []).find((x) => x.employeeStatus === true &&
      x.departmentId?.toString() === DEPARTMENT.CENTRALIZED_AR?.toString() &&
      x.employeeName === aRAdminName
    )?.employeeId || null;
    setSectionAttributeValueByKey(formdetails, 'ARAdminId', aRAdminId);

    formdetails.forEach((ele) => {
      isInputValid(ele.attributeValue, ele, formdetails);
      if (ele.isInErrorState === true) {
        isAddressValid = false;
      }
    });
    newMultiProperty.forEach((prop) => {
      const propPropertyId = getSectionAttributeValueByKey(prop, 'propertyId');
      const propertyName = getSectionAttributeValueByKey(prop, 'propertyName');
      const currentPropertyId = getSectionAttributeValueByKey(formdetails, 'propertyId');
      const currentName = getSectionAttributeValueByKey(formdetails, 'propertyName');
      if (currentPropertyId !== propPropertyId &&
        (currentName?.trim()?.toLowerCase() === propertyName?.trim()?.toLowerCase()) // && currentAddress?.trim() === propAddress?.trim() && currentCity?.trim() === propCity?.trim() && currentState?.trim() === propState?.trim() && currentZipCode?.trim() === propZipCode?.trim())
      ) {
        isAddressValid = false;
        setSectionFieldAttributeByKey(formdetails, 'propertyName', 'isInErrorState', true);
        setSectionFieldAttributeByKey(formdetails, 'propertyName', 'errorMessage', 'Property Name already exists');
        const msg = currentName + ' already exists without a Property Code. Please link the Property Code to the existing Property from the Properties screen and try again.'; // 'Duplicate property exists with the same name';
        ShowToast(msg, toastType.ERROR, 5000, 500, 'Duplicate Found');
      }
    });

    if (!isAddressValid) {
      this.setState({
        newPropertyData: formdetails,
        reloadProperty: !this.state.reloadProperty
      });
      return;
    }
    // if (isDuplicate) {
    //   return;
    // }
    const allocationData = this.updateAllocation(formdetails);
    const newPropertyId = getSectionAttributeValueByKey(
      formdetails,
      'propertyId'
    );

    propertyColumnsPTF.forEach((col) => {
      newDetails[_.camelCase(col.key)] =
        col.key === 'propertyId'
          ? newPropertyId
          : getSectionAttributeValueByKey(formdetails, col.key);
    });

    formdetails.forEach((ele) => {
      ele.recordId = newPropertyId;
      newDetails[_.camelCase(ele.dbColumn)] = ele.attributeValue;
    });

    propertyId.push(newPropertyId);
    propertyName.push(
      getSectionAttributeValueByKey(formdetails, 'propertyName')
    );
    const LegalEntity = getSectionAttributeValueByKey(
      formdetails,
      'LegalEntity'
    );
    newDetails.LegalEntity = LegalEntity;
    if (this.state.selectedTransitionTypeId?.toString() !== '2') {
      propertyDetails = propertyDetails.filter(
        (x) =>
          (x.propertyId || '').toString() !==
          getSectionAttributeValueByKey(formdetails, 'propertyId').toString()
      );
      propertyDetails.push(newDetails);
      newMultiProperty.forEach((prop) => {
        if (
          propertyDetails.find(
            (x) =>
              x.propertyName ===
              getSectionAttributeValueByKey(prop, 'propertyName')
          )
        ) {
          if (!this.state.isMultiBuilding) {
            setSectionAttributeValueByKey(prop, 'LegalEntity', LegalEntity);
          }

          const propPropertyId = getSectionAttributeValueByKey(prop, 'propertyId');
          const propertyName = getSectionAttributeValueByKey(prop, 'propertyName');
          const propAddress = getSectionAttributeValueByKey(prop, 'Address');
          const propCity = getSectionAttributeValueByKey(prop, 'City');
          const propState = getSectionAttributeValueByKey(prop, 'State');
          const propZipCode = getSectionAttributeValueByKey(prop, 'ZipCode');

          const currentPropertyId = getSectionAttributeValueByKey(formdetails, 'propertyId');
          const currentName = getSectionAttributeValueByKey(formdetails, 'propertyName');
          const currentAddress = getSectionAttributeValueByKey(formdetails, 'Address');
          const currentCity = getSectionAttributeValueByKey(formdetails, 'City');
          const currentState = getSectionAttributeValueByKey(formdetails, 'State');
          const currentZipCode = getSectionAttributeValueByKey(formdetails, 'ZipCode');

          if (currentPropertyId !== propPropertyId &&
            (currentName?.trim()?.toLowerCase() === propertyName?.trim()?.toLowerCase()) // && currentAddress?.trim() === propAddress?.trim() && currentCity?.trim() === propCity?.trim() && currentState?.trim() === propState?.trim() && currentZipCode?.trim() === propZipCode?.trim())
          ) {
            isAddressValid = false;
            // setSectionFieldAttributeByKey(formdetails, 'Address', 'isInErrorState', true);
            // setSectionFieldAttributeByKey(formdetails, 'Address', 'errorMessage', 'Address already exists');
            setSectionFieldAttributeByKey(formdetails, 'propertyName', 'isInErrorState', true);
            setSectionFieldAttributeByKey(formdetails, 'propertyName', 'errorMessage', 'Property Name already exists');
            const msg = currentName + ' already exists without a Property Code. Please link the Property Code to the existing Property from the Properties screen and try again.'; // 'Duplicate property exists with the same name';
            ShowToast(msg, toastType.ERROR, 5000, 500, 'Duplicate Found');
          }
          // else if (
          //   currentName?.trim() === propertyName?.trim() &&
          //   currentPropertyId !== propPropertyId
          // )
          // {
          //   isAddressValid = false;
          //   setSectionFieldAttributeByKey(
          //     formdetails,
          //     'propertyName',
          //     'isInErrorState',
          //     true
          //   );
          //   setSectionFieldAttributeByKey(
          //     formdetails,
          //     'propertyName',
          //     'errorMessage',
          //     'Property Name already exists'
          //   );
          // }
          updatednewMultiProperty.push(cloneDeep(prop));
        }
      });
    } else {
      if (this.state.selectedTransitionTypeId?.toString() === '2') {
        const updatedProp = CIOPropertydetails.find(
          (x) =>
            (x.propertyId || '').toString() ===
            getSectionAttributeValueByKey(formdetails, 'propertyId').toString()
        );
        updatedProp.propertyName = getSectionAttributeValueByKey(
          formdetails,
          'PropertyName'
        );
        updatedProp.address = getSectionAttributeValueByKey(
          formdetails,
          'Address'
        );
        updatedProp.city = getSectionAttributeValueByKey(formdetails, 'City');
        updatedProp.state = getSectionAttributeValueByKey(formdetails, 'State');
        updatedProp.zipCode = getSectionAttributeValueByKey(
          formdetails,
          'ZipCode'
        );
        updatedProp.areaSF = getSectionAttributeValueByKey(
          formdetails,
          'AreaSF'
        );
        updatedProp.controllerName = getSectionAttributeValueByKey(
          formdetails,
          'ControllerName'
        );
        updatedProp.sourceAccountingSystemId = getSectionAttributeValueByKey(
          formdetails,
          'SourceAccountingSystemId'
        );
        updatedProp.sourceAccountingSystem = getSectionAttributeValueByKey(
          formdetails,
          'SourceAccountingSystem'
        );

        updatedProp.propertySubTypeId = getSectionAttributeValueByKey(
          formdetails,
          'PropertySubTypeId'
        );
        updatedProp.propertySubTypeName = getSectionAttributeValueByKey(
          formdetails,
          'PropertySubTypeName'
        );
        CIOPropertydetails = CIOPropertydetails.filter(
          (x) =>
            (x.propertyId || '').toString() !==
            getSectionAttributeValueByKey(formdetails, 'propertyId').toString()
        );
        CIOPropertydetails.push(updatedProp);
      }

      newMultiProperty.forEach((prop) => {
        if (
          CIOPropertydetails.find(
            (x) =>
              x.propertyName ===
              getSectionAttributeValueByKey(prop, 'propertyName')
          )
        ) {
          if (!this.state.isMultiBuilding) {
            setSectionAttributeValueByKey(prop, 'LegalEntity', LegalEntity);
          }

          const propPropertyId = getSectionAttributeValueByKey(prop, 'propertyId');
          const propertyName = getSectionAttributeValueByKey(prop, 'propertyName');
          const propAddress = getSectionAttributeValueByKey(prop, 'Address');
          const propCity = getSectionAttributeValueByKey(prop, 'City');
          const propState = getSectionAttributeValueByKey(prop, 'State');
          const propZipCode = getSectionAttributeValueByKey(prop, 'ZipCode');

          const currentPropertyId = getSectionAttributeValueByKey(formdetails, 'propertyId');
          const currentName = getSectionAttributeValueByKey(formdetails, 'propertyName');
          const currentAddress = getSectionAttributeValueByKey(formdetails, 'Address');
          const currentCity = getSectionAttributeValueByKey(formdetails, 'City');
          const currentState = getSectionAttributeValueByKey(formdetails, 'State');
          const currentZipCode = getSectionAttributeValueByKey(formdetails, 'ZipCode');
          if (currentPropertyId !== propPropertyId &&
            (currentName?.trim().toLowerCase() === propertyName?.trim().toLowerCase()) // && currentAddress?.trim() === propAddress?.trim() && currentCity?.trim() === propCity?.trim() && currentState?.trim() === propState?.trim() && currentZipCode?.trim() === propZipCode?.trim())
          ) {
            isAddressValid = false;
            // setSectionFieldAttributeByKey(formdetails, 'Address', 'isInErrorState', true);
            // setSectionFieldAttributeByKey(formdetails, 'Address', 'errorMessage', 'Address already exists');
            setSectionFieldAttributeByKey(formdetails, 'propertyName', 'isInErrorState', true);
            setSectionFieldAttributeByKey(formdetails, 'propertyName', 'errorMessage', 'Property Name already exists');
            const msg = currentName + ' already exists without a Property Code. Please link the Property Code to the existing Property from the Properties screen and try again.'; // 'Duplicate property exists with the same name.';
            ShowToast(msg, toastType.ERROR, 5000, 500, 'Duplicate Found');
          }
          // else if (
          //   currentName?.trim() === propertyName?.trim() &&
          //   currentPropertyId !== propPropertyId
          // )
          // {
          //   isAddressValid = false;
          //   setSectionFieldAttributeByKey(
          //     formdetails,
          //     'propertyName',
          //     'isInErrorState',
          //     true
          //   );
          //   setSectionFieldAttributeByKey(
          //     formdetails,
          //     'propertyName',
          //     'errorMessage',
          //     'Property Name already exists'
          //   );
          // }
          updatednewMultiProperty.push(cloneDeep(prop));
        }
      });
    }

    if (!isAddressValid) {
      this.setState(
        {
          newPropertyData: cloneDeep(formdetails),
          previewData: cloneDeep(formdetails),
          reloadPtf: !this.state.reloadPtf,
          addNewformComponent: this.getNewPropertydetailForm(formdetails),
          reloadProperty: !this.state.reloadProperty
        },
        () => {
          this.CIOPropertyChanges(
            getSectionAttributeValueByKey(
              this.state.reorderData,
              'updatedProperties'
            )
          );
        }
      );
      return;
    }

    if (!this.state.isMultiBuilding) {
      setSectionAttributeValueByKey(
        transitionData,
        'assignmentName',
        LegalEntity
      );
    }
    if (this.state.selectedTransitionTypeId?.toString() === '2') {
      const totalSf = CIOPropertydetails.filter(
        (x) => parseFloat(x.areaSf) > 0.0 || parseFloat(x.areaSF) > 0.0
      ).reduce(
        (total, obj) =>
          ((obj.areaSf !== undefined && parseFloat(obj.areaSf)) ||
            (obj.areaSF !== undefined && parseFloat(obj.areaSF)) ||
            0) + parseFloat(total),
        0
      );
      setSectionAttributeValueByKey(transitionData, 'TotalSF', totalSf);
    } else {
      propertyDetails.forEach((x) => {
        propertyId.push(x.propertyId);
        propertyName.push(x.propertyName);
      });

      setSectionAttributeValueByKey(
        transitionData,
        'PropertyId',
        // removeDuplicates(propertyId).join('|')
        removeNullValuesFromArray(removeDuplicates(propertyId)).join('|')
      );

      setSectionAttributeValueByKey(
        transitionData,
        'propertyName',
        // removeDuplicates(propertyName).join('|')
        removeNullValuesFromArray(removeDuplicates(propertyName)).join('|')
      );

      setSectionFieldAttributeByKey(
        transitionData,
        'propertyName',
        'isInErrorState',
        false
      );

      setSectionFieldAttributeByKey(
        transitionData,
        'propertyName',
        'errorMessage',
        ''
      );
      const totalSf = propertyDetails
        .filter((x) => parseFloat(x.areaSf) > 0.0 || parseFloat(x.areaSF) > 0.0)
        .reduce(
          (total, obj) =>
            ((obj.areaSf !== undefined && parseFloat(obj.areaSf)) ||
              (obj.areaSF !== undefined && parseFloat(obj.areaSF)) ||
              0) + parseFloat(total),
          0
        );
      setSectionAttributeValueByKey(transitionData, 'TotalSF', totalSf);
    }
    const filtered = this.addPropertyToMasterData(
      propertyMasterData,
      newPropertyId,
      formdetails,
      LegalEntity
    );

    updatednewMultiProperty = [
      ...cloneDeep(updatednewMultiProperty),
      [...cloneDeep(formdetails)]
    ];
    // allocationData.forEach((ele) => {
    //   if (ele.propertyId.toString() === newPropertyId.toString()) {
    //     formdetails.forEach(field => {
    //       if (ele[_.camelCase(field.dbColumn)] !== undefined) {
    //         ele[_.camelCase(field.dbColumn)] = field.attributeValue;
    //       }
    //     });
    //     ele.LegalEntity = LegalEntity;
    //   }
    // });
    const feeDataStructure = this.state.feeDataStructure;
    setSectionFieldAttributeByKey(
      feeDataStructure,
      'ManagementPropertyName',
      ''
    );

    const expenseDataStructure = this.state.expenseDataStructure;
    setSectionFieldAttributeByKey(
      expenseDataStructure,
      'ExpensesBillablePropertyName',
      ''
    );

    function compare(a, b) {
      if (a.propertyName < b.propertyName) {
        return -1;
      }
      if (a.propertyName > b.propertyName) {
        return 1;
      }
      return 0;
    }
    propertyDetails.sort(compare);
    if (CIOPropertydetails && CIOPropertydetails.length > 0) {
      CIOPropertydetails.sort(compare);
    }

    this.setState({
      CIOPropertydetails,
      propertyDetails: propertyDetails,
      feeDataStructure: cloneDeep(feeDataStructure),
      expenseDataStructure: cloneDeep(expenseDataStructure),
      previewData: cloneDeep(formdetails),
      newMultiProperty: updatednewMultiProperty,
      transitionData: transitionData,
      propertyMasterData: filtered,
      showPropertyDialog: false,
      openaddform: isDuplicate === true,
      addformtitle: isDuplicate === true ? this.state.addformtitle : undefined,
      addNewformComponent:
        isDuplicate === true ? this.state.addNewformComponent : undefined,
      allocationData: allocationData,
      originalAllocationData: allocationData,
      reloadPtf: !this.state.reloadPtf,
      reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
      reloadExpenseSection: !this.state.reloadExpenseSection,
      reloadBillableExpenseTable: !this.state.reloadBillableExpenseTable
    });
  };

  addNewClient = (source, option, updateoption = true) => {
    const { newClientDetail } = this.state;

    if (updateoption) {
      setSectionAttributeValueByKey(newClientDetail, 'Name', option);
    }
    setSectionAttributeValueByKey(newClientDetail, 'ClientId', '-1');
    this.setState({
      openaddform: true,
      addformtitle: source.AddNewOptiontitle,
      addNewformComponent: this.getNewClientdetailForm(newClientDetail),
      addnewClientSource: source
    });
  };

  clientChanges = (value, sourceIdField) => {
    let { transitionData, newPropertyData, propertyMasterData, CIOProperties } =
      this.state;
    let propertyDetails = [...this.state.propertyDetails];
    const newMultiProperty = [...this.state.newMultiProperty];

    if (this.state.selectedTransitionTypeId?.toString() !== '1') {
      transitionData = this.state.dataAfterTransitionTypeChange;
      propertyDetails = [];
      CIOProperties = [];
      setSectionAttributeValueByKey(
        transitionData,
        'MarketId',
        getSectionAttributeValueByKey(this.state.transitionData, 'MarketId')
      );
    }

    setSectionAttributeValueByKey(transitionData, 'ClientName', value);
    setSectionAttributeValueByKey(transitionData, 'ClientId',
      sourceIdField.value
    );
    if ((value === undefined || value === '') === false) {
      setSectionFieldAttributeByKey(
        transitionData,
        'ClientName',
        'errorMessage',
        ''
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ClientName',
        'isInErrorState',
        false
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'ClientName',
        'errorMessage',
        'Client field is required'
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ClientName',
        'isInErrorState',
        true
      );
    }
    setSectionAttributeValueByKey(newPropertyData, 'ClientName', value);
    setSectionAttributeValueByKey(
      newPropertyData,
      'ClientId',
      sourceIdField.value
    );

    const isMultiBuilding =
      (transitionData.find((x) => x.dbColumn === 'IsPortfolio') || {})
        .attributeValue || false;

    transitionData.forEach((el) => {
      if (
        _.camelCase(el.dbColumn) === _.camelCase('PropertyName') ||
        _.camelCase(el.dbColumn) === _.camelCase('PropertyId')
      ) {
        let properties = (el.attributeValue || '').split('|');
        properties = properties.filter((y) =>
          propertyMasterData.find(
            (j) =>
              j[_.camelCase(el.dbColumn)]?.toString() === y &&
              (j.clientId === sourceIdField.value ||
                j.clientId === null ||
                j.propertyId < 0)
          )
        );
        properties = removeNullValuesFromArray(properties);
        el.attributeValue = properties.join('|');
        propertyDetails = propertyDetails.filter((x) =>
          properties.find((y) => y === x[_.camelCase(el.dbColumn)]?.toString())
        );
      }
    });

    this.getAssignmentData(
      getSectionAttributeValueByKey(transitionData, 'MarketId'),
      sourceIdField.value,
      {
        transitionData: transitionData,
        CIOProperties: CIOProperties,
        newPropertyData: cloneDeep(newPropertyData),
        propertyDetails: propertyDetails,
        newMultiProperty: newMultiProperty,
        IsNewClientAdded: sourceIdField.value === '-1',
        isClientSelected: (value || '').length > 0,
        reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
        reloadExpenseSection: !this.state.reloadExpenseSection,
        reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
        reloadBillableExpenseTable: !this.state.reloadBillableExpenseTable,
        reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
      }
    );

    // if selected client id > 0, remove existing new client from client master
    if (sourceIdField.value > 0) {
      const { clientMasterData, newClientDetail } = this.state;
      const filtered = clientMasterData.filter((x) => x.clientId !== -1);

      newClientDetail.forEach((x) => {
        if (x.dbColumn === 'Name' || x.dbColumn === 'Address' || x.dbColumn === 'City' || x.dbColumn === 'State' || x.dbColumn === 'ZipCode' || x.dbColumn === 'PhoneNumber' || x.dbColumn === 'Email') {
          x.attributeValue = null;
        }
      });

      this.setState({ clientMasterData: filtered, newClientDetail: newClientDetail });
    }
  };

  ownerShipClientChanges = async (value, sourceIdField) => {
    const { transitionData } = this.state;
    if (value === undefined || value === null || value === '') {
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'isInErrorState',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'errorMessage',
        'New Client field is required.'
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'NewClient',
        'errorMessage',
        ''
      );
    }
    setSectionAttributeValueByKey(transitionData, 'NewClient', value);
    setSectionAttributeValueByKey(
      transitionData,
      'NewClientId',
      sourceIdField.value
    );
    const CIOClientContactMasterData = await this.getNewClientContactDetailsData(
      sourceIdField.value
    );

    // if selected client id > 0, remove existing new client from client master
    const { clientMasterData, newClientDetail } = this.state;
    let filtered = clientMasterData;
    if (sourceIdField.value > 0) {
      filtered = clientMasterData.filter((x) => x.clientId !== -1);
      newClientDetail.forEach((x) => {
        if (x.dbColumn === 'Name' || x.dbColumn === 'Address' || x.dbColumn === 'City' || x.dbColumn === 'State' || x.dbColumn === 'ZipCode' || x.dbColumn === 'PhoneNumber' || x.dbColumn === 'Email') {
          x.attributeValue = null;
        }
      });
    }

    this.setState({
      transitionData: transitionData,
      // clientContactDetails: clientContactDetails,
      CIOClientContactMasterData: CIOClientContactMasterData,
      isClientCIOContactDetailsEditable: true,
      isClientContactDetailsEditable: false,
      CIOClientContacts: [],
      reloadClientContactDetails: !this.state.reloadClientContactDetails,
      clientMasterData: filtered,
      newClientDetail: newClientDetail
    });
  };

  isEditIconVisible = (cellInfo) => {
    const serviceTypeList = GetReadOnlyServiceType();
    if (cellInfo.serviceTypeId !== undefined && cellInfo.serviceTypeId > 0 && serviceTypeList.find(x => x.serviceTypeId.toString() === cellInfo.serviceTypeId.toString()) !== undefined) {
      return false;
    }
    return true;
  }

  isDeleteIconVisible = (cellInfo) => {
    const serviceTypeList = GetReadOnlyServiceType();
    if (cellInfo.serviceTypeId !== undefined && cellInfo.serviceTypeId > 0 && serviceTypeList.find(x => x.serviceTypeId.toString() === cellInfo.serviceTypeId.toString()) !== undefined) {
      return false;
    }
    if (
      cellInfo.approvalId !== ApprovedStatus.Approved &&
      cellInfo.approvalId !== ApprovedStatus.AutoAllocated
    ) {
      return true;
    }
    return false;
  };

  propertyTypeChange = (value, sourceIdField) => {
    const { transitionData, newPropertyData } = this.state;
    setSectionAttributeValueByKey(transitionData, 'PropertyType', value);
    setSectionAttributeValueByKey(
      transitionData,
      'PropertyTypeId',
      sourceIdField.value
    );
    setSectionAttributeValueByKey(
      newPropertyData,
      'PropertyTypeId',
      sourceIdField.value
    );
    setSectionAttributeValueByKey(newPropertyData, 'PropertyTypeName', value);

    this.setState({
      isPropertyTypeSelected: (value || '').length > 0,
      transitionData: transitionData,
      newPropertyData: cloneDeep(newPropertyData)
    });
  };

  terminationTypeChanges = (value, sourceIdField) => {
    const { transitionData } = this.state;
    if (value === 'By Service') {
      setSectionFieldAttributeByKey(
        transitionData,
        'PropertyName',
        'isEditable',
        false
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'ServiceType',
        'isEditable',
        false
      );
    }
    this.setState(transitionData);
  }

  marketChanges = (value, sourceIdField) => {
    let {
      transitionData,
      newPropertyData,
      isMultiBuilding,
      marketMasterData,
      propertyDetails,
      CIOProperties
    } = this.state;

    if (this.state.selectedTransitionTypeId?.toString() !== '1') {
      transitionData = this.state.dataAfterTransitionTypeChange;
      propertyDetails = [];
      CIOProperties = [];
      setSectionAttributeValueByKey(
        transitionData,
        'MarketId',
        getSectionAttributeValueByKey(this.state.transitionData, 'MarketId')
      );
    }
    setSectionAttributeValueByKey(
      transitionData,
      'MarketName',
      isMultiBuilding ? value.join('|') : value
    );

    if ((value === undefined || value === '' || value === null) === false) {
      setSectionFieldAttributeByKey(
        transitionData,
        'MarketName',
        'errorMessage',
        ''
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'MarketName',
        'isInErrorState',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'MarketName',
        'isRequired',
        true
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'MarketName',
        'errorMessage',
        'Market field is required.'
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'MarketName',
        'isInErrorState',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'MarketName',
        'isRequired',
        true
      );
    }
    setSectionAttributeValueByKey(
      transitionData,
      'MarketId',
      isMultiBuilding
        ? sourceIdField?.value?.join('|') || ''
        : sourceIdField.value
    );
    setSectionAttributeValueByKey(
      newPropertyData,
      'MarketName',
      isMultiBuilding ? value.join('|') : value
    );
    setSectionAttributeValueByKey(
      newPropertyData,
      'MarketId',
      isMultiBuilding ? sourceIdField.value[0] || '' : sourceIdField.value
    );
    setSectionFieldAttributeByKey(
      newPropertyData,
      'MarketName',
      'isRequired',
      true
    );

    const propertyMarketMasterData = marketMasterData.filter((x) =>
      isMultiBuilding
        ? (sourceIdField.value || []).find(
          (id) => id.toString() === x.marketId.toString()
        )
        : (sourceIdField.value || '').toString() === x.marketId.toString()
    );

    if (
      propertyMarketMasterData.find((x) => parseInt(x.marketId) === 6) !==
      undefined
    ) {
      const sdctMarket = marketMasterData.find(
        (y) => parseInt(y.marketId) === 7
      );
      if (
        sdctMarket !== undefined &&
        propertyMarketMasterData.find((x) => parseInt(x.marketId) === 7) ===
        undefined
      ) {
        propertyMarketMasterData.push(sdctMarket);
      }
    }

    if (
      propertyMarketMasterData.find((x) => parseInt(x.marketId) === 7) !==
      undefined
    ) {
      const sdctMarket = marketMasterData.find(
        (y) => parseInt(y.marketId) === 6
      );
      if (
        sdctMarket !== undefined &&
        propertyMarketMasterData.find((x) => parseInt(x.marketId) === 6) ===
        undefined
      ) {
        propertyMarketMasterData.push(sdctMarket);
      }
    }
    // const allocationMarkets = ((marketMasterData || {}).data || []).filter((x) =>
    //   isMultiBuilding
    //     ? (sourceIdField.value || []).find(
    //         (id) => id.toString() === x.marketId.toString()
    //       )
    //     : (sourceIdField.value || '').toString() === x.marketId.toString()
    // );

    this.getAssignmentData(
      isMultiBuilding ? sourceIdField.value.join('|') : sourceIdField.value,
      getSectionAttributeValueByKey(transitionData, 'clientId'),
      {
        transitionData: transitionData,
        CIOProperties: CIOProperties,
        propertyDetails: propertyDetails,
        newPropertyData: cloneDeep(newPropertyData),
        isMarketSelected: (value || '').length > 0,
        propertyMarketMasterData: propertyMarketMasterData,
        allocationMarkets: propertyMarketMasterData
      }
    );
  };

  getAssignmentData = (marketId = '0', clientId = 0, stateToBeUpdate = {}) => {
    const { selectedTransitionTypeId } = this.state;

    if ((selectedTransitionTypeId || '1').toString() !== '1') {
      apiBatchRequest([
        {
          url: `${API_URL.Transition.GetTransitionData}?marketId=${marketId || 0
            }&clientId=${clientId || 0}&approvalStatusId=4`,
          key: 'assignmentMasterData'
        }
      ])
        .then(({ assignmentMasterData }) => {
          if (assignmentMasterData.success) {
            stateToBeUpdate = {
              ...stateToBeUpdate,
              assignmentMasterData: (assignmentMasterData.data || []).filter(
                (x) => x[_.camelCase('PTFEndDate')] === null
              ),
              reloadPtf: !this.state.reloadPtf
            };
          }
          this.getCityStateData(marketId, stateToBeUpdate);
          // this.setState(stateToBeUpdate);
        })
        .catch(() => {
          this.getCityStateData(marketId, stateToBeUpdate);

          // this.setState(stateToBeUpdate);
        });
    } else {
      this.getCityStateData(marketId, stateToBeUpdate);
      // this.setState(stateToBeUpdate);
    }
    this.getClientContactDetails(clientId, stateToBeUpdate);
  };

  getCityStateData = (marketId = '0', stateToBeUpdate = {}) => {
    if ((marketId || '0').toString() !== '0') {
      apiBatchRequest([
        {
          url: `${API_URL.Market.GetMarketCityStateMasterData}?marketId=${marketId || 0
            }`,
          key: 'marketCityStateData'
        }
      ])
        .then(({ marketCityStateData }) => {
          if (marketCityStateData.success) {
            stateToBeUpdate = {
              ...stateToBeUpdate,
              cityMasterData: marketCityStateData.data || [],
              stateMasterData: getDistinctByProperty(
                marketCityStateData.data || [],
                'stateCode'
              ),
              reloadPtf: !this.state.reloadPtf,
              reloadClientContactDetails:
                !this.state.reloadClientContactDetails
            };
          }
          this.setState(stateToBeUpdate);
        })
        .catch(() => {
          this.setState(stateToBeUpdate);
        });
    } else {
      this.setState(stateToBeUpdate);
    }
  };

  getCityByStateforClient = (state, sourceIdField) => {
    this.getCityByState(state, sourceIdField, {
      addNewformComponent: this.getNewClientdetailForm(
        this.state.newClientDetail
      )
    });
  };

  getCityByState = (state, sourceIdField, stateToBeUpdate = {}) => {
    // if ((marketId || '0').toString() !== '0') {
    apiBatchRequest([
      {
        url: `${API_URL.Market.GetMarketCityStateMasterData}?stateId=${sourceIdField.value || 0
          }`,
        key: 'marketCityStateData'
      }
    ])
      .then(({ marketCityStateData }) => {
        if (marketCityStateData.success) {
          const clientCityMasterData = getDistinctByProperty(
            marketCityStateData.data || [],
            'cityId'
          );
          this.setState(
            {
              ...stateToBeUpdate,
              clientCityMasterData: clientCityMasterData,
              reloadNewClientDetails: !this.state.reloadNewClientDetails,
              reloadClientContactDetails:
                !this.state.reloadClientContactDetails,
              reloadPtf: !this.state.reloadPtf
            },
            this.forceUpdate()
          );
        }
      })
      .catch(() => { });
    // } else {
    //   this.setState(stateToBeUpdate);
    // }
  };

  applyToAll = (value, sourceIdField, isMultiple, formFieldsObj) => {
    setSectionFieldAttributeByKey(
      formFieldsObj,
      'ManagementPropertyName',
      'isRequired',
      getSectionAttributeValueByKey(formFieldsObj, 'ApplyToAll') !== '1'
    );
    if (value === '1') {
      setSectionFieldAttributeByKey(
        formFieldsObj,
        'ManagementPropertyName',
        'errorMessage',
        ''
      );
    }
    this.setState(
      {
        feeDataStructure: cloneDeep(formFieldsObj),
        reloadPtf: !this.state.reloadPtf,
        reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
        reloadManagementFeetable: !this.state.reloadManagementFeetable
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  // Click event of enable/disable Engineer Hour Billing
  changeEngineerHourBillingStatus = (value, sourceIdField, isMultiple, formFieldsObj) => {
    const records = this.getEngineerHourBillingTabledata(this.state.engineerHourBillingData)
    const formFieldsObjUpdated = this.showHideEngineerHourBillingFields(value, formFieldsObj, records?.length);

    this.setState(
      {
        engineerHourBillingDataStructure: cloneDeep(formFieldsObjUpdated),
        reloadPtf: !this.state.reloadPtf,
        reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
        reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable,
        showSubmitBtnOnEnggBillingSection: (records?.length > 0 || value === 1 || value === '1')
      },
      () => {
        this.forceUpdate();
      }
    );
  }

  expenseApplyToAll = (value, sourceIdField, isMultiple, formFieldsObj) => {
    setSectionFieldAttributeByKey(
      formFieldsObj,
      'ExpensesBillablePropertyName',
      'isRequired',
      getSectionAttributeValueByKey(formFieldsObj, 'ApplyToAll') !== '1'
    );
    if (getSectionAttributeValueByKey(formFieldsObj, 'ApplyToAll') === '1') {
      setSectionFieldAttributeByKey(
        formFieldsObj,
        'ExpensesBillablePropertyName',
        'errorMessage',
        ''
      );
    }
    this.setState(
      {
        expenseDataStructure: cloneDeep(formFieldsObj),
        reloadPtf: !this.state.reloadPtf,
        reloadExpenseSection: !this.state.reloadExpenseSection,
        reloadBillableExpenseTable: !this.state.reloadBillableExpenseTable
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  newClientOptionChange = async (value, sourceIdField) => {
    if (sourceIdField) {
      const newClientDetail = await this.getClientData(sourceIdField.value);
      if (
        sourceIdField.value === undefined ||
        (sourceIdField.value || '').toString() === '-1'
      ) {
        setSectionAttributeValueByKey(newClientDetail, 'name', value);
        setSectionAttributeValueByKey(newClientDetail, 'ClientId', '-1');
        newClientDetail.forEach((x) => {
          x.recordId = '-1';
        });
      }
      const ClientContactDetails = this.getNewClientContactDetailsData(
        sourceIdField.value
      );

      this.setState(
        {
          newClientDetail: newClientDetail,
          reloadNewClientDetails: !this.state.reloadNewClientDetails,
          reloadClientContactDetails: !this.state.reloadClientContactDetails,
          ClientContactDetails: ClientContactDetails,
          reloadPtf: !this.state.reloadPtf
        },
        () => {
          this.setState(
            {
              addNewformComponent: this.getNewClientdetailForm(newClientDetail)
            },
            () => {
              this.forceUpdate();
            }
          );
        }
      );
    }
  };

  getClientData = (sourceIdField) => {
    return new Promise(function (resolve, reject) {
      apiBatchRequest([
        {
          url: `${API_URL.Transition.GetClientDetail}?clientId=${sourceIdField || 0
            }`,
          key: 'clientDetails'
        }
      ])
        .then(({ clientDetails }) => {
          return resolve(clientDetails.data || this.state.newClientDetail);
        })
        .catch(() => {
          return resolve(this.state.newClientDetail);
        });
    });
  };

  getNewClientContactDetailsData = (clientId, stateToBeUpdate = {}) => {
    return new Promise(function (resolve, reject) {
      apiBatchRequest([
        {
          url: `${API_URL.Transition.GetClientContactDetails}?clientId=${clientId || 0
            }`,
          key: 'clientContactDetails'
        }
      ])
        .then(({ clientContactDetails }) => {
          const data = clientContactDetails.data;
          return resolve(data);
        })
        .catch(() => {
          return resolve(this.state.clientContactDetails);
        });
    });
  };

  getClientContactDetails = (clientId = '0', stateToBeUpdate = {}) => {
    if ((clientId || '0').toString() !== '0') {
      apiBatchRequest([
        {
          url: `${API_URL.Transition.GetClientContactDetails}?clientId=${clientId || 0
            }`,
          key: 'clientContactDetails'
        }
      ])
        .then(({ clientContactDetails }) => {
          const data = cloneDeep(clientContactDetails.data);
          if (clientContactDetails.success) {
            stateToBeUpdate = {
              selectedClientId: clientId,
              clientContactMainData: [],
              ...stateToBeUpdate,
              clientContactDetails: data || [],
              isClientContactDetailsEditable: true,
              ClientContactMasterData: data || [],
              reloadClientContactDetails:
                !this.state.reloadClientContactDetails
            };
          }
          this.setState(stateToBeUpdate);
        })
        .catch(() => {
          this.setState(stateToBeUpdate);
        });
    } else {
      this.setState(stateToBeUpdate);
    }
  };

  getPropertyDetailsById = (
    SelectedID = 0,
    stateToBeUpdate = {},
    SelectedProperty = []
  ) => {
    if (SelectedID === 0) {
      this.setState(stateToBeUpdate);
      return;
    }
    this._asyncRequest = apiBatchRequest([
      {
        url:
          API_URL.Property.GetPropertyData +
          '?propertyId=' +
          ((SelectedID || '').length > 0 ? SelectedID : -1),
        key: 'propertyDetails'
      },
      {
        url: API_URL.Transition.GetPropertyLandlordDetails + '?propertyId=' + 0,
        key: 'propertyLandLordDetails'
      },
      {
        url: API_URL.Allocation.GetPTFAllocationData +
          '?propertyTransitionId=' + (this.props.selectedTransitionId || 0) +
          ((SelectedID || '').length > 0 ? '&propertyId=' + SelectedID : ''),
        key: 'allocationData'
      }
    ])
      .then(
        ({
          propertyDetails,
          propertyLandLordDetails,
          allocationData
        }) => {
          this._asyncRequest = null;
          if (propertyDetails.success === true) {
            propertyDetails.data = getDistinctByProperty(
              propertyDetails.data || [],
              'propertyId'
            );
            if (this.state.selectedTransitionTypeId?.toString() === '1') {
              const assignmentName = getSectionAttributeValueByKey(
                this.state.transitionData,
                'assignmentName'
              );
              const clientId = getSectionAttributeValueByKey(
                this.state.transitionData,
                'clientId'
              );
              const clientName = getSectionAttributeValueByKey(
                this.state.transitionData,
                'clientName'
              );
              const legalEntityId = getSectionAttributeValueByKey(
                this.state.transitionData,
                'legalEntityId'
              );
              (propertyDetails.data || []).forEach((property) => {
                if (
                  assignmentName !== null &&
                  assignmentName !== '' &&
                  assignmentName !== undefined &&
                  (property.legalEntity === null ||
                    property.legalEntity === undefined ||
                    property.legalEntity === '')
                ) {
                  property.legalEntity = assignmentName;
                }
                if (
                  clientId !== null &&
                  clientId !== 0 &&
                  clientId !== '' &&
                  clientId !== undefined &&
                  (property.clientId === null ||
                    property.clientId === undefined ||
                    property.clientId === '' ||
                    property.clientId === 0)
                ) {
                  property.clientId = clientId;
                }
                if (
                  clientName !== null &&
                  clientName !== '' &&
                  clientName !== undefined &&
                  (property.clientName === null ||
                    property.clientName === undefined ||
                    property.clientName === '')
                ) {
                  property.clientName = clientName;
                }
                if (
                  legalEntityId !== null &&
                  legalEntityId !== 0 &&
                  legalEntityId !== '' &&
                  legalEntityId !== undefined &&
                  (property.legalEntityId === null ||
                    property.legalEntityId === undefined ||
                    property.legalEntityId === '' ||
                    property.legalEntityId === 0)
                ) {
                  property.legalEntityId = legalEntityId;
                }
              });
            }

            let selectedPropertyDetails =
              cloneDeep(this.state.propertyDetails) || [];

            if (propertyDetails.data === null) {
              selectedPropertyDetails =
                cloneDeep(this.state.propertyDetails) || [];
            } else {
              selectedPropertyDetails = cloneDeep(propertyDetails.data) || [];
              const onDemandProperty = this.state.propertyMasterData.filter(
                (x) => x.propertyId < 0
              );
              onDemandProperty.forEach((x) => {
                if (
                  (SelectedID.split('|') || []).indexOf(
                    x.propertyId?.toString()
                  ) !== -1
                ) {
                  if (
                    selectedPropertyDetails.find(
                      (y) =>
                        y.propertyId?.toString() === x.propertyId?.toString()
                    )
                  ) {
                  } else {
                    selectedPropertyDetails.push(x);
                  }
                }
              });
            }

            let managementFeeData = stateToBeUpdate.managementFeeData
              ? stateToBeUpdate.managementFeeData
              : cloneDeep(this.state.managementFeeData) || [];
            const OriginalManagementFeeData =
              cloneDeep(this.state.originalManagementFeeData) || [];
            let updatedManagementFeeData = [];
            const groupedData = this.getGroupedData(managementFeeData);
            const OriginalData = this.getGroupedData(OriginalManagementFeeData);
            let CurrentPropertyDetails = (selectedPropertyDetails || []).filter(
              (x) => SelectedProperty.find((y) => y === x.propertyName)
            );
            if (this.state.isLegalEntityManagementFee !== true) {
              if ((SelectedID || '').length > 0) {
                (propertyDetails.data || []).forEach((prop) => {
                  if (
                    CurrentPropertyDetails.find(
                      (x) => x.propertyId === prop.propertyId
                    ) === undefined
                  ) {
                    CurrentPropertyDetails.push(prop);
                  }
                });
                const onDemandProperty = this.state.propertyMasterData.filter(
                  (x) => x.propertyId < 0
                );
                onDemandProperty.forEach((x) => {
                  if (
                    (SelectedID.split('|') || []).indexOf(
                      x.propertyId?.toString()
                    ) !== -1
                  ) {
                    if (
                      CurrentPropertyDetails.find(
                        (y) =>
                          y.propertyId?.toString() === x.propertyId?.toString()
                      )
                    ) {
                    } else {
                      CurrentPropertyDetails.push(x);
                    }
                  }
                });
                if (
                  this.state.selectedTransitionTypeId?.toString() ===
                  this.state.selectedOriginalTransitionTypeId?.toString()
                ) {
                  const addedPropManagement = [];
                  (groupedData || []).forEach((y) => {
                    if (
                      CurrentPropertyDetails.find(
                        (prop) =>
                          prop.propertyId?.toString() ===
                          getSectionAttributeValueByKey(
                            y.data,
                            'managementPropertyId'
                          )
                      ) !== undefined
                    ) {
                      if (
                        addedPropManagement.find(
                          (p) =>
                            p.propertyId ===
                            getSectionAttributeValueByKey(
                              y.data,
                              'managementPropertyId'
                            ) && p.recordId === y.recordId
                        ) === undefined
                      ) {
                        addedPropManagement.push({
                          propertyId: getSectionAttributeValueByKey(
                            y.data,
                            'managementPropertyId'
                          ),
                          recordId: y.recordId
                        });
                        y.data.forEach((match) => {
                          updatedManagementFeeData.push(match);
                        });
                      }
                    }
                  });
                  (OriginalData || []).forEach((y) => {
                    if (
                      CurrentPropertyDetails.find(
                        (prop) =>
                          prop.propertyId?.toString() ===
                          getSectionAttributeValueByKey(
                            y.data,
                            'managementPropertyId'
                          )
                      ) !== undefined &&
                      groupedData.find((gp) => gp.recordId === y.recordId) ===
                      undefined
                    ) {
                      if (
                        addedPropManagement.find(
                          (p) =>
                            p.propertyId ===
                            getSectionAttributeValueByKey(
                              y.data,
                              'managementPropertyId'
                            ) && p.recordId === y.recordId
                        ) === undefined
                      ) {
                        addedPropManagement.push({
                          propertyId: getSectionAttributeValueByKey(
                            y.data,
                            'managementPropertyId'
                          ),
                          recordId: y.recordId
                        });
                        y.data.forEach((match) => {
                          updatedManagementFeeData.push(match);
                        });
                      }
                    }
                  });
                }
              } else {
                CurrentPropertyDetails = [];

                managementFeeData = [];
              }
            } else {
              updatedManagementFeeData = cloneDeep(this.state.managementFeeData) || [];
            }
            const { feeDataStructure } = this.state;
            setSectionAttributeValueByKey(
              feeDataStructure,
              'managementPropertyName',
              ''
            );
            setSectionAttributeValueByKey(
              feeDataStructure,
              'managementPropertyId',
              null
            );

            let expenseData = stateToBeUpdate.expenseData
              ? stateToBeUpdate.expenseData
              : cloneDeep(this.state.expenseData) || [];
            const originalExpenseData =
              cloneDeep(this.state.originalExpenseData) || [];
            const updatedExpenseData = [];
            const groupedExpenseData = this.getGroupedData(expenseData);
            const OriginalExpenseData =
              this.getGroupedData(originalExpenseData);

            if ((SelectedID || '').length > 0) {
              if (
                this.state.selectedTransitionTypeId?.toString() ===
                this.state.selectedOriginalTransitionTypeId?.toString()
              ) {
                const addedprop = [];
                (groupedExpenseData || []).forEach((y) => {
                  if (
                    CurrentPropertyDetails.find(
                      (prop) =>
                        prop.propertyId?.toString() ===
                        getSectionAttributeValueByKey(
                          y.data,
                          'ExpensesBillablePropertyId'
                        )
                    ) !== undefined
                  ) {
                    if (
                      addedprop.find(
                        (p) =>
                          p ===
                          getSectionAttributeValueByKey(
                            y.data,
                            'ExpensesBillablePropertyId'
                          )
                      ) === undefined
                    ) {
                      addedprop.push(
                        getSectionAttributeValueByKey(
                          y.data,
                          'ExpensesBillablePropertyId'
                        )
                      );
                      y.data.forEach((match) => {
                        updatedExpenseData.push(match);
                      });
                    }
                  }
                });
                (OriginalExpenseData || []).forEach((y) => {
                  if (
                    CurrentPropertyDetails.find(
                      (prop) =>
                        prop.propertyId?.toString() ===
                        getSectionAttributeValueByKey(
                          y.data,
                          'ExpensesBillablePropertyId'
                        )
                    ) !== undefined &&
                    groupedExpenseData.find(
                      (gp) => gp.recordId === y.recordId
                    ) === undefined
                  ) {
                    if (
                      addedprop.find(
                        (p) =>
                          p ===
                          getSectionAttributeValueByKey(
                            y.data,
                            'ExpensesBillablePropertyId'
                          )
                      ) === undefined
                    ) {
                      addedprop.push(
                        getSectionAttributeValueByKey(
                          y.data,
                          'ExpensesBillablePropertyId'
                        )
                      );
                      y.data.forEach((match) => {
                        updatedExpenseData.push(match);
                      });
                    }
                  }
                });
              }
            } else {
              CurrentPropertyDetails = [];
              expenseData = [];
            }
            const { expenseDataStructure } = this.state;
            setSectionAttributeValueByKey(
              expenseDataStructure,
              'expensesBillablePropertyName',
              ''
            );
            setSectionAttributeValueByKey(
              expenseDataStructure,
              'ExpensesBillablePropertyId',
              null
            );
            //

            let serviceType = (
              getSectionAttributeValueByKey(
                stateToBeUpdate.transitionData
                  ? stateToBeUpdate.transitionData
                  : this.state.transitionData,
                'ServiceType'
              ) || ''
            ).split('|');
            if (SelectedID === -1) {
              serviceType = '';
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'serviceType',
                serviceType
              );
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'propertyType',
                ''
              );
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'assignmentStartDate',
                ''
              );
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'signedDate',
                ''
              );
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'documentName',
                ''
              );
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'W9DocumentName',
                ''
              );
              setSectionAttributeValueByKey(
                stateToBeUpdate.transitionData,
                'newServiceType',
                ''
              );
            }
            const assignmentName =
              getSectionAttributeValueByKey(
                stateToBeUpdate.transitionData
                  ? stateToBeUpdate.transitionData
                  : this.state.transitionData,
                'AssignmentName'
              ) || '';
            const newLegalEntity =
              getSectionAttributeValueByKey(
                stateToBeUpdate.transitionData
                  ? stateToBeUpdate.transitionData
                  : this.state.transitionData,
                'newLegalEntity'
              ) || '';
            // const clientName = (getSectionAttributeValueByKey(stateToBeUpdate.transitionData ? stateToBeUpdate.transitionData : this.state.transitionData, 'clientName') || '');
            // const newClientName = (getSectionAttributeValueByKey(stateToBeUpdate.transitionData ? stateToBeUpdate.transitionData : this.state.transitionData, 'newClient') || '');
            allocationData.data = (allocationData.data || []).map((x) => {
              x.allocationEmployeePropertyId =
                '' + x.allocationId + x.employeeId + x.propertyId;
              return x;
            });
            // allocationData.data = (allocationData.data || []).filter(
            //   (x) =>
            //     (x.legalEntity?.toLowerCase().replace('&amp;', '&') ===
            //       newLegalEntity?.toLowerCase().replace('&amp;', '&') ||
            //       ((newLegalEntity?.toLowerCase() || '').split('|') || []).find(
            //         (nl) => nl?.replace('&amp;', '&') === x.legalEntity?.toLowerCase()?.replace('&amp;', '&')
            //       ) !== undefined ||
            //       x.legalEntity?.toLowerCase()?.replace('&amp;', '&') ===
            //       assignmentName?.toLowerCase()?.replace('&amp;', '&') ||
            //       this.state.isMultiBuilding === true) &&
            //     (serviceType.find((y) => y === x.serviceType) ||
            //       (x.serviceType || '')
            //         .split('|')
            //         .find((z) => serviceType.find((yy) => yy === z)))
            // );
            allocationData.data = (allocationData.data || []).filter(
              (x) =>
                (x.legalEntity?.toLowerCase()?.replace('&amp;', '&') ===
                  newLegalEntity?.toLowerCase()?.replace('&amp;', '&') ||
                  ((newLegalEntity?.toLowerCase() || '').split('|') || []).find(
                    (nl) => nl?.replace('&amp;', '&') ===
                      x.legalEntity?.toLowerCase()?.replace('&amp;', '&')
                  ) !== undefined ||
                  x.legalEntity?.toLowerCase()?.replace('&amp;', '&') ===
                  assignmentName?.toLowerCase()?.replace('&amp;', '&') ||
                  this.state.isMultiBuilding === true) &&
                (serviceType.find((y) => y === x.serviceType) ||
                  (x.serviceType || '')
                    .split('|')
                    .find((z) => serviceType.find((yy) => yy === z)))
            );

            const onDemandAllocation = this.state.allocationData.filter(
              (x) => x.propertyId < 0
            );
            const removedProperty = [];
            let removedAllocationId = 0;
            onDemandAllocation.forEach((x) => {
              //  allocationData.data.push(x);
              if (
                (SelectedID.split('|') || []).indexOf(
                  x.propertyId?.toString()
                ) !== -1
              ) {
                allocationData.data.push(x);
              } else {
                removedProperty.push(x);
                removedAllocationId = x.allocationId;
              }
            });
            const notAllocationIdRecord = this.state.allocationData.filter(
              (x) => x.allocationId < 0
            );
            const savedAllocation = allocationData.data.map((x) => {
              return x.allocationId;
            });
            notAllocationIdRecord.forEach((x) => {
              //  allocationData.data.push(x);
              if ((savedAllocation || []).indexOf(x.allocationId) === -1) {
                allocationData.data.push(x);
              }
            });
            if (removedProperty.length > 0) {
              let propertyBillingPercent = removedProperty.reduce(
                (total1, obj) =>
                  parseFloat(obj.propertyBillingPercent) + parseFloat(total1),
                0
              );
              let additionalFixedAmount = removedProperty.reduce(
                (total1, obj) =>
                  parseFloat(obj.additionalFixedAmount) + parseFloat(total1),
                0
              );
              let propertyAllocationPercent = removedProperty.reduce(
                (total1, obj) =>
                  parseFloat(obj.propertyAllocationPercent) +
                  parseFloat(total1),
                0
              );
              const isLegalEntityAllocation =
                allocationData.data.filter((x) => x.isAllocatedToLegalEntity) ||
                [];
              let empIds = isLegalEntityAllocation.map((x) => {
                return x.employeeId;
              });
              empIds = removeDuplicates(empIds);
              empIds.forEach((x) => {
                const allocationByEmployee = this.state.allocationData.filter(
                  (y) =>
                    y.employeeId === x && y.allocationId !== removedAllocationId
                );
                propertyBillingPercent =
                  (allocationByEmployee.reduce(
                    (total1, obj) =>
                      parseFloat(obj.propertyBillingPercent) +
                      parseFloat(total1),
                    0
                  ) +
                    propertyBillingPercent) /
                  allocationByEmployee.length;
                additionalFixedAmount =
                  (allocationByEmployee.reduce(
                    (total1, obj) =>
                      parseFloat(obj.additionalFixedAmount) +
                      parseFloat(total1),
                    0
                  ) +
                    additionalFixedAmount) /
                  allocationByEmployee.length;
                propertyAllocationPercent =
                  (allocationByEmployee.reduce(
                    (total1, obj) =>
                      parseFloat(obj.propertyAllocationPercent) +
                      parseFloat(total1),
                    0
                  ) +
                    propertyAllocationPercent) /
                  allocationByEmployee.length;
                allocationData.data
                  .filter((y) => y.employeeId === x)
                  .map((x) => {
                    x.propertyBillingPercent = propertyBillingPercent;
                    x.propertyAllocationPercent = propertyAllocationPercent;
                    x.additionalFixedAmount = additionalFixedAmount;
                    return x;
                  });
              });
            }

            stateToBeUpdate = {
              ...stateToBeUpdate,
              selectedPropertyID: SelectedID,
              propertyDetails: CurrentPropertyDetails,
              configuration: propertyDetails.config,
              feeDataStructure: feeDataStructure,
              propertyLandLordDetails: propertyLandLordDetails.data,
              allocationData: allocationData.data,
              originalAllocationData: allocationData.data,
              // reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
              reloadPtf: !this.state.reloadPtf,
              managementFeeData: updatedManagementFeeData,
              // trackerTimeLineData: trackerstepsMasterData.data || []
              expenseData: updatedExpenseData
            };
          } else {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState(
            { ...stateToBeUpdate, reloadPtf: !this.state.reloadPtf },
            () => {
              this.CIOPropertyChanges(
                getSectionAttributeValueByKey(
                  this.state.transitionData,
                  'UpdatedProperties'
                )
              );
            }
          );
        }
      )
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  getBase64Content = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  viewFileData = async (obj, title) => {
    let url = '';
    if (obj.uploadToSp) {
      const { filesToBeUploaded, spsData } = this.state;
      const file = (filesToBeUploaded || []).find(
        (x) => x.category === obj.category
      );
      if (file && file.file) {
        this.getBase64Content(file.file, (result) => {
          url = result;
          this.showFile(url, title);
        });
      } else if (
        spsData &&
        spsData[obj.category] &&
        spsData[obj.category].length > 0
      ) {
        const spFile = _.orderBy(
          spsData[obj.category].filter((x) => x.name === title) || [],
          ['createdDateTime'],
          ['desc']
        );
        if (spFile && spFile[0]) {
          this.showFile(
            await this.getSpBlob(spFile[0]['@microsoft.graph.downloadUrl']),
            title,
            true
          );

          // this.generateShareLinkAndShow(spFile);
        } else {
          ShowToast('File not found!', toastType.INFO, 2000, 2000);
        }
      } else {
        ShowToast('File not found!', toastType.INFO, 2000, 2000);
      }
    } else {
      url = getSectionAttributeValueByKey(
        this.state.transitionData,
        obj.contentKey
      );
      this.showFile(url, title);
    }
  };

  viewFilesData = async (obj, title, selectedFileName = '') => {
    let url = '';
    const fileNames = [];
    let isSpsFile = false;
    if (obj.uploadToSp) {
      const { filesToBeUploaded, spsData, w9FilesToBeUploaded } = this.state;
      const isW9 = (title || '').replace(/-/g, '').toLowerCase() === 'w9';

      // 1. Local files to upload
      let files = [];
      if (isW9) {
        files = (w9FilesToBeUploaded || []).filter(
          (x) => x.category === obj.category
        );
      } else {
        files = (filesToBeUploaded || []).filter(
          (x) => x.category === obj.category
        );
      }

      if (files && files.length > 0) {
        files.forEach((x) => {
          fileNames.push({ 'name': x.file.name, 'isSpsFile': false });
        });
        selectedFileName = selectedFileName !== '' ? selectedFileName : fileNames[0];
        isSpsFile = false;
      }

      // 2. SharePoint files
      if (spsData && spsData[obj.category] && spsData[obj.category].length > 0) {
        let spFiles = spsData[obj.category] || [];
        // Filter SP files based on W9 or not
        if (isW9) {
          spFiles = spFiles.filter(x => x.name.startsWith('W-9_'));
        } else {
          spFiles = spFiles.filter(x => !x.name.startsWith('W-9_'));
        }

        const filesToBeDeletedArr = isW9
          ? (this.state.w9FilesToBeDeleted || [])
          : (this.state.filesToBeDeleted || []);

        if (spFiles && spFiles.length > 0) {
          spFiles.forEach((x) => {
            if (!filesToBeDeletedArr.some(name => (x.name).toLowerCase() === name.toLowerCase())) {
              fileNames.push({ 'name': x.name, 'isSpsFile': true });
            }
          });
          selectedFileName = selectedFileName !== '' ? selectedFileName : fileNames[0];
          isSpsFile = true;
        }
      }

      if (fileNames.length > 0) {
        const allFileNames = [];
        fileNames?.forEach((x) => {
          allFileNames.push(x.name);
        });
        obj.attributeValue = allFileNames.join('|');
        await this.showSelectedFile(title, fileNames, fileNames[0]?.name, obj.category, obj, isSpsFile);
      } else {
        await this.showSelectedFile(title, [], '', obj.category, obj, false);
      }
    } else {
      url = getSectionAttributeValueByKey(
        this.state.transitionData,
        obj.contentKey
      );
      this.showFile(url, title);
    }
  };

  getSpBlob = (url) => {
    return new Promise(function (resolve, reject) {
      fetch(url)
        .then((response) => response.blob())
        .then(function (blob) {
          const dataUrl = URL.createObjectURL(blob);
          return resolve(dataUrl);
        })
        .catch(() => {
          return resolve('');
        });
    });
  };

  getManagementFeeSection = (dropDownSource, DetailsFormConfig) => {
    const { feeDataStructure, transitionData } = this.state;
    const extendedDataObj = transitionData.find(
      (x) => x.dbColumn === 'ExtendedDate'
    );
    const transitionTypeId = getSectionAttributeValueByKey(
      transitionData,
      'TransitionTypeId'
    );

    let propAccounting = false;
    if (extendedDataObj !== undefined) {
      if (extendedDataObj.isVisible && extendedDataObj.isEditable) {
        propAccounting = true;
      }
    }
    if (transitionTypeId === null || transitionTypeId === '') {
      propAccounting = true;
    }

    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';

    const originalTranisitionTypeId = getSectionAttributeValueByKey(
      this.state.originaltransitionData,
      'TransitionTypeId'
    );

    let isEditable =
      ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && propAccounting)) &&
        (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
        (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'));
    if (isApproved && this.state.enableSubmitButtons !== true) {
      isEditable = false;
    }
    if (isApproved && this.state?.selectedTransitionTypeId?.toString() === '2' && (originalTranisitionTypeId?.toString() === '1' || originalTranisitionTypeId?.toString() === '')) {
      isEditable = true;
    }

    if (this.state.hasPmaAccess) {
      isEditable = true;
    }


    return {
      label: 'Set Management Fee Details',
      element: (
        <FormGenerator
          key="managementFees"
          dropDownSource={dropDownSource}
          formFields={UpdateFieldsWithConfiguration(
            _.orderBy(feeDataStructure, ['attributeSortOrder'], ['asc']) || [],
            DetailsFormConfig
          )}
          submitText={'Add'}
          ReloadForm={this.state.reloadManagementFeeSetion}
          saveChanges={(ch) => {
            this.validateManagementFee(ch);
          }}
          gridColumn={13}
          // partialForm={true}
          Editable={this.props.readOnly === true ? false : isEditable}
          sectionRowConfig={[]}
        ></FormGenerator>
      ),
      row: 2
    };
  };

  getEngineerHourBillingUi = (dropDownSource, DetailsFormConfig) => {
    const { allowToEdit } = this.state;
    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    const isEditable = (this.state?.selectedTransitionTypeId?.toString() === '2' && isApproved === true) ||
      ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && this.state.propAccounting)) &&
        (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
        (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'));
    return (
      <GridTable
        key={'engineerHourBillingdetails'}
        // columns={UpdateColumnWithConfiguration(
        //   isEditable ? managementFeeColumns : readOnlyManagementFeeColumns,
        //   [],
        //   hiddenConfig || []
        // )}
        columns={UpdateColumnWithConfiguration(
          isEditable
            ? EngineerHourBillingColumns
            : EngineerHourBillingColumns.filter((x) => x.name !== 'Action'),
          []
        )}
        reload={this.state.reloadEngineerHourBillingTable}
        config={{ showPager: true, showBottomPagerOnly: true }}
        data={this.getEngineerHourBillingTabledata(this.state.engineerHourBillingData)}
        renderActionColumn={this.props.isCallFromPTFDetailReport === true ? null : this.renderDeleteEngineerHourBillingAction}
      ></GridTable>
    );
  }

  getManagementFeeUi = (dropDownSource, DetailsFormConfig) => {
    const { managementFeeData } = this.state;
    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    let isEditable = (this.state?.selectedTransitionTypeId?.toString() === '2' && isApproved === true) ||
      ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && this.state.propAccounting)) &&
        (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
        (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'));

    if (this.state.hasPmaAccess) {
      isEditable = true;
    }

    const hiddenConfig = [];
    const applyToAllObj = managementFeeData?.filter(x => _.camelCase(x.dbColumn) === _.camelCase('applyToAll') && x.attributeValue === '1' && x.recordId !== undefined && x.recordId !== '0' && x.recordId !== 'null');
    hiddenConfig.push({
      key: 'applyToAll',
      value: getSectionAttributeValueByKey(applyToAllObj, 'applyToAll') === '1'

    });
    return (<GridTable
      key={'managementFeedetails'}
      columns={UpdateColumnWithConfiguration(
        isEditable ? managementFeeColumns : readOnlyManagementFeeColumns,
        [],
        hiddenConfig || []
      )}
      reload={this.state.reloadManagementFeetable}
      // data={this.state.propertyDetails}
      config={{ showPager: true, showBottomPagerOnly: true }}
      // config={{ showPager: false }}
      data={this.getManagementFeeTabledata(managementFeeData)}
      renderActionColumn={this.props.isCallFromPTFDetailReport === true
        ? null
        : this.renderDeleteAction
      }
    ></GridTable>
    );
  };

  // validateEngineerHourBilling = (ch) => {
  //   const { engineerHourBillingData, transitionData } = this.state;
  //   this.setEngineerHourBilling(ch);
  // }

  validateManagementFee = (ch) => {
    const { managementFeeData, propertyDetails, transitionData } = this.state;
    const managementFeeData1 = managementFeeData.filter(x => x.recordId !== '0');
    if (getSectionAttributeValueByKey(managementFeeData1, 'applyToAll') === getSectionAttributeValueByKey(ch, 'applyToAll')) {
      this.setManagementFee(ch);
    } else {
      this.setState({
        isPopupOpen: true,
        confirmationMessage: 'You can apply management fee either to Property or Legal Entity level. Are you sure you want to continue?',
        mngFeeData: ch
      });
    }
  }

  validateContactDetails = (ch, isFromEdit = false) => {
    const {
      clientContactDetails,
      transitionData,
      ccDetailsFormFields,
      selectedClientId,
      CIOClientContacts,
      clientContactDataStructure,
      headerData,
      selectedClientContactDataRow,
      selectedTransitionTypeId,
      clientContactMainData,
      CIOClientContactMasterData,
      ClientContactMasterData
    } = this.state;

    let isChangeInOwnerShip = false;
    isChangeInOwnerShip = this.InTransitCIO(selectedTransitionTypeId, isChangeInOwnerShip);
    let clientId = getSectionAttributeValueByKey(transitionData, 'clientId');
    if (isChangeInOwnerShip) {
      clientId = getSectionAttributeValueByKey(transitionData, 'newClientId');
    }
    if (clientId === null || clientId === '' || clientId === undefined) {
      clientId = selectedClientId;
    }
    const clientContactId = getSectionAttributeValueByKey(ch, 'clientContactId');
    const recordId = ch[0].recordId;
    let duplicateCheck = [];
    let data1 = [];
    if (isFromEdit) {
      if (isChangeInOwnerShip) {
        data1 = CIOClientContacts.filter(x => x.recordId == recordId);
      } else {
        data1 = clientContactMainData.filter(x => x.recordId == recordId);
      }
    } else {
      if (isChangeInOwnerShip) {
        data1 = [...CIOClientContacts, ...CIOClientContactMasterData];
      } else {
        data1 = [...ClientContactMasterData, ...clientContactMainData];
      }
    }
    duplicateCheck = data1?.filter(x => (x.dbColumn === 'ContactName' || x.dbColumn === 'Address' || x.dbColumn === 'City' || x.dbColumn === 'State' || x.dbColumn === 'ZipCode' || x.dbColumn === 'Comments' || x.dbColumn === 'Email' || x.dbColumn === 'PhoneNumber' || x.dbColumn === 'Role')).map(x => {
      const obj = {};
      obj[x.dbColumn] = x.attributeValue;
      return obj;
    });
    const contactName = getSectionAttributeValueByKey(ch, 'contactName');
    const address = getSectionAttributeValueByKey(ch, 'address');
    const city = getSectionAttributeValueByKey(ch, 'city');
    const state = getSectionAttributeValueByKey(ch, 'state');
    const zip = getSectionAttributeValueByKey(ch, 'zipCode');
    const phoneNumber = getSectionAttributeValueByKey(ch, 'phoneNumber');
    const description = getSectionAttributeValueByKey(ch, 'comments');
    // const recordId = getSectionAttributeValueByKey(ch, 'recordId');
    const email = getSectionAttributeValueByKey(ch, 'email');
    const roleId = getSectionAttributeValueByKey(ch, 'contactRoleId');
    const role = getSectionAttributeValueByKey(ch, 'roleName');

    if (contactName === '') {
      ShowToast(
        'Client Contact Name is Empty. Please fill data to proceed.',
        toastType.WARNING,
        5000,
        500
      );
      return;
    }

    if (contactName === '' || address === '') {
      ShowToast(
        'Address is Empty. Please fill data to proceed.',
        toastType.WARNING,
        5000,
        500
      );
      return;
    }

    if (contactName === '' || address === '' || city === '') {
      ShowToast(
        'Client Contact Name, Address and City are Empty. Please fill data to proceed.',
        toastType.WARNING,
        5000,
        500
      );
      return;
    }

    const { duplicateContactFlag, duplicateAddressFlag, duplicateCityFlag, duplicateStateFlag, duplicateZipCodeFlag, duplicateDescFlag, duplicateEmailFlag, duplicatePhoneFlag, duplicateRoleFlag } = this.duplicateClientContact(duplicateCheck, contactName, address, city, state, zip, description, email, phoneNumber, role);
    if (duplicateContactFlag && duplicateAddressFlag && duplicateCityFlag && duplicateStateFlag && duplicateZipCodeFlag && duplicateDescFlag && duplicateEmailFlag && duplicatePhoneFlag && duplicateRoleFlag) {
      if (isFromEdit) {
        ShowToast(
          'No changes are made, Please make changes to proceed with edit',
          toastType.WARNING,
          5000,
          500
        );
      } else {
        ShowToast(
          'Duplicate Client Contact Name, Address, City and State',
          toastType.ERROR,
          5000,
          500
        );
      }

      return;
    }
    // }
    let editCIOContactDetails = false;
    let editContactDetails = false;
    if (isFromEdit) {
      // setSectionAttributeValueByKey(editedData, 'contactName', contactName);
      let unChangedData = [];// clientContactDetails.filter(x => x.recordId != '0').filter(x => x.recordId != recordId);
      // let editedData = clientContactDetails.filter(x => x.recordId != '0').filter(x => x.recordId != recordId);

      if (isChangeInOwnerShip) {
        editCIOContactDetails = true;
        // unChangedData = CIOClientContacts.filter(x => x.recordId != '0').filter(x => x.recordId != recordId);
        // const data = [...unChangedData, ...ch];
        unChangedData = CIOClientContacts.filter(x => x.recordId != '0').filter(x => x.recordId != recordId);
        const duplicateCheck = unChangedData.map(x => {
          const obj = {};
          obj[x.dbColumn] = x.attributeValue;
          return obj;
        });
        const contactName = getSectionAttributeValueByKey(ch, 'contactName');
        const address = getSectionAttributeValueByKey(ch, 'address');
        const city = getSectionAttributeValueByKey(ch, 'city');
        const state = getSectionAttributeValueByKey(ch, 'state');
        const zip = getSectionAttributeValueByKey(ch, 'zipCode');
        const phoneNumber = getSectionAttributeValueByKey(ch, 'phoneNumber');
        const description = getSectionAttributeValueByKey(ch, 'comments');
        const email = getSectionAttributeValueByKey(ch, 'email');
        const roleId = getSectionAttributeValueByKey(ch, 'contactRoleId');
        const role = getSectionAttributeValueByKey(ch, 'roleName');

        let data = [];
        let updatedCIOClientContactMasterData = [];
        const { duplicateContactFlag, duplicateAddressFlag, duplicateCityFlag, duplicateStateFlag, duplicateZipCodeFlag, duplicateDescFlag, duplicateEmailFlag, duplicatePhoneFlag, duplicateRoleFlag } = this.duplicateClientContact(duplicateCheck, contactName, address, city, state, zip, description, email, phoneNumber, role);

        if (duplicateContactFlag && duplicateAddressFlag && duplicateCityFlag && duplicateStateFlag && duplicateZipCodeFlag && duplicateDescFlag && duplicateEmailFlag && duplicatePhoneFlag && duplicateRoleFlag) {
          ShowToast(
            'Duplicate Contact Details found. Please make changes in field to edit.',
            toastType.WARNING,
            5000,
            500
          );
          data = CIOClientContacts;
          updatedCIOClientContactMasterData = CIOClientContactMasterData;
        } else {
          data = [...unChangedData, ...ch];
          let unChangedCIOClientContactMasterData = [];
          unChangedCIOClientContactMasterData = CIOClientContactMasterData.filter(x => x.recordId?.toString() !== clientContactId?.toString());
          updatedCIOClientContactMasterData = [...unChangedCIOClientContactMasterData, ...ch];
        }
        this.setState({
          CIOClientContacts: data,
          clientContactDataStructure: data,
          reloadClientContactSection: !this.state.reloadClientContactSection,
          reloadClientContactTable: !this.state.reloadClientContactTable,
          ccDetailsFormFields,
          editContactDetails: false,
          editCIOContactDetails: false, // editCIOContactDetails,
          CIOClientContactMasterData: updatedCIOClientContactMasterData
        });
      } else {
        editContactDetails = true;
        unChangedData = clientContactMainData.filter(x => x.recordId != '0').filter(x => x.recordId != recordId);
        const duplicateCheck = unChangedData.map(x => {
          const obj = {};
          obj[x.dbColumn] = x.attributeValue;
          return obj;
        });
        const contactName = getSectionAttributeValueByKey(ch, 'contactName');
        const address = getSectionAttributeValueByKey(ch, 'address');
        const city = getSectionAttributeValueByKey(ch, 'city');
        const state = getSectionAttributeValueByKey(ch, 'state');
        const zip = getSectionAttributeValueByKey(ch, 'zipCode');
        const phoneNumber = getSectionAttributeValueByKey(ch, 'phoneNumber');
        const description = getSectionAttributeValueByKey(ch, 'comments');
        const email = getSectionAttributeValueByKey(ch, 'email');
        const roleId = getSectionAttributeValueByKey(ch, 'contactRoleId');
        const role = getSectionAttributeValueByKey(ch, 'roleName');
        let data = [];
        let updatedClientContactMasterData = [];
        const { duplicateContactFlag, duplicateAddressFlag, duplicateCityFlag, duplicateStateFlag, duplicateZipCodeFlag, duplicateDescFlag, duplicateEmailFlag, duplicatePhoneFlag, duplicateRoleFlag } = this.duplicateClientContact(duplicateCheck, contactName, address, city, state, zip, description, email, phoneNumber, role);

        if (duplicateContactFlag && duplicateAddressFlag && duplicateCityFlag && duplicateStateFlag && duplicateZipCodeFlag && duplicateDescFlag && duplicateEmailFlag && duplicatePhoneFlag && duplicateRoleFlag) {
          ShowToast(
            'Duplicate Contact Details found. Please make changes in field to edit.',
            toastType.WARNING,
            5000,
            500
          );
          data = clientContactMainData;
          updatedClientContactMasterData = ClientContactMasterData;
        } else {
          data = [...unChangedData, ...ch];
          let unChangedClientContactMasterData = [];
          unChangedClientContactMasterData = ClientContactMasterData.filter(x => x.recordId?.toString() !== clientContactId?.toString());
          updatedClientContactMasterData = [...unChangedClientContactMasterData, ...ch];
        }

        this.setState({
          clientContactMainData: data,
          clientContactDataStructure: data,
          reloadClientContactSection: !this.state.reloadClientContactSection,
          reloadClientContactTable: !this.state.reloadClientContactTable,
          ccDetailsFormFields,
          editContactDetails: false,
          editCIOContactDetails: editCIOContactDetails,
          ClientContactMasterData: updatedClientContactMasterData
        });
      }

      ShowToast(
        'Record Edited Successfully',
        toastType.SUCCESS,
        5000,
        500
      );
    } else {
      let newDetails = [];
      const selectedAttribute = {
        attributeSortOrder: 1,
        attributeValue: true,
        dataFormat: 'Boolean',
        dbColumn: 'IsSelected',
        displayName: 'Is Selected',
        errorMessage: '',
        isEditable: false,
        isInErrorState: false,
        isRequired: false,
        isVisible: false,
        recordId: '0',
        sectionDetailId: 497,
        sectionId: 36
      };
      ch.push(selectedAttribute);
      setSectionAttributeValueByKey(
        ch,
        'clientId',
        clientId
      );
      setSectionAttributeValueByKey(
        ch,
        'isSelected',
        true
      );
      let zipCode = getSectionAttributeValueByKey(ch, 'zipCode');
      if (zipCode === '' || zipCode === 0 || zipCode === '0') {
        zipCode = '12345';
      }
      // const num = Math.floor(Math.random() * (zipCode.toString().length * 10));
      const num = Math.floor(parseInt(zipCode) * Math.random());
      const newNum = num * -1;
      // const contactName = getSectionAttributeValueByKey(ch, 'contactName');
      setSectionAttributeValueByKey(
        ch,
        'clientContactId',
        newNum
      );
      ch.forEach(x => {
        x.recordId = newNum;
      });
      if (isChangeInOwnerShip) {
        newDetails = [...this.state.CIOClientContacts, ...ch];
      } else {
        if (selectedClientContactDataRow.length === 0) {
          newDetails = [...clientContactMainData, ...ch];
        } else {
          newDetails = [...clientContactMainData, ...ch];
        }
      }
      // this.setClientContactdata(ch);
      // transitionData = [...transitionData, newDetails]
      ccDetailsFormFields.forEach(x => {
        x.attributeValue = '';
      });
      ShowToast(
        'Record Added Successfully',
        toastType.SUCCESS,
        5000,
        500
      );
      if (isChangeInOwnerShip) {
        this.setState({
          CIOClientContacts: newDetails.filter(x => x.recordId !== '0')
        });
      } else {
        this.setState({
          clientContactMainData: newDetails

        });
      }
      const selectAll = false;
      headerData.selectAll = selectAll;
      this.setState({
        clientContactDataStructure: newDetails,
        reloadClientContactSection: !this.state.reloadClientContactSection,
        reloadClientContactTable: !this.state.reloadClientContactTable,
        ccDetailsFormFields,
        showClientContactDialog: false,
        IsNewClientContact: false,
        headerData

      });
    }
  }

  onTrueUpPopup = (isConfirmed) => {
    if (isConfirmed) {
      const allocationDataToStore = this.state.allocationDataToStore;
      this.setState({
        isTrueUpPopupOpen: false,
        trueUpConfirmationMessage: '',
        allocationData: allocationDataToStore,
        originalAllocationData: allocationDataToStore,
        isInAddMode: false,
        selectedEditRowId: undefined,
        updateData: undefined,
        isEditableMode: false,
        reloadAllocationTable: !this.state.reloadAllocationTable
      });
    } else {
      this.setState({
        isTrueUpPopupOpen: false,
        trueUpConfirmationMessage: ''
      });
    }
  }

  onPopup = (isOpen) => {
    const mngFeeData = cloneDeep(this.state.mngFeeData);
    if (isOpen) {
      this.setState({
        isPopupOpen: false,
        confirmationMessage: '',
        managementFeeData: [],
        mngFeeData: []
      }, () => {
        this.setManagementFee(mngFeeData);
      });
    } else {
      this.setState({
        isPopupOpen: false,
        confirmationMessage: '',
        mngFeeData: []
      });
    }
  }

  onRetryFileUploadClickHandle = async (isConfirmed) => {
    if (isConfirmed) {
      this.getSpsData();
    } else {
      const approvalStatusId = getSectionAttributeValueByKey(this.state.transitionData, 'ApprovalStatusId');
      if (approvalStatusId?.toString() === '3') {
        // update PTF status as Draft instead of Pending Approval
        await apiPut(API_URL.Transition.UpdatePTFStatus, null, {
          transitionId: this.state.transitionIdForSP,
          statusId: '5'
        })
          .then(({ data: response }) => {
            getSpsAPiRequest(
              getSharePointUrl('streamrealty', 'getChildItem', this.state.spListkey, '', this.state.spDriveId)
            ).then((files) => {
              this.setCategoryWiseData(files, this.state.transitionIdForSP);
            });
            this.props.onViewChange();
          })
          .catch(() => {
            const approvalStatusId = getSectionAttributeValueByKey(this.state.transitionData, 'ApprovalStatusId');
            getSpsAPiRequest(
              getSharePointUrl('streamrealty', 'getChildItem', this.state.spListkey, '', this.state.spDriveId)
            ).then((files) => {
              this.setCategoryWiseData(files, this.state.transitionIdForSP);
            });
            this.props.onViewChange();
          });
      } else {
        getSpsAPiRequest(
          getSharePointUrl('streamrealty', 'getChildItem', this.state.spListkey, '', this.state.spDriveId)
        ).then((files) => {
          this.setCategoryWiseData(files, this.state.transitionIdForSP);
        });
        this.props.onViewChange();
      }
    }
  }

  onDeleteFilePopupClickHandle = (isConfirmed) => {
    if (isConfirmed) {
      this.setState({
        isConfirmPopupOpen: false,
        deleteFileConfirmationMessage: ''
      }, () => {
        const deleteFileObj = this.state.deleteFileObj;
        this.deleteSelectedDocument(deleteFileObj.title, deleteFileObj.fileNames, deleteFileObj.fileName, deleteFileObj.category, deleteFileObj.obj, deleteFileObj.isSpsFile);
      });
    } else {
      this.setState({
        isConfirmPopupOpen: false,
        deleteFileConfirmationMessage: ''
      });
    }
  }

  setManagementFee = (ch) => {
    const { managementFeeData, propertyDetails, transitionData } = this.state;
    let updatedmanagementFeeData = (cloneDeep(managementFeeData) || []).filter(
      (x) => x.recordId !== null && x.recordId !== 'null'
    );
    const groupedData = this.getGroupedData(updatedmanagementFeeData) || [];
    const applyToAll = getSectionAttributeValueByKey(ch, 'applyToAll') === '1';
    const exclatedFee =
      getSectionAttributeValueByKey(ch, 'exclatedFee') === '1';
    setSectionAttributeValueByKey(
      ch,
      'propertyTransitionId',
      this.props.selectedTransitionId
    );
    const startDateNum =
      moment(getSectionAttributeValueByKey(ch, 'Startdate'))?.format('MDYY') ||
      '';
    const startDate = getSectionAttributeValueByKey(ch, 'Startdate');
    const extendedDate = getSectionAttributeValueByKey(
      transitionData,
      'ExtendedDate'
    );
    const serviceTypes = getSectionAttributeValueByKey(
      transitionData,
      'ServiceType'
    );
    const aDate =
      this.state?.selectedTransitionTypeId?.toString() === '2'
        ? new Date(
          moment(
            getSectionAttributeValueByKey(
              this.state.transitionData,
              'effectiveFrom'
            )
          )
        ).getTime()
        : new Date(
          moment(
            getSectionAttributeValueByKey(
              this.state.transitionData,
              'assignmentStartDate'
            )
          )
        ).getTime();

    let aaDate;
    let terminationDate;
    if (
      this.state?.selectedTransitionTypeId?.toString() === '3' &&
      serviceTypes.split('|').includes('Property Accounting')
    ) {
      aaDate = new Date(
        moment(
          getSectionAttributeValueByKey(
            this.state.transitionData,
            'extendedDate'
          )
        )
      ).getTime();
      terminationDate = new Date(
        moment(
          getSectionAttributeValueByKey(
            this.state.transitionData,
            'assignmentEndDate'
          )
        )
      ).getTime();
    }
    const bDate = new Date(moment(startDate)).getTime();
    let result = Operators.GreaterThanEqualsTo(bDate, aDate);
    let result2;
    if (this.state?.selectedTransitionTypeId?.toString() === '3') {
      result = Operators.LessThanEqualsTo(bDate, aaDate);
      result2 = Operators.GreaterThan(bDate, terminationDate);
    }

    const properties =
      this.state.selectedTransitionTypeId?.toString() === '2'
        ? this.getManagementProperties(transitionData)
        : propertyDetails;
    if (properties === undefined || properties.length <= 0) {
      const msg =
        this.state.selectedTransitionTypeId?.toString() === '2'
          ? 'In order to set management fee please select CIO property in Assignment Details section.'
          : 'In order to set management fee please select/add property in Assignment Details section.';

      ShowToast(msg, toastType.ERROR, 5000, 500);
      return;
    }
    if (
      this.state?.selectedTransitionTypeId?.toString() === '3' &&
      serviceTypes.split('|').includes('Property Accounting')
    ) {
      if (result.result && result2.result) {
        setSectionFieldAttributeByKey(ch, 'Startdate', 'isInErrorState', false);
        setSectionFieldAttributeByKey(ch, 'Startdate', 'errorMessage', '');

        groupedData.forEach((x) => {
          const selectedPropName = getSectionAttributeValueByKey(
            ch,
            'managementPropertyName'
          );
          const selectedProp = getSectionAttributeValueByKey(
            ch,
            'managementPropertyId'
          );
          if (
            selectedPropName ===
            getSectionAttributeValueByKey(x.data, 'managementPropertyName')
          ) {
            const recordId = getSectionAttributeFieldValueByKeyValue(
              x.data,
              'Startdate',
              startDate,
              'recordId'
            );
            if (recordId !== '') {
              updatedmanagementFeeData = updatedmanagementFeeData.filter(
                (z) => z.recordId !== recordId
              );
            }
          }
        });
        if (applyToAll) {
          const propertyData = properties[0];
          setSectionFieldAttributeByKey(ch, 'managementPropertyId', 'attributeValue', propertyData.propertyId);
          setSectionFieldAttributeByKey(ch, 'managementPropertyName', 'attributeValue', propertyData.propertyName);
        }

        // if (applyToAll) {
        //   if (exclatedFee === false) {
        //     groupedData.forEach(x => {
        //       const recordId = getSectionAttributeFieldValueByKeyValue(x.data,
        //         'ManagementTransitionId',
        //         this.props.selectedTransitionId,
        //         'recordId');
        //       if (recordId !== '') {
        //         updatedmanagementFeeData = updatedmanagementFeeData.filter(z => (z.recordId !== recordId));
        //       }
        //     });
        //     // updatedmanagementFeeData = [];
        //   } else {
        //     groupedData.forEach(x => {
        //       const recordId = getSectionAttributeFieldValueByKeyValue(x.data,
        //         'Startdate',
        //         startDate,
        //         'recordId');
        //       if (recordId !== '') {
        //         updatedmanagementFeeData = updatedmanagementFeeData.filter(z => (z.recordId !== recordId));
        //       }
        //     });
        //   }
        //   properties.forEach((x, i) => {
        //     let recordId = getSectionAttributeFieldValueByKeyValue(updatedmanagementFeeData,
        //       'managementPropertyName',
        //       x.propertyName,
        //       'recordId');
        //     if (recordId !== '') {
        //       recordId = exclatedFee === true ? recordId + startDateNum : recordId;
        //       updatedmanagementFeeData = updatedmanagementFeeData.filter(x => (x.recordId !== recordId));
        //     }
        //     const fields = cloneDeep(ch);
        //     setSectionAttributeValueByKey(fields, 'managementPropertyName', x.propertyName);
        //     setSectionAttributeValueByKey(fields, 'managementPropertyId', x.propertyId);
        //     setSectionAttributeValueByKey(fields, 'ManagementTransitionId', this.props.selectedTransitionId);
        //     fields.forEach(y => {
        //       y.recordId = (recordId !== '' && recordId !== 0 ? recordId : x.propertyId.toString() + startDateNum);
        //       updatedmanagementFeeData.push(cloneDeep(y));
        //     });
        //   });
        //   // const getFistRecord = [];
        //   // updatedmanagementFeeData = getFistRecord.push(updatedmanagementFeeData.find(x => x));
        // } else
        {
          const selectedPropertyID = getSectionAttributeValueByKey(ch, 'managementPropertyId');
          const selectedPropertyName = getSectionAttributeValueByKey(ch, 'managementPropertyName');
          let selected = getSectionAttributeFieldValueByKeyValue(updatedmanagementFeeData, 'managementPropertyName',
            selectedPropertyName, 'recordId');
          if (selected === '') {
            selected = selectedPropertyID;
          } else {
            const selectedGroup = (
              (groupedData || []).find((x) => x.recordId === selected) || {}
            ).data;
            if (selectedGroup) {
              const recordId = getSectionAttributeFieldValueByKeyValue(
                selectedGroup,
                'Startdate',
                startDate,
                'recordId'
              );
              if (recordId !== '') {
                selected = recordId;
              } else {
                selected = selectedPropertyID;
              }
            }
          }
          selected = exclatedFee === true ? selected + startDateNum : selected;
          updatedmanagementFeeData = updatedmanagementFeeData.filter(
            (x) => x.recordId !== selected
          );
          // setSectionAttributeValueByKey(ch, 'applyToAll', '0');
          setSectionAttributeValueByKey(
            ch,
            'ManagementTransitionId',
            this.props.selectedTransitionId
          );
          ch.forEach((x) => {
            x.recordId = (
              selected !== '' && selected !== 0
                ? selected
                : selectedPropertyID + startDateNum
            ).toString();
            updatedmanagementFeeData.push(cloneDeep(x));
            // if (!applyToAll || (applyToAll && (updatedmanagementFeeData.filter(x => x.recordId !== '0') || []).length <= 0)) { updatedmanagementFeeData.push(cloneDeep(x)); }
          });
        }

        ShowToast(
          "Management Fee added successfully. Please refer 'Management Fee(s)' table below.",
          toastType.INFO,
          5000,
          5000
        );
        if (applyToAll) {
          setSectionFieldAttributeByKey(ch, 'managementPropertyId', 'attributeValue', 0);
          setSectionFieldAttributeByKey(ch, 'managementPropertyName', 'attributeValue', '');
        }
        this.setState(
          {
            managementFeeData: updatedmanagementFeeData.filter(
              (x) =>
                (x.recordId || '') !== null && (x.recordId || '') !== 'null'
            ),
            feeDataStructure: cloneDeep(ch),
            reloadPtf: !this.state.reloadPtf,
            reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
            reloadManagementFeetable: !this.state.reloadManagementFeetable,
            isLegalEntityManagementFee: applyToAll,
            isChangesInManagementFee: true
          },
          () => {
            this.forceUpdate();
          }
        );
      } else {
        setSectionFieldAttributeByKey(ch, 'Startdate', 'isInErrorState', true);
        setSectionFieldAttributeByKey(
          ch,
          'Startdate',
          'errorMessage',
          'Management Fee start date should be greater or equal to ' +
          (this.state?.selectedTransitionTypeId?.toString() === '2'
            ? 'Effective From'
            : 'Service(s) Start Date')
        );
        if (
          this.state?.selectedTransitionTypeId?.toString() === '3' &&
          serviceTypes.split('|').includes('Property Accounting')
        ) {
          if (result2 !== undefined) {
            if (result2.result === false) {
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'isInErrorState',
                true
              );
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'errorMessage',
                'Management Fee start date should be greater than Service End Date'
              );
            }
            if (result.result === false) {
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'isInErrorState',
                true
              );
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'errorMessage',
                'Management Fee start date should be less than or equal to Grace Period (Property Accounting)'
              );
            }
          }
        }
        this.setState(
          {
            feeDataStructure: cloneDeep(ch),
            reloadPtf: !this.state.reloadPtf,
            reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
            reloadManagementFeetable: !this.state.reloadManagementFeetable
          },
          () => {
            this.forceUpdate();
          }
        );
      }
    } else {
      if (result.result) {
        setSectionFieldAttributeByKey(ch, 'Startdate', 'isInErrorState', false);
        setSectionFieldAttributeByKey(ch, 'Startdate', 'errorMessage', '');

        groupedData.forEach((x) => {
          const selectedPropName = getSectionAttributeValueByKey(
            ch,
            'managementPropertyName'
          );
          const selectedProp = getSectionAttributeValueByKey(
            ch,
            'managementPropertyId'
          );
          if (
            selectedPropName ===
            getSectionAttributeValueByKey(x.data, 'managementPropertyName')
          ) {
            const recordId = getSectionAttributeFieldValueByKeyValue(
              x.data,
              'Startdate',
              startDate,
              'recordId'
            );
            if (recordId !== '') {
              updatedmanagementFeeData = updatedmanagementFeeData.filter(
                (z) => z.recordId !== recordId
              );
            }
          }
        });

        if (applyToAll) {
          const propertyData = properties[0];
          setSectionFieldAttributeByKey(ch, 'managementPropertyId', 'attributeValue', propertyData.propertyId);
          setSectionFieldAttributeByKey(ch, 'managementPropertyName', 'attributeValue', propertyData.propertyName);
        }

        // if (applyToAll) {
        //   if (exclatedFee === false) {
        //     groupedData.forEach(x => {
        //       const recordId = getSectionAttributeFieldValueByKeyValue(x.data,
        //         'ManagementTransitionId',
        //         this.props.selectedTransitionId,
        //         'recordId');
        //       if (recordId !== '') {
        //         updatedmanagementFeeData = updatedmanagementFeeData.filter(z => (z.recordId !== recordId));
        //       }
        //     });
        //     // updatedmanagementFeeData = [];
        //   } else {
        //     groupedData.forEach(x => {
        //       const recordId = getSectionAttributeFieldValueByKeyValue(x.data,
        //         'Startdate',
        //         startDate,
        //         'recordId');
        //       if (recordId !== '') {
        //         updatedmanagementFeeData = updatedmanagementFeeData.filter(z => (z.recordId !== recordId));
        //       }
        //     });
        //   }
        //   properties.forEach((x, i) => {
        //     let recordId = getSectionAttributeFieldValueByKeyValue(updatedmanagementFeeData,
        //       'managementPropertyName',
        //       x.propertyName,
        //       'recordId');
        //     if (recordId !== '') {
        //       recordId = exclatedFee === true ? recordId + startDateNum : recordId;
        //       updatedmanagementFeeData = updatedmanagementFeeData.filter(x => (x.recordId !== recordId));
        //     }
        //     const fields = cloneDeep(ch);
        //     setSectionAttributeValueByKey(fields, 'managementPropertyName', x.propertyName);
        //     setSectionAttributeValueByKey(fields, 'managementPropertyId', x.propertyId);
        //     setSectionAttributeValueByKey(fields, 'ManagementTransitionId', this.props.selectedTransitionId);
        //     fields.forEach(y => {
        //       y.recordId = (recordId !== '' && recordId !== 0 ? recordId : x.propertyId.toString() + startDateNum);
        //       updatedmanagementFeeData.push(cloneDeep(y));
        //     });
        //   });
        //   // const getFistRecord = [];
        //   // updatedmanagementFeeData = getFistRecord.push(updatedmanagementFeeData.find(x => x));
        // } else
        {
          const selectedPropertyID = getSectionAttributeValueByKey(ch, 'managementPropertyId');
          const selectedPropertyName = getSectionAttributeValueByKey(ch, 'managementPropertyName');
          let selected = getSectionAttributeFieldValueByKeyValue(updatedmanagementFeeData, 'managementPropertyName',
            selectedPropertyName, 'recordId');
          if (selected === '') {
            selected = selectedPropertyID;
          } else {
            const selectedGroup = (
              (groupedData || []).find((x) => x.recordId === selected) || {}
            ).data;
            if (selectedGroup) {
              const recordId = getSectionAttributeFieldValueByKeyValue(
                selectedGroup,
                'Startdate',
                startDate,
                'recordId'
              );
              if (recordId !== '') {
                selected = recordId;
              } else {
                selected = selectedPropertyID;
              }
            }
          }
          selected = exclatedFee === true ? selected + startDateNum : selected;
          updatedmanagementFeeData = updatedmanagementFeeData.filter(
            (x) => x.recordId !== selected
          );
          // setSectionAttributeValueByKey(ch, 'applyToAll', '0');
          setSectionAttributeValueByKey(
            ch,
            'ManagementTransitionId',
            this.props.selectedTransitionId
          );
          ch.forEach((x) => {
            x.recordId = (
              selected !== '' && selected !== 0
                ? selected
                : selectedPropertyID + startDateNum
            ).toString();
            updatedmanagementFeeData.push(cloneDeep(x));
            // if (!applyToAll || (applyToAll && (updatedmanagementFeeData.filter(x => x.recordId !== '0') || []).length <= 0)) { updatedmanagementFeeData.push(cloneDeep(x)); }
          });
        }
        if (applyToAll) {
          setSectionFieldAttributeByKey(ch, 'managementPropertyId', 'attributeValue', 0);
          setSectionFieldAttributeByKey(ch, 'managementPropertyName', 'attributeValue', '');
        }
        ShowToast(
          "Management Fee added successfully. Please refer 'Management Fee(s)' table below.",
          toastType.INFO,
          5000,
          5000
        );
        this.setState(
          {
            managementFeeData: updatedmanagementFeeData.filter(
              (x) =>
                (x.recordId || '') !== null && (x.recordId || '') !== 'null'
            ),
            feeDataStructure: cloneDeep(ch),
            reloadPtf: !this.state.reloadPtf,
            reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
            reloadManagementFeetable: !this.state.reloadManagementFeetable,
            isLegalEntityManagementFee: applyToAll,
            isChangesInManagementFee: true
          },
          () => {
            this.forceUpdate();
          }
        );
      } else {
        setSectionFieldAttributeByKey(ch, 'Startdate', 'isInErrorState', true);
        setSectionFieldAttributeByKey(
          ch,
          'Startdate',
          'errorMessage',
          'Management Fee start date should be greater or equal to ' +
          (this.state?.selectedTransitionTypeId?.toString() === '2'
            ? 'Effective From'
            : 'Service(s) Start Date')
        );
        if (
          this.state?.selectedTransitionTypeId?.toString() === '3' &&
          serviceTypes.split('|').includes('Property Accounting')
        ) {
          if (result2 !== undefined) {
            if (result2.result === false) {
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'isInErrorState',
                true
              );
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'errorMessage',
                'Management Fee start date should be grater than or equal to Service End Date'
              );
            }
            if (result.result === false) {
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'isInErrorState',
                true
              );
              setSectionFieldAttributeByKey(
                ch,
                'Startdate',
                'errorMessage',
                'Management Fee start date should be less than or equal to Grace Period (Property Accounting)'
              );
            }
          }
        }
        this.setState(
          {
            feeDataStructure: cloneDeep(ch),
            reloadPtf: !this.state.reloadPtf,
            reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
            reloadManagementFeetable: !this.state.reloadManagementFeetable
          },
          () => {
            this.forceUpdate();
          }
        );
      }
    }
  };

  // Validate and Set Engineer Hour Billing
  setEngineerHourBilling = (ch) => {
    const { engineerHourBillingData, transitionData } = this.state;
    const isEngineerHourBilling = getSectionAttributeValueByKey(ch, 'IsEngineerHourBilling');
    const startDate = getSectionAttributeValueByKey(ch, 'EngineerHourlyBillingStartDate');
    const endDate = getSectionAttributeValueByKey(ch, 'EngineerHourlyBillingEndDate');

    let updatedEngineerHourBillingData = (cloneDeep(engineerHourBillingData) || []).filter(
      (x) => x.recordId !== null && x.recordId !== 'null'
    );

    // If End Date is selected
    if (isEngineerHourBilling === '0' && (startDate || '') === '' && (endDate || '') !== '') {
      const startDateValues = updatedEngineerHourBillingData.filter(x => x.recordId?.toString() !== '0' && x.dbColumn === 'EngineerHourlyBillingStartDate') || [];
      if (startDateValues.length > 0) {
        const latestRecordId = startDateValues.reduce(function (r, a) {
          return new Date(r.attributeValue) > new Date(a.attributeValue) ? r : a;
        })?.recordId;
        const latestStartDate = updatedEngineerHourBillingData?.find(x => x.recordId?.toString() === latestRecordId?.toString() && x.dbColumn === 'EngineerHourlyBillingStartDate')?.attributeValue;
        if (latestStartDate !== undefined && new Date(endDate) >= new Date(latestStartDate)) {
          // set End Date to the latest record
          updatedEngineerHourBillingData.forEach(x => {
            if (x.recordId?.toString() === latestRecordId?.toString() && x.dbColumn === 'EngineerHourlyBillingEndDate') {
              x.attributeValue = endDate;
            }
          });
          ShowToast(
            "Engineer Hour Billing End Date updated successfully. Please refer 'Engineer Hour Billing' table below.",
            toastType.INFO,
            5000,
            5000
          );
          this.setState(
            {
              engineerHourBillingData: updatedEngineerHourBillingData.filter(
                (x) =>
                  (x.recordId || '') !== null && (x.recordId || '') !== 'null'
              ),
              engineerHourBillingDataStructure: cloneDeep(ch),
              reloadPtf: !this.state.reloadPtf,
              reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
              reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable,
              isChangesInEngineerHourBilling: true
            },
            () => {
              this.forceUpdate();
            }
          );
        } else {
          // Validation Error
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingEndDate', 'isInErrorState', true);
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingEndDate', 'errorMessage', 'Engineer Hour Billing End Date should be greater or equal to ' + latestStartDate);
          this.setState(
            {
              engineerHourBillingDataStructure: cloneDeep(ch),
              reloadPtf: !this.state.reloadPtf,
              reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
              reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
            },
            () => {
              this.forceUpdate();
            }
          );
        }
      } else {
        // error popup
        ShowToast(
          "Engineer Hour Billing record is not available to update End Date. Please add the record and update the End Date",
          toastType.ERROR,
          5000,
          5000
        );
      }
    } else {
      const newRecordId = moment(new Date()).format('YYYYMMDDmmss');
      const groupedData = this.getGroupedData(updatedEngineerHourBillingData) || [];
      setSectionAttributeValueByKey(ch, 'propertyTransitionId', this.props.selectedTransitionId);
      const serviceTypes = getSectionAttributeValueByKey(transitionData, 'ServiceType');

      // PTF Start Date
      const ptfStartDate =
        this.state?.selectedTransitionTypeId?.toString() === '2'
          ? new Date(
            moment(
              getSectionAttributeValueByKey(
                this.state.transitionData,
                'effectiveFrom'
              )
            )
          ).getTime()
          : new Date(
            moment(
              getSectionAttributeValueByKey(
                this.state.transitionData,
                'assignmentStartDate'
              )
            )
          ).getTime();

      let extendedPTFDate;
      let terminationDate;
      if (this.state?.selectedTransitionTypeId?.toString() === '3' && serviceTypes.split('|').includes('Property Accounting')) {
        extendedPTFDate = new Date(
          moment(
            getSectionAttributeValueByKey(
              this.state.transitionData,
              'extendedDate'
            )
          )
        ).getTime();
        terminationDate = new Date(
          moment(
            getSectionAttributeValueByKey(
              this.state.transitionData,
              'assignmentEndDate'
            )
          )
        ).getTime();
      }
      const selectedStartDate = new Date(moment(startDate)).getTime();
      let result = Operators.GreaterThanEqualsTo(selectedStartDate, ptfStartDate);
      let result2;
      if (this.state?.selectedTransitionTypeId?.toString() === '3') {
        result = Operators.LessThanEqualsTo(selectedStartDate, extendedPTFDate);
        result2 = Operators.GreaterThan(selectedStartDate, terminationDate);
      }

      if (this.state?.selectedTransitionTypeId?.toString() === '3' && serviceTypes.split('|').includes('Property Accounting')) {
        if (result.result && result2.result) {
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', false);
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', '');
          setSectionAttributeValueByKey(ch, 'EngineerHourBillingTransitionId', this.props.selectedTransitionId);

          // Remove existing record, if exist, with same start date
          groupedData.forEach((x) => {
            const recordId = getSectionAttributeFieldValueByKeyValue(x.data, 'EngineerHourlyBillingStartDate', startDate, 'recordId');
            if (recordId !== '') {
              updatedEngineerHourBillingData = updatedEngineerHourBillingData.filter((z) => z.recordId !== recordId);
            }
          });

          // Set End Date of Latest Record As Selected Date - 1
          let isSelectedDateValid = true;
          const startDateValues = updatedEngineerHourBillingData.filter(x => x.recordId?.toString() !== '0' && x.dbColumn === 'EngineerHourlyBillingStartDate') || [];
          if (startDateValues.length > 0) {
            const latestRecordId = startDateValues.reduce(function (r, a) {
              return new Date(r.attributeValue) > new Date(a.attributeValue) ? r : a;
            })?.recordId;

            const latestStartDate = updatedEngineerHourBillingData?.find(x => x.recordId?.toString() === latestRecordId?.toString() && x.dbColumn === 'EngineerHourlyBillingStartDate')?.attributeValue;

            if (latestStartDate !== undefined && new Date(startDate) >= new Date(latestStartDate)) {
              isSelectedDateValid = true;
              const endDateToSet = new Date(new Date(startDate) - 1);
              const endDate = moment(endDateToSet).format('MM/DD/YYYY');
              updatedEngineerHourBillingData.forEach(x => {
                if (x.recordId?.toString() === latestRecordId?.toString() && x.dbColumn === 'EngineerHourlyBillingEndDate') {
                  x.attributeValue = endDate;
                }
              });
            } else {
              isSelectedDateValid = false;
              setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
              setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be greater or equal to ' + latestStartDate);
              this.setState(
                {
                  engineerHourBillingDataStructure: cloneDeep(ch),
                  reloadPtf: !this.state.reloadPtf,
                  reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
                  reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
                },
                () => {
                  this.forceUpdate();
                }
              );
            }
          }

          // Set record id to the newly created record
          if (isSelectedDateValid === true) {
            ch.forEach((x) => {
              x.recordId = newRecordId.toString();
              updatedEngineerHourBillingData.push(cloneDeep(x));
            });

            ShowToast(
              "Engineer Hour Billing added successfully. Please refer 'Engineer Hour Billing' table below.",
              toastType.INFO,
              5000,
              5000
            );
            this.setState(
              {
                engineerHourBillingData: updatedEngineerHourBillingData.filter(
                  (x) =>
                    (x.recordId || '') !== null && (x.recordId || '') !== 'null'
                ),
                engineerHourBillingDataStructure: cloneDeep(ch),
                reloadPtf: !this.state.reloadPtf,
                reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
                reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable,
                isChangesInEngineerHourBilling: true
              },
              () => {
                this.forceUpdate();
              }
            );
          }
        } else {
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
          setSectionFieldAttributeByKey(
            ch,
            'EngineerHourlyBillingStartDate',
            'errorMessage',
            'Engineer Hour Billing start date should be greater or equal to ' +
            (this.state?.selectedTransitionTypeId?.toString() === '2'
              ? 'Effective From'
              : 'Service(s) Start Date')
          );
          if (this.state?.selectedTransitionTypeId?.toString() === '3' && serviceTypes.split('|').includes('Property Accounting')) {
            if (result2 !== undefined) {
              if (result2.result === false) {
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be greater than Service End Date');
              }
              if (result.result === false) {
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be less than or equal to Grace Period (Property Accounting)');
              }
            }
          }
          this.setState(
            {
              engineerHourBillingDataStructure: cloneDeep(ch),
              reloadPtf: !this.state.reloadPtf,
              reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
              reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
            },
            () => {
              this.forceUpdate();
            }
          );
        }
      } else {
        if (result.result) {
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', false);
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', '');
          setSectionAttributeValueByKey(ch, 'EngineerHourBillingTransitionId', this.props.selectedTransitionId);

          // Remove existing record, if exist, with same start date
          groupedData.forEach((x) => {
            const recordId = getSectionAttributeFieldValueByKeyValue(x.data, 'EngineerHourlyBillingStartDate', startDate, 'recordId');
            if (recordId !== '') {
              updatedEngineerHourBillingData = updatedEngineerHourBillingData.filter((z) => z.recordId !== recordId);
            }
          });

          // Check if selected Start Date is valid. i.e., Greater than existing Start Date(s).
          let isSelectedDateValid = true;
          const startDateValues = updatedEngineerHourBillingData.filter(x => x.recordId?.toString() !== '0' && x.dbColumn === 'EngineerHourlyBillingStartDate') || [];
          if (startDateValues.length > 0) {
            const latestRecordId = startDateValues.reduce(function (r, a) {
              return new Date(r.attributeValue) > new Date(a.attributeValue) ? r : a;
            })?.recordId;

            const latestStartDate = updatedEngineerHourBillingData?.find(x => x.recordId?.toString() === latestRecordId?.toString() && x.dbColumn === 'EngineerHourlyBillingStartDate')?.attributeValue;

            // If selected start date is greater than or equal to latest start date
            if (latestStartDate !== undefined && new Date(startDate) >= new Date(latestStartDate)) {
              isSelectedDateValid = true;
              const endDateToSet = new Date(new Date(startDate) - 1);
              const endDate = moment(endDateToSet).format('MM/DD/YYYY');

              // Set End Date of Latest Record As Selected Date - 1
              updatedEngineerHourBillingData.forEach(x => {
                if (x.recordId?.toString() === latestRecordId?.toString() && x.dbColumn === 'EngineerHourlyBillingEndDate') {
                  x.attributeValue = endDate;
                }
              });
            } else {
              isSelectedDateValid = false;
              setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
              setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be greater or equal to ' + latestStartDate);

              this.setState(
                {
                  engineerHourBillingDataStructure: cloneDeep(ch),
                  reloadPtf: !this.state.reloadPtf,
                  reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
                  reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
                },
                () => {
                  this.forceUpdate();
                }
              );
            }
          }

          if (isSelectedDateValid === true) {
            // Set Record Id to the new created record.
            ch.forEach((x) => {
              x.recordId = newRecordId.toString();
              updatedEngineerHourBillingData.push(cloneDeep(x));
            });

            ShowToast(
              "Engineer Hour Billing added successfully. Please refer 'Engineer Hour Billing' table below.",
              toastType.INFO,
              5000,
              5000
            );
            this.setState(
              {
                engineerHourBillingData: updatedEngineerHourBillingData.filter(
                  (x) =>
                    (x.recordId || '') !== null && (x.recordId || '') !== 'null'
                ),
                engineerHourBillingDataStructure: cloneDeep(ch),
                reloadPtf: !this.state.reloadPtf,
                reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
                reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable,
                isChangesInEngineerHourBilling: true
              },
              () => {
                this.forceUpdate();
              }
            );
          }
        } else {
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
          setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be greater or equal to ' +
            (this.state?.selectedTransitionTypeId?.toString() === '2'
              ? 'Effective From'
              : 'Service(s) Start Date')
          );
          if (this.state?.selectedTransitionTypeId?.toString() === '3' && serviceTypes.split('|').includes('Property Accounting')) {
            if (result2 !== undefined) {
              if (result2.result === false) {
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be greater than or equal to Service End Date');
              }
              if (result.result === false) {
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'isInErrorState', true);
                setSectionFieldAttributeByKey(ch, 'EngineerHourlyBillingStartDate', 'errorMessage', 'Engineer Hour Billing start date should be less than or equal to Grace Period (Property Accounting)');
              }
            }
          }
          this.setState(
            {
              engineerHourBillingDataStructure: cloneDeep(ch),
              reloadPtf: !this.state.reloadPtf,
              reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
              reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
            },
            () => {
              this.forceUpdate();
            }
          );
        }
      }
    }
  };

  getEngineerHourBillingSection = (dropDownSource, DetailsFormConfig) => {
    const { engineerHourBillingDataStructure, transitionData, showSubmitBtnOnEnggBillingSection } = this.state;
    const extendedDataObj = transitionData.find(
      (x) => x.dbColumn === 'ExtendedDate'
    );
    const transitionTypeId = getSectionAttributeValueByKey(
      transitionData,
      'TransitionTypeId'
    );
    let propAccounting = false;
    if (extendedDataObj !== undefined) {
      if (extendedDataObj.isVisible && extendedDataObj.isEditable) {
        propAccounting = true;
      }
    }
    if (transitionTypeId === null || transitionTypeId === '') {
      propAccounting = true;
    }

    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';

    const originalTranisitionTypeId = getSectionAttributeValueByKey(
      this.state.originaltransitionData,
      'TransitionTypeId'
    );

    let isEditable =
      ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && propAccounting)) &&
        (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
        (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'));
    if (isApproved && this.state.enableSubmitButtons !== true) {
      isEditable = false;
    }
    if (isApproved && this.state?.selectedTransitionTypeId?.toString() === '2' && (originalTranisitionTypeId?.toString() === '1' || originalTranisitionTypeId?.toString() === '')) {
      isEditable = true;
    }

    if (this.state.hasPmaAccess) {
      isEditable = true;
    }

    return {
      label: 'Set Engineer Hour Billing Details',
      element: (
        <FormGenerator
          key="engineerHourBilling"
          dropDownSource={dropDownSource}
          formFields={UpdateFieldsWithConfiguration(
            _.orderBy(engineerHourBillingDataStructure, ['attributeSortOrder'], ['asc']) || [],
            DetailsFormConfig
          )}
          submitText={'Add'}
          ReloadForm={this.state.reloadEngineerHourBillingSection}
          saveChanges={(ch) => {
            // this.validateEngineerHourBilling(ch);
            this.setEngineerHourBilling(ch);
          }}
          gridColumn={13}
          // partialForm={true}
          Editable={this.props.readOnly === true ? false : isEditable}
          sectionRowConfig={[]}
          showSubmitButton={showSubmitBtnOnEnggBillingSection}
        ></FormGenerator>
      ),
      row: 2
    };
  }

  getPropertyExpenseSection = (dropDownSource, DetailsFormConfig) => {
    const { expenseDataStructure } = this.state;
    let isEditable =
      (this.state.readOnly !== true || this.state.readOnly === undefined) &&
      this.state.allowToEdit === true &&
      this.state?.selectedTransitionTypeId?.toString() !== '3';

    if (this.state.hasPmaAccess) {
      isEditable = true;
    }
    return {
      label: 'Set Billable Expense(s)',
      element: (
        <FormGenerator
          key="propertyExpenseData"
          dropDownSource={dropDownSource}
          formFields={UpdateFieldsWithConfiguration(
            _.orderBy(expenseDataStructure, ['attributeSortOrder'], ['asc']) ||
            [],
            DetailsFormConfig
          )}
          submitText={'Add'}
          ReloadForm={this.state.reloadExpenseSection}
          saveChanges={(ch) => {
            this.setBillableExpense(ch);
          }}
          gridColumn={13}
          // partialForm={true}
          Editable={this.props.readOnly === true ? false : isEditable}
          sectionRowConfig={[]}
        ></FormGenerator>
      ),
      row: 2
    };
  };

  getBillableExpenseUi = (dropDownSource, DetailsFormConfig) => {
    const { allowToEdit } = this.state;

    return (
      <GridTable
        key={'billableExpensedetails'}
        columns={UpdateColumnWithConfiguration(
          allowToEdit
            ? ExpenseColumns
            : ExpenseColumns.filter((x) => x.name !== 'Action'),
          []
        )}
        reload={this.state.reloadBillableExpenseTable}
        // data={this.state.propertyDetails}
        config={{ showPager: true, showBottomPagerOnly: true }}
        // config={{ showPager: false }}
        data={this.getBillableExpenseTabledata(this.state.expenseData)}
        renderActionColumn={this.props.isCallFromPTFDetailReport === true ? null : this.renderDeleteExpenseAction}
      ></GridTable>
    );
  };

  setBillableExpense = (ch) => {
    const { expenseData, propertyDetails, transitionData, expenseTypes } =
      this.state;
    let updatedExpenseData = (cloneDeep(expenseData) || []).filter(
      (x) => x.recordId !== null && x.recordId !== 'null'
    );
    const groupedData = this.getGroupedData(updatedExpenseData) || [];
    const applyToAll = getSectionAttributeValueByKey(ch, 'applyToAll') === '1';
    const expenses = getSectionAttributeValueByKey(ch, 'expenseName')?.split(
      '|'
    );
    const selectedExpenseId = [];
    expenseTypes.forEach((x) => {
      if (expenses.find((y) => y === x.propertyExpenseType) !== undefined) {
        selectedExpenseId.push(x.propertyExpenseTypeId);
      }
    });
    setSectionAttributeValueByKey(
      ch,
      'ExpensesBillableTransitionId',
      this.props.selectedTransitionId
    );
    setSectionAttributeValueByKey(ch, 'ExpenseId', selectedExpenseId.join('|'));
    // const properties = this.state.selectedTransitionTypeId?.toString() === '2' ? managementProperties : propertyDetails;
    const properties =
      this.state.selectedTransitionTypeId?.toString() === '2'
        ? this.getManagementProperties(transitionData)
        : propertyDetails;

    if (properties === undefined || properties.length <= 0) {
      const msg =
        this.state.selectedTransitionTypeId?.toString() === '2'
          ? 'In order to set billable expense please select CIO property in Assignment Details section.'
          : 'In order to set billable expense please select/add property in Assignment Details section.';

      ShowToast(msg, toastType.ERROR, 5000, 500);
      return;
    }

    if (applyToAll) {
      groupedData.forEach((x) => {
        const recordId = getSectionAttributeFieldValueByKeyValue(
          x.data,
          'ExpensesBillableTransitionId',
          this.props.selectedTransitionId,
          'recordId'
        );
        if (recordId !== '') {
          updatedExpenseData = updatedExpenseData.filter(
            (z) => z.recordId !== recordId
          );
        }
      });
      // updatedmanagementFeeData = [];
      properties.forEach((x, i) => {
        const recordId = getSectionAttributeFieldValueByKeyValue(
          updatedExpenseData,
          'ExpensesBillablePropertyName',
          x.propertyName,
          'recordId'
        );
        if (recordId !== '') {
          updatedExpenseData = updatedExpenseData.filter(
            (x) => x.recordId !== recordId
          );
        }
        const fields = cloneDeep(ch);
        setSectionAttributeValueByKey(
          fields,
          'ExpensesBillablePropertyName',
          x.propertyName
        );
        setSectionAttributeValueByKey(
          fields,
          'ExpensesBillablePropertyId',
          x.propertyId
        );
        setSectionAttributeValueByKey(
          fields,
          'ExpensesBillableTransitionId',
          this.props.selectedTransitionId
        );
        fields.forEach((y) => {
          y.recordId =
            recordId !== '' && recordId !== 0
              ? recordId
              : x.propertyId.toString();
          updatedExpenseData.push(cloneDeep(y));
        });
      });
    } else {
      const selectedPropertyID = getSectionAttributeValueByKey(
        ch,
        'ExpensesBillablePropertyId'
      );
      const selectedPropertyName = getSectionAttributeValueByKey(
        ch,
        'ExpensesBillablePropertyName'
      );
      let selected = getSectionAttributeFieldValueByKeyValue(
        updatedExpenseData,
        'ExpensesBillablePropertyName',
        selectedPropertyName,
        'recordId'
      );
      if (selected === '') {
        selected = selectedPropertyID;
      }
      updatedExpenseData = updatedExpenseData.filter(
        (x) => x.recordId !== selected
      );
      // setSectionAttributeValueByKey(ch, 'applyToAll', '0');
      setSectionAttributeValueByKey(
        ch,
        'ExpensesBillableTransitionId',
        this.props.selectedTransitionId
      );
      ch.forEach((x) => {
        x.recordId = (
          selected !== '' && selected !== 0 ? selected : selectedPropertyID
        ).toString();
        updatedExpenseData.push(cloneDeep(x));
      });
    }

    ShowToast(
      "Billable Expense added successfully. Please refer 'Billable Expense(s)' table below.",
      toastType.INFO,
      5000,
      5000
    );
    this.setState(
      {
        expenseData: updatedExpenseData.filter(
          (x) => (x.recordId || '') !== null && (x.recordId || '') !== 'null'
        ),
        expenseDataStructure: cloneDeep(ch),
        reloadPtf: !this.state.reloadPtf,
        reloadExpenseSection: !this.state.reloadExpenseSection,
        reloadBillableExpenseTable: !this.state.reloadBillableExpenseTable
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  getNewClientdetailForm = (newClientDetail) => {
    const newClientDropdownSource = [
      {
        key: 'name',
        option: 'clientName',
        idField: 'clientId',
        source: this.state.clientMasterData,
        onChange: this.newClientOptionChange
      },
      {
        key: 'state',
        option: 'stateName',
        idField: 'stateId',
        autoSelect: true,
        source: getDistinctByProperty(
          this.state.allMarketStateData || [],
          'stateCode'
        )
        // onChange: this.getCityByStateforClient
      },
      {
        key: 'Role',
        option: 'roleName',
        idField: 'contactRoleId',
        optionIdField: 'contactRoleId',
        source: this.state.contactRoleMasterData || []
      }
    ];
    return (
      <FormGenerator
        key={'addNewClient'}
        parentKey={'client'}
        gridColumn={4}
        dropDownSource={newClientDropdownSource}
        formFields={UpdateFieldsWithConfiguration(
          newClientDetail,
          newclientContactDetailConfig
        )}
        validationMessages={[]}
        ReloadForm={this.state.reloadNewClientDetails}
        saveChanges={this.SaveClientDetails}
        Editable={IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) && this.state.readOnly !== true}
        partialForm={false}
      ></FormGenerator>
    );
  };

  getNewPropertydetailForm = (newPropertyData) => {
    let propertySubTypeData = cloneDeep(this.state.originalPropertySubTypeData);
    const value = getSectionAttributeValueByKey(this.state.transitionData, 'PropertyType');
    if (propertySubTypeData.find(x => x.propertySubTypeName === value) !== undefined) {
      propertySubTypeData = propertySubTypeData.filter(x => x.propertySubTypeName === value);
    }
    const newPropertyFormConfig = [
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      { key: 'marketName', type: controlType.DropDown, multiple: false },
      {
        key: 'sourceAccountingSystem',
        type: controlType.DropDown,
        multiple: false,
        isRequired: true
      },
      {
        key: 'propertySubTypeName',
        type: controlType.DropDown,
        multiple: false,
        isRequired: true
      },
      { key: 'yardiCode', type: controlType.TextBox, isVisible: false },
      { key: 'state', type: controlType.DropDown, multiple: false },
      { key: 'controllerName', type: controlType.DropDown, multiple: false },
      { key: 'aRAdminName', type: controlType.DropDown, multiple: false }
    ];
    const newPropertydropDownSource = [
      {
        key: 'marketName',
        option: 'marketName',
        idField: 'marketId',
        source: this.state.propertyMarketMasterData
      },
      {
        key: 'controllerName',
        option: 'employeeName',
        source: controllerEmployeesMasterData,
        applyfilter: true,
        filterMode: 'strict'
      },
      {
        key: 'state',
        option: 'stateName',
        source: this.state.stateMasterData,
        autoSelect: true
      },
      {
        key: 'sourceAccountingSystem',
        option: 'sourceAccountingSystem',
        idField: 'sourceAccountingSystemId',
        source: this.state.sourceAccountingSystemData,
        autoSelect: true,
        onChange: this.getSourceAccountingDetails
      },
      {
        key: 'propertySubTypeName',
        option: 'propertySubTypeName',
        idField: 'propertySubTypeId',
        source: propertySubTypeData,
        autoSelect: true
      },
      {
        key: 'aRAdminName',
        option: 'employeeName',
        source: (this.state.employeesAllMasterData || []).filter(
          (x) =>
            x.employeeStatus === true && x.departmentId?.toString() === DEPARTMENT.CENTRALIZED_AR?.toString()
        ),
        applyfilter: true,
        filterMode: 'strict'
      }
    ];
    return (
      <FormGenerator
        key={'addnewproperty'}
        gridColumn={4}
        formFields={UpdateFieldsWithConfiguration(
          newPropertyData,
          newPropertyFormConfig
        )}
        dropDownSource={newPropertydropDownSource}
        validationMessages={this.state.validationMessages}
        saveChanges={this.SaveNewProperty}
        ReloadForm={this.state.reloadProperty}
        parentKey={'addnewproperty'}
        partialForm={false}
        formType={'Section'}
        innerFieldColumn={11}
        // separatorConfig={PropertySeparatorConfig}
        sectionColumn={4}
        // sectionRowConfig={[
        //   { row: 1, column: 12 },
        //   { row: 2, column: 12 }
        // ]}
        Editable={IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) && this.state.readOnly !== true}
      ></FormGenerator>
    );
  };

  showFile = (url, title, isSpsFile = false) => {
    const contentType = 'application/pdf';
    let blobUrl;
    if (isSpsFile === false) {
      const blob = this.b64toBlob(
        url.replace('data:application/pdf;base64,', ''),
        contentType
      );
      blobUrl = URL.createObjectURL(blob);
    } else {
      blobUrl = url;
    }
    this.setState({
      openaddform: true,
      addformtitle: title,
      addNewformComponent: (
        <div style={{ width: '800px', height: '530px', overflow: 'hidden' }}>
          {/* <iframe src={url} width="700" height="700"></iframe> */}
          {/* <embed src={`data:application/pdf;base64,${url}`} type="application/pdf" width="100%"></embed> */}
          <div>file chips</div>
          <iframe
            id="iframe"
            onLoad={(ev) => {
              const x = document.getElementById('iframe');
              (
                ((x.contentWindow || {}).document.getElementsByTagName(
                  'embed'
                ) || [])[0] || {}
              ).style.height = '500px';
            }}
            src={blobUrl}
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              display: 'block'
            }}
            frameBorder="0"
            allowFullScreen={true}
          ></iframe>
        </div>
      )
    });
  };

  showFileWithFileNames = (blobUrl, title, fileNames, category, obj, selectedFileName = '', isSpsFile = false) => {
    const { isApproved, transitionData, spsData } = this.state;
    let showUploadButton = false;
    const originalTransitionTypeId = getSectionAttributeValueByKey(
      this.state.originaltransitionData,
      'TransitionTypeId'
    );
    const selectedTransitionTypeId = getSectionAttributeValueByKey(
      this.state.transitionData,
      'TransitionTypeId'
    );

    if (isApproved === true && originalTransitionTypeId?.toString() === selectedTransitionTypeId?.toString()) { // && (spsData[obj.category] === undefined || spsData[obj.category]?.length === 0)) {
      showUploadButton = true;
    }

    if (obj.category === 'NewAssignment' && selectedTransitionTypeId?.toString() !== '1') {
      showUploadButton = false;
    }
    if (IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) === false) {
      showUploadButton = false;
    }

    const ptfNumber = getSectionAttributeValueByKey(
      this.state.transitionData,
      'PtfNumber'
    );
    const propertyTransitionId = getSectionAttributeValueByKey(
      this.state.transitionData,
      'PropertyTransitionId'
    );
    (transitionData.find(
      (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
    ) || {}).attributeValue = obj.attributeValue;
    this.setState({
      openaddform: true,
      addformtitle: title,
      transitionData: transitionData,
      addNewformComponent: (
        <div style={{ width: '800px', height: '530px', overflow: 'hidden' }}>
          {/* <iframe src={url} width="700" height="700"></iframe> */}
          {/* <embed src={`data:application/pdf;base64,${url}`} type="application/pdf" width="100%"></embed> */}
          {this.props.isCallFromPTFDetailReport !== true && (obj.isEditable === true || showUploadButton === true) && (
            <div>
              <span style={{ lineHeight: '57px', margin: '10px' }}>Select New File(s) to Upload</span>
              <Tooltip title="Upload Document">
                <IconButton
                  className="action-button"
                  variant="contained"
                  size="small"
                  component="label"
                >
                  <CloudUploadOutlined size="small"></CloudUploadOutlined>
                  <input
                    type="file"
                    hidden
                    multiple={true}
                    onChange={(event) => {
                      this.onFileChange(event, obj, title);
                      event.target.value = "";
                    }}
                    accept="application/pdf"
                  />
                </IconButton>
              </Tooltip>
            </div>
          )}
          <div>
            <div><span style={{ marginLeft: '10px', marginBottom: '10px', fontWeight: 'bold' }}>Uploaded/Selected Files:</span></div>
            <div className='file-list'> {(fileNames || []).length === 0
              ? <div></div>
              : (fileNames || []).length > 0 &&
              (fileNames || []).map(fileName => {
                let fileNameToShow = fileName?.name?.toString().replace('NewAssignment_Document_', '')
                  .replace('ChangeInOwnerShip_Document_', '')
                  .replace('Termination_Document_', '')
                  .replace('W-9_', '');
                if ((/^\d+$/).test(fileNameToShow.split('.')[0])) {
                  fileNameToShow = fileName.name;
                }
                return (
                  (obj.isEditable === true || (showUploadButton === true && fileName?.isSpsFile === false))
                    ? (<Chip
                      key={'chip' + fileName.name}
                      label={fileNameToShow}
                      style={{ margin: 1 }}
                      variant='outlined'
                      onClick={() => { this.loadDocument(title, fileNames, fileName.name, category, obj, isSpsFile); }}
                      color={fileName.name === selectedFileName ? 'primary' : ''}
                      deleteIcon={fileName?.isSpsFile === true ? <DeleteIcon /> : ''}
                      // onDelete={() => { this.deleteSelectedDocument(title, fileNames, fileName.name, category, obj, isSpsFile); }}
                      onDelete={
                        fileName?.isSpsFile === true
                          ? () => {
                            this.setState(
                              {
                                deleteFileObj: { title: title, fileNames: fileNames, fileName: fileName.name, category: category, obj: obj, isSpsFile: isSpsFile },
                                isConfirmPopupOpen: true,
                                deleteFileConfirmationMessage: fileName?.isSpsFile === true
                                  ? 'You are deleting the file which is uploaded on the Server. File will be deleted from the server when you save the PTF. Are you sure you want to continue?'
                                  : 'Are you sure you want to delete this file?'
                              });
                          }
                          : () => { this.deleteSelectedDocument(title, fileNames, fileName.name, category, obj, fileName?.isSpsFile || false); }
                      }
                    />)
                    : (<Chip
                      key={'chip' + fileName.name}
                      label={fileNameToShow}
                      style={{ margin: 1 }}
                      variant='outlined'
                      onClick={() => { this.loadDocument(title, fileNames, fileName.name, category, obj, isSpsFile); }}
                      color={fileName.name === selectedFileName ? 'primary' : ''}
                    />)
                );
              })
            }
            </div>
          </div>
          {(blobUrl === undefined || blobUrl.length === 0) &&
            <div className='file-view'>
              <span>No file selected. Please select file to view.</span>
            </div >
          }
          {
            blobUrl?.length > 0 &&
            <iframe
              id="iframe"
              onLoad={(ev) => {
                const x = document.getElementById('iframe');
                (
                  ((x.contentWindow || {}).document.getElementsByTagName(
                    'embed'
                  ) || [])[0] || {}
                ).style.height = '500px';
              }}
              src={blobUrl}
              style={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                display: 'block'
              }}
              frameBorder="0"
              allowFullScreen={true}
            ></iframe>
          }
        </div >
      )
    });
  };

  onFileChange = (event, obj, title) => {
    if (event.target && !event.target.files.length) return;

    const { transitionData, spsData } = this.state;
    let { filesToBeUploaded, filesToBeDeleted } = this.state || [];
    let { w9FilesToBeUploaded, w9FilesToBeDeleted } = this.state || [];
    w9FilesToBeUploaded = w9FilesToBeUploaded || [];
    filesToBeUploaded = filesToBeUploaded || [];
    w9FilesToBeDeleted = w9FilesToBeDeleted || [];
    filesToBeDeleted = filesToBeDeleted || [];

    const isW9 = (title || '').replace(/-/g, '').toLowerCase() === 'w9';

    let isError = false;
    Array.from(event.target.files)?.forEach((file) => {
      if (file.type !== 'application/pdf') {
        ShowToast('Please select PDF file', toastType.WARNING, 5000, 500);
        event.target.value = null;
        isError = true;
        return false;
      }
      if (obj.uploadToSp === true) {
        // Check duplicate selected file of the category
        let dupFileName;
        if (isW9) {
          dupFileName = ((w9FilesToBeUploaded || []).filter((y) => y.category === obj.category) || [])
            .find(x => (x?.file?.name || '').toLowerCase() === (file?.name || '').toLowerCase());
        } else {
          dupFileName = ((filesToBeUploaded || []).filter((y) => y.category === obj.category) || [])
            .find(x => (x?.file?.name || '').toLowerCase() === (file?.name || '').toLowerCase());
        }
        if (dupFileName !== undefined) {
          ShowToast('File with the same name is already selected. Please select other file to upload.', toastType.WARNING, 5000, 500);
          isError = true;
          return false;
        } else if (spsData && spsData[obj.category] && spsData[obj.category].length > 0) {
          let spFiles = spsData[obj.category] || [];
          if (isW9) {
            // Only check among W9 files in SharePoint
            spFiles = spFiles.filter(x => x.name.toLowerCase().startsWith('w-9_') && !w9FilesToBeDeleted.includes(x.name));
          } else {
            // Only check among non-W9 files in SharePoint
            spFiles = spFiles.filter(x => !(x.name.toLowerCase().startsWith('w-9_')) && !filesToBeDeleted.includes(x.name));
          }
          const dupFileOnSP = spFiles
            .find(x => (x?.name || '')
              .replace('NewAssignment_Document_', '')
              .replace('ChangeInOwnerShip_Document_', '')
              .replace('Termination_Document_', '')
              .replace('W-9_', '')
              .toLowerCase() === (file?.name || '').toLowerCase()
            );
          if (dupFileOnSP !== undefined) {
            ShowToast('File with the same name is already uploaded. Please select other file to upload.', toastType.WARNING, 5000, 500);
            isError = true;
            return false;
          }
        }
      }
    });
    if (isError === false) {
      Array.from(event.target.files)?.forEach((file) => {
        if (obj.uploadToSp === true) {
          if (isW9) {
            w9FilesToBeUploaded.push({ category: obj.category, file: file, isW9: true });
          }
          else {
            filesToBeUploaded.push({ category: obj.category, file: file, isW9: false });
          }
          obj.attributeValue = (obj.attributeValue || '').length === 0 ? file.name : obj.attributeValue + '|' + file.name;
          (transitionData.find(
            (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
          ) || {}).attributeValue = obj.attributeValue;

          if ((obj.attributeValue || '').length > 0) {
            (transitionData.find(
              (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
            ) || {}).errorMessage = '';
            (transitionData.find(
              (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
            ) || {}).isInErrorState = false;
          }
        }
      });
      this.setState({ filesToBeUploaded, w9FilesToBeUploaded, transitionData, reloadPtf: !this.state.reloadPtf }, () => { this.viewFilesData(obj, title, event.target.files[0]?.name || ''); });
    }
  };

  showSelectedFile = async (title, fileNames, selectedFileName, category, obj, isSpsFile = false) => {
    let url = '';
    let blobUrl;
    const contentType = 'application/pdf';

    isSpsFile = fileNames.find(x => x.name === selectedFileName)?.isSpsFile || false;
    if (isSpsFile === true) {
      const { spsData } = this.state;
      const spFiles = spsData[category] || [];
      const selectedFile = (spFiles || []).find((x) => x.name === selectedFileName);
      if (selectedFile !== undefined) {
        this.showFileWithFileNames(
          await this.getSpBlob(selectedFile['@microsoft.graph.downloadUrl']),
          title,
          fileNames,
          category,
          obj,
          selectedFileName,
          isSpsFile
        );
      }
    } else {
      const { filesToBeUploaded } = this.state;
      const { w9FilesToBeUploaded } = this.state;
      const isW9 = (title || '').replace(/-/g, '').toLowerCase() === 'w9';

      let selectedFile;
      if (isW9) {
        selectedFile = (w9FilesToBeUploaded || []).find(
          (x) => x.category === category && x.file.name === selectedFileName
        );
      } else {
        selectedFile = (filesToBeUploaded || []).find(
          (x) => x.category === category && x.file.name === selectedFileName
        );
      }
      if (selectedFile && selectedFile.file) {
        this.getBase64Content(selectedFile?.file, (result) => {
          url = result;
          const blob = this.b64toBlob(
            url.replace('data:application/pdf;base64,', ''),
            contentType
          );
          blobUrl = URL.createObjectURL(blob);
          this.showFileWithFileNames(blobUrl, title, fileNames, category, obj, selectedFileName, isSpsFile);
        });
      } else {
        this.showFileWithFileNames('', title, [], category, obj, selectedFileName, isSpsFile);
      }
    }
  };

  deleteSelectedDocument = (title, fileNames, selectedFileName, category, obj, isSpsFile = false) => {
    // Determine if this is the W9 dialog
    const isW9 = (title || '').replace(/-/g, '').toLowerCase() === 'w9';

    isSpsFile = fileNames.find(x => x.name === selectedFileName)?.isSpsFile || false;

    if (isSpsFile === true) {
      // For SharePoint files
      let filesToBeDeleted = isW9
        ? (this.state.w9FilesToBeDeleted || [])
        : (this.state.filesToBeDeleted || []);
      filesToBeDeleted = filesToBeDeleted || [];

      const fileIndex = (fileNames || []).findIndex(x => x.name === selectedFileName);
      fileNames.splice(fileIndex, 1);

      const remainingFileNames = [];
      fileNames?.forEach((x) => {
        remainingFileNames.push(x.name);
      });
      obj.attributeValue = remainingFileNames.join('|');
      const fileName = fileNames?.length > 0 ? fileNames[0].name : '';
      filesToBeDeleted.push(selectedFileName);

      // Remove file details from files to avoid deleted file into email attachment
      let files = this.state.files || '';
      const firstIndexOfFileDetails = files.indexOf(selectedFileName);
      let lastIndexOfFileDetails = files.substring(firstIndexOfFileDetails).indexOf('%%%');
      lastIndexOfFileDetails = firstIndexOfFileDetails + lastIndexOfFileDetails + 3;
      const fileDetails = files.substring(firstIndexOfFileDetails, lastIndexOfFileDetails);
      files = files.replace(fileDetails, '');

      // Set the correct state property
      if (isW9) {
        this.setState({ w9FilesToBeDeleted: filesToBeDeleted, files: files }, () => {
          this.showSelectedFile(title, fileNames, fileName, category, obj, isSpsFile);
        });
      } else {
        this.setState({ filesToBeDeleted: filesToBeDeleted, files: files }, () => {
          this.showSelectedFile(title, fileNames, fileName, category, obj, isSpsFile);
        });
      }
    } else {
      // For local files
      if (isW9) {
        const { w9FilesToBeUploaded } = this.state;
        const filteredFiles = (w9FilesToBeUploaded || []).filter(
          (x) => x.file.name !== selectedFileName
        );
        const fileIndex = (fileNames || []).findIndex(x => x.name === selectedFileName);
        fileNames.splice(fileIndex, 1);
        const remainingFileNames = [];
        fileNames?.forEach((x) => {
          remainingFileNames.push(x.name);
        });
        obj.attributeValue = remainingFileNames.join('|');
        const fileName = fileNames?.length > 0 ? fileNames[0].name : '';
        this.setState({ w9FilesToBeUploaded: filteredFiles }, () => {
          this.showSelectedFile(title, fileNames, fileName, category, obj, isSpsFile);
        });
      } else {
        const { filesToBeUploaded } = this.state;
        const filteredFiles = (filesToBeUploaded || []).filter(
          (x) => x.file.name !== selectedFileName
        );
        const fileIndex = (fileNames || []).findIndex(x => x.name === selectedFileName);
        fileNames.splice(fileIndex, 1);
        const remainingFileNames = [];
        fileNames?.forEach((x) => {
          remainingFileNames.push(x.name);
        });
        obj.attributeValue = remainingFileNames.join('|');
        const fileName = fileNames?.length > 0 ? fileNames[0].name : '';
        this.setState({ filesToBeUploaded: filteredFiles }, () => {
          this.showSelectedFile(title, fileNames, fileName, category, obj, isSpsFile);
        });
      }
    }
  };

  loadDocument = (title, fileNames, selectedFileName, category, obj, isSpsFile = false) => {
    // alert(selectedFileName);
    this.showSelectedFile(title, fileNames, selectedFileName, category, obj, isSpsFile);
  }

  generateShareLinkAndShow = (spFile) => {
    spsApiPost({
      url: getSharePointUrl(
        'streamrealty',
        'createLink',
        this.state.spListkey,
        '',
        spFile[0].parentReference.driveId,
        spFile[0].id
      ),
      postBody: {
        type: 'embed',
        scope: 'anonymous'
      }
    })
      .then((res) => {
        if (res && res.link) {
          this.showFile(res.link.webUrl, spFile[0].name, true);
        }
      })
      .catch(() => {
        ShowToast(
          'Unable to load file from Share Point!',
          toastType.ERROR,
          2000,
          2000
        );
        this.showFile(
          spFile[0]['@microsoft.graph.downloadUrl'],
          spFile[0].name,
          true
        );
      });
  };

  uploadFilesToSharePoint = (driveId, key, transitionId = 0, folderName = null) => {
    const filesToUpload = [
      ...(this.state.filesToBeUploaded || []),
      ...(this.state.w9FilesToBeUploaded || [])
    ];
    const filesCount = filesToUpload.length;
    let responseCounter = 0;
    let errorCounter = 0;

    filesToUpload.forEach((x) => {
      // 1. Build file name
      const fileName = x.isW9
        ? 'W-9_' + (x?.file?.name || 'document.pdf')
        : (x.category + '_Document_' + (x?.file?.name || 'document.pdf'));

      spsApiPost({
        url: getSharePointUrl(
          'streamrealty',
          'uploadFileSession',
          key,
          // this.cleanName(
          //   getSectionAttributeValueByKey(
          //     this.state.transitionData,
          //     'assignmentStartDate'
          //   )
          // ) +
          // transitionId.toString() +
          // '.pdf',
          // (x?.file?.name ? '_' + x?.file?.name : '.pdf'),
          fileName,
          folderName || this.state.folderName
        ),
        postBody: {
          fileSize: x.file.size,
          item: {
            '@microsoft.graph.conflictBehavior': 'replace'
          }
        }
      }).then((data) => {
        if (data) {
          uploadSpsAPiRequest(data.data.uploadUrl, x.file, true).then(
            (data) => {
              if (data) {
                // ShowToast('File(s) uploaded successfully.', toastType.SUCCESS, 5000, 600);
                this.getList(
                  data.name,
                  (((store.getState() || {}).auth || {}).account || {})
                    .username || '',
                  x
                );

                responseCounter++;

                if (responseCounter === filesCount) {
                  getSpsAPiRequest(
                    getSharePointUrl('streamrealty', 'getChildItem', key, '', driveId)
                  ).then((files) => {
                    this.setCategoryWiseData(files, transitionId);
                    ShowToast('File(s) uploaded successfully.', toastType.SUCCESS, 5000, 600);

                    // upload file into CIO new folder -- New Legal Entity
                    this.uploadSpsDataForCIO(transitionId);
                  });
                }
                return true;
              } else {
                errorCounter++;
                this.setState({ isErrorOccurredWhileFileUpload: true });
                return false;
              }
              // this.props.onViewChange();
            }
          ).catch(response => {
            errorCounter++;
            this.setState({ isErrorOccurredWhileFileUpload: true });
            return false;
          });
        } else {
          errorCounter++;
          this.setState({ isErrorOccurredWhileFileUpload: true });
          return false;
        }
      }).catch(response => {
        errorCounter++;
        this.setState({ isErrorOccurredWhileFileUpload: true });
        return false;
      });
    });
  };

  deleteFileFromSharePoint = (fileName, spListkey, folderName) => {
    const url = getSharePointUrl(
      'streamrealty',
      'deleteFileByDrive',
      spListkey,
      fileName,
      folderName
    );
    deleteSpsApiRequest(url).then((data) => {
      if (data) {
        ShowToast('File(s) deleted successfully.', toastType.SUCCESS, 5000, 300);
        return data;
      }
    });
  };

  deleteCIOFileFromSharePoint = () => {
    const { filesToBeDeleted } = this.state || [];
    if ((this.state.selectedTransitionTypeId || '1').toString() === '2' && filesToBeDeleted && filesToBeDeleted.length > 0) {
      if (this.state.spCIOListkey === undefined || (this.state.spCIOListkey || '').length === 0) {
        const newLegalEntity = getSectionAttributeValueByKey(
          this.state.transitionData,
          'newLegalEntity',
          false
        );
        const newFolderName = this.cleanName(newLegalEntity);
        if (newFolderName && newFolderName.length) {
          getSpsAPiRequest(
            getSharePointUrl('streamrealty', 'getFolder', '', newFolderName)
          ).then((res) => {
            if (res !== null &&
              (res.displayName === newFolderName || res.name === newFolderName)
            ) {
              const folder = res;
              const key = folder.id;
              filesToBeDeleted?.forEach(x => {
                const cioFileName = x.replace('ChangeInOwnerShip', 'NewAssignment');
                this.deleteFileFromSharePoint(cioFileName, key, newFolderName);
              });
            }
          });
        }
      } else {
        filesToBeDeleted?.forEach(x => {
          this.deleteFileFromSharePoint(x, this.state.spCIOListkey, this.state.newFolderName);
        });
      }
    }
  }

  get_bigrams = (string) => {
    const s = string.toLowerCase();
    const v = [];
    for (let i = 0; i < s.length; i++) {
      v[i] = s.slice(i, i + 2);
    }
    return v;
  };

  string_similarity = (str1, str2) => {
    if (str1.length > 0 && str2.length > 0) {
      const pairs1 = this.get_bigrams(str1);
      const pairs2 = this.get_bigrams(str2);
      const union = pairs1.length + pairs2.length;
      let hit_count = 0;
      pairs1.forEach((x) => {
        pairs2.forEach((y) => {
          if (x === y) {
            hit_count++;
          }
        });
      });
      if (hit_count > 0) {
        return (2.0 * hit_count) / union;
      }
    }
    return 0.0;
  };

  getManagementFeeTabledata = (managementFeeData) => {
    const tableData = [];
    const grouped = this.getGroupedData(managementFeeData);
    const updatedProperties = getSectionAttributeValueByKey(
      this.state.transitionData,
      'UpdatedProperties'
    )?.split('|');
    (grouped || []).forEach((x) => {
      let a = {};
      if (x.recordId !== undefined && x.recordId !== '0' && x.recordId !== 'null'
        // &&
        // (this.state.managementProperties || []).find(y => (y.propertyId || '').toString() ===
        //   (getSectionAttributeValueByKey(x.data, 'managementPropertyId') || '').toString()) !== undefined
      ) {
        a.recordId = x.recordId;
        x.data.forEach((y) => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        tableData.push(a);
      }
    });
    function compare(a, b) {
      if (a.managementPropertyName < b.managementPropertyName) {
        return -1;
      }
      if (a.managementPropertyName > b.managementPropertyName) {
        return 1;
      }
      return 0;
    }

    updatedProperties.forEach((x) => {
      const xd = x.split('::');
      const data =
        tableData.find(
          (v) =>
            v.managementPropertyId?.toString() === xd[0]?.toString() ||
            v.managementPropertyId?.toString() === xd[2]?.toString()
        ) || {};
      data.managementPropertyName = xd[1];
    });

    tableData.sort(compare);
    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    const originalTranisitionTypeId = getSectionAttributeValueByKey(
      this.state.originaltransitionData,
      'TransitionTypeId'
    );
    if (isApproved && this.state?.selectedTransitionTypeId?.toString() === '2' && originalTranisitionTypeId?.toString() === '1') {
      tableData.map(x => {
        x.legalEntity = getSectionAttributeValueByKey(this.state.transitionData, 'newLegalEntity');
        return x;
      });
    } else {
      tableData.map(x => {
        x.legalEntity = getSectionAttributeValueByKey(this.state.transitionData, 'assignmentName');
        return x;
      });
    }
    return tableData;
  };

  getEngineerHourBillingTabledata = (engineerHourBillingData) => {
    const tableData = [];
    const grouped = this.getGroupedData(engineerHourBillingData);
    (grouped || []).forEach((x) => {
      let a = {};
      if (
        x.recordId !== undefined &&
        x.recordId !== '0' &&
        x.recordId !== 'null'
      ) {
        a.recordId = x.recordId;

        x.data.forEach((y) => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        tableData.push(a);
      }
    });

    function compare(a, b) {
      if (a.expensesBillablePropertyName < b.expensesBillablePropertyName) {
        return -1;
      }
      if (a.expensesBillablePropertyName > b.expensesBillablePropertyName) {
        return 1;
      }
      return 0;
    }

    tableData.sort(compare);

    return tableData;
  };

  getBillableExpenseTabledata = (expenseData) => {
    const tableData = [];
    let expenseName = [];
    const updatedProperties = getSectionAttributeValueByKey(
      this.state.transitionData,
      'UpdatedProperties'
    )?.split('|');
    const grouped = this.getGroupedData(expenseData);
    (grouped || []).forEach((x) => {
      let a = {};
      if (
        x.recordId !== undefined &&
        x.recordId !== '0' &&
        x.recordId !== 'null'
        // &&
        // (this.state.managementProperties || []).find(y => (y.propertyId || '').toString() ===
        //   (getSectionAttributeValueByKey(x.data, 'ExpensesBillablePropertyId') || '').toString()) !== undefined
      ) {
        a.recordId = x.recordId;
        expenseName = getSectionAttributeValueByKey(
          x.data,
          'ExpenseName'
        )?.split('|');

        x.data.forEach((y) => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        a.expenseName = expenseName.sort(stringCompare)?.join('|');
        if (a.expenseName && a.expenseName.length > 0) {
          tableData.push(a);
        }
      }
    });

    function stringCompare(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    function compare(a, b) {
      if (a.expensesBillablePropertyName < b.expensesBillablePropertyName) {
        return -1;
      }
      if (a.expensesBillablePropertyName > b.expensesBillablePropertyName) {
        return 1;
      }
      return 0;
    }

    updatedProperties.forEach((x) => {
      const xd = x.split('::');
      const data =
        tableData.find(
          (v) =>
            v.expensesBillablePropertyId?.toString() === xd[0]?.toString() ||
            v.expensesBillablePropertyId?.toString() === xd[2]?.toString()
        ) || {};
      data.expensesBillablePropertyName = xd[1];
    });

    tableData.sort(compare);

    return tableData;
  };

  getClientContactTableData = (clientData) => {
    const tableData = [];
    let contactName = [];
    // let zipCode = getSectionAttributeValueByKey(clientData, 'zipCode');
    // if (zipCode === '' || zipCode === 0 || zipCode === '0') {
    //   zipCode = '12345';
    // }

    // const contactName1 = getSectionAttributeValueByKey(clientData, 'contactName');
    // if (contactName1 !== null && contactName1 !== '') {
    //   const num = Math.floor(Math.random() * (zipCode.toString().length * 10));
    //   clientData.forEach(x => {
    //     x.recordId = num;
    //   });
    // }

    const grouped = this.getGroupedData(clientData);
    (grouped || []).forEach((x) => {
      let a = {};
      if (
        x.recordId !== undefined &&
        x.recordId !== '0' &&
        x.recordId !== 'null'
        // &&
        // (this.state.managementProperties || []).find(y => (y.propertyId || '').toString() ===
        //   (getSectionAttributeValueByKey(x.data, 'ExpensesBillablePropertyId') || '').toString()) !== undefined
      ) {
        a.recordId = x.recordId;
        contactName = getSectionAttributeValueByKey(
          x.data,
          'ContactName'
        )?.split('|');

        x.data.forEach((y) => {
          a = { ...a, ...{ [_.camelCase(y.dbColumn)]: y.attributeValue } };
        });
        a.contactName = contactName.sort(stringCompare)?.join('|');
        if (a.contactName && a.contactName.length > 0) {
          tableData.push(a);
        }
      }
    });

    function stringCompare(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    function compare(a, b) {
      if (a.expensesBillablePropertyName < b.expensesBillablePropertyName) {
        return -1;
      }
      if (a.expensesBillablePropertyName > b.expensesBillablePropertyName) {
        return 1;
      }
      return 0;
    }

    // updatedProperties.forEach((x) => {
    //   const xd = x.split('::');
    //   const data =
    //     tableData.find(
    //       (v) =>
    //         v.expensesBillablePropertyId?.toString() === xd[0]?.toString() ||
    //         v.expensesBillablePropertyId?.toString() === xd[2]?.toString()
    //     ) || {};
    //   data.expensesBillablePropertyName = xd[1];
    // });

    tableData.sort(compare);

    return tableData;
  };

  getGroupedData = (managementFeeData, key = 'recordId') => {
    if (key === 'recordId') {
      return _.chain(managementFeeData || [])
        .groupBy(key)
        .map(function (v, i) {
          return {
            recordId: i,
            data: v
          };
        })
        .value();
    } else {
      return _.chain(managementFeeData || [])
        .groupBy(key)
        .map(function (v, i) {
          return {
            dbColumn: i,
            data: v
          };
        })
        .value();
    }
  };

  ManageMentfeeChanges = (value, sourceIdField) => {
    const { managementFeeData } = this.state;
  };

  ExpenseDataChanges = (value, sourceIdField) => {
    const { expenseData } = this.state;
  };

  NewManageMentfeeChanges = (value, sourceIdField) => { };

  // Setup fields based on Transition Type selected. 
  // It will show/hide the fields and data based of the selcted transition type
  setUpFieldsBasedonTransitionType = (
    reorderData,
    originalstate,
    allowToEdit,
    propAccounting = false
  ) => {
    const selectedOriginalTransitionTypeId = getSectionAttributeValueByKey(
      reorderData,
      'TransitionTypeId'
    );
    // propAccounting = false;

    const originalTransitionId = getSectionAttributeValueByKey(
      originalstate,
      'TransitionTypeId'
    );
    const isApproved =
      getSectionAttributeValueByKey(
        reorderData,
        'ApprovalStatusId'
      ).toString() === '4';
    const selectedTransitionTypeId = (
      selectedOriginalTransitionTypeId || '1'
    ).toString();

    let ignoreFields = ['TransitionType'];
    if (this.props.actionType !== 'Edit') {
      ignoreFields = [
        ...ignoreFields,
        'ClientName',
        'MarketName',
        'AssignmentName',
        'documentName'
      ];
    }
    if ((selectedTransitionTypeId || '1').toString() === '2') {
      if (isApproved === false) {
        ignoreFields.push('propertyName');
        // ignoreFields.push('AssignmentEndDate');
      } else {
        if (allowToEdit) {
          ignoreFields.push('propertyName');
        }
        ignoreFields.push('TransitionType');
        this.setState({
          ...this.state,
          showGraceButton: false
        });
      }
      setSectionFieldAttributeByKey(
        reorderData,
        'DocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'W9DocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'W9DocumentName',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'W9DocumentName',
        'isEditable',
        false
      );

      setSectionFieldAttributeByKey(
        reorderData,
        'UpdatedProperties',
        'isVisible',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'PropertyName',
        'isVisible',
        false
      );
      // ignoreFields.push('AssignmentEndDate');
      // ignoreFields.push('AssignmentStartDate');
      reorderData = this.disableFields(
        // ['transitionType', 'propertyName'],
        ignoreFields,
        cloneDeep([...reorderData]),
        cloneDeep([...originalstate]),
        selectedTransitionTypeId,
        allowToEdit
      );
    } else if (selectedTransitionTypeId === '3') {
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationDocumentName',
        'isVisible',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationDocumentName',
        'isRequired',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationDocumentName',
        'isEditable',
        allowToEdit
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationDocumentName',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationDocumentName',
        'attributeSortOrder',
        2
      );

      setSectionFieldAttributeByKey(
        reorderData,
        'UpdatedProperties',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'PropertyName',
        'isVisible',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'PropertyName',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationType',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        reorderData,
        'TerminationType',
        'isVisible',
        true
      );
      // setSectionFieldAttributeByKey(reorderData, 'ExtendedDate', 'isRequired', true);
      // setSectionFieldAttributeByKey(reorderData, 'ExtendedDate', 'isEditable', true);
      let selectedTerminationType = getSectionAttributeValueByKey(reorderData, 'TerminationType');
      if (selectedTerminationType === null || selectedTerminationType === undefined || selectedTerminationType === '') {
        selectedTerminationType = 'By Service';
        setSectionFieldAttributeByKey(reorderData, 'TerminationType', 'attributeValue', selectedTerminationType);
      }
      if (isApproved === false) {
        if (selectedTerminationType === 'By Service') {
          let originalPropertyId;
          let originalPropertyName;
          if (originalTransitionId === '') {
            originalPropertyId = getSectionAttributeValueByKey(reorderData, 'AssignmentPropertyId'); // NewPropertyId
            originalPropertyName = getSectionAttributeValueByKey(reorderData, 'AssignmentPropertyName'); // NewPropertyName
          } else {
            originalPropertyId = getSectionAttributeValueByKey(originalstate, 'AssignmentPropertyId'); // NewPropertyId
            originalPropertyName = getSectionAttributeValueByKey(originalstate, 'AssignmentPropertyName'); // NewPropertyName
          }
          if (originalPropertyId !== '') {
            setSectionFieldAttributeByKey(
              reorderData,
              'PropertyId',
              'attributeValue',
              originalPropertyId
            );
            setSectionFieldAttributeByKey(
              reorderData,
              'PropertyName',
              'attributeValue',
              originalPropertyName
            );
          }

          let originalServiceTypeId;
          let originalServiceType;
          if (originalTransitionId === '') {
            originalServiceTypeId = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceId'); // NewServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceName'); // NewServiceType
          } else {
            originalServiceTypeId = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceId'); // NewServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceName'); // NewServiceType
          }
          const serviceTypeId = getSectionAttributeValueByKey(reorderData, 'ServiceTypeId');
          if ((serviceTypeId || '').split('|').length > (originalServiceTypeId || '').split('|').length) {
            if (originalServiceTypeId !== '') {
              setSectionFieldAttributeByKey(
                reorderData,
                'ServiceTypeId',
                'attributeValue',
                originalServiceTypeId
              );
              setSectionFieldAttributeByKey(
                reorderData,
                'ServiceType',
                'attributeValue',
                originalServiceType
              );
            }
          }
          ignoreFields.push('ServiceType');
        } else {
          let originalServiceTypeId;
          let originalServiceType;
          if (originalTransitionId === '') {
            originalServiceTypeId = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceId'); // NewServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceName'); // NewServiceType
          } else {
            originalServiceTypeId = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceId'); // NewServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceName'); // NewServiceType
          }

          if (originalServiceTypeId !== '') {
            setSectionFieldAttributeByKey(
              reorderData,
              'ServiceTypeId',
              'attributeValue',
              originalServiceTypeId
            );
            setSectionFieldAttributeByKey(
              reorderData,
              'ServiceType',
              'attributeValue',
              originalServiceType
            );
          }
          ignoreFields.push('PropertyName');
        }
        // ignoreFields.push('ServiceType');
        // ignoreFields.push('PropertyName');
        ignoreFields.push('AssignmentEndDate');
        ignoreFields.push('Description');
        ignoreFields.push('TerminationDocumentName');
        ignoreFields.push('TerminationType');
        setSectionFieldAttributeByKey(
          reorderData,
          'AssignmentEndDate',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'AssignmentEndDate',
          'isEditable',
          allowToEdit
        );
        // setSectionFieldAttributeByKey(reorderData, 'ExtendedDate', 'isRequired', true);
        setSectionFieldAttributeByKey(
          reorderData,
          'ExtendedDate',
          'isEditable',
          allowToEdit
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'DocumentName',
          'isRequired',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'DocumentName',
          'isEditable',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'DocumentName',
          'isEditable',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'W9DocumentName',
          'isRequired',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'W9DocumentName',
          'isEditable',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'W9DocumentName',
          'isEditable',
          false
        );
      } else {
        if (selectedTerminationType === 'By Service') {
          let originalPropertyId;
          let originalPropertyName;
          if (originalTransitionId === '') {
            originalPropertyId = getSectionAttributeValueByKey(reorderData, 'AssignmentPropertyId'); // NewPropertyId
            originalPropertyName = getSectionAttributeValueByKey(reorderData, 'AssignmentPropertyName'); // NewPropertyName
          } else {
            originalPropertyId = getSectionAttributeValueByKey(originalstate, 'AssignmentPropertyId'); // NewPropertyId
            originalPropertyName = getSectionAttributeValueByKey(originalstate, 'AssignmentPropertyName'); // NewPropertyName
          }

          if (originalPropertyId !== '') {
            setSectionFieldAttributeByKey(
              reorderData,
              'PropertyId',
              'attributeValue',
              originalPropertyId
            );
            setSectionFieldAttributeByKey(
              reorderData,
              'PropertyName',
              'attributeValue',
              originalPropertyName
            );
          }
          let originalServiceTypeId;
          let originalServiceType;
          if (originalTransitionId === '') {
            originalServiceTypeId = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceId'); // NewServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceName'); // NewServiceType
          } else {
            originalServiceTypeId = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceId'); // NewServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceName'); // NewServiceType
          }
          const serviceTypeId = getSectionAttributeValueByKey(reorderData, 'ServiceTypeId');
          if (originalTransitionId !== '3' && (serviceTypeId || '').split('|').length > (originalServiceTypeId || '').split('|').length) {
            if (originalServiceTypeId !== '') {
              setSectionFieldAttributeByKey(
                reorderData,
                'ServiceTypeId',
                'attributeValue',
                originalServiceTypeId
              );
              setSectionFieldAttributeByKey(
                reorderData,
                'ServiceType',
                'attributeValue',
                originalServiceType
              );
            }
          }
          ignoreFields.push('ServiceType');
        } else {
          let originalServiceTypeId;
          let originalServiceType;
          if (originalTransitionId === '') {
            originalServiceTypeId = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceId'); // ServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(reorderData, 'AssignmentServiceName'); // ServiceType
          } else {
            originalServiceTypeId = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceId'); // ServiceTypeId
            originalServiceType = getSectionAttributeValueByKey(originalstate, 'AssignmentServiceName'); // ServiceType
          }
          if (originalServiceTypeId !== '') {
            setSectionFieldAttributeByKey(
              reorderData,
              'ServiceTypeId',
              'attributeValue',
              originalServiceTypeId
            );
            setSectionFieldAttributeByKey(
              reorderData,
              'ServiceType',
              'attributeValue',
              originalServiceType
            );
          }
          ignoreFields.push('PropertyName');
        }
        // ignoreFields.push('ServiceType');
        // ignoreFields.push('PropertyName');
        ignoreFields.push('AssignmentEndDate');
        ignoreFields.push('Description');
        ignoreFields.push('TerminationDocumentName');
        ignoreFields.push('ExtendedDate');
        ignoreFields.push('TerminationType');
        setSectionFieldAttributeByKey(
          reorderData,
          'TerminationDocumentName',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'TerminationDocumentName',
          'isEditable',
          allowToEdit
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'TerminationDocumentName',
          'attributeSortOrder',
          2
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'AssignmentEndDate',
          'isRequired',
          true
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'AssignmentEndDate',
          'isEditable',
          true
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'DocumentName',
          'isRequired',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'DocumentName',
          'isEditable',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'W9DocumentName',
          'isRequired',
          false
        );
        setSectionFieldAttributeByKey(
          reorderData,
          'W9DocumentName',
          'isEditable',
          false
        );
        // setSectionFieldAttributeByKey(reorderData, 'ExtendedDate', 'isRequired', true);
        const serviceTypeNames = getSectionAttributeValueByKey(
          reorderData,
          'ServiceType'
        );
        const serviceTypeNamesArray = serviceTypeNames.split('|');
        if (serviceTypeNamesArray.includes('Property Accounting')) {
          if (isApproved && originalTransitionId.toString() === '3') {
            this.setState({
              ...this.state,
              showGraceButton: true
            });
          } else {
            this.setState({
              ...this.state,
              showGraceButton: false
            });
          }
          setSectionFieldAttributeByKey(
            reorderData,
            'ExtendedDate',
            'isVisible',
            true
          );
          setSectionFieldAttributeByKey(
            reorderData,
            'ExtendedDate',
            'isEditable',
            true
          );
          setSectionFieldAttributeByKey(
            reorderData,
            'ExtendedDate',
            'isRequired',
            true
          );
          propAccounting = true;
        } else {
          setSectionFieldAttributeByKey(
            reorderData,
            'ExtendedDate',
            'isVisible',
            false
          );
          setSectionFieldAttributeByKey(
            reorderData,
            'ExtendedDate',
            'isEditable',
            true
          );
          setSectionFieldAttributeByKey(
            reorderData,
            'ExtendedDate',
            'isRequired',
            false
          );
          this.setState({
            ...this.state,
            showGraceButton: false
          });
          propAccounting = false;
        }
      }
      reorderData = this.disableFields(
        // ['transitionType', 'serviceType'],
        ignoreFields,
        cloneDeep([...reorderData]),
        cloneDeep([...originalstate]),
        selectedTransitionTypeId,
        allowToEdit
      );
    } else if (
      selectedTransitionTypeId === '1' &&
      this.props.actionType === 'Edit' &&
      getSectionAttributeValueByKey(
        reorderData,
        'ApprovalStatusId'
      ).toString() === '4'
    ) {
      reorderData = this.disableFields(
        ignoreFields,
        cloneDeep([...reorderData]),
        cloneDeep([...originalstate]),
        selectedTransitionTypeId,
        allowToEdit
      );
      this.setState({
        ...this.state,
        showGraceButton: false
      });
    } else {
      reorderData = this.reEnableFields(
        cloneDeep([...reorderData]),
        cloneDeep([...originalstate]),
        selectedTransitionTypeId
      );
    }
    return {
      selectedOriginalTransitionTypeId,
      selectedTransitionTypeId,
      reorderData,
      propAccounting
    };
  };

  addPropertyToMasterData = (
    propertyMasterData,
    newPropertyId,
    formdetails,
    LegalEntity
  ) => {
    const findobject = {
      ...(propertyMasterData.find(
        (x) =>
          x[_.camelCase('PropertyId')].toString() === newPropertyId.toString()
      ) || { ...propertyMasterData[0] })
    };
    Object.keys(findobject).forEach((e) => {
      findobject[e] = getSectionAttributeValueByKey(formdetails, e);
    });

    const filtered = propertyMasterData.filter(
      (x) => x.propertyId !== newPropertyId
    );
    findobject.LegalEntity = LegalEntity;
    filtered.push(findobject);
    return filtered;
  };

  duplicateClientContact(duplicateCheck, contactName, address, city, state, zip, description, email, phoneNumber) {
    let duplicateContactFlag = false;
    let duplicateAddressFlag = false;
    let duplicateCityFlag = false;
    let duplicateStateFlag = false;
    let duplicateZipCodeFlag = false;
    let duplicateDescFlag = false;
    let duplicateEmailFlag = false;
    let duplicatePhoneFlag = false;
    duplicateContactFlag = duplicateCheck?.find(x => x.ContactName?.toLowerCase() === contactName.toLowerCase()) !== undefined;
    duplicateAddressFlag = duplicateCheck?.find(x => x.Address?.toLowerCase() === address.toLowerCase()) !== undefined;
    duplicateCityFlag = duplicateCheck?.find(x => x.City?.toLowerCase() === city.toLowerCase()) !== undefined;
    duplicateStateFlag = duplicateCheck?.find(x => x.State === state) !== undefined;
    duplicateZipCodeFlag = duplicateCheck?.find(x => x.ZipCode === zip) !== undefined;
    duplicateDescFlag = duplicateCheck?.find(x => x.Comments?.toLowerCase() === description.toLowerCase()) !== undefined;
    duplicateEmailFlag = duplicateCheck?.find(x => x.Email?.toLowerCase() === email.toLowerCase()) !== undefined;
    duplicatePhoneFlag = duplicateCheck?.find(x => x.PhoneNumber === phoneNumber) !== undefined;
    return { duplicateContactFlag, duplicateAddressFlag, duplicateCityFlag, duplicateStateFlag, duplicateZipCodeFlag, duplicateDescFlag, duplicateEmailFlag, duplicatePhoneFlag };
  }

  InTransitCIO(selectedTransitionTypeId, isChangeInOwnerShip) {
    if (selectedTransitionTypeId.toString() == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) {
      isChangeInOwnerShip = true;
    }
    return isChangeInOwnerShip;
  }

  setUpMasterDataBasedOnTransitionType(
    transitiontype,
    originaltransitionData,
    serviceTypeMasterData,
    originalserviceTypeMasterData,
    propertyMasterData,
    originalPropertyMasterData,
    transitionData
  ) {
    if ((transitiontype || '').toString() === '3') {
      const serviceTypeName = [
        ...getSectionAttributeValueByKey(
          cloneDeep(originaltransitionData),
          'ServiceType'
        )
          .toString()
          .split('|')
      ];
      if (serviceTypeName && serviceTypeName.length > 0) {
        serviceTypeMasterData = originalserviceTypeMasterData.filter(
          (x) =>
            serviceTypeName.find((y) => y === x.serviceType.toString()) ||
            (this.state.isApproved === false &&
              (
                getSectionAttributeValueByKey(
                  transitionData,
                  'ActiveServices'
                ) || ''
              )
                .split('|')
                ?.find((z) => z === x.serviceType.toString()))
        );

        if (serviceTypeName.includes('Property Accounting')) {
          setSectionFieldAttributeByKey(
            transitionData,
            'ExtendedDate',
            'isEditable',
            true
          );
          setSectionFieldAttributeByKey(
            transitionData,
            'ExtendedDate',
            'isVisible',
            true
          );
          setSectionFieldAttributeByKey(
            transitionData,
            'ExtendedDate',
            'isRequired',
            true
          );
          this.setState({
            propAccounting: true
          });
        } else {
          setSectionFieldAttributeByKey(
            transitionData,
            'ExtendedDate',
            'isEditable',
            false
          );
          setSectionFieldAttributeByKey(
            transitionData,
            'ExtendedDate',
            'isVisible',
            false
          );
          setSectionFieldAttributeByKey(
            transitionData,
            'ExtendedDate',
            'isRequired',
            false
          );
          this.setState({
            propAccounting: false
          });
        }
      }
      setSectionFieldAttributeByKey(
        transitionData,
        'TerminationType',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'TerminationType',
        'isVisible',
        true
      );
    } else if ((transitiontype || '').toString() === '2') {
      const PropertyName = [
        ...getSectionAttributeValueByKey(
          cloneDeep(originaltransitionData),
          'propertyName'
        )
          .toString()
          .split('|')
      ];
      if (PropertyName && PropertyName.length > 0) {
        propertyMasterData = originalPropertyMasterData; // .filter((x) => PropertyName.find((y) => y === x.propertyName.toString()));
      }
    } else {
      transitionData = cloneDeep(originaltransitionData);
      serviceTypeMasterData = cloneDeep(originalserviceTypeMasterData);
      propertyMasterData = cloneDeep(originalPropertyMasterData);
    }

    setSectionFieldAttributeByKey(
      transitionData,
      'DocumentName',
      'attributeValue',
      getSectionAttributeValueByKey(originaltransitionData, 'DocumentName', false)
    );
    setSectionFieldAttributeByKey(
      transitionData,
      'W9DocumentName',
      'attributeValue',
      getSectionAttributeValueByKey(originaltransitionData, 'W9DocumentName', false)
    );
    setSectionFieldAttributeByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName',
      'attributeValue',
      getSectionAttributeValueByKey(originaltransitionData, 'ChangeOfOwnershipDocumentName', false)
    );
    setSectionFieldAttributeByKey(
      transitionData,
      'TerminationDocumentName',
      'attributeValue',
      getSectionAttributeValueByKey(originaltransitionData, 'TerminationDocumentName', false)
    );
    return { serviceTypeMasterData, propertyMasterData, transitionData };
  }

  cleanName = (name) => {
    name = (name || '').replace(/\s+/gi, '-'); // Replace white space with dash
    return name.replace(/[^a-zA-Z0-9]/gi, ''); // Strip any special charactere
  };

  async deleteSpsData(namesToDelete) {
    if (!getSPSTokenData()) {
      const { updateData } = await apiRequest({ url: API_URL.Users.AcquireSPToken });
      if (updateData) setSPSToken(updateData); else return;
    }

    const tasks = namesToDelete.map(name =>
      this.deleteFileFromSharePoint(name, this.state.spListkey, this.state.folderName)
    );

    await Promise.allSettled(tasks);
  };

  getAssignmentSpsData = () => {
    if (getSPSTokenData()) {
      this.setState({ spsData: {} });
      const transitionTypeId = parseInt(
        getSectionAttributeValueByKey(
          this.state.transitionData,
          'transitionId',
          false
        ) || '1'
      );
      const assignmentName = getSectionAttributeValueByKey(this.state.transitionData, 'assignmentName', false);
      const folderName = getSectionAttributeValueByKey(this.state.transitionData, 'folderName', false) ?? this.cleanName(assignmentName);
      if (folderName && folderName.length) {
        getSpsAPiRequest(
          getSharePointUrl('streamrealty', 'getFolder', '', folderName)
        ).then((res) => {
          if (
            res !== null &&
            (res?.displayName?.trim().toLowerCase() === folderName?.trim().toLowerCase() || res?.name?.trim().toLowerCase() === folderName?.trim().toLowerCase())
          ) {
            const folder = res;
            const driveId = folder.parentReference.driveId;
            const key = folder.id;
            // this.setState({ folderName: folderName, spListkey: key, spDriveId: driveId, transitionIdForSP: transitionId });

            getSpsAPiRequest(
              getSharePointUrl('streamrealty', 'getChildItem', key, '', driveId)
            ).then((files) => {
              this.setNewAssignmentCategoryeData(files);
            });
          } else {
            if (folderName.length > 0) {
              const currentEnvironment = getCurrentEnvironment('streamrealty');
              spsApiPost({
                url: getSharePointUrl('streamrealty', 'createFolder'),
                postBody:
                  currentEnvironment === 'prod' || currentEnvironment === 'stage'
                    ? {
                      name: folderName,
                      folder: {}
                    }
                    : {
                      displayName: folderName,
                      columns: [
                        {
                          name: 'FileType',
                          text: {}
                        },
                        {
                          name: 'UserEmail',
                          text: {}
                        },
                        {
                          name: 'UserEmail',
                          text: {}
                        }
                      ],
                      list: {
                        template: 'documentLibrary'
                      }
                    }
              }).then((data) => {
                if (data) {
                  this.getAssignmentSpsData();
                }
              });
            }
          }
        });
      }
    } else {
      apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
        ({ updateData }) => {
          if (updateData) {
            setSPSToken(updateData);
            this.getAssignmentSpsData();
          } else {
            apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
              ({ updateData }) => {
                if (updateData) {
                  setSPSToken(updateData);
                  this.getAssignmentSpsData();
                }
              }
            );
          }
        }
      ).catch(() => {
        apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
          ({ updateData }) => {
            if (updateData) {
              setSPSToken(updateData);
              this.getAssignmentSpsData();
            } else {
              apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
                ({ updateData }) => {
                  if (updateData) {
                    setSPSToken(updateData);
                    this.getAssignmentSpsData();
                  }
                }
              );
            }
          }
        ).catch(() => {
          apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
            ({ updateData }) => {
              if (updateData) {
                setSPSToken(updateData);
                this.getAssignmentSpsData();
              }
            }
          );
        });
      });
    }
  }

  async getSpsData(transitionId = 0) {
    if (getSPSTokenData()) {
      this.setState({ spsData: {} });
      const transitionTypeId = parseInt(
        getSectionAttributeValueByKey(
          this.state.transitionData,
          'transitionId',
          false
        ) || '1'
      );
      const assignmentName = getSectionAttributeValueByKey(
        this.state.transitionData,
        'assignmentName',
        false
      );
      const folderName = getSectionAttributeValueByKey(this.state.transitionData, 'folderName', false) ?? this.cleanName(assignmentName);
      if (folderName && folderName.length) {
        const res = await getSpsAPiRequest(
          getSharePointUrl('streamrealty', 'getFolder', '', folderName)
        );
        if (
          res !== null &&
          (res?.displayName?.trim().toLowerCase() === folderName?.trim().toLowerCase() || res?.name?.trim().toLowerCase() === folderName?.trim().toLowerCase())
        ) {
          const folder = res;
          const driveId = folder.parentReference.driveId;
          const key = folder.id;
          this.setState({ folderName: folderName, spListkey: key, spDriveId: driveId, transitionIdForSP: transitionId });
          if (
            (this.state.filesToBeUploaded &&
              this.state.filesToBeUploaded.length > 0) ||
            (this.state.w9FilesToBeUploaded &&
              this.state.w9FilesToBeUploaded.length > 0)
          ) {
            await this.uploadFilesToSharePoint(driveId, key, transitionId, folderName);
          } else {
            getSpsAPiRequest(
              getSharePointUrl('streamrealty', 'getChildItem', key, '', driveId)
            ).then((files) => {
              this.setCategoryWiseData(files, transitionId);
            });
          }
        } else {
          if (folderName.length > 0) {
            const currentEnvironment = getCurrentEnvironment('streamrealty');
            const createResult = await spsApiPost({
              url: getSharePointUrl('streamrealty', 'createFolder'),
              postBody:
                currentEnvironment === 'prod' || currentEnvironment === 'stage'
                  ? {
                    name: folderName,
                    folder: {}
                  }
                  : {
                    displayName: folderName,
                    columns: [
                      {
                        name: 'FileType',
                        text: {}
                      },
                      {
                        name: 'UserEmail',
                        text: {}
                      },
                      {
                        name: 'UserEmail',
                        text: {}
                      }
                    ],
                    list: {
                      template: 'documentLibrary'
                    }
                  }
            });
            if (createResult) {
              // Recursively call getSpsData and AWAIT its completion
              await this.getSpsData(transitionId);
            }
          }
        }
      }
    } else {
      apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
        ({ updateData }) => {
          if (updateData) {
            setSPSToken(updateData);
            this.getSpsData(transitionId);
          } else {
            apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
              ({ updateData }) => {
                if (updateData) {
                  setSPSToken(updateData);
                  this.getSpsData(transitionId);
                }
              }
            );
          }
        }
      ).catch(() => {
        apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
          ({ updateData }) => {
            if (updateData) {
              setSPSToken(updateData);
              this.getSpsData(transitionId);
            } else {
              apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
                ({ updateData }) => {
                  if (updateData) {
                    setSPSToken(updateData);
                    this.getSpsData(transitionId);
                  }
                }
              );
            }
          }
        ).catch(() => {
          apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
            ({ updateData }) => {
              if (updateData) {
                setSPSToken(updateData);
                this.getSpsData(transitionId);
              }
            }
          );
        });
      });
    }
  };

  uploadSpsDataForCIO = (transitionId = 0) => {
    // create folder and upload files for New CIO Legal Entity in case of CIO
    const filesCountCIO = (this.state.filesToBeUploaded?.filter(x => x.category === 'ChangeInOwnerShip') || []).length;
    if ((this.state.selectedTransitionTypeId || '1').toString() === '2' && this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0 && filesCountCIO > 0) {
      const newLegalEntity = getSectionAttributeValueByKey(
        this.state.transitionData,
        'newLegalEntity',
        false
      );
      const newFolderName = this.cleanName(newLegalEntity);
      if (newFolderName && newFolderName.length) {
        getSpsAPiRequest(
          getSharePointUrl('streamrealty', 'getFolder', '', newFolderName)
        ).then((res) => {
          if (
            res !== null &&
            (res?.displayName?.trim().toLowerCase() === newFolderName?.trim().toLowerCase() || res?.name?.trim().toLowerCase() === newFolderName?.trim().toLowerCase())
          ) {
            const folder = res;
            const driveId = folder.parentReference.driveId;
            const key = folder.id;
            this.setState({ newFolderName: newFolderName, spCIOListkey: key });
            if (
              this.state.filesToBeUploaded &&
              this.state.filesToBeUploaded.length > 0 &&
              filesCountCIO > 0
            ) {
              this.uploadCIOFilesToSharePoint(newFolderName, key, transitionId);
            }
          } else {
            if (newFolderName.length > 0) {
              const currentEnvironment = getCurrentEnvironment('streamrealty');
              spsApiPost({
                url: getSharePointUrl('streamrealty', 'createFolder'),
                postBody:
                  currentEnvironment === 'prod' || currentEnvironment === 'stage'
                    ? {
                      name: newFolderName,
                      folder: {}
                    }
                    : {
                      displayName: newFolderName,
                      columns: [
                        {
                          name: 'FileType',
                          text: {}
                        },
                        {
                          name: 'UserEmail',
                          text: {}
                        },
                        {
                          name: 'UserEmail',
                          text: {}
                        }
                      ],
                      list: {
                        template: 'documentLibrary'
                      }
                    }
              }).then((data) => {
                if (data) {
                  this.uploadSpsDataForCIO(transitionId);
                }
              });
            }
          }
        });
      }
    } else {
      this.props.onViewChange();
    }
  }

  uploadCIOFilesToSharePoint = (newFolderName, spCIOListkey, transitionId = 0) => {
    const filesCountCIO = (this.state.filesToBeUploaded?.filter(x => x.category === 'ChangeInOwnerShip') || []).length;
    let responseCounterCIO = 0;
    let errorCounterCIO = 0;
    if (filesCountCIO > 0) {
      this.state.filesToBeUploaded.forEach((x) => {
        if (x.category === 'ChangeInOwnerShip') {
          spsApiPost({
            url: getSharePointUrl(
              'streamrealty',
              'uploadFileSession',
              spCIOListkey,
              'NewAssignment' +
              '_Document_' +
              // this.cleanName(
              //   getSectionAttributeValueByKey(
              //     this.state.transitionData,
              //     'assignmentStartDate'
              //   )
              // ) +
              // transitionId.toString() +
              // '.pdf',
              // (x?.file?.name ? '_' + x?.file?.name : '.pdf'),
              ((x?.file?.name) ? (x?.file?.name) : '.pdf'),
              newFolderName
            ),
            postBody: {
              fileSize: x.file.size,
              item: {
                '@microsoft.graph.conflictBehavior': 'replace'
              }
            }
          }).then((data) => {
            if (data) {
              uploadSpsAPiRequest(data.data.uploadUrl, x.file, true).then(
                (data) => {
                  if (data) {
                    responseCounterCIO++;

                    this.getListCIO(
                      data.name,
                      (((store.getState() || {}).auth || {}).account || {})
                        .username || '',
                      x,
                      newFolderName,
                      spCIOListkey
                    );

                    if (responseCounterCIO === filesCountCIO) {
                      ShowToast('CIO File(s) uploaded successfully.', toastType.SUCCESS, 5000, 400);
                      this.props.onViewChange();
                    }
                  } else {
                    errorCounterCIO++;
                    this.setState({ isErrorOccurredWhileFileUpload: true });
                    return false;
                  }
                }
              ).catch(errorResponse => {
                errorCounterCIO++;
                this.setState({ isErrorOccurredWhileFileUpload: true });
                return false;
              });
            } else {
              errorCounterCIO++;
              this.setState({ isErrorOccurredWhileFileUpload: true });
              return false;
            }
            // this.props.onViewChange();
          }).catch(errorResponse => {
            errorCounterCIO++;
            this.setState({ isErrorOccurredWhileFileUpload: true });
            return false;
          });
        }
      });
    } else {
      this.props.onViewChange();
    }
  };

  setNewAssignmentCategoryeData = (spsDataRes) => {
    if (!spsDataRes) return;
    const transitionData = this.state.transitionData;
    let { value } = cloneDeep(spsDataRes);
    value = _.orderBy(value, ['lastModifiedDateTime'], ['desc']);
    const spsCategories = {
      ChangeInOwnerShip: [],
      NewAssignment: [],
      Termination: [],
      OtherDocs: [],
      "W-9": []
    };
    const categoriesKeysList = Object.keys(spsCategories);
    value &&
      value.forEach((obj) => {
        const catKeyByName =
          categoriesKeysList.indexOf(obj.name.split('_')[0]) !== -1
            ? obj.name.split('_')[0]
            : '';
        const caseKey = obj.listItem.fields.FileType || '' || catKeyByName;
        switch (caseKey) {
          case 'NewAssignment':
            spsCategories[caseKey].push(obj);
            break;
          case 'W-9':
            spsCategories['NewAssignment'].push(obj);
            break;
        }
      });
    const terminationDocumentname = getSectionAttributeValueByKey(
      transitionData,
      'TerminationDocumentName'
    );
    let terminationDocumentnameArray = terminationDocumentname.split('|') || [];
    let terminationDocumentsArray = spsCategories.Termination || [];
    terminationDocumentsArray = terminationDocumentsArray.filter(x => terminationDocumentnameArray.includes(x.name)) || [];
    terminationDocumentnameArray = terminationDocumentnameArray.filter(x => terminationDocumentsArray.find(y => y.name === x)) || [];
    setSectionAttributeValueByKey(
      transitionData,
      'TerminationDocumentName',
      terminationDocumentnameArray.join('|') || ''
    );
    spsCategories.Termination = terminationDocumentsArray;

    // 1. Get the referenced file names from both fields
    const w9DocumentNames = (getSectionAttributeValueByKey(transitionData, 'W9DocumentName') || '').split('|').filter(Boolean);
    const assignmentDocumentNames = (getSectionAttributeValueByKey(transitionData, 'DocumentName') || '').split('|').filter(Boolean);

    // 2. Combine both lists for easy lookup
    let newAssignmentDocumentsNameArray = [...w9DocumentNames, ...assignmentDocumentNames];

    let newAssignmentDocumentsArray = spsCategories.NewAssignment;
    // 3. Filter SharePoint files to only those referenced in either field
    newAssignmentDocumentsArray = newAssignmentDocumentsArray.filter(x => {
      return newAssignmentDocumentsNameArray.includes(x.name);
    })

    newAssignmentDocumentsNameArray = newAssignmentDocumentsNameArray.filter(x => {
      return newAssignmentDocumentsArray.find(y => y.name === x)
    }) || [];

    w9DocumentNames = w9DocumentNames.filter(x => newAssignmentDocumentsArray.find(y => y.name === x));
    assignmentDocumentNames = assignmentDocumentNames.filter(x => newAssignmentDocumentsArray.find(y => y.name === x));

    setSectionAttributeValueByKey(
      transitionData,
      'DocumentName',
      assignmentDocumentNames.join('|') || ''
    );

    setSectionAttributeValueByKey(
      transitionData,
      'W9DocumentName',
      w9DocumentNames.join('|') || ''
    );
    spsCategories.NewAssignment = newAssignmentDocumentsArray;

    const changeInOwnerShipDocumentname = getSectionAttributeValueByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName'
    );
    let changeInOwnerShipDocumentnameArray = changeInOwnerShipDocumentname.split('|') || [];
    let changeInOwnerShipDocumentsArray = spsCategories.ChangeInOwnerShip || [];
    changeInOwnerShipDocumentsArray = changeInOwnerShipDocumentsArray.filter(x => changeInOwnerShipDocumentnameArray.includes(x.name)) || [];
    changeInOwnerShipDocumentnameArray = changeInOwnerShipDocumentnameArray.filter(x => changeInOwnerShipDocumentsArray.find(y => y.name === x)) || [];
    setSectionAttributeValueByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName',
      changeInOwnerShipDocumentnameArray.join('|') || ''
    );
    spsCategories.ChangeInOwnerShip = changeInOwnerShipDocumentsArray;

    let files = '';
    const newAssignmentFiles = newAssignmentDocumentsArray;
    if (newAssignmentFiles && newAssignmentFiles.length > 0) {
      newAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    const terminationAssignmentFiles = terminationDocumentsArray;
    if (terminationAssignmentFiles && terminationAssignmentFiles.length > 0) {
      terminationAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    const cioAssignmentFiles = changeInOwnerShipDocumentsArray;
    if (cioAssignmentFiles && cioAssignmentFiles.length > 0) {
      cioAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    this.setState({
      transitionData: transitionData,
      spsData: spsCategories,
      spsAllData: spsDataRes,
      reloadPtf: !this.state.reloadPtf,
      files: files
    });
  };

  setCategoryWiseData = (spsDataRes, transitionId = 0) => {
    if (!spsDataRes) return;
    const transitionData = this.state.transitionData;
    let { value } = cloneDeep(spsDataRes);
    value = _.orderBy(value, ['lastModifiedDateTime'], ['desc']);
    const spsCategories = {
      ChangeInOwnerShip: [],
      NewAssignment: [],
      Termination: [],
      OtherDocs: [],
      "W-9": []
    };
    const categoriesKeysList = Object.keys(spsCategories);
    value &&
      value.forEach((obj) => {
        const catKeyByName =
          categoriesKeysList.indexOf(obj.name.split('_')[0]) !== -1
            ? obj.name.split('_')[0]
            : '';
        const caseKey = obj.listItem.fields.FileType || '' || catKeyByName;
        switch (caseKey) {
          case 'NewAssignment':
            spsCategories[caseKey].push(obj);
            break;
          case 'ChangeInOwnerShip':
            spsCategories[caseKey].push(obj);
            break;
          case 'Termination':
            spsCategories[caseKey].push(obj);
            break;
          case 'W-9':
            spsCategories['NewAssignment'].push(obj);
            break;
          default:
            spsCategories.OtherDocs.push(obj);
            break;
        }
      });
    const terminationDocumentname = getSectionAttributeValueByKey(
      transitionData,
      'TerminationDocumentName'
    );
    let terminationDocumentnameArray = terminationDocumentname.split('|') || [];
    let terminationDocumentsArray = spsCategories.Termination || [];
    terminationDocumentsArray = terminationDocumentsArray.filter(x => terminationDocumentnameArray.includes(x.name)) || [];
    terminationDocumentnameArray = terminationDocumentnameArray.filter(x => terminationDocumentsArray.find(y => y.name === x)) || [];
    setSectionAttributeValueByKey(
      transitionData,
      'TerminationDocumentName',
      terminationDocumentnameArray.join('|') || ''
    );
    spsCategories.Termination = terminationDocumentsArray;
    // if (
    //   terminationDocumentname === null ||
    //   terminationDocumentname === '0' ||
    //   terminationDocumentname === ''
    // ) {
    //   if ((spsCategories.Termination || []).length > 0) {
    //     setSectionAttributeValueByKey(
    //       transitionData,
    //       'TerminationDocumentName',
    //       spsCategories.Termination[0].name || ''
    //     );
    //   }
    // }

    // 1. Get the referenced file names from both fields
    let w9DocumentNames = (getSectionAttributeValueByKey(transitionData, 'W9DocumentName') || '').split('|').filter(Boolean);
    let assignmentDocumentNames = (getSectionAttributeValueByKey(transitionData, 'DocumentName') || '').split('|').filter(Boolean);

    // 2. Combine both lists for easy lookup
    let newAssignmentDocumentsNameArray = [...w9DocumentNames, ...assignmentDocumentNames];

    let newAssignmentDocumentsArray = spsCategories.NewAssignment;
    // 3. Filter SharePoint files to only those referenced in either field
    newAssignmentDocumentsArray = newAssignmentDocumentsArray.filter(x => {
      return newAssignmentDocumentsNameArray.includes(x.name);
    })

    newAssignmentDocumentsNameArray = newAssignmentDocumentsNameArray.filter(x => {
      return newAssignmentDocumentsArray.find(y => y.name === x)
    }) || [];

    w9DocumentNames = w9DocumentNames.filter(x => newAssignmentDocumentsArray.find(y => y.name === x));
    assignmentDocumentNames = assignmentDocumentNames.filter(x => newAssignmentDocumentsArray.find(y => y.name === x));

    setSectionAttributeValueByKey(
      transitionData,
      'DocumentName',
      assignmentDocumentNames.join('|') || ''
    );

    setSectionAttributeValueByKey(
      transitionData,
      'W9DocumentName',
      w9DocumentNames.join('|') || ''
    );
    spsCategories.NewAssignment = newAssignmentDocumentsArray;

    const changeInOwnerShipDocumentname = getSectionAttributeValueByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName'
    );
    let changeInOwnerShipDocumentnameArray = changeInOwnerShipDocumentname.split('|') || [];
    let changeInOwnerShipDocumentsArray = spsCategories.ChangeInOwnerShip || [];
    changeInOwnerShipDocumentsArray = changeInOwnerShipDocumentsArray.filter(x => changeInOwnerShipDocumentnameArray.includes(x.name)) || [];
    changeInOwnerShipDocumentnameArray = changeInOwnerShipDocumentnameArray.filter(x => changeInOwnerShipDocumentsArray.find(y => y.name === x)) || [];
    setSectionAttributeValueByKey(
      transitionData,
      'ChangeOfOwnershipDocumentName',
      changeInOwnerShipDocumentnameArray.join('|') || ''
    );
    spsCategories.ChangeInOwnerShip = changeInOwnerShipDocumentsArray;

    let files = ''; // = [];
    const newAssignmentFiles = newAssignmentDocumentsArray; // value.filter(x => x.name.indexOf('NewAssignment') !== -1);
    if (newAssignmentFiles && newAssignmentFiles.length > 0) {
      // newAssignmentFiles = _.orderBy(newAssignmentFiles, ['lastModifiedDateTime'], ['desc']);
      // newAssignmentFiles[0]['@microsoft.graph.downloadUrl'] && (files += (newAssignmentFiles[0].name + '$$$' + newAssignmentFiles[0]['@microsoft.graph.downloadUrl'] + '%%%'));
      newAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    const terminationAssignmentFiles = terminationDocumentsArray; // value.filter(x => x.name.indexOf('Termination') !== -1);
    if (terminationAssignmentFiles && terminationAssignmentFiles.length > 0) {
      terminationAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    const cioAssignmentFiles = changeInOwnerShipDocumentsArray; // value.filter(x => x.name.indexOf('ChangeInOwnerShip') !== -1);
    if (cioAssignmentFiles && cioAssignmentFiles.length > 0) {
      cioAssignmentFiles.forEach((x) => {
        x['@microsoft.graph.downloadUrl'] && (files += (x.name + '$$$' + x['@microsoft.graph.downloadUrl'] + '%%%'));
      });
    }

    if (notifyEmail === 'notify' && transitionId !== 0 &&
      ((this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) ||
        (this.state.w9FilesToBeUploaded && this.state.w9FilesToBeUploaded.length > 0))) {
      this.sendEmailNotification(files, transitionId);
      return;
    }

    this.setState({
      transitionData: transitionData,
      spsData: spsCategories,
      spsAllData: spsDataRes,
      reloadPtf: !this.state.reloadPtf,
      files: files
    });
  };

  sendEmailNotification = (files, transitionId = 0) => {
    if (transitionId !== 0 &&
      ((this.state.filesToBeUploaded && this.state.filesToBeUploaded.length > 0) ||
        (this.state.w9FilesToBeUploaded && this.state.w9FilesToBeUploaded.length > 0))) {
      const transitionData = this.state.transitionData;
      if (transitionData.find((x) => x.dbColumn === 'Notify') === undefined) {
        transitionData.push({
          attributeSortOrder: 2,
          attributeValue: false,
          dataFormat: 'Boolean',
          dbColumn: 'notify',
          displayName: 'Notify',
          isEditable: false,
          isRequired: false,
          isVisible: false,
          recordId: null,
          sectionDetailId: 274,
          sectionId: 26
        });
      }
      setSectionFieldAttributeByKey(
        transitionData,
        'notify',
        'attributeValue',
        'notify'
      );

      if (transitionData.find((x) => x.dbColumn === 'files') === undefined) {
        transitionData.push({
          attributeSortOrder: 2,
          attributeValue: files,
          dataFormat: 'Text',
          dbColumn: 'files',
          displayName: 'files',
          isEditable: false,
          isRequired: false,
          isVisible: false,
          recordId: null,
          sectionDetailId: 274,
          sectionId: 26
        });
      }

      setSectionFieldAttributeByKey(
        transitionData,
        'propertyTransitionId',
        'attributeValue',
        transitionId
      );

      setSectionFieldAttributeByKey(
        transitionData,
        'files',
        'attributeValue',
        files
      );

      const existingPropertyIds = new Set(
        (this.state.ExistingPropertyDetails || [])
          .map((property) => (property?.propertyId || '').toString())
          .filter((propertyId) => propertyId !== '')
      );
      const selectedProperties = this.state.selectedTransitionTypeId?.toString() === '2'
        ? (this.state.CIOPropertydetails || [])
        : (this.state.propertyDetails || []);
      const isPropertyAddedInPTF = selectedProperties.some((property) => {
        const propertyId = (property?.propertyId || '').toString();
        return propertyId !== '' && existingPropertyIds.has(propertyId) === false;
      });

      const approvalStatusId = getSectionAttributeValueByKey(transitionData, 'ApprovalStatusId');
      const isApprovedPTF = (approvalStatusId || '').toString() === '4';
      const isDraftReNotification =
        this.props.selectedTransitionId > 0 && notifyEmail === 'notify';
      const isEditAfterApproval =
        this.props.selectedTransitionId > 0 &&
        isApprovedPTF &&
        isDraftReNotification === false;

      apiPut(API_URL.Transition.SendPTFEmailNotification, transitionData, {
        PropertyTransitionId: transitionId,
        isEditAfterApproval: isEditAfterApproval,
        isDraftReNotification: isDraftReNotification,
        isPropertyAddedInPTF: isPropertyAddedInPTF
      })
        .then(({ data: response }) => { })
        .catch(() => { });
    }
  }

  getUploadedFile = (file, category) => {
    let { filesToBeUploaded } = this.state || [];
    // filesToBeUploaded = (filesToBeUploaded || []).filter((x) => x.category !== category) || [];
    filesToBeUploaded = filesToBeUploaded || [];
    filesToBeUploaded.push({ category: category, file: file });
    this.setState({ filesToBeUploaded, reloadPtf: !this.state.reloadPtf });
  };

  CIOPropertyChanges = (value, sourceField) => {
    const updatedProperties = value?.split('|');
    const { transitionData } = this.state;
    setSectionAttributeValueByKey(transitionData, 'updatedProperties', value);
    const propIds = getSectionAttributeValueByKey(
      this.state.transitionData,
      'OriginalProperties'
    )?.split('|');
    const cioPropId = getSectionAttributeValueByKey(
      this.state.transitionData,
      'CiOProperties'
    )?.split('|');
    const cioDone = getSectionAttributeValueByKey(
      this.state.transitionData,
      'OwnershipChangedPropertyId'
    )?.split('|');

    // const CIOProperties = [...this.state.propertyDetails, ...this.state.propertyMasterData.filter(x => propIds
    //   .find(y => y.toString() === x.propertyId.toString() &&
    //     cioDone.find(cp => cp.toString() === x.propertyId.toString()) === undefined
    // ))];

    // const CIOProperties = [];
    //         this.state?.propertyDetails?.forEach(p => {
    //           CIOProperties.push(p);
    //         });

    //         this.state?.propertyMasterData
    //           ?.filter(x => cioPropId?.find(y => y?.toString() === x.propertyId?.toString()))?.forEach(pm => {
    //             CIOProperties.push(pm);
    //           });
    let managementProperties = [];
    let allocationData = [];
    if (this.state.selectedTransitionTypeId?.toString() === '2') {
      updatedProperties?.forEach((x) => {
        const prop = x.split('::');
        const property = cloneDeep(
          this.state.propertyMasterData.find(
            (x) => x.propertyId?.toString() === prop[0]
          )
        );
        if (property) {
          property.propertyName = prop[1];
          managementProperties.push(property);
          this.state.originalAllocationData.forEach((ax) => {
            if (
              ax?.propertyId?.toString() === property?.propertyId?.toString()
            ) {
              allocationData.push(cloneDeep(ax));
            }
          });
        }
      });
      cioPropId?.forEach((cx) => {
        this.state.originalAllocationData.forEach((ax) => {
          if (ax?.propertyId?.toString() === cx?.toString()) {
            allocationData.push(cloneDeep(ax));
          }
        });
      });
      if (
        updatedProperties === undefined ||
        updatedProperties === '' ||
        updatedProperties.length === 0 ||
        (updatedProperties.length === 1 && updatedProperties[0].length === 0)
      ) {
        this.state.propertyMasterData
          .filter(
            (x) =>
              getSectionAttributeValueByKey(
                this.state.transitionData,
                'PropertyId'
              )
                ?.split('|')
                .find((y) => y.toString() === x.propertyId.toString()) !==
              undefined
          )
          ?.forEach((xp) => {
            // managementProperties.push(xp);
            // if (this.state.selectedTransitionTypeId?.toString() === '2') {
            //   managementProperties.push(xp);
            // }
            this.state.originalAllocationData.forEach((ax) => {
              if (ax?.propertyId?.toString() === xp?.propertyId?.toString()) {
                allocationData.push(cloneDeep(ax));
              }
            });
          });
      }

      // if (this.state.selectedOriginalTransitionTypeId?.toString() === '2') {
      //   this.getAllocationData(getSectionAttributeValueByKey(transitionData, 'CiOProperties'));
      // }
    } else {
      allocationData = cloneDeep(this.state.allocationData);
      managementProperties = this.state.propertyDetails;
    }

    const feeDataStructure = this.state.feeDataStructure;
    setSectionAttributeValueByKey(
      feeDataStructure,
      'ManagementPropertyName',
      ''
    );

    const expenseDataStructure = this.state.expenseDataStructure;
    setSectionAttributeValueByKey(
      expenseDataStructure,
      'ExpensesBillablePropertyName',
      ''
    );
    const updatedData = {};

    if (this.state.selectedTransitionTypeId?.toString() === '2') {
      const { expenseData } = this.state;
      const { managementFeeData } = this.state;
      const OriginalManagementFeeData =
        cloneDeep(this.state.originalManagementFeeData) || [];
      const groupedData = this.getGroupedData(managementFeeData);
      const OriginalData = this.getGroupedData(OriginalManagementFeeData);
      updatedData.managementFeeData = this.SetSectionListData(
        groupedData,
        managementProperties,
        cioPropId,
        OriginalData,
        'managementPropertyId'
      );
      const groupedExpenseData = this.getGroupedData(expenseData);
      const OriginalExpenseData = this.getGroupedData(
        this.state.OriginalExpenseData
      );
      updatedData.expenseData = this.SetSectionListData(
        groupedExpenseData,
        managementProperties,
        cioPropId,
        OriginalExpenseData,
        'ExpensesBillablePropertyId'
      );
    }

    this.setState({
      ...updatedData,
      managementProperties,
      // CIOProperties,
      allocationData: allocationData,
      feeDataStructure: cloneDeep(feeDataStructure),
      expenseDataStructure: cloneDeep(expenseDataStructure),
      transitionData,
      reloadManagementFeeSetion: !this.state.reloadManagementFeeSetion,
      reloadBillableExpenseTable: !this.state.reloadBillableExpenseTable,
      reloadManagementFeetable: !this.state.reloadManagementFeetable,
      reloadExpenseSection: !this.state.reloadExpenseSection,
      reloadEngineerHourBillingSection: !this.state.reloadEngineerHourBillingSection,
      reloadEngineerHourBillingTable: !this.state.reloadEngineerHourBillingTable
    });
  };

  IMPAKSetupChange = (value, sourceIdField, isMultiple, formFieldsObj) => {
    setSectionFieldAttributeByKey(
      formFieldsObj,
      'IMPAKSetupDate',
      'isRequired',
      getSectionAttributeValueByKey(formFieldsObj, 'IMPAKSetup') === '1'
    );
    if (value === '0') {
      setSectionFieldAttributeByKey(
        formFieldsObj,
        'IMPAKSetupDate',
        'isVisible',
        false
      );
    } else {
      setSectionFieldAttributeByKey(
        formFieldsObj,
        'IMPAKSetupDate',
        'isVisible',
        true
      );
    }
    this.setState(
      {
        transitionData: cloneDeep(formFieldsObj),
        reloadPtf: !this.state.reloadPtf
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  gracePeriodUpdate = (formFields) => {
    const extendedDate = formFields.find(
      (x) => x.dbColumn === 'ExtendedDate'
    )?.attributeValue;
    const assignmentEndDate = formFields.find(
      (x) => x.dbColumn === 'AssignmentEndDate'
    )?.attributeValue;
    const aDate = new Date(moment(extendedDate)).getTime();
    const bDate = new Date(moment(assignmentEndDate)).getTime();
    const result = Operators.GreaterThan(aDate, bDate);
    let isError = false;
    if (result.result === true) {
      const payCycleStartDate = moment(getCurrentPayCycleStartDate()).format(
        'MM/DD/YYYY'
      );
      const cDate = new Date(moment(payCycleStartDate)).getTime();
      const result1 = Operators.GreaterThan(cDate, aDate);
      if (result1.result) {
        setSectionFieldAttributeByKey(
          formFields,
          'ExtendedDate',
          'isInErrorState',
          true
        );
        setSectionFieldAttributeByKey(
          formFields,
          'ExtendedDate',
          'errorMessage',
          'Grace Period(Property Accounting) should be greater than or equal to Current Pay Cycle Start Date'
        );
        isError = true;
      } else {
        setSectionFieldAttributeByKey(
          formFields,
          'ExtendedDate',
          'isInErrorState',
          false
        );
        setSectionFieldAttributeByKey(
          formFields,
          'ExtendedDate',
          'errorMessage',
          ''
        );
      }
    } else {
      setSectionFieldAttributeByKey(
        formFields,
        'ExtendedDate',
        'isInErrorState',
        true
      );
      setSectionFieldAttributeByKey(
        formFields,
        'ExtendedDate',
        'errorMessage',
        'Grace Period(Property Accounting) should be greater than Service(s) End Date'
      );
      isError = true;
    }
    if (isError) {
      return;
    }
    if (extendedDate !== null && extendedDate !== '') {
      const postBody = {
        extendedDate,
        propertyTransitionId: this.props.selectedTransitionId
      };
      apiPost({
        url: API_URL.Transition.UpdateServiceExtendedDate,
        params: {},
        postBody: postBody
      }).then(({ data: response }) => {
        if (response.success) {
          ShowToast(
            'Grace Period updated successfully.',
            toastType.SUCCESS,
            5000,
            500
          );

          this.props.onViewChange();
          this.setState({
          });
        }
      });
    } else {
      ShowToast(
        'Error Occured while updating grace period',
        toastType.SUCCESS,
        5000,
        500
      );
    }
  };

  _updatePropertyCode = () => {
    const postBody = {
      propertyId: getSectionAttributeValueByKey(
        this.state.previewSourceAccountingData,
        'propertyId'
      ),
      propertyCode: getSectionAttributeValueByKey(
        this.state.previewSourceAccountingData,
        'yardiCode'
      )?.trim(),
      sourceAccountingSystemId: getSectionAttributeValueByKey(
        this.state.previewSourceAccountingData,
        'sourceAccountingSystemId'
      ),
      sourceAccountingSystem: getSectionAttributeValueByKey(
        this.state.previewSourceAccountingData,
        'sourceAccountingSystem'
      )
    };
    apiPost({
      url: API_URL.Transition.UpdatePropertyCode,
      params: {},
      postBody: postBody
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast(
          'Property Code updated successfully.',
          toastType.SUCCESS,
          5000,
          500
        );
        const propertyDetails = this.state.propertyDetails.map((x) => {
          if (x.propertyId?.toString() === postBody.propertyId?.toString()) {
            x.yardiCode = postBody.propertyCode;
            x.sourceAccountingSystemId = postBody.sourceAccountingSystemId;
            x.sourceAccountingSystem = postBody.sourceAccountingSystem;
          }
          return x;
        });
        const CIOPropertydetails = this.state.CIOPropertydetails.map((x) => {
          if (x.propertyId?.toString() === postBody.propertyId?.toString()) {
            x.yardiCode = postBody.propertyCode;
            x.sourceAccountingSystemId = postBody.sourceAccountingSystemId;
            x.sourceAccountingSystem = postBody.sourceAccountingSystem;
          }
          return x;
        });
        this.setState({
          sourceAccountingDialog: false,
          previewSourceAccountingData: undefined,
          propertyDetails: propertyDetails,
          CIOPropertydetails,
          reloadPtf: !this.state.reloadPtf
        });
      }
    });
  };

  SetSectionListData(
    groupedData,
    managementProperties,
    cioPropId,
    OriginalData,
    key
  ) {
    const addedProp = [];
    const updatedData = [];
    (groupedData || []).forEach((y) => {
      if (
        managementProperties.find(
          (prop) =>
            prop.propertyId?.toString() ===
            getSectionAttributeValueByKey(y.data, key)
        ) !== undefined ||
        cioPropId.find(
          (prop) =>
            prop?.toString() === getSectionAttributeValueByKey(y.data, key)
        ) !== undefined
      ) {
        if (
          addedProp.find(
            (p) =>
              p ===
              getSectionAttributeValueByKey(y.data, key) +
              getSectionAttributeValueByKey(y.data, 'Startdate')
          ) === undefined
        ) {
          addedProp.push(
            getSectionAttributeValueByKey(y.data, key) +
            getSectionAttributeValueByKey(y.data, 'Startdate')
          );
          y.data.forEach((match) => {
            updatedData.push(match);
          });
        }
      }
    });
    (OriginalData || []).forEach((y) => {
      if (
        (managementProperties.find(
          (prop) =>
            prop.propertyId?.toString() ===
            getSectionAttributeValueByKey(y.data, key)
        ) !== undefined ||
          cioPropId.find(
            (prop) =>
              prop?.toString() === getSectionAttributeValueByKey(y.data, key)
          ) !== undefined) &&
        groupedData.find((gp) => gp.recordId === y.recordId) === undefined
      ) {
        if (
          addedProp.find(
            (p) =>
              p ===
              getSectionAttributeValueByKey(y.data, key) +
              getSectionAttributeValueByKey(y.data, 'Startdate')
          ) === undefined
        ) {
          addedProp.push(
            getSectionAttributeValueByKey(y.data, key) +
            getSectionAttributeValueByKey(y.data, 'Startdate')
          );
          y.data.forEach((match) => {
            updatedData.push(match);
          });
        }
      }
    });
    return updatedData;
  }

  get updatePropertyCode() {
    return this._updatePropertyCode;
  }

  set updatePropertyCode(value) {
    this._updatePropertyCode = value;
  }

  setupGracePeriodFields = (transitionData) => {
    const transitionTypeId = getSectionAttributeValueByKey(
      transitionData,
      'TransitionTypeId'
    );
    const serviceTypes = getSectionAttributeValueByKey(
      transitionData,
      'ServiceType'
    );
    const terminationType = getSectionAttributeValueByKey(
      transitionData,
      'TerminationType'
    );
    // const { allowToEdit } = this.state;
    const { allowToEdit } = this.props.readOnly === true ? false : this.state;

    if (
      transitionTypeId.toString() === '3' &&
      serviceTypes.split('|').includes('Property Accounting')
    ) {
      if (allowToEdit) {
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isEditable',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isVisible',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isRequired',
          true
        );
      } else {
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isEditable',
          false
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isVisible',
          true
        );
        setSectionFieldAttributeByKey(
          transitionData,
          'ExtendedDate',
          'isRequired',
          true
        );
      }
      // setSectionFieldAttributeByKey(transitionData, 'ExtendedDate', 'attributeValue', null);
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'ExtendedDate',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ExtendedDate',
        'isVisible',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ExtendedDate',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ExtendedDate',
        'attributeValue',
        null
      );
    }
  };

  setupEmailCCDetails = (transitionData) => {
    // const { originaltransitionData, allowToEdit } = this.state;
    const { originaltransitionData } = this.state;
    const { allowToEdit } = this.props.readOnly === true ? false : this.state;
    const originalTranisitionTypeId = getSectionAttributeValueByKey(
      originaltransitionData,
      'TransitionTypeId'
    );
    const transitionTypeId = getSectionAttributeValueByKey(
      transitionData,
      'TransitionTypeId'
    );
    if (
      originalTranisitionTypeId !== transitionTypeId ||
      allowToEdit === true
    ) {
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'Description',
        'isEditable',
        true
      );
    } else {
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isEditable',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isRequired',
        false
      );
    }
  };

  setupFieldsBasedOnAprrovedStatus = (transitionData) => {
    const { hasTransitionChanged, selectedTransitionTypeId } =
      this.state;
    const isApproveStatus =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    let enableSubmitButtons = false;
    if (
      isApproveStatus === true &&
      hasTransitionChanged === false &&
      selectedTransitionTypeId === '1' &&
      IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION, SECTIONS.ADD_EDIT) &&
      this.props.readOnly !== true
    ) {
      setSectionFieldAttributeByKey(
        transitionData,
        'LegalEntitySF',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'Description',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'EmailCC',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ServiceType',
        'isEditable',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'ServiceType',
        'enableSubmitButtons',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'PropertyName',
        'enableSubmitButtons',
        true
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'documentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'W9DocumentName',
        'isRequired',
        false
      );
      setSectionFieldAttributeByKey(
        transitionData,
        'PropertyName',
        'isEditable',
        true
      );
      // enableSubmitButtons = true;
      enableSubmitButtons = this.props.readOnly !== true;
    }

    // let enableSubmitButtons = true;
    this.setState({
      enableSubmitButtons
    });
  };

  render() {
    const isApproveStatus =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() !== '4';
    const terminationType = getSectionAttributeValueByKey(this.state.transitionData, 'TerminationType');
    const newPropertyFormConfig = [
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      { key: 'marketName', type: controlType.DropDown, multiple: false },
      {
        key: 'sourceAccountingSystem',
        type: controlType.DropDown,
        multiple: false
      },
      {
        key: 'propertySubTypeName',
        type: controlType.DropDown,
        multiple: false
      },
      { key: 'yardiCode', type: controlType.TextBox, isVisible: false },
      {
        key: 'state',
        type: controlType.DropDown,
        multiple: false
      },
      { key: 'controllerName', type: controlType.DropDown, multiple: false },
      { key: 'aRAdminName', type: controlType.DropDown, multiple: false },
      { key: 'engineerHourBillings', type: controlType.Switch }
    ];

    const editPropertyFormConfig = [
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      {
        key: 'marketName',
        type: controlType.DropDown,
        multiple: false,
        isEditable: false
      },
      {
        key: 'sourceAccountingSystem',
        type: controlType.DropDown,
        multiple: false
      },
      {
        key: 'propertySubTypeName',
        type: controlType.DropDown,
        multiple: false
      },
      { key: 'yardiCode', type: controlType.TextBox },
      { key: 'state', type: controlType.DropDown, multiple: false },
      { key: 'controllerName', type: controlType.DropDown, multiple: false },
      {
        key: 'propertyType',
        type: controlType.DropDown,
        multiple: false,
        isEditable: false
      },
      { key: 'aRAdminName', type: controlType.DropDown, multiple: false }
    ];

    const editClientContactForm = [
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      {
        key: 'marketName',
        type: controlType.DropDown,
        multiple: false,
        isEditable: false
      },
      {
        key: 'sourceAccountingSystem',
        type: controlType.DropDown,
        multiple: false,
        isRequired: true
      },
      {
        key: 'propertySubTypeName',
        type: controlType.DropDown,
        multiple: false,
        isRequired: true
      },
      { key: 'yardiCode', type: controlType.TextBox, isVisible: true },
      { key: 'state', type: controlType.DropDown, multiple: false },
      { key: 'controllerName', type: controlType.DropDown, multiple: false },
      {
        key: 'propertyType',
        type: controlType.DropDown,
        multiple: false,
        isEditable: false
      }
    ];

    const serviceTypeMasterData = this.state.serviceTypeMasterData || [];
    const propertyMasterData =
      isApproveStatus === false && this.state.enableSubmitButtons != true
        ? // || this.state?.selectedTransitionTypeId?.toString() !== '2'
        this.state.ExistingPropertyDetails || []
        : this.state.propertyMasterData || [];

    // const propertyMasterData =
    //   (isApproveStatus === true && this.state?.selectedTransitionTypeId?.toString() === '1')
    //     ? this.state.propertyMasterData || []
    //     : (
    //       isApproveStatus === false ||
    //         this.state?.selectedTransitionTypeId?.toString() !== '2'
    //         ? this.state.propertyDetails || []
    //         : this.state.propertyMasterData || []
    //     );
    const transitionTypeListingData =
      this.props.transitionTypeListingData || [];
    let employeeMaster = this.props.employeeTypeMasterData || [];

    const {
      managementProperties,
      transitionData,
      CIOProperties,
      propertyDetails,
      selectedTransitionTypeId,
      updateData,
      departmentMasterData,
      assignmentMasterData,
      marketMasterData,
      selectedTrackerItem,
      customerMasterData,
      clientMasterData,
      propertyTypeMasterData,
      validationMessages,
      showPropertyDialog,
      showClientContactDialog,
      IsNewClientContact,
      editContactDetails,
      editCIOContactDetails,
      previewData,
      isMultiBuilding,
      propertyMarketMasterData,
      cityMasterData,
      stateMasterData,
      propertyAllocation,
      allocationMarkets,
      expenseTypes,
      isClientContactDetailsEditable,
      isClientCIOContactDetailsEditable,
      ClientContactMasterData,
      pmaTitleMasterData,
      controllerEmployeesMasterData
    } = this.state;
    let clientContactsColumn = cloneDeep(clientContactDetailsColumn);
    if (selectedTransitionTypeId != TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP) {
      if (this.getClientContactTableData(this.state.ClientContactMasterData).length === 0) {
        clientContactsColumn = clientContactsColumn.filter(x => x.name !== '');
      }
    } else {
      if (this.getClientContactTableData(this.state.CIOClientContactMasterData).length === 0) {
        clientContactsColumn = clientContactsColumn.filter(x => x.name !== '');
      }
    }

    this.setupGracePeriodFields(transitionData);
    this.setupEmailCCDetails(transitionData);
    this.setupFieldsBasedOnAprrovedStatus(transitionData);
    // this.setupDates(transitionData);
    const selectedProp =
      selectedTransitionTypeId?.toString() === '2'
        ? managementProperties
        : propertyDetails;
    let calculatedSumSF = 0;
    selectedProp.forEach((element) => {
      calculatedSumSF += element.totalSF || 0;
    });
    if (calculatedSumSF > 0) {
      setSectionAttributeValueByKey(transitionData, 'TotalSF', calculatedSumSF);
    }

    const EngineerHourBillingConfig = [
      {
        key: 'IsEngineerHourBilling',
        type: controlType.Switch,
        multiple: false,
        columnWidth: 12,
        onChange: this.changeEngineerHourBillingStatus
      }
    ]

    const ExpenseConfig = [
      {
        key: 'ExpensesBillablePropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 8,
        onChange: this.expenseApplyToAll
      },
      {
        key: 'ApplyToAll',
        type: controlType.Switch,
        multiple: false,
        columnWidth: 3,
        onChange: this.expenseApplyToAll
      },
      {
        key: 'ExpenseName',
        type: controlType.CheckboxList,
        multiple: false,
        columnWidth: 12,
        overrideErrorMessage: 'Please select atleast 1 Billable Expense.',
        onChange: this.expenseApplyToAll
      }
    ];

    const DetailsFormConfig = [
      {
        key: 'TerminationType',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 8
      },
      {
        key: 'IMPAKSetup',
        type: controlType.Switch,
        onChange: this.IMPAKSetupChange
      },
      {
        key: 'UpdatedProperties',
        type: controlType.Table,
        columnWidth: 12,
        overrideErrorMessage:
          'Please select at least 1 Property for Change In Ownership.'
      },

      {
        key: 'propertyTransitionId',
        type: controlType.TextBox,
        multiple: false,
        columnWidth: 2,
        className: 'highlighted-field'
      },
      {
        key: 'assignmentName',
        type: controlType.DropDown,
        multiple: false,
        renderAsWhen: {
          key: 'TransitionTypeId',
          value: '1',
          type: controlType.TextBox
        }
      },
      {
        key: 'documentName',
        type: controlType.File,
        contentKey: 'documentContent',
        multiple: true,
        viewFile: true,
        uploadToSp: true,
        category: 'NewAssignment'
        // className: this.state.className === undefined ? 'highlighted-field' : this.state.className
      },
      {
        key: 'W9DocumentName',
        type: controlType.File,
        contentKey: 'W9DocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'NewAssignment'
      },
      {
        key: 'ChangeOfOwnershipDocumentName',
        type: controlType.File,
        contentKey: 'ChangeOfOwnershipDocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'ChangeInOwnerShip'
      },
      {
        key: 'TerminationDocumentName',
        type: controlType.File,
        contentKey: 'TerminationDocumentContent',
        multiple: false,
        viewFile: true,
        uploadToSp: true,
        category: 'Termination'
      },
      {
        key: 'EffectiveFrom',
        type: controlType.DatePicker,
        // minDate: getSectionAttributesByKeyValue(this.state.transitionData, 'assignmentStartDate') !== ''
        //   ? moment(getSectionAttributesByKeyValue(this.state.transitionData, 'assignmentStartDate'))
        //   : moment(),
        // shouldDisableDate: disableDatesForPayCycleStart1,
        rules: {
          And: [
            {
              operator: Operators.GreaterThan,
              key: 'assignmentStartDate'
            },
            {
              operator: Operators.GreaterThan,
              key: 'assignmentEndDate'
            }
            // {
            //   operator: Operators.PayCycleStart,
            //   key: 'EffectiveFrom'
            // }
          ]
        },
        helperText: 'Date must be within current Pay period or Future'
      },
      {
        key: 'serviceType',
        type: controlType.DropDown,
        multiple: true,
        columnWidth: 8
      },
      {
        key: 'emailCC',
        type: controlType.DropDown,
        multiple: true,
        columnWidth: 8
      },
      { key: 'TerminatedServices', multiple: true, columnWidth: 12 },
      { key: 'ActiveServices', multiple: true, columnWidth: 12 },
      { key: 'OwnershipChangedProperty', multiple: true, columnWidth: 12 },
      { key: 'newServiceType', type: controlType.DropDown, multiple: true },
      {
        key: 'propertyName',
        type: controlType.DropDown,
        multiple: true,
        columnWidth: 12
      },
      {
        key: 'propertyType',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 4
      },
      {
        key: 'transitionType',
        type: controlType.DropDown,
        multiple: false,
        className: 'highlighted-field'
      },
      {
        key: 'marketName',
        type: controlType.DropDown,
        multiple: isMultiBuilding
      },
      {
        key: 'marketId',
        type: controlType.DropDown,
        multiple: isMultiBuilding
      },
      { key: 'customerName', type: controlType.DropDown, multiple: false },
      { key: 'clientName', type: controlType.DropDown, multiple: false },
      { key: 'newClient', type: controlType.DropDown, multiple: false },
      {
        key: 'signedDate',
        rules: {
          And: [
            {
              operator: Operators.LessThanEqualsTo,
              key: 'assignmentStartDate'
            }
          ]
        }
      },
      {
        key: 'assignmentStartDate',
        // shouldDisableDate: disableDatesForPayCycleStart1,
        rules: {
          And: [
            {
              operator: Operators.LessThan,
              key: 'assignmentEndDate'
            }
            // {
            //   operator: Operators.PayCycleStart,
            //   key: 'assignmentStartDate'
            // }
          ]
        }
      },
      {
        key: 'assignmentEndDate',
        // shouldDisableDate: disableDatesForPayCycleEnd1,
        rules: {
          And: [
            {
              operator: Operators.GreaterThan,
              key: 'assignmentStartDate'
            },
            {
              operator: Operators.LessThanEqualsTo,
              key: 'extendedDate'
            }
            // {
            //   operator: Operators.PayCycleEnd,
            //   key: 'assignmentEndDate'
            // }
          ]
        },
        dependentField: {
          key: 'extendedDate',
          rules: {
            And: [
              {
                operator: Operators.GreaterThan,
                key: 'assignmentStartDate'
              }
            ]
          }
        }
      },
      {
        key: 'extendedDate',
        rules: {
          And: [
            {
              operator: Operators.GreaterThanEqualsTo,
              key: 'assignmentEndDate'
            }
          ]
        },
        dependentField: {
          key: 'assignmentEndDate',
          rules: {
            And: [
              {
                operator: Operators.GreaterThan,
                key: 'assignmentStartDate'
              }
            ]
          }
        }
      },
      {
        key: 'signedDate',
        rules: {
          And: [
            {
              operator: Operators.LessThanEqualsTo,
              key: 'assignmentStartDate'
            }
          ]
        }
      },
      // {
      //   key: 'startdate',
      //   rules: {
      //     and: [
      //       {
      //         operator: operators.greaterthanequalsto,
      //         key: 'assignmentstartdate'
      //       }
      //     ]
      //   }
      // },
      {
        key: 'ManagementPropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 9,
        onChange: this.applyToAll
      },
      {
        key: 'newManagementPropertyName',
        type: controlType.DropDown,
        multiple: false,
        columnWidth: 8,
        onChange: this.applyToAll
      },
      {
        key: 'ApplyToAll',
        type: controlType.Switch,
        multiple: false,
        columnWidth: 3,
        onChange: this.applyToAll
      },
      {
        key: 'exclatedFee',
        type: controlType.Switch,
        multiple: false,
        columnWidth: 11,
        onChange: this.applyToAll
      },
      {
        key: 'Description',
        type: controlType.TextBox,
        // columnWidth: 3,
        shrink: this.state.actionType === 'Edit'
      },
      {
        key: 'LegalEntitySF',
        type: controlType.TextBox,
        shrink: this.state.actionType === 'Edit'
      },
      {
        key: 'TotalSF',
        type: controlType.TextBox,
        shrink: this.state.actionType === 'Edit'
      },
      {
        key: 'CreatedBy',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'ModifiedBy',
        type: controlType.TextBox,
        shrink: true
      },
      {
        key: 'ApprovedBy',
        type: controlType.TextBox,
        shrink: true
      }
    ];
    const serviceType = (
      getSectionAttributeValueByKey(this.state.transitionData, 'ServiceType') ||
      ''
    ).split('|');
    employeeMaster = (this.state.employeesForAllocationMasterData || []).filter(
      (x) =>
        serviceType.find((y) => y === x.serviceType) ||
        (x.serviceType || '')
          .split('|')
          .find((z) => serviceType.find((yy) => yy === z))
    );
    let empDataForAllocation = cloneDeep(employeeMaster);
    const serviceTypeList = GetReadOnlyServiceType();

    empDataForAllocation = empDataForAllocation.filter(y => serviceTypeList.find(x => x.serviceTypeId.toString() === y.serviceTypeId.toString()) === undefined);
    const EditSource = [
      {
        key: 'employeeMasterData',
        data: (empDataForAllocation || []).filter((x) => x.employeeStatus === true)
      },
      { key: 'departmentMasterData', data: departmentMasterData },
      { key: 'marketMasterData', data: allocationMarkets },
      { key: 'propertyMasterData', data: propertyDetails },
      { key: 'pmaTitleMasterData', data: pmaTitleMasterData }
    ];

    const PropertySeparatorConfig = [
      {
        separatorBeforeKey: 'FeePercentage',
        label: 'Management Fee',
        order: 1,
        row: 2,
        sectionColumn: 10
      }
      // {
      //   separatorBeforeKey: 'NewFeePercentage',
      //   label: 'New Ownership Management Fee',
      //   order: 2,
      //   row: 2,
      //   sectionColumn: 10
      // }
    ];

    const transitionSeparatorConfig = [
      {
        separatorBeforeKey: 'ClientName',
        label:
          (this.state.selectedTransitionTypeId || '1').toString() === '2'
            ? 'Current Assignment Details'
            : 'Assignment Details',
        order: 1,
        row: 1,
        sectionColumn: 4,
        infoLabel:
          this.props.actionType !== 'Edit' &&
            ((this.state.selectedTransitionTypeId || '1').toString() === '2' ||
              (this.state.selectedTransitionTypeId || '1').toString() === '3')
            ? // ? 'Please select existing Client and Market having ongoing Property Transition for ' + ((this.state.selectedTransitionTypeId || '1').toString() === '2' ? 'Change In Ownership' : 'Termination')
            'Please select an existing Client, Market and Legal Entity for the Property You want to ' +
            ((this.state.selectedTransitionTypeId || '1').toString() === '2'
              ? 'Change Ownership'
              : 'Terminate')
            : ''
      },
      {
        separatorBeforeKey: 'NewClient',
        label: 'New Ownership Details',
        order: 2,
        row: 1,
        sectionColumn: 4
      }
      // {
      //   separatorBeforeKey: 'ManagementPropertyName',
      //   label: 'Management Fee',
      //   order: 1,
      //   row: 2,
      //   sectionColumn: 10
      // }
      // {
      //   separatorBeforeKey: 'NewFeePercentage',
      //   label: 'New Ownership Management Fee',
      //   order: 2,
      //   row: 2,
      //   sectionColumn: 10
      // }
    ];
    const addnewOption =
      (this.state.selectedTransitionTypeId || '1').toString() === '1' ||
      (this.state.selectedTransitionTypeId || '1').toString() === '2';

    const applyfilter =
      (this.state.selectedTransitionTypeId || '1').toString() === '1';
    let propertySubTypeData = cloneDeep(this.state.originalPropertySubTypeData);
    const value = this.state?.previewData?.length > 0 && this.state.showPropertyDialog === true
      ? getSectionAttributeValueByKey(this.state.previewData, 'PropertyTypeName')
      : this.state.transitionData.length > 0
        ? getSectionAttributeValueByKey(this.state.transitionData, 'PropertyType')
        : '';
    if (propertySubTypeData.find(x => x.propertySubTypeName === value) !== undefined) {
      propertySubTypeData = propertySubTypeData.filter(x => x.propertySubTypeName === value);
      if (this.state?.previewData?.length > 0) {
        setSectionFieldAttributeByKey(
          (this.state?.previewData || []),
          'PropertySubTypeName',
          'isEditable',
          false
        );
      }
    } else {
      if (this.state?.previewData?.length > 0) {
        setSectionFieldAttributeByKey(
          (this.state?.previewData || []),
          'PropertySubTypeName',
          'isEditable',
          true
        );
      }
    }
    const newPropertydropDownSource = [
      {
        key: 'customerName',
        option: 'customerName',
        idField: 'customerId',
        source: customerMasterData,
        AddNewOption: addnewOption,
        AddOptionType: 'Button',
        AddNewOptiontitle: 'New Customer',
        AddOptionComponent: (
          <FormGenerator
            key={'addnewCustomer'}
            gridColumn={4}
            formFields={UpdateFieldsWithConfiguration(
              this.state.propertyLandLordDetails,
              []
            )}
            dropDownSource={[]}
            validationMessages={[]}
            partialForm={false}
            Editable={this.state.readOnly !== true}
          ></FormGenerator>
        )
      },
      {
        key: 'marketName',
        option: 'marketName',
        idField: 'marketId',
        source: propertyMarketMasterData
        // onChange: this.propMarketChange
      },
      // {
      //   key: 'city',
      //   option: 'cityName',
      //   // idField: 'marketId',
      //   source: cityMasterData
      //   // onChange: this.propMarketChange
      // },
      {
        key: 'controllerName',
        option: 'employeeName',
        // idField: 'marketId',
        source: controllerEmployeesMasterData,
        applyfilter: true,
        filterMode: 'strict'
        // filterSourceOn: [
        //   { key: 'marketId', filterBy: 'marketId' }]
        // onChange: this.propMarketChange
      },
      {
        key: 'state',
        option: 'stateName',
        // idField: 'marketId',
        autoSelect: true,
        // source: stateMasterData
        source: this.state.allMarketStateData
        // onChange: this.propMarketChange
      },
      {
        key: 'sourceAccountingSystem',
        option: 'sourceAccountingSystem',
        idField: 'sourceAccountingSystemId',
        source: this.state.sourceAccountingSystemData,
        autoSelect: true,
        onChange: this.getSourceAccountingDetails
      },
      {
        key: 'propertySubTypeName',
        option: 'propertySubTypeName',
        idField: 'propertySubTypeId',
        source: propertySubTypeData,
        autoSelect: true
      },
      {
        key: 'aRAdminName',
        option: 'employeeName',
        source: (this.state.employeesAllMasterData || []).filter(
          (x) =>
            x.employeeStatus === true && x.departmentId?.toString() === DEPARTMENT.CENTRALIZED_AR?.toString()
        ),
        applyfilter: true,
        filterMode: 'strict'
      }
    ];

    const newClientContactdropDownSource = [
      {
        key: 'customerName',
        option: 'customerName',
        idField: 'customerId',
        source: customerMasterData,
        AddNewOption: addnewOption,
        AddOptionType: 'Button',
        AddNewOptiontitle: 'New Customer',
        AddOptionComponent: (
          <FormGenerator
            key={'addnewCustomer'}
            gridColumn={4}
            formFields={UpdateFieldsWithConfiguration(
              this.state.propertyLandLordDetails,
              []
            )}
            dropDownSource={[]}
            validationMessages={[]}
            partialForm={false}
            Editable={this.state.readOnly !== true}
          ></FormGenerator>
        )
      },
      {
        key: 'marketName',
        option: 'marketName',
        idField: 'marketId',
        source: propertyMarketMasterData
        // onChange: this.propMarketChange
      },
      // {
      //   key: 'city',
      //   option: 'cityName',
      //   // idField: 'marketId',
      //   source: cityMasterData
      //   // onChange: this.propMarketChange
      // },
      {
        key: 'controllerName',
        option: 'employeeName',
        // idField: 'marketId',
        source: controllerEmployeesMasterData,
        // (this.state.employeesAllMasterData || []).filter(
        //   (x) =>
        //     x.employeeStatus === true &&
        //     (x.designationId?.toString() === '16' ||
        //       x.designationId?.toString() === '44' ||
        //       x.designationId?.toString() === '107')
        // ),
        applyfilter: true,
        filterMode: 'strict'
        // filterSourceOn: [
        //   { key: 'marketId', filterBy: 'marketId' }]
        // onChange: this.propMarketChange
      },
      {
        key: 'state',
        option: 'stateName',
        // idField: 'marketId',
        autoSelect: true,
        // source: stateMasterData
        source: this.state.allMarketStateData
        // onChange: this.propMarketChange
      },
      {
        key: 'sourceAccountingSystem',
        option: 'sourceAccountingSystem',
        idField: 'sourceAccountingSystemId',
        source: this.state.sourceAccountingSystemData,
        autoSelect: true,
        onChange: this.getSourceAccountingDetails
      }
    ];

    const clientDropdownSource = [
      {
        key: 'clientName',
        option: 'clientName',
        idField: 'ClientId',
        source: clientMasterData,
        onChange: this.newClientOptionChange
      },
      {
        key: 'state',
        option: 'stateName',
        autoSelect: true,
        idField: 'stateId',
        source: getDistinctByProperty(
          this.state.allMarketStateData || [],
          'stateCode'
        )
      },
      {
        key: 'role',
        option: 'roleName',
        idField: 'contactRoleId',
        source: this.state.contactRoleMasterData || []
      }
    ];

    const terminationTypeMasterData = [
      { terminationTypeId: 'Service', terminationType: 'By Service' },
      { terminationTypeId: 'Property', terminationType: 'By Property' }
    ];

    const dropDownSource = [
      {
        key: 'terminationType',
        option: 'terminationType',
        idField: 'terminationTypeId',
        source: terminationTypeMasterData,
        onChange: this.terminationTypeChanges
      },
      {
        key: 'assignmentName',
        option: 'assignmentName',
        idField: 'assignmentId',
        source: assignmentMasterData,
        onChange: this.getSelectedTransitionDetails
      },
      {
        key: 'marketName',
        option: 'marketName',
        idField: 'marketId',
        source: marketMasterData,
        onChange: this.marketChanges
      },
      {
        key: 'propertyType',
        option: 'propertyTypeName',
        idField: 'propertyTypeId',
        source: propertyTypeMasterData,
        onChange: this.propertyTypeChange
      },
      {
        key: 'customerName',
        option: 'customerName',
        idField: 'customerId',
        source: customerMasterData,
        AddNewOption: addnewOption,
        AddOptionType: 'Button',
        AddNewOptiontitle: 'New Customer',
        AddOptionComponent: (
          <FormGenerator
            key={'addnewCustomer'}
            gridColumn={4}
            formFields={UpdateFieldsWithConfiguration(
              this.state.propertyLandLordDetails,
              []
            )}
            dropDownSource={[]}
            validationMessages={[]}
            // saveChanges={()={}}
            Editable={this.state.readOnly !== true}
            partialForm={false}
          ></FormGenerator>
        )
      },
      {
        key: 'clientName',
        option: 'clientName',
        idField: 'ClientId',
        source: clientMasterData,
        AddNewOption: this.props.isCallFromPTFDetailReport === true
          ? false
          : (
            (this.state.selectedTransitionTypeId || '1').toString() === '1'
              ? addnewOption
              : false
          ),
        AddOptionType: 'Button',
        AddNewOptiontitle: 'New Client',
        onAddClick: this.addNewClient,
        onChange: this.clientChanges,
        AddOptionComponent: (
          <FormGenerator
            key={'addNewClient'}
            parentKey={'client'}
            gridColumn={4}
            dropDownSource={clientDropdownSource}
            formFields={UpdateFieldsWithConfiguration(
              this.state.newClientDetail,
              newclientContactDetailConfig
            )}
            validationMessages={[]}
            ReloadForm={this.state.reloadNewClientDetails}
            saveChanges={this.SaveClientDetails}
            partialForm={false}
            Editable={this.state.readOnly !== true}
          ></FormGenerator>
        )
        // onChange: this.getSelectedTransitionDetails
      },
      {
        key: 'newClient',
        option: 'clientName',
        idField: 'newClientId',
        optionIdField: 'ClientId',
        source: clientMasterData,
        AddNewOption: addnewOption,
        AddOptionType: 'Button',
        AddNewOptiontitle: 'New Client',
        onAddClick: this.addNewClient,
        onChange: this.ownerShipClientChanges,
        AddOptionComponent: (
          <FormGenerator
            key={'addCIONewClient'}
            parentKey={'Cinclient'}
            gridColumn={4}
            formFields={UpdateFieldsWithConfiguration(
              this.state.newClientDetail,
              newclientContactDetailConfig // []
            )}
            dropDownSource={[]}
            validationMessages={[]}
            saveChanges={this.SaveOwnerChangeClientDetails}
            partialForm={false}
            Editable={this.state.readOnly !== true}
          ></FormGenerator>
        )
        // onChange: this.getSelectedTransitionDetails
      },
      {
        key: 'UpdatedProperties',
        option: 'propertyName',
        idField: 'UpdatedPropertiesId',
        optionIdField: 'propertyId',
        source: CIOProperties,
        onChange: this.CIOPropertyChanges
      },
      {
        key: 'propertyName',
        option: 'propertyName',
        idField: 'propertyId',
        source: propertyMasterData,
        validateBeforeChange: this.CheckLeagalEntity,
        onChange: this.getSelectedPropertyDetails,
        filterSourceOn: [
          {
            key: ['clientId', 'newClientId'],
            filterBy: 'clientId',
            multiple: true,
            type: 'Any',
            allowNullorEmpty: true,
            isFieldValueMandatory: true,
            ignore:
              (this.state.selectedTransitionTypeId || '1').toString() === '3' &&
              isApproveStatus === false
          },
          {
            key: ((this.state.selectedOriginalTransitionTypeId || '1').toString() === '3' && isApproveStatus === false) ? ['propertyId'] : ['assignmentPropertyId'],
            filterBy: 'propertyId',
            multiple: true,
            type: 'Any',
            allowNullorEmpty: true,
            isFieldValueMandatory: true,
            ignore:
              (this.state.selectedTransitionTypeId || '1').toString() !== '3'
          },
          {
            key: 'marketId',
            filterBy: 'marketId',
            allowAllIfNotSelected: false
          },
          {
            key: ['assignmentName', 'newLegalEntity'],
            multiple: true,
            filterBy: 'legalEntity',
            type: 'Any',
            allowNullorEmpty: true,
            ignore:
              (this.state.selectedTransitionTypeId || '1').toString() === '3' &&
              isApproveStatus === false
          }
        ],
        applyFilter: true,
        filterMode: this.state.isMultiBuilding ? 'AppendExisting' : 'strict',
        AddNewOption: this.props.isCallFromPTFDetailReport === true ? false : applyfilter,
        AddOptionType: 'Button',
        AddNewOptiontitle: 'New Property',
        onAddClick: this.addNewProperty,
        AddOptionComponent: (
          <FormGenerator
            key={'addnewproperty'}
            gridColumn={4}
            formFields={UpdateFieldsWithConfiguration(
              this.state.newPropertyData,
              newPropertyFormConfig
            )}
            dropDownSource={newPropertydropDownSource}
            validationMessages={this.state.validationMessages}
            saveChanges={this.SaveNewProperty}
            ReloadForm={this.state.reloadProperty}
            parentKey={'addnewproperty'}
            partialForm={false}
            formType={'Section'}
            innerFieldColumn={11}
            // separatorConfig={PropertySeparatorConfig}
            sectionColumn={4}
            // sectionRowConfig={[
            //   { row: 1, column: 12 },
            //   { row: 2, column: 12 }
            // ]}
            Editable={IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) && this.state.readOnly !== true}
          ></FormGenerator>
        )
      },
      {
        key: 'managementPropertyName',
        option: 'propertyName',
        idField: 'managementPropertyId',
        optionIdField: 'propertyId',
        source:
          selectedTransitionTypeId?.toString() === '2'
            ? this.getManagementProperties(transitionData)
            : propertyDetails,
        onChange: this.ManageMentfeeChanges
      },
      {
        key: 'ExpensesBillablePropertyName',
        option: 'propertyName',
        idField: 'ExpensesBillablePropertyId',
        optionIdField: 'propertyId',
        source:
          selectedTransitionTypeId?.toString() === '2'
            ? this.getManagementProperties(transitionData)
            : propertyDetails,
        onChange: this.ExpenseDataChanges
      },
      {
        key: 'ExpenseName',
        option: 'propertyExpenseType',
        idField: 'ExpenseId',
        optionIdField: 'propertyExpenseTypeId',
        source: expenseTypes,
        onChange: this.ExpenseDataChanges
      },
      {
        key: 'newManagementPropertyName',
        option: 'propertyName',
        idField: 'newManagementPropertyId',
        optionIdField: 'propertyId',
        source:
          selectedTransitionTypeId?.toString() === '2'
            ? managementProperties
            : propertyDetails,
        onChange: this.NewManageMentfeeChanges
      },
      {
        key: 'serviceType',
        option: 'serviceType',
        idField: 'serviceTypeId',
        optionIdField: 'ServiceTypeId',
        source: serviceTypeMasterData,
        validateBeforeChange: this.serviceTypeChanged,
        filterSourceOn: [
          {
            key: ((this.state.selectedOriginalTransitionTypeId || '1').toString() === '3' && isApproveStatus === false && (terminationType || '') === TERMINATION_TYPE.BY_SERVICE) ? ['serviceTypeId'] : ['assignmentServiceId'],
            filterBy: 'serviceTypeId',
            multiple: true,
            type: 'Any',
            allowNullorEmpty: true,
            isFieldValueMandatory: true,
            ignore: ((this.state.selectedTransitionTypeId || '1').toString() !== '3') || ((terminationType || '') === TERMINATION_TYPE.BY_PROPERTY)
          }
        ],
        applyFilter: true,
        filterMode: this.state.isMultiBuilding ? 'AppendExisting' : 'strict'
      },
      {
        key: 'emailCC',
        option: 'email',
        source: this.state.employeesAllMasterData,
        multiple: true
      },
      {
        key: 'newServiceType',
        option: 'serviceType',
        idField: 'NewServiceTypeId',
        optionIdField: 'ServiceTypeId',
        source: serviceTypeMasterData
      },
      {
        key: 'transitionType',
        option: 'transitionTypeName',
        idField: 'transitionTypeId',
        source: transitionTypeListingData,
        localChanges: false,
        onChange: this.TransitionTypeChange
      }
    ];

    const sourceAccotingConfig = [
      {
        key: 'propertyName',
        type: controlType.TextBox,
        shrink: true,
        isEditable: false
      },
      {
        key: 'sourceAccountingSystem',
        type: controlType.DropDown,
        shrink: true,
        isEditable: true,
        isRequired: true
      }
    ];

    const gracePeriodConfig = [
      {
        key: 'extendedDate',
        type: controlType.Date,
        shrink: true,
        isEditable: true,
        isRequired: true,
        isVisible: true
        // rules: {
        //   And: [
        //     {
        //       operator: Operators.GreaterThan,
        //       key: 'assignmentEndDate'
        //     }
        //   ]
        // }
      },
      {
        key: 'assignmentEndDate',
        type: controlType.Date,
        shrink: true,
        isEditable: false,
        isRequired: false,
        isVisible: false
      }
      // {
      //   key: 'sourceAccountingSystem',
      //   type: controlType.DropDown,
      //   shrink: true,
      //   isEditable: true,
      //   isRequired: true
      // }
    ];

    const dropDownSourceAccounting = [
      {
        key: 'sourceAccountingSystem',
        option: 'sourceAccountingSystem',
        idField: 'sourceAccountingSystemId',
        source: this.state.sourceAccountingSystemData,
        autoSelect: true,
        onChange: this.getPropertyCodeSystem
      }
    ];

    // const dropDownSourceAccounting = [
    //   {
    //     key: 'sourceAccountingSystem',
    //     option: 'sourceAccountingSystem',
    //     idField: 'sourceAccountingSystemId',
    //     source: this.state.sourceAccountingSystemData,
    //     autoSelect: true,
    //     onChange: this.getPropertyCodeSystem
    //   }
    // ];
    // const transtionTypeObj = this.state.transitionData;

    const isApproved =
      getSectionAttributeValueByKey(
        this.state.transitionData,
        'ApprovalStatusId'
      ).toString() === '4';
    const isClientEditable =
      ((this.state?.selectedTransitionTypeId?.toString() !== '3' || (isApproved !== true && this.state.propAccounting)) &&
        (this.state?.selectedTransitionTypeId?.toString() !== '2' || isApproved !== true) &&
        (isApproved !== true || this.state?.selectedTransitionTypeId?.toString() === '1'));

    const showButtons = (this.props.readOnly !== true &&
      this.state.readOnly !== true &&
      this.state.allowToEdit === true) ||
      this.state.enableSubmitButtons ||
      this.state.hasPmaAccess;

    return (
      <div style={{ padding: '10px' }}>
        {this.state.isTrueUpPopupOpen && (
          <ConfirmDialog
            IsOpen={this.state.isTrueUpPopupOpen}
            Message={this.state.trueUpConfirmationMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onTrueUpPopup(isValid);
              } else {
                this.onTrueUpPopup(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        )}
        {this.state.isPopupOpen && (
          <ConfirmDialog
            IsOpen={this.state.isPopupOpen}
            Message={this.state.confirmationMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopup(isValid);
              } else {
                this.onPopup(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        )}
        {this.state.isConfirmPopupOpen && (
          <ConfirmDialog
            IsOpen={this.state.isConfirmPopupOpen}
            Message={this.state.deleteFileConfirmationMessage}
            OnHandelClick={(isConfirmed) => {
              if (isConfirmed) {
                this.onDeleteFilePopupClickHandle(isConfirmed);
              } else {
                this.onDeleteFilePopupClickHandle(isConfirmed);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        )}
        {this.state.isErrorOccurredWhileFileUpload && (
          <ConfirmDialog
            Title={this.state.RetryFileUploadTitle}
            IsOpen={this.state.isErrorOccurredWhileFileUpload}
            Message={this.state.retryFileUploadMessage}
            OnHandelClick={(isConfirmed) => {
              if (isConfirmed) {
                this.onRetryFileUploadClickHandle(isConfirmed);
              } else {
                this.onRetryFileUploadClickHandle(isConfirmed);
              }
            }}
            AgreeText="Retry to upload file(s)"
            DisAgreeText="Upload File(s) Later"
            DisableBackgroundClick={true}
          />
        )}
        {this.state.sourceAccountingDialog &&
          this.state.previewSourceAccountingData && (
            <Dialog open={this.state.sourceAccountingDialog} maxWidth="lg">
              <AppBar
                style={{ position: 'relative', backgroundColor: '#064473' }}
              >
                <Toolbar>
                  <Typography
                    variant="h6"
                    className="app-header-white"
                    style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                  >
                    Link to Source Accounting System
                  </Typography>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => {
                      this.setState({
                        sourceAccountingDialog: false,
                        previewSourceAccountingData: undefined
                      });
                    }}
                    aria-label="close"
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <FormGenerator
                key={'sourceAccountingPreview'}
                gridColumn={6}
                formFields={UpdateFieldsWithConfiguration(
                  this.state.previewSourceAccountingData,
                  sourceAccotingConfig
                )}
                dropDownSource={dropDownSourceAccounting}
                // validationMessages={this.state.validationMessages}
                saveChanges={this.updatePropertyCode}
                ReloadForm={this.state.reloadProperty}
                parentKey={'sourceAccountingPreview'}
                partialForm={false}
              ></FormGenerator>
            </Dialog>
          )}

        {this.state.gracePeriodDialog && (
          <Dialog open={this.state.gracePeriodDialog} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  Extend Grace Period
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  style={{ marginLeft: '20px' }}
                  onClick={() => {
                    this.setState({
                      gracePeriodDialog: false
                      // previewSourceAccountingData: undefined
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <FormGenerator
              key={'gracePeriodPreview'}
              gridColumn={12}
              formFields={UpdateFieldsWithConfiguration(
                this.state?.transitionData?.filter(
                  (x) =>
                    x.dbColumn === 'ExtendedDate' ||
                    x.dbColumn === 'AssignmentEndDate'
                ),
                gracePeriodConfig
              )}
              isFromGraceForm={true}
              // dropDownSource={dropDownSourceAccounting}
              // validationMessages={this.state.validationMessages}
              saveChanges={this.gracePeriodUpdate}
              ReloadForm={this.state.reloadProperty}
              parentKey={'gracePeriodPreview'}
              partialForm={false}
            ></FormGenerator>
          </Dialog>
        )}

        {showPropertyDialog && previewData && (
          <Dialog open={showPropertyDialog} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  Property Details
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      showPropertyDialog: false,
                      previewData: undefined
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <FormGenerator
              key={'propertyPreview'}
              gridColumn={4}
              formFields={UpdateFieldsWithConfiguration(
                this.state.previewData,
                editPropertyFormConfig
              )}
              dropDownSource={newPropertydropDownSource}
              // validationMessages={this.state.validationMessages}
              saveChanges={
                this.state.isEditableProperty &&
                  (getSectionAttributeValueByKey(
                    this.state.previewData,
                    'IsFreezed'
                  ) === undefined ||
                    getSectionAttributeValueByKey(
                      this.state.previewData,
                      'IsFreezed'
                    ) === null ||
                    getSectionAttributeValueByKey(
                      this.state.previewData,
                      'IsFreezed'
                    ) === '' ||
                    getSectionAttributeValueByKey(
                      this.state.previewData,
                      'IsFreezed'
                    ) === '0' ||
                    getSectionAttributeValueByKey(
                      this.state.previewData,
                      'IsFreezed'
                    ) === false)
                  ? this.checkDuplicateAndUpdateProperty // this.updateProperty
                  : undefined
              }
              ReloadForm={this.state.reloadProperty}
              parentKey={'previewnewproperty'}
              partialForm={false}
              Editable={
                this.state.isEditableProperty &&
                (getSectionAttributeValueByKey(
                  this.state.previewData,
                  'IsFreezed'
                ) === undefined ||
                  getSectionAttributeValueByKey(
                    this.state.previewData,
                    'IsFreezed'
                  ) === null ||
                  getSectionAttributeValueByKey(
                    this.state.previewData,
                    'IsFreezed'
                  ) === '' ||
                  getSectionAttributeValueByKey(
                    this.state.previewData,
                    'IsFreezed'
                  ) === '0' ||
                  getSectionAttributeValueByKey(
                    this.state.previewData,
                    'IsFreezed'
                  ) === false)
              }
            ></FormGenerator>
          </Dialog>
        )}

        {showClientContactDialog && (
          <Dialog open={showClientContactDialog} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  Contact Details
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    const ccFields = this.state.ccDetailsFormFields;
                    ccFields.forEach(x => {
                      x.isInErrorState = false;
                      x.errorMessage = '';
                      x.attributeValue = '';
                    });
                    this.setState({
                      showClientContactDialog: false,
                      isRowChecked: false,
                      headerData: { ...this.state.headerData, selectAll: false },
                      ccDetailsFormFields: ccFields,
                      selectedClientContactDataRow: []
                      // previewData: undefined
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <FormGenerator
              key={'clientContactForm'}
              gridColumn={4}
              formFields={UpdateFieldsWithConfiguration(
                this.state.ccDetailsFormFields || [],
                newclientContactDetailConfig
              )}
              dropDownSource={clientDropdownSource}
              submitText={'Add New Contact'}
              saveChanges={(ch) => {
                this.validateContactDetails(ch);
              }}
              ReloadForm={this.state.reloadClientContactSection}
              sectionRowConfig={[]}></FormGenerator>
            <div className="col-sm-12 end-sm margin20lr">
              <PageHeader
                // classNames="margin30lr"
                key={'Existing_Contact_Details'}
                title="Existing Contact Details"
              >
                {' '}
                Existing Client Contacts
              </PageHeader>
              <hr className="hr-custom" />
            </div>
            <div className="row table-list-container" style={{ marginBottom: '20px' }}>
              {/* <Button variant="contained" onClick={this.openClientContactDialog}>Add/Select Client Contact</Button> */}
              <GridTable
                key={'clientContactDetailsTable'}
                columns={UpdateColumnWithConfiguration(
                  clientContactsColumn.filter(x => x.name !== 'Action'),
                  this.state.clientContactDetailConfig || []
                )}
                reload={this.state.reloadClientContactTable}
                config={{ showPager: false }}
                headerData={this.state.headerData}
                data={selectedTransitionTypeId == 0 ? [] : selectedTransitionTypeId == '2' ? this.getClientContactTableData(this.state.CIOClientContactMasterData) : (this.getClientContactTableData(this.state.ClientContactMasterData))}
                renderActionColumn={this.renderActionForCheckBoxClientContact}
                handleTableHeaderEditChange={this.handleTableHeaderEditChange}
              // handleTableHeaderEditChange={this.getClientContactTableData(this.state.ClientContactMasterData).length > 0 ? this.handleTableHeaderEditChange : () => { return <></>; }}
              ></GridTable>
              {(IsNewClientContact === false) && <Button
                onClick={this.handleAddToPTF}
                title="Add Selected Existing Contacts"
                size="small"
                variant="contained"
                disabled={this.getClientContactTableData(ClientContactMasterData).length === 0}
              >
                Add Selected Existing Contacts
              </Button>}
              {IsNewClientContact && <Button
                onClick={this.handleAddToPTF}
                title="Add Selected Existing Contacts"
                size="small"
                variant="contained"
                disabled={this.getClientContactTableData(this.state.CIOClientContactMasterData).length === 0}
              >
                Add Selected Existing Contacts
              </Button>}
            </div>
          </Dialog>
        )}

        {editContactDetails && (
          <Dialog open={editContactDetails} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  {isClientContactDetailsEditable ? 'Edit Contact Details' : 'Contact Details'}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      editContactDetails: false
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <FormGenerator
              key={'clientContactForm'}
              gridColumn={4}
              formFields={UpdateFieldsWithConfiguration(
                this.state.selectedClientContact,
                newclientContactDetailConfig
              )}
              dropDownSource={clientDropdownSource}
              submitText={'Submit Contact'}
              Editable={isClientContactDetailsEditable}
              saveChanges={(ch) => {
                this.validateContactDetails(ch, true);
              }}
            ></FormGenerator>

          </Dialog>
        )}

        {editCIOContactDetails && (
          <Dialog open={editCIOContactDetails} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  {isClientCIOContactDetailsEditable ? 'Edit Contact Details' : 'Contact Details'}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      editCIOContactDetails: false
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <FormGenerator
              key={'clientContactForm'}
              gridColumn={4}
              formFields={UpdateFieldsWithConfiguration(
                this.state.selectedClientContact,
                newclientContactDetailConfig
              )}
              dropDownSource={clientDropdownSource}
              submitText={'Submit Contact'}
              Editable={isClientCIOContactDetailsEditable}
              saveChanges={(ch) => {
                this.validateContactDetails(ch, true);
              }}
            ></FormGenerator>

          </Dialog>
        )}

        {this.state.openUpdateTrackerItemPopup && selectedTrackerItem && (
          <Dialog open={this.state.openUpdateTrackerItemPopup} maxWidth="xs">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  Update Tracker Step
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      openUpdateTrackerItemPopup: false,
                      selectedTrackerItem: undefined
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>

            <Paper className="tracker-item-update-form">
              <div className="row margin-top">
                <div className="col-xs-12">
                  <b> Step: {selectedTrackerItem.name} </b>
                </div>
                <div className="col-xs-12">
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      aria-label="position"
                      name="position"
                      value={
                        selectedTrackerItem.isCompleted === true
                          ? 'completed'
                          : selectedTrackerItem.isApplicable === true
                            ? 'isApplicable'
                            : 'notApplicable'
                      }
                      onChange={(event) => {
                        if (event.target.value === 'isApplicable') {
                          this.onTrackerItemChange(true, 'isApplicable');
                          this.onTrackerItemChange(false, 'isCompleted');
                        } else if (event.target.value === 'notApplicable') {
                          this.onTrackerItemChange(false, 'isCompleted');
                          this.onTrackerItemChange(false, 'isApplicable');
                        } else if (event.target.value === 'completed') {
                          this.onTrackerItemChange(true, 'isCompleted');
                          this.onTrackerItemChange(true, 'isApplicable');
                        }
                      }}
                    >
                      <FormControlLabel
                        value="notApplicable"
                        control={<Radio color="primary" />}
                        label="Not Applicable"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="isApplicable"
                        control={<Radio color="primary" />}
                        label="Applicable"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="completed"
                        control={<Radio color="primary" />}
                        label="Completed"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="col-xs-6">
                  <TextField
                    title="comment"
                    label="Comments"
                    value={selectedTrackerItem.comments}
                    onChange={(event) => {
                      this.onTrackerItemChange(event.target.value, 'Comments');
                    }}
                  ></TextField>
                </div>
                <div className="col-xs-6">
                  <TextField
                    title="value"
                    label="Value"
                    value={selectedTrackerItem.value}
                    onChange={(event) => {
                      this.onTrackerItemChange(event.target.value, 'Value');
                    }}
                  ></TextField>
                </div>
                <div className="col-xs-auto pull-right end-xs margin-top">
                  <Button
                    onClick={this.saveTrackerChanges}
                    title="Save Changes"
                    size="small"
                  >
                    Save
                  </Button>
                  <Button
                    onClick={this.cancelTrackerChanges}
                    title="Cancel Changes"
                    size="small"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Paper>
          </Dialog>
        )}

        {this.state.showConfirmDialog && this.state.ConfirmDialogMessage && (
          <ConfirmDialog
            IsOpen={this.state.showConfirmDialog}
            Message={this.state.ConfirmDialogMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}

        {/* {this.state.showSRPConfirmDialog && this.state.ConfirmDialogMessage && (
          <ConfirmDialog
            IsOpen={this.state.showSRPConfirmDialog}
            Message={this.state.ConfirmDialogMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onConfirmHandle(isValid);
              } else {
                this.onConfirmHandle(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )} */}

        {this.state.openaddform && (
          <Dialog open={this.state.openaddform} maxWidth="lg">
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  {this.state.addformtitle}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      openaddform: false,
                      addNewformComponent: undefined
                    });
                  }}
                  aria-label="close"
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div>
              <Paper>{this.state.addNewformComponent}</Paper>
            </div>
          </Dialog>
        )}

        <PageHeader
          key={'Property_Transition_Form'}
          title={
            ' Property Transition Form ' +
            (this.state.actionType ? '(' + this.state.actionType + ')' : '')
          }
        // actionsConfig={[
        //   {
        //     icon: <ArrowBackIcon size="small" className="back-button" />,
        //     onClick: this.props.onViewChange,
        //     title: 'Back to Transition List'
        //   }
        // ]}
        >
          Property Transition Form
        </PageHeader>
        <div className="row form-container">
          <div className="col-xs-12 no-padding">
            {this.props.isCallFromPTFDetailReport !== true &&
              (
                <div className="row" style={{ marginTop: '5px' }}>
                  <div className="col-sm-11 col-sm-offset-1 field-control text-align-r">
                    {/* {transtionTypeObj !== undefined && */}

                    {showButtons
                      ? (<>
                        {this.state.enableSubmitButtons !== true && (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              className="ptf-buttons"
                              size="small"
                              disabled={this.state.isButtonsDisabled}
                              onClick={() => {
                                this.setState({ isButtonsDisabled: true }, () => {
                                  this.SubmitTransition(true);
                                });
                                // this.SubmitTransition(true);
                              }}
                            >
                              Save as Draft
                            </Button>

                            <Button
                              isVisible="false"
                              variant="contained"
                              color="primary"
                              className="ptf-buttons"
                              size="small"
                              disabled={this.state.isButtonsDisabled}
                              onClick={() => {
                                this.setState({ isButtonsDisabled: true }, () => {
                                  this.SubmitTransition(true, true);
                                });
                                // this.SubmitTransition(true, true);
                              }}
                            >
                              Notify and Save as Draft
                            </Button>
                          </>
                        )}
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="ptf-buttons"
                          disabled={this.state.isButtonsDisabled}
                          onClick={() => {
                            this.setState({ isButtonsDisabled: true }, () => {
                              this.SubmitTransition(false, true);
                            });
                            // this.SubmitTransition(false, true);
                          }}
                        >
                          Submit
                        </Button>
                      </>
                      )
                      : null}
                    {this.state.showGraceButton && (
                      <Button // this.state.readOnly !== true &&
                        variant="contained"
                        size="small"
                        color="primary"
                        className="ptf-buttons"
                        onClick={() => {
                          this.handleGraceClick();
                        }}
                      >
                        Extend Grace Period
                      </Button>
                    )}
                    {
                      <Button // this.state.readOnly !== true &&
                        variant="contained"
                        size="small"
                        color="primary"
                        className="ptf-buttons"
                        onClick={this.props.onViewChange}
                      >
                        Cancel
                      </Button>
                    }

                    {/* {this.state.actionType === 'Edit' && <Button
              variant="contained"
              size="small"
              color="primary"
              className="ptf-buttons"
              onClick={this.LoadTransitionData}
            >
              Refresh
            </Button>} */}
                  </div>
                </div>
              )
            }
            {transitionData && (
              <FormGenerator
                spsData={this.state.spsData}
                selectedFiles={this.state.filesToBeUploaded}
                selectedW9Files={this.state.w9FilesToBeUploaded}
                selectedCategory={'other'}
                selectedPtfKey={1}
                Editable={this.props.readOnly === true ? false : (this.state.readOnly !== true)}
                key="PropertyTransitionform"
                gridColumn={3}
                formFields={UpdateFieldsWithConfiguration(
                  cloneDeep(transitionData),
                  DetailsFormConfig
                )}
                enableSubmitButtons={this.state.enableSubmitButtons}
                dropDownSource={dropDownSource}
                hasTransitionChanged={this.state.hasTransitionChanged}
                validationMessages={validationMessages}
                saveChanges={this.getChanges}
                partialForm={true}
                viewPDF={this.viewFilesData}
                parentKey={'ptf'}
                getUploadedFile={this.getUploadedFile}
                formType={'Section'}
                innerFieldColumn={11}
                ReloadForm={this.state.reloadPtf}
                separatorConfig={transitionSeparatorConfig}
                sectionColumn={4}
                otherChildsection={[
                  // {
                  //   label:
                  //     ((
                  //       this.state.selectedTransitionTypeId || '1'
                  //     ).toString() === '2'
                  //       ? 'New '
                  //       : '') + 'Client Contact Details',
                  //   element: this.state.clientContactDetails && (
                  //   // <FormGenerator
                  //   //   key="clientContactDetails"
                  //   //   gridColumn={4}
                  //   //   dropDownSource={clientDropdownSource}
                  //   //   formFields={UpdateFieldsWithConfiguration(
                  //   //     this.state.clientContactDetails,
                  //   //     newclientContactDetailConfig
                  //   //   )}
                  //   //   ReloadForm={this.state.reloadClientContactDetails}
                  //   //   saveChanges={this.getClientContactChanges}
                  //   //   partialForm={true}
                  //   //   Editable={
                  //   //     ((this.props.readOnly !== true &&
                  //   //       this.state.readOnly !== true &&
                  //   //       this.state.allowToEdit &&
                  //   //       this.state?.selectedTransitionTypeId?.toString() !==
                  //   //       '3') || this.state.enableSubmitButtons)
                  //   //   }
                  //   // ></FormGenerator>
                  //   <></>),
                  //   row: 1
                  // },
                  this.getManagementFeeSection(
                    dropDownSource,
                    DetailsFormConfig
                  ),
                  this.getPropertyExpenseSection(dropDownSource, ExpenseConfig),
                  this.getEngineerHourBillingSection(dropDownSource, EngineerHourBillingConfig)
                ]}
                sectionRowConfig={[
                  { row: 1, column: 8 },
                  { row: 2, column: 4 },
                  { row: 3, column: 8 }
                ]}
              ></FormGenerator>
            )}
            <PageHeader
              classNames="margin30lr"
              key={'Client_Contact_Details'}
              title="Contact Details"
            >
              {' '}
              Contact Details
            </PageHeader>
            <div className="col-sm-12 end-sm margin20lr">
              <hr className="hr-custom" />
            </div>
            <div className="row table-list-container">
              {
                // (selectedTransitionTypeId == TRANSITION_TYPE_ID.NEW_ASSIGNMENT || selectedTransitionTypeId == TRANSITION_TYPE_ID.TERMINATION) &&
                //   (this.state.allowToEdit || isApproved) &&
                ((selectedTransitionTypeId == TRANSITION_TYPE_ID.NEW_ASSIGNMENT && (this.state.allowToEdit || isApproved)) ||
                  (selectedTransitionTypeId == TRANSITION_TYPE_ID.TERMINATION && this.state.allowToEdit))
                && (this.props.isCallFromPTFDetailReport !== true) &&
                (<Button variant="contained" onClick={() => this.openClientContactDialog(false)}>Add/Select Client Contact</Button>)
              }
              <GridTable
                key={'clientContactDetailsTable'}
                columns={UpdateColumnWithConfiguration(
                  // this.state.isApproved === false
                  clientContactDetailsColumn.filter(x => x.name !== ''),
                  // : clientContactDetailsColumn.filter((x) => x.name !== 'Action'),
                  this.state.clientContactDetailConfig || []
                )}
                reload={this.state.reloadPtf}
                config={{ showPager: true, showBottomPagerOnly: true }}
                // data={this.state.propertyDetails}
                // config={propertyallocationConfig}
                data={selectedTransitionTypeId == 0 ? [] : this.getClientContactTableData(this.state.clientContactMainData)}
                renderActionColumn={this.props.isCallFromPTFDetailReport === true ? null : this.renderActionForEditClientContact}
              ></GridTable>
            </div>

            {selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP && (<>
              <PageHeader
                classNames="margin30lr"
                key={'CIO_Client_Contact_Details'}
                title="New Contact Details"
              >
                {' '}
                New Contact Details
              </PageHeader>
              <div className="col-sm-12 end-sm margin20lr">
                <hr className="hr-custom" />
              </div>
              <div className="row table-list-container">
                {selectedTransitionTypeId == TRANSITION_TYPE_ID.CHANGE_IN_OWNERSHIP && this.state.allowToEdit
                  && (this.props.isCallFromPTFDetailReport !== true) &&
                  (<Button variant="contained" onClick={() => this.openClientContactDialog(true)}>Add/Select Contact</Button>)
                }
                <GridTable
                  key={'clientContactDetailsTable'}
                  columns={UpdateColumnWithConfiguration(
                    // this.state.isApproved === false
                    clientContactDetailsColumn.filter(x => x.name !== ''),
                    // : clientContactDetailsColumn.filter((x) => x.name !== 'Action'),
                    this.state.clientContactDetailConfig || []
                  )}
                  reload={this.state.reloadPtf}
                  config={{ showPager: true, showBottomPagerOnly: true }}
                  // data={this.state.propertyDetails}
                  // config={propertyallocationConfig}
                  data={selectedTransitionTypeId == 0 ? [] : this.getClientContactTableData(this.state.CIOClientContacts)}
                  renderActionColumn={this.props.isCallFromPTFDetailReport === true ? null : this.renderActionForEditCIOClientContact}
                ></GridTable>
              </div>
            </>)}
            <PageHeader
              classNames="margin30lr"
              key={'ManagementFee'}
              title="Management Fee(s)"
            ></PageHeader>
            <div className="col-sm-12 end-sm margin20lr">
              <hr className="hr-custom" />
            </div>

            <div className="row table-list-container">
              {this.getManagementFeeUi(dropDownSource, DetailsFormConfig)}
            </div>

            <PageHeader
              classNames="margin30lr"
              key={'expenseFee'}
              title="Billable Expense(s)"
            ></PageHeader>
            <div className="col-sm-12 end-sm margin20lr">
              <hr className="hr-custom" />
            </div>

            <div className="row table-list-container">
              {this.getBillableExpenseUi(dropDownSource, DetailsFormConfig)}
            </div>

            <PageHeader
              classNames="margin30lr"
              key={'engineerHourBilling'}
              title="Engineer Hour Billing"
            ></PageHeader>
            <div className="col-sm-12 end-sm margin20lr">
              <hr className="hr-custom" />
            </div>

            <div className="row table-list-container">
              {this.getEngineerHourBillingUi(dropDownSource, DetailsFormConfig)}
            </div>

            <PageHeader
              classNames="margin30lr"
              key={'Property_Details'}
              title=" Property Details"
            >
              {' '}
              Property Details
            </PageHeader>
            <div className="col-sm-12 end-sm margin20lr">
              <hr className="hr-custom" />
            </div>
            <div className="row table-list-container">
              <GridTable
                key={'propertyDetailsTable'}
                columns={UpdateColumnWithConfiguration(
                  propertyColumnsPTF,
                  this.state.configuration
                )}
                reload={this.state.reloadPtf}
                // data={this.state.propertyDetails}
                config={propertyallocationConfig}
                // config={{ showPager: false }}
                data={this.state.propertyDetails}
                renderActionColumn={this.props.isCallFromPTFDetailReport === true ? null : this.renderActionColumnOriginalProperty}
              ></GridTable>
            </div>
            {this.state.selectedOriginalTransitionTypeId?.toString() ===
              '2' && (
                <>
                  <PageHeader
                    classNames="margin30lr"
                    key={'CIOProperty_Details'}
                    title="CIO Property Details"
                  >
                    {' '}
                    CIO Property Details
                  </PageHeader>
                  <div className="col-sm-12 end-sm margin20lr">
                    <hr className="hr-custom" />
                  </div>
                  <div className="row table-list-container">
                    <GridTable
                      key={'CIOpropertyDetailsTable'}
                      columns={UpdateColumnWithConfiguration(
                        propertyColumnsPTF,
                        this.state.configuration
                      )}
                      reload={this.state.reloadPtf}
                      // data={this.state.propertyDetails}
                      config={propertyallocationConfig}
                      // config={{ showPager: false }}
                      data={this.state.CIOPropertydetails}
                      renderActionColumn={this.props.isCallFromPTFDetailReport === true ? null : this.renderActionColumn}
                    ></GridTable>
                  </div>
                </>
              )}
            <PageHeader
              classNames="margin30lr"
              key={'Employee_Allocation'}
              title="Employee Allocation"
            >
              {' '}
              Employee Allocation
            </PageHeader>
            <div className="col-sm-12 end-sm margin20lr">
              <hr className="hr-custom" />
            </div>

            <div className="row table-list-container">
              <GridTable
                key={'allocationTable' + this.state.reloadPtf.toString()}
                columns={UpdateColumnWithConfiguration(
                  this.state.isApproved === false
                    ? propertyAllocation
                    : propertyAllocation.filter((x) => x.name !== 'Action'),
                  this.state.allocationConfiguration || []
                )}
                data={this.state.allocationData || []}
                config={propertyallocationConfig}
                renderActionColumn={
                  this.props.isCallFromPTFDetailReport === true
                    ? null
                    : (
                      IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
                        this.state.readOnly !== true &&
                        addnewOption &&
                        this.state.selectedTransitionTypeId?.toString() !== '2'
                        ? this.renderAllocationActionColumn
                        : () => {
                          return <></>;
                        }
                    )
                }
                selectedEditRowId={this.state.selectedEditRowId}
                isInAddMode={this.state.isInAddMode}
                isEditableMode={this.state.isEditableMode}
                reload={this.state.reloadAllocationTable}
                EditSource={EditSource}
                handleTableEditChange={this.handleTableEditChange}
                updateData={updateData}
                AddNewRecord={{
                  action: this.AddNewRecord,
                  title: 'Add Employee',
                  visible: this.props.isCallFromPTFDetailReport === true
                    ? false
                    : (IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
                      this.state.readOnly !== true &&
                      addnewOption &&
                      isApproveStatus &&
                      this.state.selectedTransitionTypeId?.toString() !== '2' // || this.state.propAccounting
                    )
                }}
                gracePeriodBadge={{
                  key: 'recordSource',
                  equalsTo: RECORD_SOURCE.GRACE_PERIOD,
                  referenceKey: 'recordSource',
                  class: 'message rotate-badge',
                  title: 'GP',
                  tooltip: 'This is the record created for Extended Grace Period Allocation of Property Accounting ',
                  separateBySpace: true
                }}
                renderDynamicForm={this.renderDynamicForm}
              // rowBadge={{ key: "allocationId", equalsTo: 2, class: "message rotate-badge", title: "New" }}
              ></GridTable>
            </div>

            {this.props.isCallFromPTFDetailReport !== true &&
              (<div className="row" style={{ marginTop: '5px' }}>
                <div className="col-sm-11 col-sm-offset-1 field-control text-align-r">
                  {/* {transtionTypeObj !== undefined && */}

                  {(this.props.readOnly !== true &&
                    this.state.readOnly !== true &&
                    this.state.allowToEdit === true) ||
                    this.state.enableSubmitButtons
                    ? (<>
                      {this.state.enableSubmitButtons !== true && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            className="ptf-buttons"
                            size="small"
                            disabled={this.state.isButtonsDisabled}
                            onClick={() => {
                              this.setState({ isButtonsDisabled: true }, () => {
                                this.SubmitTransition(true);
                              });
                              // this.SubmitTransition(true);
                            }}
                          >
                            Save as Draft
                          </Button>

                          <Button
                            isVisible="false"
                            variant="contained"
                            color="primary"
                            className="ptf-buttons"
                            size="small"
                            disabled={this.state.isButtonsDisabled}
                            onClick={() => {
                              this.setState({ isButtonsDisabled: true }, () => {
                                this.SubmitTransition(true, true);
                              });
                              // this.SubmitTransition(true, true);
                            }}
                          >
                            Notify and Save as Draft
                          </Button>
                        </>
                      )}
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="ptf-buttons"
                        disabled={this.state.isButtonsDisabled}
                        onClick={() => {
                          this.setState({ isButtonsDisabled: true }, () => {
                            this.SubmitTransition(false, true);
                          });
                          // this.SubmitTransition(false, true);
                        }}
                      >
                        Submit
                      </Button>
                    </>
                    )
                    : null}
                  {this.state.showGraceButton && (
                    <Button // this.state.readOnly !== true &&
                      variant="contained"
                      size="small"
                      color="primary"
                      className="ptf-buttons"
                      onClick={() => {
                        this.handleGraceClick();
                      }}
                    >
                      Extend Grace Period
                    </Button>
                  )}
                  {
                    <Button // this.state.readOnly !== true &&
                      variant="contained"
                      size="small"
                      color="primary"
                      className="ptf-buttons"
                      onClick={this.props.onViewChange}
                    >
                      Cancel
                    </Button>
                  }

                  {/* {this.state.actionType === 'Edit' && <Button
              variant="contained"
              size="small"
              color="primary"with2DecimalsPoints
              className="ptf-buttons"
              onClick={this.LoadTransitionData}
            >
              Refresh
            </Button>} */}
                </div>
              </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}
let notifyEmail = '';
export default AddEdit;
